//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: UserDTO | undefined): Observable<AuthenticateResult> {
        let url_ = this.baseUrl + "/api/Auth/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResult>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AuthenticateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: UserActivationDTO | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailInvitation(body: UserInviteDTO | undefined): Observable<UserConfirmationLinkResult> {
        let url_ = this.baseUrl + "/api/Auth/SendEmailInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfirmationLinkResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfirmationLinkResult>;
        }));
    }

    protected processSendEmailInvitation(response: HttpResponseBase): Observable<UserConfirmationLinkResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfirmationLinkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailInvitationNew(body: UserInviteNewDTO | undefined): Observable<UserConfirmationLinkResult> {
        let url_ = this.baseUrl + "/api/Auth/SendEmailInvitationNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailInvitationNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailInvitationNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfirmationLinkResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfirmationLinkResult>;
        }));
    }

    protected processSendEmailInvitationNew(response: HttpResponseBase): Observable<UserConfirmationLinkResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfirmationLinkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    sendPasswordResetEmail(username: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/SendPasswordResetEmail?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSendPasswordResetEmail(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    getPasswordResetLink(username: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/GetPasswordResetLink?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordResetLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordResetLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetPasswordResetLink(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    generateConfirmEmailLink(userId: string | undefined): Observable<UserConfirmationLinkResult> {
        let url_ = this.baseUrl + "/api/Auth/GenerateConfirmEmailLink?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateConfirmEmailLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateConfirmEmailLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserConfirmationLinkResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserConfirmationLinkResult>;
        }));
    }

    protected processGenerateConfirmEmailLink(response: HttpResponseBase): Observable<UserConfirmationLinkResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConfirmationLinkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getUsers(page: number | undefined, take: number | undefined, search: string | undefined, filter: TeamFilter | undefined): Observable<UserModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Auth/GetUsers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModelPagedListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param teamFilter (optional) 
     * @return Success
     */
    getUsersAssignedToLocation(locationId: string | undefined, teamFilter: TeamFilter | undefined): Observable<ShortUserModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetUsersAssignedToLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (teamFilter === null)
            throw new Error("The parameter 'teamFilter' cannot be null.");
        else if (teamFilter !== undefined)
            url_ += "teamFilter=" + encodeURIComponent("" + teamFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignedToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignedToLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortUserModel[]>;
        }));
    }

    protected processGetUsersAssignedToLocation(response: HttpResponseBase): Observable<ShortUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShortUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param teamFilter (optional) 
     * @return Success
     */
    getUsersAssignedToPractice(practiceId: string | undefined, teamFilter: TeamFilter | undefined): Observable<ShortUserModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetUsersAssignedToPractice?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (teamFilter === null)
            throw new Error("The parameter 'teamFilter' cannot be null.");
        else if (teamFilter !== undefined)
            url_ += "teamFilter=" + encodeURIComponent("" + teamFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignedToPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignedToPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortUserModel[]>;
        }));
    }

    protected processGetUsersAssignedToPractice(response: HttpResponseBase): Observable<ShortUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShortUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getInfoForDeletUser(userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/GetInfoForDeletUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoForDeletUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoForDeletUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetInfoForDeletUser(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    deletUser(userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/DeletUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeletUser(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getFinishedOnboardingSteps(locationId: string | undefined): Observable<OnboardingFinishedStepModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetFinishedOnboardingSteps?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinishedOnboardingSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinishedOnboardingSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingFinishedStepModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingFinishedStepModel[]>;
        }));
    }

    protected processGetFinishedOnboardingSteps(response: HttpResponseBase): Observable<OnboardingFinishedStepModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OnboardingFinishedStepModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stepNumber (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    finishOnboardingStep(stepNumber: number | undefined, locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/FinishOnboardingStep?";
        if (stepNumber === null)
            throw new Error("The parameter 'stepNumber' cannot be null.");
        else if (stepNumber !== undefined)
            url_ += "stepNumber=" + encodeURIComponent("" + stepNumber) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishOnboardingStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishOnboardingStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processFinishOnboardingStep(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isSHowWelcome(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/IsSHowWelcome";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSHowWelcome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSHowWelcome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSHowWelcome(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLocationsForOnboarding(): Observable<LocationModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetLocationsForOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsForOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsForOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationModel[]>;
        }));
    }

    protected processGetLocationsForOnboarding(response: HttpResponseBase): Observable<LocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LocationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsersByIds(body: string[] | undefined): Observable<ShortUserModel[]> {
        let url_ = this.baseUrl + "/api/Auth/GetUsersByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortUserModel[]>;
        }));
    }

    protected processGetUsersByIds(response: HttpResponseBase): Observable<ShortUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShortUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotUsername(body: ForgotUsernameModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/ForgotUsername";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processForgotUsername(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUsersDetailsForIntercomById(): Observable<UserDetailsIntecom> {
        let url_ = this.baseUrl + "/api/Auth/GetUsersDetailsForIntercomById";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersDetailsForIntercomById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersDetailsForIntercomById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsIntecom>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsIntecom>;
        }));
    }

    protected processGetUsersDetailsForIntercomById(response: HttpResponseBase): Observable<UserDetailsIntecom> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailsIntecom.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAcessToPractice(body: PracticeAcessModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/AddAcessToPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAcessToPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAcessToPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAddAcessToPractice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAcessToPractice(body: PracticeAcessModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/UpdateAcessToPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAcessToPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAcessToPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateAcessToPractice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAcessToLocation(body: LocationAcessModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/AddAcessToLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAcessToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAcessToLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAddAcessToLocation(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeAcessToPractice(body: PracticeAcessModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/RemoveAcessToPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAcessToPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAcessToPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveAcessToPractice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeAcessToLocation(body: LocationAcessModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/RemoveAcessToLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAcessToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAcessToLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveAcessToLocation(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    archiveUserById(userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/ArchiveUserById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processArchiveUserById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unarchiveUserById(userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/UnarchiveUserById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchiveUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchiveUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUnarchiveUserById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkArchiveUsersByIds(body: ListGuidIdModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/BulkArchiveUsersByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkArchiveUsersByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkArchiveUsersByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processBulkArchiveUsersByIds(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPermissions(userId: string | undefined): Observable<UpdateUserModel> {
        let url_ = this.baseUrl + "/api/Auth/GetUserPermissions?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserModel>;
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<UpdateUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userName (optional) 
     * @return Success
     */
    checkUserName(userName: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Auth/CheckUserName?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCheckUserName(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAllByLocationId(locationId: string | undefined): Observable<AutomationModel[]> {
        let url_ = this.baseUrl + "/api/Automation/GetAllByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomationModel[]>;
        }));
    }

    protected processGetAllByLocationId(response: HttpResponseBase): Observable<AutomationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AutomationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getUsersForAutomationByLocationId(locationId: string | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/Automation/GetUsersForAutomationByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForAutomationByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForAutomationByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersForAutomationByLocationId(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserToAutomation(body: AutomationsUserSimpleModel | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/Automation/AddUserToAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserToAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserToAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processAddUserToAutomation(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserFromAutomation(body: AutomationsUserSimpleModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Automation/RemoveUserFromAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveUserFromAutomation(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAutomation(body: AutomationCreateModel | undefined): Observable<AutomationModel> {
        let url_ = this.baseUrl + "/api/Automation/CreateAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomationModel>;
        }));
    }

    protected processCreateAutomation(response: HttpResponseBase): Observable<AutomationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAutomation(body: AutomationModel | undefined): Observable<AutomationModel> {
        let url_ = this.baseUrl + "/api/Automation/UpdateAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomationModel>;
        }));
    }

    protected processUpdateAutomation(response: HttpResponseBase): Observable<AutomationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param automationId (optional) 
     * @return Success
     */
    deleteAutomationById(automationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Automation/DeleteAutomationById?";
        if (automationId === null)
            throw new Error("The parameter 'automationId' cannot be null.");
        else if (automationId !== undefined)
            url_ += "automationId=" + encodeURIComponent("" + automationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAutomationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAutomationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteAutomationById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runAutomation(body: RunAutomationRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Automation/RunAutomation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAutomation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAutomation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRunAutomation(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BillingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllByRole(body: GetListOptionsBilling | undefined): Observable<InvoiceListModelInvoicePagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetAllByRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceListModelInvoicePagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceListModelInvoicePagedListDto>;
        }));
    }

    protected processGetAllByRole(response: HttpResponseBase): Observable<InvoiceListModelInvoicePagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceListModelInvoicePagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined): Observable<InvoiceModel> {
        let url_ = this.baseUrl + "/api/Billing/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailInvoices(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/EmailInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processEmailInvoices(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllPatientStatementByRole(practiceId: string | undefined, locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PatientStatementListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetAllPatientStatementByRole?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatientStatementByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatientStatementByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientStatementListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientStatementListModelPagedListDto>;
        }));
    }

    protected processGetAllPatientStatementByRole(response: HttpResponseBase): Observable<PatientStatementListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientStatementListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPatientStatementById(id: string | undefined): Observable<PatientStatementModel> {
        let url_ = this.baseUrl + "/api/Billing/GetPatientStatementById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientStatementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientStatementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientStatementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientStatementModel>;
        }));
    }

    protected processGetPatientStatementById(response: HttpResponseBase): Observable<PatientStatementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientStatementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    payInvoice(body: InvoicePayRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/PayInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processPayInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markInvoicesAsPaid(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/MarkInvoicesAsPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkInvoicesAsPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkInvoicesAsPaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processMarkInvoicesAsPaid(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discountInvoice(body: InvoicePayRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/DiscountInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscountInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscountInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDiscountInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archiveInvoices(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/ArchiveInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processArchiveInvoices(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConsolidatedInvoice(body: CreateConsolidatedInvoiceModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/CreateConsolidatedInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsolidatedInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsolidatedInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateConsolidatedInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getLocationBillingOwners(locationId: string | undefined): Observable<ShortUserModel[]> {
        let url_ = this.baseUrl + "/api/Billing/GetLocationBillingOwners?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationBillingOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationBillingOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortUserModel[]>;
        }));
    }

    protected processGetLocationBillingOwners(response: HttpResponseBase): Observable<ShortUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShortUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConsolidatedInvoiceForBillingOwner(body: CreateConsolidatedInvoiceForBillingOwnerModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/CreateConsolidatedInvoiceForBillingOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsolidatedInvoiceForBillingOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsolidatedInvoiceForBillingOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateConsolidatedInvoiceForBillingOwner(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllConsolidatedInvoices(body: GetConsolidatedInvoiceModel | undefined): Observable<ConsolidatedInvoiceModelInvoicePagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetAllConsolidatedInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConsolidatedInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConsolidatedInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsolidatedInvoiceModelInvoicePagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsolidatedInvoiceModelInvoicePagedListDto>;
        }));
    }

    protected processGetAllConsolidatedInvoices(response: HttpResponseBase): Observable<ConsolidatedInvoiceModelInvoicePagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsolidatedInvoiceModelInvoicePagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsolidatedInvoiceById(id: string | undefined): Observable<ConsolidatedInvoiceModel> {
        let url_ = this.baseUrl + "/api/Billing/GetConsolidatedInvoiceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsolidatedInvoiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsolidatedInvoiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsolidatedInvoiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsolidatedInvoiceModel>;
        }));
    }

    protected processGetConsolidatedInvoiceById(response: HttpResponseBase): Observable<ConsolidatedInvoiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsolidatedInvoiceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    payConsolidatedInvoice(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/PayConsolidatedInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayConsolidatedInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayConsolidatedInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processPayConsolidatedInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteConsolidatedInvoice(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/DeleteConsolidatedInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsolidatedInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsolidatedInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteConsolidatedInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStatement(body: CreateStatementModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/CreateStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllStatements(body: GetStatementsModel | undefined): Observable<StatementModelInvoicePagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetAllStatements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementModelInvoicePagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementModelInvoicePagedListDto>;
        }));
    }

    protected processGetAllStatements(response: HttpResponseBase): Observable<StatementModelInvoicePagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementModelInvoicePagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStatementById(id: string | undefined): Observable<StatementModel> {
        let url_ = this.baseUrl + "/api/Billing/GetStatementById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementModel>;
        }));
    }

    protected processGetStatementById(response: HttpResponseBase): Observable<StatementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    payStatement(id: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/PayStatement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processPayStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/DeleteStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/SubmitStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSubmitStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addItemToStatement(body: CreateCustomStatementItemModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/AddItemToStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddItemToStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemToStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAddItemToStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    openActivityStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/OpenActivityStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenActivityStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenActivityStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processOpenActivityStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportBillingForLocation(body: ExportBillingRequestModel | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Billing/ExportBillingForLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBillingForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBillingForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBillingForLocation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBillingStatement(body: CreateBillingStatementModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/CreateBillingStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param date (optional) 
     * @return Success
     */
    createBillingStatementsByLocationId(locationId: string | undefined, date: Date | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/CreateBillingStatementsByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingStatementsByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingStatementsByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateBillingStatementsByLocationId(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllBillingStatements(body: GetStatementsModel | undefined): Observable<BillingStatementModelInvoicePagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetAllBillingStatements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillingStatements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillingStatements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingStatementModelInvoicePagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingStatementModelInvoicePagedListDto>;
        }));
    }

    protected processGetAllBillingStatements(response: HttpResponseBase): Observable<BillingStatementModelInvoicePagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingStatementModelInvoicePagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillingStatementById(id: string | undefined): Observable<BillingStatementModel> {
        let url_ = this.baseUrl + "/api/Billing/GetBillingStatementById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingStatementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingStatementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingStatementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingStatementModel>;
        }));
    }

    protected processGetBillingStatementById(response: HttpResponseBase): Observable<BillingStatementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingStatementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    payBillingStatement(id: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/PayBillingStatement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processPayBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBillingStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/DeleteBillingStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitBillingStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/SubmitBillingStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSubmitBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discountBillingStatement(body: StatementPayRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/DiscountBillingStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscountBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscountBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDiscountBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    openBillingStatement(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/OpenBillingStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processOpenBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCreditNote(body: AddCreditNoteModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/AddCreditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAddCreditNote(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingDoctorStatistics(body: GetBillingDoctorStatisticsModel | undefined): Observable<BillingDoctorStatisticsItemModelInvoicePagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetBillingDoctorStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingDoctorStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingDoctorStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDoctorStatisticsItemModelInvoicePagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDoctorStatisticsItemModelInvoicePagedListDto>;
        }));
    }

    protected processGetBillingDoctorStatistics(response: HttpResponseBase): Observable<BillingDoctorStatisticsItemModelInvoicePagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDoctorStatisticsItemModelInvoicePagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBillingProductStatistics(body: GetBillingProductStatisticsModel | undefined): Observable<BillingProductStatisticsItemModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Billing/GetBillingProductStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingProductStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingProductStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingProductStatisticsItemModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingProductStatisticsItemModelPagedListDto>;
        }));
    }

    protected processGetBillingProductStatistics(response: HttpResponseBase): Observable<BillingProductStatisticsItemModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingProductStatisticsItemModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateInvoicesDentistId(): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/UpdateInvoicesDentistId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoicesDentistId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoicesDentistId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateInvoicesDentistId(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param statementId (optional) 
     * @param amount (optional) 
     * @return Success
     */
    partialyPayBillingStatement(statementId: string | undefined, amount: number | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/PartialyPayBillingStatement?";
        if (statementId === null)
            throw new Error("The parameter 'statementId' cannot be null.");
        else if (statementId !== undefined)
            url_ += "statementId=" + encodeURIComponent("" + statementId) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartialyPayBillingStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialyPayBillingStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processPartialyPayBillingStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param returnUrl (optional) 
     * @return Success
     */
    stripePayInvoice(invoiceId: string | undefined, returnUrl: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/StripePayInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripePayInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripePayInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processStripePayInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param statementId (optional) 
     * @param returnUrl (optional) 
     * @return Success
     */
    stripePayStatement(statementId: string | undefined, returnUrl: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/StripePayStatement?";
        if (statementId === null)
            throw new Error("The parameter 'statementId' cannot be null.");
        else if (statementId !== undefined)
            url_ += "statementId=" + encodeURIComponent("" + statementId) + "&";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripePayStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripePayStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processStripePayStatement(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param locationId (optional) 
     * @param exportGroupId (optional) 
     * @return Success
     */
    exportByGroup(dateStart: Date | undefined, dateEnd: Date | undefined, locationId: string | undefined, exportGroupId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Billing/ExportByGroup?";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (exportGroupId === null)
            throw new Error("The parameter 'exportGroupId' cannot be null.");
        else if (exportGroupId !== undefined)
            url_ += "exportGroupId=" + encodeURIComponent("" + exportGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processExportByGroup(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param orderStatusId (optional) 
     * @return Success
     */
    checkIfInvoicesShouldBeCreated(orderId: string | undefined, orderStatusId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Billing/CheckIfInvoicesShouldBeCreated?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (orderStatusId === null)
            throw new Error("The parameter 'orderStatusId' cannot be null.");
        else if (orderStatusId !== undefined)
            url_ += "orderStatusId=" + encodeURIComponent("" + orderStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfInvoicesShouldBeCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfInvoicesShouldBeCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfInvoicesShouldBeCreated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param doctorId (optional) 
     * @param practiceId (optional) 
     * @return Success
     */
    getDoctorFinancials(doctorId: string | undefined, practiceId: string | undefined): Observable<DoctorPaymentsModel> {
        let url_ = this.baseUrl + "/api/Billing/GetDoctorFinancials?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorFinancials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorFinancials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorPaymentsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorPaymentsModel>;
        }));
    }

    protected processGetDoctorFinancials(response: HttpResponseBase): Observable<DoctorPaymentsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorPaymentsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAll(page: number | undefined, take: number | undefined, search: string | undefined): Observable<CompanyModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Company/GetAll?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModelPagedListDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getById(companyId: string | undefined): Observable<CompanyModel> {
        let url_ = this.baseUrl + "/api/Company/GetById?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CompanyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CompanyCreateModel | undefined): Observable<CompanyModel> {
        let url_ = this.baseUrl + "/api/Company/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CompanyModel | undefined): Observable<CompanyModel> {
        let url_ = this.baseUrl + "/api/Company/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param previousLogoUrl (optional) 
     * @return Success
     */
    uploadLogo(file: FileParameter | undefined, previousLogoUrl: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Company/UploadLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (previousLogoUrl === null || previousLogoUrl === undefined)
            throw new Error("The parameter 'previousLogoUrl' cannot be null.");
        else
            content_.append("PreviousLogoUrl", previousLogoUrl.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param file (optional) 
     * @return Success
     */
    updateLogo(companyId: string | undefined, file: FileParameter | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Company/UpdateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    romoveLogo(companyId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Company/RomoveLogo?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRomoveLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRomoveLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRomoveLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param locationId (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getOverview(startDate: Date | undefined, endDate: Date | undefined, locationId: string | undefined, companyId: string | undefined): Observable<DashboardOverviewResponceModel> {
        let url_ = this.baseUrl + "/api/Dashboard/GetOverview?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOverviewResponceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOverviewResponceModel>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<DashboardOverviewResponceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverviewResponceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getDashboardRevenue(startDate: Date | undefined, endDate: Date | undefined, locationId: string | undefined): Observable<DashboardRevenueResponceModel> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDashboardRevenue?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardRevenueResponceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardRevenueResponceModel>;
        }));
    }

    protected processGetDashboardRevenue(response: HttpResponseBase): Observable<DashboardRevenueResponceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardRevenueResponceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Data3ShapeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    generateLink(clientId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Data3Shape/GenerateLink?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGenerateLink(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateToken(body: Code3ShapeModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Data3Shape/GenerateToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGenerateToken(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @return Success
     */
    getCases(locationId: string | undefined, page: number | undefined): Observable<CasesResponce3shapeModel> {
        let url_ = this.baseUrl + "/api/Data3Shape/GetCases?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CasesResponce3shapeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CasesResponce3shapeModel>;
        }));
    }

    protected processGetCases(response: HttpResponseBase): Observable<CasesResponce3shapeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CasesResponce3shapeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrderFromCase(body: CreateOrder3Shape | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Data3Shape/CreateOrderFromCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderFromCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderFromCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateOrderFromCase(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param statusIds (optional) 
     * @param sortBy (optional) 
     * @param sortType (optional) 
     * @param search (optional) 
     * @param tags (optional) 
     * @return Success
     */
    getAllDone(locationId: string | undefined, page: number | undefined, take: number | undefined, statusIds: string | undefined, sortBy: string | undefined, sortType: string | undefined, search: string | undefined, tags: string | undefined): Observable<Done3ShapeOrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Data3Shape/GetAllDoneAsync?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            url_ += "statusIds=" + encodeURIComponent("" + statusIds) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "sortType=" + encodeURIComponent("" + sortType) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Done3ShapeOrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Done3ShapeOrderModelPagedListDto>;
        }));
    }

    protected processGetAllDone(response: HttpResponseBase): Observable<Done3ShapeOrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Done3ShapeOrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DoctorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllDoctors(body: GetListOptionsDoctorList | undefined): Observable<DoctorListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Doctor/GetAllDoctors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDoctors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDoctors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorListModelPagedListDto>;
        }));
    }

    protected processGetAllDoctors(response: HttpResponseBase): Observable<DoctorListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllArchivedDoctors(body: GetListOptionsDoctorList | undefined): Observable<DoctorListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Doctor/GetAllArchivedDoctors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArchivedDoctors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArchivedDoctors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorListModelPagedListDto>;
        }));
    }

    protected processGetAllArchivedDoctors(response: HttpResponseBase): Observable<DoctorListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param doctorId (optional) 
     * @return Success
     */
    getDoctorProfileById(doctorId: string | undefined): Observable<DoctorProfileModel> {
        let url_ = this.baseUrl + "/api/Doctor/GetDoctorProfileById?";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorProfileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorProfileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorProfileModel>;
        }));
    }

    protected processGetDoctorProfileById(response: HttpResponseBase): Observable<DoctorProfileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getPatientProfileById(patientId: string | undefined): Observable<PatiendProfileModel> {
        let url_ = this.baseUrl + "/api/Doctor/GetPatientProfileById?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientProfileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatiendProfileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatiendProfileModel>;
        }));
    }

    protected processGetPatientProfileById(response: HttpResponseBase): Observable<PatiendProfileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatiendProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getPracticeProfileById(practiceId: string | undefined): Observable<PracticeProfileModel> {
        let url_ = this.baseUrl + "/api/Doctor/GetPracticeProfileById?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticeProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticeProfileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeProfileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeProfileModel>;
        }));
    }

    protected processGetPracticeProfileById(response: HttpResponseBase): Observable<PracticeProfileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeDoctorFinancialNote(body: FinancialNoteEditModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Doctor/ChangeDoctorFinancialNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDoctorFinancialNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDoctorFinancialNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processChangeDoctorFinancialNote(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    createInvoicePdf(invoiceId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Document/CreateInvoicePdf?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoicePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoicePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateInvoicePdf(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadInvoices(body: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/DownloadInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInvoices(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param statementId (optional) 
     * @return Success
     */
    createBillingStatementPdf(statementId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Document/CreateBillingStatementPdf?";
        if (statementId === null)
            throw new Error("The parameter 'statementId' cannot be null.");
        else if (statementId !== undefined)
            url_ += "statementId=" + encodeURIComponent("" + statementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingStatementPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingStatementPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateBillingStatementPdf(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadBillingStatements(body: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/DownloadBillingStatements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBillingStatements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBillingStatements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBillingStatements(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InternalNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param patientId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createPatientInternalNote(patientId: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/CreatePatientInternalNote?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processCreatePatientInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createPracticeInternalNote(practiceId: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/CreatePracticeInternalNote?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePracticeInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePracticeInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processCreatePracticeInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dentistId (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createDentistInternalNote(dentistId: string | undefined, locationId: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/CreateDentistInternalNote?";
        if (dentistId === null)
            throw new Error("The parameter 'dentistId' cannot be null.");
        else if (dentistId !== undefined)
            url_ += "dentistId=" + encodeURIComponent("" + dentistId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDentistInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDentistInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processCreateDentistInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param managerId (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createManagerInternalNote(managerId: string | undefined, locationId: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/CreateManagerInternalNote?";
        if (managerId === null)
            throw new Error("The parameter 'managerId' cannot be null.");
        else if (managerId !== undefined)
            url_ += "managerId=" + encodeURIComponent("" + managerId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManagerInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManagerInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processCreateManagerInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePracticeInternalNote(id: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/UpdatePracticeInternalNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePracticeInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePracticeInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processUpdatePracticeInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserInternalNote(id: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/UpdateUserInternalNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processUpdateUserInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePatientInternalNote(id: string | undefined, body: string | undefined): Observable<InternalNoteModel> {
        let url_ = this.baseUrl + "/api/InternalNote/UpdatePatientInternalNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalNoteModel>;
        }));
    }

    protected processUpdatePatientInternalNote(response: HttpResponseBase): Observable<InternalNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param companyId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAll(companyId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<LocationModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Location/GetAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationModelPagedListDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LocationModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getById(locationId: string | undefined): Observable<LocationModel> {
        let url_ = this.baseUrl + "/api/Location/GetById?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<LocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: LocationCreateModel | undefined): Observable<LocationModel> {
        let url_ = this.baseUrl + "/api/Location/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    addMissingWorkflowsToAllLocations(): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/AddMissingWorkflowsToAllLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMissingWorkflowsToAllLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMissingWorkflowsToAllLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAddMissingWorkflowsToAllLocations(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: LocationModel | undefined): Observable<LocationModel> {
        let url_ = this.baseUrl + "/api/Location/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getTagsListByLocationId(locationId: string | undefined): Observable<LocationsTagListModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetTagsListByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagsListByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagsListByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationsTagListModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationsTagListModel[]>;
        }));
    }

    protected processGetTagsListByLocationId(response: HttpResponseBase): Observable<LocationsTagListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LocationsTagListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTag(body: LocationsTagCreateModel | undefined): Observable<LocationsTagModel> {
        let url_ = this.baseUrl + "/api/Location/AddTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationsTagModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationsTagModel>;
        }));
    }

    protected processAddTag(response: HttpResponseBase): Observable<LocationsTagModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationsTagModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagId (optional) 
     * @return Success
     */
    removeTag(tagId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/RemoveTag?";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveTag(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param file (optional) 
     * @param previousLogoUrl (optional) 
     * @return Success
     */
    uploadLogo(companyId: string | undefined, file: FileParameter | undefined, previousLogoUrl: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/UploadLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (previousLogoUrl === null || previousLogoUrl === undefined)
            throw new Error("The parameter 'previousLogoUrl' cannot be null.");
        else
            content_.append("PreviousLogoUrl", previousLogoUrl.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param file (optional) 
     * @return Success
     */
    updateLogo(locationId: string | undefined, file: FileParameter | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/UpdateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    romoveLogo(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/RomoveLogo?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRomoveLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRomoveLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRomoveLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getLocationRoutesByLocationId(locationId: string | undefined): Observable<LocationRouteModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetLocationRoutesByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationRoutesByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationRoutesByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationRouteModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationRouteModel[]>;
        }));
    }

    protected processGetLocationRoutesByLocationId(response: HttpResponseBase): Observable<LocationRouteModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LocationRouteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLocationRoute(body: LocationRouteCreateModel | undefined): Observable<LocationRouteModel> {
        let url_ = this.baseUrl + "/api/Location/CreateLocationRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLocationRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLocationRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationRouteModel>;
        }));
    }

    protected processCreateLocationRoute(response: HttpResponseBase): Observable<LocationRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editLocationRoute(body: LocationRouteModel | undefined): Observable<LocationRouteModel> {
        let url_ = this.baseUrl + "/api/Location/EditLocationRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLocationRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLocationRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationRouteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationRouteModel>;
        }));
    }

    protected processEditLocationRoute(response: HttpResponseBase): Observable<LocationRouteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationRouteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAllLocationHolydayByLocationId(locationId: string | undefined): Observable<LocationHolidayModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetAllLocationHolydayByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationHolydayByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationHolydayByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationHolidayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationHolidayModel[]>;
        }));
    }

    protected processGetAllLocationHolydayByLocationId(response: HttpResponseBase): Observable<LocationHolidayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LocationHolidayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addLocationHolyday(body: LocationHolidayCreateModel | undefined): Observable<LocationHolidayModel> {
        let url_ = this.baseUrl + "/api/Location/AddLocationHolyday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocationHolyday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocationHolyday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationHolidayModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationHolidayModel>;
        }));
    }

    protected processAddLocationHolyday(response: HttpResponseBase): Observable<LocationHolidayModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationHolidayModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLocationHolyday(body: LocationHolidayModel | undefined): Observable<LocationHolidayModel> {
        let url_ = this.baseUrl + "/api/Location/UpdateLocationHolyday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocationHolyday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocationHolyday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationHolidayModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationHolidayModel>;
        }));
    }

    protected processUpdateLocationHolyday(response: HttpResponseBase): Observable<LocationHolidayModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationHolidayModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationHolydayId (optional) 
     * @return Success
     */
    deleteLocationHolydayById(locationHolydayId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/DeleteLocationHolydayById?";
        if (locationHolydayId === null)
            throw new Error("The parameter 'locationHolydayId' cannot be null.");
        else if (locationHolydayId !== undefined)
            url_ += "locationHolydayId=" + encodeURIComponent("" + locationHolydayId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLocationHolydayById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLocationHolydayById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteLocationHolydayById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    deleteLocationById(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/DeleteLocationById?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLocationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLocationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteLocationById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencyModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyModel[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getCurrencyByLocation(locationId: string | undefined): Observable<CurrencyModel> {
        let url_ = this.baseUrl + "/api/Location/GetCurrencyByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencyByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencyByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyModel>;
        }));
    }

    protected processGetCurrencyByLocation(response: HttpResponseBase): Observable<CurrencyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCountries(): Observable<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetAllCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel[]>;
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<CountryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CountryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getCurrencuSymbolByCode(code: string | undefined): Observable<CurrencyModel> {
        let url_ = this.baseUrl + "/api/Location/GetCurrencuSymbolByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencuSymbolByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencuSymbolByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyModel>;
        }));
    }

    protected processGetCurrencuSymbolByCode(response: HttpResponseBase): Observable<CurrencyModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editLocationLocalization(body: LocationLocalizationModel | undefined): Observable<LocationLocalizationModel> {
        let url_ = this.baseUrl + "/api/Location/EditLocationLocalization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditLocationLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditLocationLocalization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationLocalizationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationLocalizationModel>;
        }));
    }

    protected processEditLocationLocalization(response: HttpResponseBase): Observable<LocationLocalizationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationLocalizationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllDateFormats(): Observable<DateFormatModel[]> {
        let url_ = this.baseUrl + "/api/Location/GetAllDateFormats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDateFormats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDateFormats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateFormatModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateFormatModel[]>;
        }));
    }

    protected processGetAllDateFormats(response: HttpResponseBase): Observable<DateFormatModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DateFormatModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getBillingSettings(locationId: string | undefined): Observable<LocationBillingSettingsModel> {
        let url_ = this.baseUrl + "/api/Location/GetBillingSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationBillingSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationBillingSettingsModel>;
        }));
    }

    protected processGetBillingSettings(response: HttpResponseBase): Observable<LocationBillingSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationBillingSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    createBillingSettings(locationId: string | undefined): Observable<LocationBillingSettingsModel> {
        let url_ = this.baseUrl + "/api/Location/CreateBillingSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBillingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationBillingSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationBillingSettingsModel>;
        }));
    }

    protected processCreateBillingSettings(response: HttpResponseBase): Observable<LocationBillingSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationBillingSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBillingSettings(body: LocationBillingSettingsModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/UpdateBillingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateBillingSettings(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getStripeDashboardToken(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/GetStripeDashboardToken?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStripeDashboardToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStripeDashboardToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetStripeDashboardToken(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getExportGroups(locationId: string | undefined): Observable<LocationExportGroupList> {
        let url_ = this.baseUrl + "/api/Location/GetExportGroups?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationExportGroupList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationExportGroupList>;
        }));
    }

    protected processGetExportGroups(response: HttpResponseBase): Observable<LocationExportGroupList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationExportGroupList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param exportGroupId (optional) 
     * @return Success
     */
    getExportGroupById(exportGroupId: string | undefined): Observable<LocationExportGroupModel> {
        let url_ = this.baseUrl + "/api/Location/GetExportGroupById?";
        if (exportGroupId === null)
            throw new Error("The parameter 'exportGroupId' cannot be null.");
        else if (exportGroupId !== undefined)
            url_ += "exportGroupId=" + encodeURIComponent("" + exportGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportGroupById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportGroupById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationExportGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationExportGroupModel>;
        }));
    }

    protected processGetExportGroupById(response: HttpResponseBase): Observable<LocationExportGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationExportGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExportGroup(body: CreateLocationExportGroupModel | undefined): Observable<LocationExportGroupModel> {
        let url_ = this.baseUrl + "/api/Location/CreateExportGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExportGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExportGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationExportGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationExportGroupModel>;
        }));
    }

    protected processCreateExportGroup(response: HttpResponseBase): Observable<LocationExportGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationExportGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExportGroup(body: LocationExportGroupModel | undefined): Observable<LocationExportGroupModel> {
        let url_ = this.baseUrl + "/api/Location/UpdateExportGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExportGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExportGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationExportGroupModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationExportGroupModel>;
        }));
    }

    protected processUpdateExportGroup(response: HttpResponseBase): Observable<LocationExportGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationExportGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param exportGroupId (optional) 
     * @return Success
     */
    deleteExportGroup(exportGroupId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/DeleteExportGroup?";
        if (exportGroupId === null)
            throw new Error("The parameter 'exportGroupId' cannot be null.");
        else if (exportGroupId !== undefined)
            url_ += "exportGroupId=" + encodeURIComponent("" + exportGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExportGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExportGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteExportGroup(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getLocationDocumentSettingsByLocationId(locationId: string | undefined): Observable<LocationDocumentSettingsModel> {
        let url_ = this.baseUrl + "/api/Location/GetLocationDocumentSettingsByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationDocumentSettingsByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationDocumentSettingsByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDocumentSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDocumentSettingsModel>;
        }));
    }

    protected processGetLocationDocumentSettingsByLocationId(response: HttpResponseBase): Observable<LocationDocumentSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDocumentSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateLocationDocumentSettings(body: LocationDocumentSettingsModel | undefined): Observable<LocationDocumentSettingsModel> {
        let url_ = this.baseUrl + "/api/Location/AddOrUpdateLocationDocumentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateLocationDocumentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateLocationDocumentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDocumentSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDocumentSettingsModel>;
        }));
    }

    protected processAddOrUpdateLocationDocumentSettings(response: HttpResponseBase): Observable<LocationDocumentSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDocumentSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param locationId (optional) 
     * @param file (optional) 
     * @param previousLogoUrl (optional) 
     * @return Success
     */
    uploadLocationDocumentFile(companyId: string | undefined, locationId: string | undefined, file: FileParameter | undefined, previousLogoUrl: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/UploadLocationDocumentFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (previousLogoUrl === null || previousLogoUrl === undefined)
            throw new Error("The parameter 'previousLogoUrl' cannot be null.");
        else
            content_.append("PreviousLogoUrl", previousLogoUrl.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLocationDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLocationDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUploadLocationDocumentFile(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getCountryByLocationId(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Location/GetCountryByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetCountryByLocationId(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    triggers(): Observable<NotificationTriggerModel[]> {
        let url_ = this.baseUrl + "/api/Notification/Triggers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTriggerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTriggerModel[]>;
        }));
    }

    protected processTriggers(response: HttpResponseBase): Observable<NotificationTriggerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NotificationTriggerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    variables(triggerId: number): Observable<NotificationVariableModel[]> {
        let url_ = this.baseUrl + "/api/Notification/Variables/{triggerId}";
        if (triggerId === undefined || triggerId === null)
            throw new Error("The parameter 'triggerId' must be defined.");
        url_ = url_.replace("{triggerId}", encodeURIComponent("" + triggerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVariables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVariables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationVariableModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationVariableModel[]>;
        }));
    }

    protected processVariables(response: HttpResponseBase): Observable<NotificationVariableModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NotificationVariableModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(locationId: string): Observable<NotificationModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetAll/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NotificationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NotificationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    get(id: number): Observable<NotificationModel> {
        let url_ = this.baseUrl + "/api/Notification/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NotificationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: NotificationModel | undefined): Observable<NotificationModel> {
        let url_ = this.baseUrl + "/api/Notification/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NotificationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: NotificationModel | undefined): Observable<NotificationModel> {
        let url_ = this.baseUrl + "/api/Notification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NotificationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    generateDefaultBillingSettings(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Notification/GenerateDefaultBillingSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDefaultBillingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDefaultBillingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGenerateDefaultBillingSettings(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param triggerName (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getNotificationId(triggerName: string | undefined, locationId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Notification/GetNotificationId?";
        if (triggerName === null)
            throw new Error("The parameter 'triggerName' cannot be null.");
        else if (triggerName !== undefined)
            url_ += "triggerName=" + encodeURIComponent("" + triggerName) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNotificationId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param practiceId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllByPracticeId(practiceId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetAllByPracticeId?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByPracticeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByPracticeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processGetAllByPracticeId(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param statusIds (optional) 
     * @param sortBy (optional) 
     * @param sortType (optional) 
     * @param search (optional) 
     * @param tags (optional) 
     * @param getArchived (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllByRole(locationId: string | undefined, page: number | undefined, take: number | undefined, statusIds: string | undefined, sortBy: string | undefined, sortType: string | undefined, search: string | undefined, tags: string | undefined, getArchived: boolean | undefined, body: string[] | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetAllByRole?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            url_ += "statusIds=" + encodeURIComponent("" + statusIds) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "sortType=" + encodeURIComponent("" + sortType) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        if (getArchived === null)
            throw new Error("The parameter 'getArchived' cannot be null.");
        else if (getArchived !== undefined)
            url_ += "getArchived=" + encodeURIComponent("" + getArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processGetAllByRole(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getById(orderId: string | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/GetById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getDetailsById(orderId: string | undefined): Observable<OrderDetailModel> {
        let url_ = this.baseUrl + "/api/Order/GetDetailsById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailModel>;
        }));
    }

    protected processGetDetailsById(response: HttpResponseBase): Observable<OrderDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrderCreateModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrderModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addProductsToOrder(orderId: string | undefined, body: OrderProductModel[] | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/AddProductsToOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductsToOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductsToOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processAddProductsToOrder(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getCategoriesForOrder(locationId: string | undefined): Observable<CategoryModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetCategoriesForOrder?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoriesForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryModel[]>;
        }));
    }

    protected processGetCategoriesForOrder(response: HttpResponseBase): Observable<CategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param categoryId (optional) 
     * @return Success
     */
    getSubcategoriesForOrder(locationId: string | undefined, categoryId: number | undefined): Observable<SubCategoryModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetSubcategoriesForOrder?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubcategoriesForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubcategoriesForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubCategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubCategoryModel[]>;
        }));
    }

    protected processGetSubcategoriesForOrder(response: HttpResponseBase): Observable<SubCategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubCategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param subcategoryId (optional) 
     * @return Success
     */
    getProductsForOrder(locationId: string | undefined, subcategoryId: number | undefined): Observable<ProductNameModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetProductsForOrder?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (subcategoryId === null)
            throw new Error("The parameter 'subcategoryId' cannot be null.");
        else if (subcategoryId !== undefined)
            url_ += "subcategoryId=" + encodeURIComponent("" + subcategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductNameModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductNameModel[]>;
        }));
    }

    protected processGetProductsForOrder(response: HttpResponseBase): Observable<ProductNameModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductNameModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param subcategoryId (optional) 
     * @param productName (optional) 
     * @return Success
     */
    getMaterialForOrder(locationId: string | undefined, subcategoryId: number | undefined, productName: string | undefined): Observable<ProductMaterialModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetMaterialForOrder?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (subcategoryId === null)
            throw new Error("The parameter 'subcategoryId' cannot be null.");
        else if (subcategoryId !== undefined)
            url_ += "subcategoryId=" + encodeURIComponent("" + subcategoryId) + "&";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMaterialModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMaterialModel[]>;
        }));
    }

    protected processGetMaterialForOrder(response: HttpResponseBase): Observable<ProductMaterialModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductMaterialModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param subcategoryId (optional) 
     * @param productName (optional) 
     * @param materialId (optional) 
     * @return Success
     */
    getStandardTierForOrder(locationId: string | undefined, subcategoryId: number | undefined, productName: string | undefined, materialId: number | undefined): Observable<ProductWithStandardTier[]> {
        let url_ = this.baseUrl + "/api/Order/GetStandardTierForOrder?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (subcategoryId === null)
            throw new Error("The parameter 'subcategoryId' cannot be null.");
        else if (subcategoryId !== undefined)
            url_ += "subcategoryId=" + encodeURIComponent("" + subcategoryId) + "&";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandardTierForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandardTierForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductWithStandardTier[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductWithStandardTier[]>;
        }));
    }

    protected processGetStandardTierForOrder(response: HttpResponseBase): Observable<ProductWithStandardTier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductWithStandardTier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    uploadOrderFile(file: FileParameter | undefined, orderId: string | undefined): Observable<UploadOrderFileResponseModel> {
        let url_ = this.baseUrl + "/api/Order/UploadOrderFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOrderFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOrderFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadOrderFileResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadOrderFileResponseModel>;
        }));
    }

    protected processUploadOrderFile(response: HttpResponseBase): Observable<UploadOrderFileResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadOrderFileResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param orderId (optional) 
     * @param typeId (optional) 
     * @param url (optional) 
     * @param typeName (optional) 
     * @return Success
     */
    addUploadedFileToOrder(id: string | undefined, orderId: string | undefined, typeId: number | undefined, url: string | undefined, typeName: string | undefined): Observable<OrderFileModel> {
        let url_ = this.baseUrl + "/api/Order/AddUploadedFileToOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (url === null || url === undefined)
            throw new Error("The parameter 'url' cannot be null.");
        else
            content_.append("Url", url.toString());
        if (typeName === null || typeName === undefined)
            throw new Error("The parameter 'typeName' cannot be null.");
        else
            content_.append("TypeName", typeName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUploadedFileToOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUploadedFileToOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderFileModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderFileModel>;
        }));
    }

    protected processAddUploadedFileToOrder(response: HttpResponseBase): Observable<OrderFileModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderFileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    removeOrderFile(fileId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/RemoveOrderFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrderFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrderFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveOrderFile(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    submitOrder(id: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/SubmitOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSubmitOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrderStatus(body: UpdateOrderStatusModel | undefined): Observable<ManualInvoiceResponseModelResultMessage> {
        let url_ = this.baseUrl + "/api/Order/UpdateOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualInvoiceResponseModelResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualInvoiceResponseModelResultMessage>;
        }));
    }

    protected processUpdateOrderStatus(response: HttpResponseBase): Observable<ManualInvoiceResponseModelResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualInvoiceResponseModelResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrderNote(body: AddOrderNoteModel | undefined): Observable<OrderNoteModel> {
        let url_ = this.baseUrl + "/api/Order/AddOrderNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrderNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderNoteModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderNoteModel>;
        }));
    }

    protected processAddOrderNote(response: HttpResponseBase): Observable<OrderNoteModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderNoteModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    uploadOrderNoteFile(file: FileParameter | undefined, orderId: string | undefined): Observable<UploadOrderFileResponseModel> {
        let url_ = this.baseUrl + "/api/Order/UploadOrderNoteFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOrderNoteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOrderNoteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadOrderFileResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadOrderFileResponseModel>;
        }));
    }

    protected processUploadOrderNoteFile(response: HttpResponseBase): Observable<UploadOrderFileResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadOrderFileResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param url (optional) 
     * @return Success
     */
    removeOrderNoteFile(url: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/RemoveOrderNoteFile?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrderNoteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrderNoteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveOrderNoteFile(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    findOrderByCode(code: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/FindOrderByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindOrderByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindOrderByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processFindOrderByCode(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTag(body: AddOrderTagModel | undefined): Observable<OrderTagModel> {
        let url_ = this.baseUrl + "/api/Order/AddTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderTagModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderTagModel>;
        }));
    }

    protected processAddTag(response: HttpResponseBase): Observable<OrderTagModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderTagModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tagId (optional) 
     * @return Success
     */
    removeTag(tagId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/RemoveTag?";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveTag(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    deleteOrder(orderId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/DeleteOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkArchiveOrder(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/BulkArchiveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkArchiveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkArchiveOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processBulkArchiveOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param statusIds (optional) 
     * @param tags (optional) 
     * @return Success
     */
    getOrdersCalendarDeadline(start: Date | undefined, end: Date | undefined, statusIds: string | undefined, tags: string | undefined): Observable<OrderListResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersCalendarDeadline?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            url_ += "statusIds=" + encodeURIComponent("" + statusIds) + "&";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersCalendarDeadline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersCalendarDeadline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderListResponse>;
        }));
    }

    protected processGetOrdersCalendarDeadline(response: HttpResponseBase): Observable<OrderListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param statusIds (optional) 
     * @param tags (optional) 
     * @return Success
     */
    getOrdersCalendarDueDate(start: Date | undefined, end: Date | undefined, statusIds: string | undefined, tags: string | undefined): Observable<OrderListResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersCalendarDueDate?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            url_ += "statusIds=" + encodeURIComponent("" + statusIds) + "&";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersCalendarDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersCalendarDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderListResponse>;
        }));
    }

    protected processGetOrdersCalendarDueDate(response: HttpResponseBase): Observable<OrderListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param statusIds (optional) 
     * @param tags (optional) 
     * @return Success
     */
    getOrdersCalendar(start: Date | undefined, end: Date | undefined, statusIds: string | undefined, tags: string | undefined): Observable<OrderListResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersCalendar?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            url_ += "statusIds=" + encodeURIComponent("" + statusIds) + "&";
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            url_ += "tags=" + encodeURIComponent("" + tags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderListResponse>;
        }));
    }

    protected processGetOrdersCalendar(response: HttpResponseBase): Observable<OrderListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param statusId (optional) 
     * @param tag (optional) 
     * @return Success
     */
    getOrdersDashboard(filter: string | undefined, statusId: number | undefined, tag: string | undefined): Observable<OrderListWithRoutResponse> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersDashboard?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderListWithRoutResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderListWithRoutResponse>;
        }));
    }

    protected processGetOrdersDashboard(response: HttpResponseBase): Observable<OrderListWithRoutResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderListWithRoutResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getOrdersRequiringDoctorResponse(page: number | undefined, take: number | undefined, search: string | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersRequiringDoctorResponse?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersRequiringDoctorResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersRequiringDoctorResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processGetOrdersRequiringDoctorResponse(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getOrdersRequiringLocationResponse(page: number | undefined, take: number | undefined, search: string | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetOrdersRequiringLocationResponse?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersRequiringLocationResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersRequiringLocationResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processGetOrdersRequiringLocationResponse(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    locationListSentResponse(page: number | undefined, take: number | undefined, search: string | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/LocationListSentResponse?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationListSentResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationListSentResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processLocationListSentResponse(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    locationInboxCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/Order/LocationInboxCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationInboxCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationInboxCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLocationInboxCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    doctorInboxCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/Order/DoctorInboxCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoctorInboxCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoctorInboxCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDoctorInboxCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductsForOrder(body: OrderModel | undefined): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Order/UpdateProductsForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductsForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductsForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModel>;
        }));
    }

    protected processUpdateProductsForOrder(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAddonProductsForOrder(body: AddAddonOrderProductModel | undefined): Observable<OrderProductModel[]> {
        let url_ = this.baseUrl + "/api/Order/AddAddonProductsForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAddonProductsForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAddonProductsForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderProductModel[]>;
        }));
    }

    protected processAddAddonProductsForOrder(response: HttpResponseBase): Observable<OrderProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeAddonProductFromOrder(body: RemoveAddonOrderProductModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/RemoveAddonProductFromOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAddonProductFromOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAddonProductFromOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveAddonProductFromOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePanNumber(body: UpdatePanNumberModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/UpdatePanNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePanNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePanNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdatePanNumber(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    remakeOrder(body: RemakeOrderModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Order/RemakeOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemakeOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemakeOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRemakeOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getNotesForOrder(orderId: string | undefined): Observable<OrderNoteModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetNotesForOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotesForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotesForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderNoteModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderNoteModel[]>;
        }));
    }

    protected processGetNotesForOrder(response: HttpResponseBase): Observable<OrderNoteModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderNoteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startNewStage(body: NewStageModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/StartNewStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartNewStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartNewStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processStartNewStage(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeOrderDueDate(body: OrderDueDateChangeModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/ChangeOrderDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOrderDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOrderDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processChangeOrderDueDate(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getDentistsPracticeAccountHolderForCreateOrder(searchString: string | undefined, locationId: string | undefined): Observable<AccountPracticeDoctorModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetDentistsPracticeAccountHolderForCreateOrder?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistsPracticeAccountHolderForCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistsPracticeAccountHolderForCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountPracticeDoctorModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountPracticeDoctorModel[]>;
        }));
    }

    protected processGetDentistsPracticeAccountHolderForCreateOrder(response: HttpResponseBase): Observable<AccountPracticeDoctorModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AccountPracticeDoctorModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getDoctorsForCreateOrder(searchString: string | undefined, locationId: string | undefined): Observable<DoctorPracticeModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetDoctorsForCreateOrder?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsForCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsForCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorPracticeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorPracticeModel[]>;
        }));
    }

    protected processGetDoctorsForCreateOrder(response: HttpResponseBase): Observable<DoctorPracticeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DoctorPracticeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    get5FrequentlyСhosenDentists(locationId: string | undefined): Observable<PracticeDentistForCreateOrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/Get5FrequentlyСhosenDentists?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet5FrequentlyСhosenDentists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet5FrequentlyСhosenDentists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeDentistForCreateOrderModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeDentistForCreateOrderModel[]>;
        }));
    }

    protected processGet5FrequentlyСhosenDentists(response: HttpResponseBase): Observable<PracticeDentistForCreateOrderModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PracticeDentistForCreateOrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    get5FrequentlyOrderedProducts(practiceId: string | undefined): Observable<FrequentlyOrderedProductsModel[]> {
        let url_ = this.baseUrl + "/api/Order/Get5FrequentlyOrderedProducts?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet5FrequentlyOrderedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet5FrequentlyOrderedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrequentlyOrderedProductsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrequentlyOrderedProductsModel[]>;
        }));
    }

    protected processGet5FrequentlyOrderedProducts(response: HttpResponseBase): Observable<FrequentlyOrderedProductsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FrequentlyOrderedProductsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param categoryId (optional) 
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllProductsForOrderByLocationId(practiceId: string | undefined, categoryId: number | undefined, locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<ProductListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetAllProductsForOrderByLocationId?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProductsForOrderByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductsForOrderByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListModelPagedListDto>;
        }));
    }

    protected processGetAllProductsForOrderByLocationId(response: HttpResponseBase): Observable<ProductListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDoctorPageOrders(body: DoctorPageOrdersRequestModel | undefined): Observable<OrderModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Order/GetDoctorPageOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorPageOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorPageOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderModelPagedListDto>;
        }));
    }

    protected processGetDoctorPageOrders(response: HttpResponseBase): Observable<OrderModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestChangeDueDate(body: DueDateChangeRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/RequestChangeDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestChangeDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestChangeDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRequestChangeDueDate(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveChangeDueDate(body: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/ApproveChangeDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveChangeDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveChangeDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processApproveChangeDueDate(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    declineChangeDueDate(body: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/DeclineChangeDueDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineChangeDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineChangeDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeclineChangeDueDate(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deadlineManuallyChange(body: DeadlineDateChangeRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/DeadlineManuallyChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeadlineManuallyChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeadlineManuallyChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeadlineManuallyChange(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderLogs(orderId: string | undefined): Observable<OrderLogModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetOrderLogs?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderLogModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderLogModel[]>;
        }));
    }

    protected processGetOrderLogs(response: HttpResponseBase): Observable<OrderLogModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderLogModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateActualDueDateByOrderId(body: string | undefined): Observable<DueDateResponceModel> {
        let url_ = this.baseUrl + "/api/Order/CalculateActualDueDateByOrderId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateActualDueDateByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateActualDueDateByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DueDateResponceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DueDateResponceModel>;
        }));
    }

    protected processCalculateActualDueDateByOrderId(response: HttpResponseBase): Observable<DueDateResponceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DueDateResponceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrderAccountHolderAndPractice(body: OrderAccountHolderPracticeUpdateModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Order/UpdateOrderAccountHolderAndPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderAccountHolderAndPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderAccountHolderAndPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateOrderAccountHolderAndPractice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    createInvoiceForOrder(orderId: string | undefined): Observable<ManualInvoiceResponseModel> {
        let url_ = this.baseUrl + "/api/Order/CreateInvoiceForOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualInvoiceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualInvoiceResponseModel>;
        }));
    }

    protected processCreateInvoiceForOrder(response: HttpResponseBase): Observable<ManualInvoiceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualInvoiceResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param practiceID (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllByRole(page: number | undefined, take: number | undefined, practiceID: string | undefined, search: string | undefined): Observable<PatientModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Patient/GetAllByRole?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (practiceID === null)
            throw new Error("The parameter 'practiceID' cannot be null.");
        else if (practiceID !== undefined)
            url_ += "practiceID=" + encodeURIComponent("" + practiceID) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModelPagedListDto>;
        }));
    }

    protected processGetAllByRole(response: HttpResponseBase): Observable<PatientModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param practiceID (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllArchivedByRole(page: number | undefined, take: number | undefined, practiceID: string | undefined, search: string | undefined): Observable<PatientModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Patient/GetAllArchivedByRole?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (practiceID === null)
            throw new Error("The parameter 'practiceID' cannot be null.");
        else if (practiceID !== undefined)
            url_ += "practiceID=" + encodeURIComponent("" + practiceID) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArchivedByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArchivedByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModelPagedListDto>;
        }));
    }

    protected processGetAllArchivedByRole(response: HttpResponseBase): Observable<PatientModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllByPracticeId(practiceId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PatientModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Patient/GetAllByPracticeId?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByPracticeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByPracticeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModelPagedListDto>;
        }));
    }

    protected processGetAllByPracticeId(response: HttpResponseBase): Observable<PatientModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllArchivedByPracticeId(practiceId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PatientModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Patient/GetAllArchivedByPracticeIdAsync?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArchivedByPracticeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArchivedByPracticeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModelPagedListDto>;
        }));
    }

    protected processGetAllArchivedByPracticeId(response: HttpResponseBase): Observable<PatientModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    getById(patientId: string | undefined): Observable<PatientDetailModel> {
        let url_ = this.baseUrl + "/api/Patient/GetById?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientDetailModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PatientDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PatientCreateModel | undefined): Observable<PatientModel> {
        let url_ = this.baseUrl + "/api/Patient/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PatientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PatientModel | undefined): Observable<PatientModel> {
        let url_ = this.baseUrl + "/api/Patient/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PatientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    archivePatientById(patientId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Patient/ArchivePatientById?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePatientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePatientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processArchivePatientById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param patientId (optional) 
     * @return Success
     */
    unarchivePatientById(patientId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Patient/UnarchivePatientById?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchivePatientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchivePatientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUnarchivePatientById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PracticeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAll(locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PracticeModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetAll?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModelPagedListDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PracticeModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getById(practiceId: string | undefined): Observable<PracticeModel> {
        let url_ = this.baseUrl + "/api/Practice/GetById?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PracticeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PracticeCreateModel | undefined): Observable<PracticeModel> {
        let url_ = this.baseUrl + "/api/Practice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PracticeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNew(body: PracticeCreateNewModel | undefined): Observable<PracticeModel> {
        let url_ = this.baseUrl + "/api/Practice/CreateNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<PracticeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PracticeModel | undefined): Observable<PracticeModel> {
        let url_ = this.baseUrl + "/api/Practice/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PracticeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param dentistId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getPracticesByLocationAndDentist(locationId: string | undefined, dentistId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PracticeModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetPracticesByLocationAndDentist?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (dentistId === null)
            throw new Error("The parameter 'dentistId' cannot be null.");
        else if (dentistId !== undefined)
            url_ += "dentistId=" + encodeURIComponent("" + dentistId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticesByLocationAndDentist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticesByLocationAndDentist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModelPagedListDto>;
        }));
    }

    protected processGetPracticesByLocationAndDentist(response: HttpResponseBase): Observable<PracticeModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getDentistsForCurrentCompany(page: number | undefined, take: number | undefined, search: string | undefined): Observable<DentistModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetDentistsForCurrentCompany?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistsForCurrentCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistsForCurrentCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DentistModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DentistModelPagedListDto>;
        }));
    }

    protected processGetDentistsForCurrentCompany(response: HttpResponseBase): Observable<DentistModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DentistModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getDentistsByCompanyId(companyId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<DentistModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetDentistsByCompanyId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistsByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistsByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DentistModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DentistModelPagedListDto>;
        }));
    }

    protected processGetDentistsByCompanyId(response: HttpResponseBase): Observable<DentistModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DentistModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dentistId (optional) 
     * @return Success
     */
    getDentistDetailById(dentistId: string | undefined): Observable<DentistDetailModel> {
        let url_ = this.baseUrl + "/api/Practice/GetDentistDetailById?";
        if (dentistId === null)
            throw new Error("The parameter 'dentistId' cannot be null.");
        else if (dentistId !== undefined)
            url_ += "dentistId=" + encodeURIComponent("" + dentistId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistDetailById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistDetailById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DentistDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DentistDetailModel>;
        }));
    }

    protected processGetDentistDetailById(response: HttpResponseBase): Observable<DentistDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DentistDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getDentistsByLocationId(locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<DentistModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetDentistsByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistsByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistsByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DentistModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DentistModelPagedListDto>;
        }));
    }

    protected processGetDentistsByLocationId(response: HttpResponseBase): Observable<DentistModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DentistModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param doctorNameIndex (optional) 
     * @param doctorEmailIndex (optional) 
     * @param doctorPhoneIndex (optional) 
     * @param practiceNameIndex (optional) 
     * @param practiceEmailIndex (optional) 
     * @param practiceAddress1Index (optional) 
     * @param practiceAddress2Index (optional) 
     * @param practiceCityIndex (optional) 
     * @param practicePostcodeIndex (optional) 
     * @param practiceCountryIndex (optional) 
     * @param practiceRoutNumberIndex (optional) 
     * @param practicePhoneIndex (optional) 
     * @param billingEmailIndex (optional) 
     * @param billingAddress1Index (optional) 
     * @param billingAddress2Index (optional) 
     * @param billingCityIndex (optional) 
     * @param billingCountryIndex (optional) 
     * @param practiceStateIndex (optional) 
     * @param billingStateIndex (optional) 
     * @param billingPostcodeIndex (optional) 
     * @param accountDentalRegistrationNumberIndex (optional) 
     * @param dentistDentalRegistrationNumberIndex (optional) 
     * @param accountCodeIndex (optional) 
     * @param locationId (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    updatedImportDoctorsAndPractices(doctorNameIndex: number | undefined, doctorEmailIndex: number | undefined, doctorPhoneIndex: number | undefined, practiceNameIndex: number | undefined, practiceEmailIndex: number | undefined, practiceAddress1Index: number | undefined, practiceAddress2Index: number | undefined, practiceCityIndex: number | undefined, practicePostcodeIndex: number | undefined, practiceCountryIndex: number | undefined, practiceRoutNumberIndex: number | undefined, practicePhoneIndex: number | undefined, billingEmailIndex: number | undefined, billingAddress1Index: number | undefined, billingAddress2Index: number | undefined, billingCityIndex: number | undefined, billingCountryIndex: number | undefined, practiceStateIndex: number | undefined, billingStateIndex: number | undefined, billingPostcodeIndex: number | undefined, accountDentalRegistrationNumberIndex: number | undefined, dentistDentalRegistrationNumberIndex: number | undefined, accountCodeIndex: number | undefined, locationId: string | undefined, csvFile: FileParameter | undefined): Observable<ImportDoctorsAndPracticesResponseModel> {
        let url_ = this.baseUrl + "/api/Practice/UpdatedImportDoctorsAndPractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (doctorNameIndex === null || doctorNameIndex === undefined)
            throw new Error("The parameter 'doctorNameIndex' cannot be null.");
        else
            content_.append("DoctorNameIndex", doctorNameIndex.toString());
        if (doctorEmailIndex === null || doctorEmailIndex === undefined)
            throw new Error("The parameter 'doctorEmailIndex' cannot be null.");
        else
            content_.append("DoctorEmailIndex", doctorEmailIndex.toString());
        if (doctorPhoneIndex === null || doctorPhoneIndex === undefined)
            throw new Error("The parameter 'doctorPhoneIndex' cannot be null.");
        else
            content_.append("DoctorPhoneIndex", doctorPhoneIndex.toString());
        if (practiceNameIndex === null || practiceNameIndex === undefined)
            throw new Error("The parameter 'practiceNameIndex' cannot be null.");
        else
            content_.append("PracticeNameIndex", practiceNameIndex.toString());
        if (practiceEmailIndex === null || practiceEmailIndex === undefined)
            throw new Error("The parameter 'practiceEmailIndex' cannot be null.");
        else
            content_.append("PracticeEmailIndex", practiceEmailIndex.toString());
        if (practiceAddress1Index === null || practiceAddress1Index === undefined)
            throw new Error("The parameter 'practiceAddress1Index' cannot be null.");
        else
            content_.append("PracticeAddress1Index", practiceAddress1Index.toString());
        if (practiceAddress2Index === null || practiceAddress2Index === undefined)
            throw new Error("The parameter 'practiceAddress2Index' cannot be null.");
        else
            content_.append("PracticeAddress2Index", practiceAddress2Index.toString());
        if (practiceCityIndex === null || practiceCityIndex === undefined)
            throw new Error("The parameter 'practiceCityIndex' cannot be null.");
        else
            content_.append("PracticeCityIndex", practiceCityIndex.toString());
        if (practicePostcodeIndex === null || practicePostcodeIndex === undefined)
            throw new Error("The parameter 'practicePostcodeIndex' cannot be null.");
        else
            content_.append("PracticePostcodeIndex", practicePostcodeIndex.toString());
        if (practiceCountryIndex === null || practiceCountryIndex === undefined)
            throw new Error("The parameter 'practiceCountryIndex' cannot be null.");
        else
            content_.append("PracticeCountryIndex", practiceCountryIndex.toString());
        if (practiceRoutNumberIndex === null || practiceRoutNumberIndex === undefined)
            throw new Error("The parameter 'practiceRoutNumberIndex' cannot be null.");
        else
            content_.append("PracticeRoutNumberIndex", practiceRoutNumberIndex.toString());
        if (practicePhoneIndex === null || practicePhoneIndex === undefined)
            throw new Error("The parameter 'practicePhoneIndex' cannot be null.");
        else
            content_.append("PracticePhoneIndex", practicePhoneIndex.toString());
        if (billingEmailIndex === null || billingEmailIndex === undefined)
            throw new Error("The parameter 'billingEmailIndex' cannot be null.");
        else
            content_.append("BillingEmailIndex", billingEmailIndex.toString());
        if (billingAddress1Index === null || billingAddress1Index === undefined)
            throw new Error("The parameter 'billingAddress1Index' cannot be null.");
        else
            content_.append("BillingAddress1Index", billingAddress1Index.toString());
        if (billingAddress2Index === null || billingAddress2Index === undefined)
            throw new Error("The parameter 'billingAddress2Index' cannot be null.");
        else
            content_.append("BillingAddress2Index", billingAddress2Index.toString());
        if (billingCityIndex === null || billingCityIndex === undefined)
            throw new Error("The parameter 'billingCityIndex' cannot be null.");
        else
            content_.append("BillingCityIndex", billingCityIndex.toString());
        if (billingCountryIndex === null || billingCountryIndex === undefined)
            throw new Error("The parameter 'billingCountryIndex' cannot be null.");
        else
            content_.append("BillingCountryIndex", billingCountryIndex.toString());
        if (practiceStateIndex === null || practiceStateIndex === undefined)
            throw new Error("The parameter 'practiceStateIndex' cannot be null.");
        else
            content_.append("PracticeStateIndex", practiceStateIndex.toString());
        if (billingStateIndex === null || billingStateIndex === undefined)
            throw new Error("The parameter 'billingStateIndex' cannot be null.");
        else
            content_.append("BillingStateIndex", billingStateIndex.toString());
        if (billingPostcodeIndex === null || billingPostcodeIndex === undefined)
            throw new Error("The parameter 'billingPostcodeIndex' cannot be null.");
        else
            content_.append("BillingPostcodeIndex", billingPostcodeIndex.toString());
        if (accountDentalRegistrationNumberIndex === null || accountDentalRegistrationNumberIndex === undefined)
            throw new Error("The parameter 'accountDentalRegistrationNumberIndex' cannot be null.");
        else
            content_.append("AccountDentalRegistrationNumberIndex", accountDentalRegistrationNumberIndex.toString());
        if (dentistDentalRegistrationNumberIndex === null || dentistDentalRegistrationNumberIndex === undefined)
            throw new Error("The parameter 'dentistDentalRegistrationNumberIndex' cannot be null.");
        else
            content_.append("DentistDentalRegistrationNumberIndex", dentistDentalRegistrationNumberIndex.toString());
        if (accountCodeIndex === null || accountCodeIndex === undefined)
            throw new Error("The parameter 'accountCodeIndex' cannot be null.");
        else
            content_.append("AccountCodeIndex", accountCodeIndex.toString());
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("CsvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "CsvFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatedImportDoctorsAndPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatedImportDoctorsAndPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportDoctorsAndPracticesResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportDoctorsAndPracticesResponseModel>;
        }));
    }

    protected processUpdatedImportDoctorsAndPractices(response: HttpResponseBase): Observable<ImportDoctorsAndPracticesResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportDoctorsAndPracticesResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getPracticeDentistList(practiceId: string | undefined): Observable<PracticeDentistListModel[]> {
        let url_ = this.baseUrl + "/api/Practice/GetPracticeDentistList?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticeDentistList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticeDentistList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeDentistListModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeDentistListModel[]>;
        }));
    }

    protected processGetPracticeDentistList(response: HttpResponseBase): Observable<PracticeDentistListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PracticeDentistListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPracticeDentistList(body: PracticeDentistListCreateModel | undefined): Observable<PracticeDentistListModel> {
        let url_ = this.baseUrl + "/api/Practice/CreatePracticeDentistList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePracticeDentistList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePracticeDentistList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeDentistListModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeDentistListModel>;
        }));
    }

    protected processCreatePracticeDentistList(response: HttpResponseBase): Observable<PracticeDentistListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeDentistListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDentistPracticeDentistList(body: PracticeDentistListModel | undefined): Observable<PracticeDentistListModel> {
        let url_ = this.baseUrl + "/api/Practice/UpdateDentistPracticeDentistList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDentistPracticeDentistList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDentistPracticeDentistList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeDentistListModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeDentistListModel>;
        }));
    }

    protected processUpdateDentistPracticeDentistList(response: HttpResponseBase): Observable<PracticeDentistListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeDentistListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAccountDetails(body: UserNamePhoneModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/UpdateAccountDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateAccountDetails(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignDoctorToPractice(body: AssignDoctorToPracticeModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/AssignDoctorToPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDoctorToPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDoctorToPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAssignDoctorToPractice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getAssignedDoctorsByPracticeId(practiceId: string | undefined): Observable<DentistDetailModel[]> {
        let url_ = this.baseUrl + "/api/Practice/GetAssignedDoctorsByPracticeId?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedDoctorsByPracticeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedDoctorsByPracticeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DentistDetailModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DentistDetailModel[]>;
        }));
    }

    protected processGetAssignedDoctorsByPracticeId(response: HttpResponseBase): Observable<DentistDetailModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DentistDetailModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    deletePracticeById(practiceId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/DeletePracticeById?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePracticeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePracticeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeletePracticeById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePracticeDentistListItemById(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/DeletePracticeDentistListItemById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePracticeDentistListItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePracticeDentistListItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeletePracticeDentistListItemById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDentistsWithPractices(body: DentistSearchModel | undefined): Observable<GetDoctorsResponseModel> {
        let url_ = this.baseUrl + "/api/Practice/GetDentistsWithPractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDentistsWithPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDentistsWithPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDoctorsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDoctorsResponseModel>;
        }));
    }

    protected processGetDentistsWithPractices(response: HttpResponseBase): Observable<GetDoctorsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDoctorsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPracticesUserCanAccess(): Observable<PracticeModel[]> {
        let url_ = this.baseUrl + "/api/Practice/GetPracticesUserCanAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticesUserCanAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticesUserCanAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel[]>;
        }));
    }

    protected processGetPracticesUserCanAccess(response: HttpResponseBase): Observable<PracticeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PracticeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param practiceId (optional) 
     * @param doctorId (optional) 
     * @return Success
     */
    getUserWithPracticeWithDoctor(userId: string | undefined, practiceId: string | undefined, doctorId: string | undefined): Observable<UserPracticeDoctorModel> {
        let url_ = this.baseUrl + "/api/Practice/GetUserWithPracticeWithDoctor?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        if (doctorId === null)
            throw new Error("The parameter 'doctorId' cannot be null.");
        else if (doctorId !== undefined)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWithPracticeWithDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWithPracticeWithDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPracticeDoctorModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPracticeDoctorModel>;
        }));
    }

    protected processGetUserWithPracticeWithDoctor(response: HttpResponseBase): Observable<UserPracticeDoctorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPracticeDoctorModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllUserPractices(userId: string | undefined): Observable<PracticeModel[]> {
        let url_ = this.baseUrl + "/api/Practice/GetAllUserPractices?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModel[]>;
        }));
    }

    protected processGetAllUserPractices(response: HttpResponseBase): Observable<PracticeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PracticeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllDoctorsAssignedToUserPractices(userId: string | undefined): Observable<PracticeDentistListModel[]> {
        let url_ = this.baseUrl + "/api/Practice/GetAllDoctorsAssignedToUserPractices?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDoctorsAssignedToUserPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDoctorsAssignedToUserPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeDentistListModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeDentistListModel[]>;
        }));
    }

    protected processGetAllDoctorsAssignedToUserPractices(response: HttpResponseBase): Observable<PracticeDentistListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PracticeDentistListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    createUsersFromPracticesDentistListsDEV(userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/CreateUsersFromPracticesDentistListsDEV?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUsersFromPracticesDentistListsDEV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUsersFromPracticesDentistListsDEV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateUsersFromPracticesDentistListsDEV(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getClientsByCompanyId(companyId: string | undefined, locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<ClientListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetClientsByCompanyId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientListModelPagedListDto>;
        }));
    }

    protected processGetClientsByCompanyId(response: HttpResponseBase): Observable<ClientListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getClientsByPracticeId(practiceId: string | undefined): Observable<PracticeProfileClientModelListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetClientsByPracticeId?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByPracticeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByPracticeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeProfileClientModelListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeProfileClientModelListDto>;
        }));
    }

    protected processGetClientsByPracticeId(response: HttpResponseBase): Observable<PracticeProfileClientModelListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeProfileClientModelListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getPracticesByClientId(userId: string | undefined): Observable<DoctorProfilePracticesRolesListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetPracticesByClientId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticesByClientId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticesByClientId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorProfilePracticesRolesListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorProfilePracticesRolesListDto>;
        }));
    }

    protected processGetPracticesByClientId(response: HttpResponseBase): Observable<DoctorProfilePracticesRolesListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorProfilePracticesRolesListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getAllPracticesByCompanyId(companyId: string | undefined): Observable<PracticeModelListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetAllPracticesByCompanyId?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPracticesByCompanyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPracticesByCompanyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModelListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModelListDto>;
        }));
    }

    protected processGetAllPracticesByCompanyId(response: HttpResponseBase): Observable<PracticeModelListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModelListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllArchived(locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<PracticeModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Practice/GetAllArchivedAsync?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PracticeModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PracticeModelPagedListDto>;
        }));
    }

    protected processGetAllArchived(response: HttpResponseBase): Observable<PracticeModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    archivePracticeById(practiceId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/ArchivePracticeById?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivePracticeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivePracticeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processArchivePracticeById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    unarchivePracticeById(practiceId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Practice/UnarchivePracticeById?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchivePracticeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchivePracticeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUnarchivePracticeById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param categoryId (optional) 
     * @param locationId (optional) 
     * @param page (optional) 
     * @param take (optional) 
     * @param search (optional) 
     * @return Success
     */
    getAllByLocationId(categoryId: number | undefined, locationId: string | undefined, page: number | undefined, take: number | undefined, search: string | undefined): Observable<ProductListModelPagedListDto> {
        let url_ = this.baseUrl + "/api/Product/GetAllByLocationId?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListModelPagedListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListModelPagedListDto>;
        }));
    }

    protected processGetAllByLocationId(response: HttpResponseBase): Observable<ProductListModelPagedListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListModelPagedListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProductCreateModel | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProductModel | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/api/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    remove(productId: number | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/Remove?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getCategories(locationId: string | undefined): Observable<ProductCategoryModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetCategories?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductCategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductCategoryModel[]>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<ProductCategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductCategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getSubcategories(categoryId: number | undefined): Observable<ProductSubcategoryModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetSubcategories?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubcategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubcategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSubcategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSubcategoryModel[]>;
        }));
    }

    protected processGetSubcategories(response: HttpResponseBase): Observable<ProductSubcategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductSubcategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getMaterials(categoryId: number | undefined): Observable<ProductMaterialModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetMaterials?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMaterialModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMaterialModel[]>;
        }));
    }

    protected processGetMaterials(response: HttpResponseBase): Observable<ProductMaterialModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductMaterialModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getStandardTiers(locationId: string | undefined): Observable<ProductMaterialModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetStandardTiers?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandardTiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandardTiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMaterialModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMaterialModel[]>;
        }));
    }

    protected processGetStandardTiers(response: HttpResponseBase): Observable<ProductMaterialModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductMaterialModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAddonsProducts(locationId: string | undefined): Observable<ProductListModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetAddonsProducts?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddonsProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddonsProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListModel[]>;
        }));
    }

    protected processGetAddonsProducts(response: HttpResponseBase): Observable<ProductListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getCategoriesSettings(locationId: string | undefined): Observable<ProductCategoriesSettingModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetCategoriesSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoriesSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductCategoriesSettingModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductCategoriesSettingModel[]>;
        }));
    }

    protected processGetCategoriesSettings(response: HttpResponseBase): Observable<ProductCategoriesSettingModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductCategoriesSettingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategoriesSettings(body: ProductCategoriesSettingModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateCategoriesSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategoriesSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategoriesSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateCategoriesSettings(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getStandartTierSettings(locationId: string | undefined): Observable<ProductStandardTierSettingModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetStandartTierSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandartTierSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandartTierSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStandardTierSettingModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStandardTierSettingModel[]>;
        }));
    }

    protected processGetStandartTierSettings(response: HttpResponseBase): Observable<ProductStandardTierSettingModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductStandardTierSettingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandartTierSettings(body: ProductStandardTierSettingModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateStandartTierSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStandartTierSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStandartTierSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateStandartTierSettings(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getMaterialSettings(locationId: string | undefined): Observable<ProductMaterialSettingModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetMaterialSettings?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMaterialSettingModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMaterialSettingModel[]>;
        }));
    }

    protected processGetMaterialSettings(response: HttpResponseBase): Observable<ProductMaterialSettingModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductMaterialSettingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMaterialSettings(body: ProductMaterialSettingModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateMaterialSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaterialSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateMaterialSettings(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getPricesForFastChecker(locationId: string | undefined): Observable<FastCheckerPricesModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetPricesForFastChecker?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPricesForFastChecker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPricesForFastChecker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FastCheckerPricesModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FastCheckerPricesModel[]>;
        }));
    }

    protected processGetPricesForFastChecker(response: HttpResponseBase): Observable<FastCheckerPricesModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FastCheckerPricesModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePricesFastChecker(body: FastCheckerPricesModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdatePricesFastChecker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePricesFastChecker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePricesFastChecker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdatePricesFastChecker(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    showHideProduct(body: ShowHideProductModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/ShowHideProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShowHideProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowHideProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processShowHideProduct(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getPriceLists(locationId: string | undefined): Observable<PriceListModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetPriceLists?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListModel[]>;
        }));
    }

    protected processGetPriceLists(response: HttpResponseBase): Observable<PriceListModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PriceListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param priceListId (optional) 
     * @return Success
     */
    getPriceList(priceListId: string | undefined): Observable<PriceListModel> {
        let url_ = this.baseUrl + "/api/Product/GetPriceList?";
        if (priceListId === null)
            throw new Error("The parameter 'priceListId' cannot be null.");
        else if (priceListId !== undefined)
            url_ += "priceListId=" + encodeURIComponent("" + priceListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListModel>;
        }));
    }

    protected processGetPriceList(response: HttpResponseBase): Observable<PriceListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPricelist(body: PriceListCreateModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/CreatePricelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePricelist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePricelist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreatePricelist(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePricelist(body: PriceListUpdateModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdatePricelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePricelist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePricelist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdatePricelist(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param priceListId (optional) 
     * @return Success
     */
    removePriceList(priceListId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/RemovePriceList?";
        if (priceListId === null)
            throw new Error("The parameter 'priceListId' cannot be null.");
        else if (priceListId !== undefined)
            url_ += "priceListId=" + encodeURIComponent("" + priceListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemovePriceList(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductsInBulk(body: PriceListProductsUpdateModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateProductsInBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductsInBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductsInBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateProductsInBulk(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePricelistItem(body: PriceListitemUpdateModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdatePricelistItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePricelistItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePricelistItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdatePricelistItem(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandartTierCustomName(body: StandartTierCustomNameModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateStandartTierCustomName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStandartTierCustomName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStandartTierCustomName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateStandartTierCustomName(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sKU (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    checkSKU(sKU: string | undefined, locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/CheckSKU?";
        if (sKU === null)
            throw new Error("The parameter 'sKU' cannot be null.");
        else if (sKU !== undefined)
            url_ += "SKU=" + encodeURIComponent("" + sKU) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSKU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSKU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCheckSKU(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportProductForLocation(body: ExportProductRequestModel | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Product/ExportProductForLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProductForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportProductForLocation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCategory(body: CreateCategoryModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/CreateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateCategory(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getCategory(categoryId: number | undefined): Observable<CategoryModel> {
        let url_ = this.baseUrl + "/api/Product/GetCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryModel>;
        }));
    }

    protected processGetCategory(response: HttpResponseBase): Observable<CategoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategory(body: CategoryModel | undefined): Observable<CategoryModel> {
        let url_ = this.baseUrl + "/api/Product/UpdateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryModel>;
        }));
    }

    protected processUpdateCategory(response: HttpResponseBase): Observable<CategoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param locationId (optional) 
     * @param isSubCategory (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadLogo(companyId: string | undefined, locationId: string | undefined, isSubCategory: boolean | undefined, file: FileParameter | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UploadLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (isSubCategory === null || isSubCategory === undefined)
            throw new Error("The parameter 'isSubCategory' cannot be null.");
        else
            content_.append("IsSubCategory", isSubCategory.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param locationId (optional) 
     * @param isSubCategory (optional) 
     * @param categoryId (optional) 
     * @param subCategoryId (optional) 
     * @param file (optional) 
     * @return Success
     */
    updateLogo(companyId: string | undefined, locationId: string | undefined, isSubCategory: boolean | undefined, categoryId: number | undefined, subCategoryId: number | undefined, file: FileParameter | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/UpdateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (isSubCategory === null || isSubCategory === undefined)
            throw new Error("The parameter 'isSubCategory' cannot be null.");
        else
            content_.append("IsSubCategory", isSubCategory.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (subCategoryId === null || subCategoryId === undefined)
            throw new Error("The parameter 'subCategoryId' cannot be null.");
        else
            content_.append("SubCategoryId", subCategoryId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeLogo(body: DeleteLogoModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Product/RemoveLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processRemoveLogo(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuickbooksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    connect(body: QuickbooksRequestDto | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Quickbooks/Connect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processConnect(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReceivingSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getSettingsByLocationId(locationId: string | undefined): Observable<ReceivingSettingsModel> {
        let url_ = this.baseUrl + "/api/ReceivingSetting/GetSettingsByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceivingSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceivingSettingsModel>;
        }));
    }

    protected processGetSettingsByLocationId(response: HttpResponseBase): Observable<ReceivingSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceivingSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: ReceivingSettingsModel | undefined): Observable<ReceivingSettingsModel> {
        let url_ = this.baseUrl + "/api/ReceivingSetting/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceivingSettingsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceivingSettingsModel>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<ReceivingSettingsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceivingSettingsModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receivingOptionId (optional) 
     * @return Success
     */
    deleteOptionById(receivingOptionId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/ReceivingSetting/DeleteOptionById?";
        if (receivingOptionId === null)
            throw new Error("The parameter 'receivingOptionId' cannot be null.");
        else if (receivingOptionId !== undefined)
            url_ += "receivingOptionId=" + encodeURIComponent("" + receivingOptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOptionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOptionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteOptionById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDailyReport(body: ReportRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Report/GetDailyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetDailyReport(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ShipmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    shipmentDashboard(locationId: string | undefined): Observable<DashboardResponse> {
        let url_ = this.baseUrl + "/api/Shipment/ShipmentDashboard?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShipmentDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShipmentDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardResponse>;
        }));
    }

    protected processShipmentDashboard(response: HttpResponseBase): Observable<DashboardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    checkLocationShippingKey(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Shipment/CheckLocationShippingKey?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLocationShippingKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLocationShippingKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCheckLocationShippingKey(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getLocationShipments(locationId: string | undefined): Observable<OrderShipmentModel[]> {
        let url_ = this.baseUrl + "/api/Shipment/GetLocationShipments?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationShipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationShipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderShipmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderShipmentModel[]>;
        }));
    }

    protected processGetLocationShipments(response: HttpResponseBase): Observable<OrderShipmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderShipmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    carriers(locationGuid: string): Observable<Carrier[]> {
        let url_ = this.baseUrl + "/api/Shipment/{locationGuid}/Carriers";
        if (locationGuid === undefined || locationGuid === null)
            throw new Error("The parameter 'locationGuid' must be defined.");
        url_ = url_.replace("{locationGuid}", encodeURIComponent("" + locationGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCarriers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCarriers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Carrier[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Carrier[]>;
        }));
    }

    protected processCarriers(response: HttpResponseBase): Observable<Carrier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Carrier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    estimateRates(body: EstimateRatesRequestModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Shipment/EstimateRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processEstimateRates(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShipmentLabelsForOrders(body: CreateShippingLabelsRequest | undefined): Observable<CreateShippingLabelsResponse> {
        let url_ = this.baseUrl + "/api/Shipment/CreateShipmentLabelsForOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShipmentLabelsForOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShipmentLabelsForOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateShippingLabelsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateShippingLabelsResponse>;
        }));
    }

    protected processCreateShipmentLabelsForOrders(response: HttpResponseBase): Observable<CreateShippingLabelsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateShippingLabelsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mergePdfFiles(body: string[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Shipment/MergePdfFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergePdfFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergePdfFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMergePdfFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateAddresses(body: ValidateAddressesRequest | undefined): Observable<ValidateAddressResponse[]> {
        let url_ = this.baseUrl + "/api/Shipment/ValidateAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateAddressResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateAddressResponse[]>;
        }));
    }

    protected processValidateAddresses(response: HttpResponseBase): Observable<ValidateAddressResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ValidateAddressResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderLabels(orderId: string | undefined): Observable<ShipmentLabelResponse[]> {
        let url_ = this.baseUrl + "/api/Shipment/GetOrderLabels?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShipmentLabelResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShipmentLabelResponse[]>;
        }));
    }

    protected processGetOrderLabels(response: HttpResponseBase): Observable<ShipmentLabelResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShipmentLabelResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trackingNumber (optional) 
     * @return Success
     */
    getTrakingPageUrl(trackingNumber: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Shipment/GetTrakingPageUrl?";
        if (trackingNumber === null)
            throw new Error("The parameter 'trackingNumber' cannot be null.");
        else if (trackingNumber !== undefined)
            url_ += "trackingNumber=" + encodeURIComponent("" + trackingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrakingPageUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrakingPageUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processGetTrakingPageUrl(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trackingNumber (optional) 
     * @param carrierCode (optional) 
     * @return Success
     */
    getTrackingStatus(trackingNumber: string | undefined, carrierCode: string | undefined): Observable<TrackingResponse> {
        let url_ = this.baseUrl + "/api/Shipment/GetTrackingStatus?";
        if (trackingNumber === null)
            throw new Error("The parameter 'trackingNumber' cannot be null.");
        else if (trackingNumber !== undefined)
            url_ += "trackingNumber=" + encodeURIComponent("" + trackingNumber) + "&";
        if (carrierCode === null)
            throw new Error("The parameter 'carrierCode' cannot be null.");
        else if (carrierCode !== undefined)
            url_ += "carrierCode=" + encodeURIComponent("" + carrierCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrackingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrackingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrackingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrackingResponse>;
        }));
    }

    protected processGetTrackingStatus(response: HttpResponseBase): Observable<TrackingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getStagesBylocationId(locationId: string | undefined): Observable<StageCategoryModel[]> {
        let url_ = this.baseUrl + "/api/Stage/GetStagesBylocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStagesBylocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStagesBylocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageCategoryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageCategoryModel[]>;
        }));
    }

    protected processGetStagesBylocationId(response: HttpResponseBase): Observable<StageCategoryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StageCategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStage(body: CreateStageModel | undefined): Observable<StageModel> {
        let url_ = this.baseUrl + "/api/Stage/CreateStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageModel>;
        }));
    }

    protected processCreateStage(response: HttpResponseBase): Observable<StageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStage(body: StageModel | undefined): Observable<StageModel> {
        let url_ = this.baseUrl + "/api/Stage/UpdateStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageModel>;
        }));
    }

    protected processUpdateStage(response: HttpResponseBase): Observable<StageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stageId (optional) 
     * @return Success
     */
    deleteStageById(stageId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Stage/DeleteStageById?";
        if (stageId === null)
            throw new Error("The parameter 'stageId' cannot be null.");
        else if (stageId !== undefined)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteStageById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addStageProducts(body: StageProductsAddModel | undefined): Observable<StageProductModel[]> {
        let url_ = this.baseUrl + "/api/Stage/AddStageProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStageProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStageProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageProductModel[]>;
        }));
    }

    protected processAddStageProducts(response: HttpResponseBase): Observable<StageProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StageProductModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setActiveStageCategory(body: StageCategoryActive | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Stage/SetActiveStageCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetActiveStageCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetActiveStageCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSetActiveStageCategory(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    deleteStageProductById(productId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Stage/DeleteStageProductById?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStageProductById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStageProductById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteStageProductById(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStagesOrderIndex(body: UpdateStagesOrderIndexModel | undefined): Observable<StageModel[]> {
        let url_ = this.baseUrl + "/api/Stage/UpdateStagesOrderIndex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStagesOrderIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStagesOrderIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageModel[]>;
        }));
    }

    protected processUpdateStagesOrderIndex(response: HttpResponseBase): Observable<StageModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubdomainServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getSubdomainByLocationId(locationId: string | undefined): Observable<SubdomainModel> {
        let url_ = this.baseUrl + "/api/Subdomain/GetSubdomainByLocationId?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubdomainByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubdomainByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdomainModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdomainModel>;
        }));
    }

    protected processGetSubdomainByLocationId(response: HttpResponseBase): Observable<SubdomainModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubdomainModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subdomainName (optional) 
     * @return Success
     */
    getSubdomainByName(subdomainName: string | undefined): Observable<SubdomainModel> {
        let url_ = this.baseUrl + "/api/Subdomain/GetSubdomainByName?";
        if (subdomainName === null)
            throw new Error("The parameter 'subdomainName' cannot be null.");
        else if (subdomainName !== undefined)
            url_ += "subdomainName=" + encodeURIComponent("" + subdomainName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubdomainByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubdomainByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdomainModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdomainModel>;
        }));
    }

    protected processGetSubdomainByName(response: HttpResponseBase): Observable<SubdomainModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubdomainModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubdomain(body: SubdomainCreateModel | undefined): Observable<SubdomainModel> {
        let url_ = this.baseUrl + "/api/Subdomain/CreateSubdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubdomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubdomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdomainModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdomainModel>;
        }));
    }

    protected processCreateSubdomain(response: HttpResponseBase): Observable<SubdomainModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubdomainModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSubdomain(body: SubdomainCreateModel | undefined): Observable<SubdomainModel> {
        let url_ = this.baseUrl + "/api/Subdomain/UpdateSubdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubdomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubdomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdomainModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdomainModel>;
        }));
    }

    protected processUpdateSubdomain(response: HttpResponseBase): Observable<SubdomainModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubdomainModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSubdomain(body: SubdomainDeleteModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Subdomain/DeleteSubdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubdomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubdomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteSubdomain(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param file (optional) 
     * @return Success
     */
    subdomainFileUpload(locationId: string | undefined, file: FileParameter | undefined): Observable<SubdomainFileUploadResponseModel> {
        let url_ = this.baseUrl + "/api/Subdomain/SubdomainFileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("LocationId", locationId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubdomainFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubdomainFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdomainFileUploadResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdomainFileUploadResponseModel>;
        }));
    }

    protected processSubdomainFileUpload(response: HttpResponseBase): Observable<SubdomainFileUploadResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubdomainFileUploadResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subdomainFileDelete(body: SubdomainFileDeleteModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Subdomain/SubdomainFileDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubdomainFileDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubdomainFileDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processSubdomainFileDelete(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreatmentPlanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    get(id: string): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/{id}/Get";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: string, body: TreatmentPlanModel | undefined): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/{id}/Update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TreatmentPlanModel | undefined): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/{id}/Publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    archive(id: string): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/{id}/Archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    confirm(id: string): Observable<TreatmentPlanModel> {
        let url_ = this.baseUrl + "/api/TreatmentPlan/{id}/Confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreatmentPlanModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreatmentPlanModel>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<TreatmentPlanModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreatmentPlanModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhooksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    stripe(): Observable<void> {
        let url_ = this.baseUrl + "/api/Webhooks/Stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStripe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkbenchTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    doesUserHaveActiveTask(locationId: string | undefined, userId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DoesUserHaveActiveTask?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesUserHaveActiveTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesUserHaveActiveTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDoesUserHaveActiveTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTasksForCurrentUser(body: GetWorkbenchTasksForUserModel | undefined): Observable<WorkbenchTaskModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetTasksForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchTaskModel[]>;
        }));
    }

    protected processGetTasksForCurrentUser(response: HttpResponseBase): Observable<WorkbenchTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchTaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllFilteredTasks(body: GetFilteredWorkbenchTasksModel | undefined): Observable<WorkbenchTaskModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllFilteredTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFilteredTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFilteredTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchTaskModel[]>;
        }));
    }

    protected processGetAllFilteredTasks(response: HttpResponseBase): Observable<WorkbenchTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchTaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getTasksByOrderId(orderId: string | undefined): Observable<WorkbenchTaskModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetTasksByOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchTaskModel[]>;
        }));
    }

    protected processGetTasksByOrderId(response: HttpResponseBase): Observable<WorkbenchTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchTaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTask(body: CreateWorkbenchTaskModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CreateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTask(body: UpdateWorkbenchTaskModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTask(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DeleteTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startTask(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/StartTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processStartTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workbenchTaskId (optional) 
     * @return Success
     */
    cancelTask(workbenchTaskId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CancelTask?";
        if (workbenchTaskId === null)
            throw new Error("The parameter 'workbenchTaskId' cannot be null.");
        else if (workbenchTaskId !== undefined)
            url_ += "workbenchTaskId=" + encodeURIComponent("" + workbenchTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCancelTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finishTask(body: string[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/FinishTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processFinishTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param workbenchTaskId (optional) 
     * @return Success
     */
    assignUserToTask(userId: string | undefined, workbenchTaskId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/AssignUserToTask?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (workbenchTaskId === null)
            throw new Error("The parameter 'workbenchTaskId' cannot be null.");
        else if (workbenchTaskId !== undefined)
            url_ += "workbenchTaskId=" + encodeURIComponent("" + workbenchTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processAssignUserToTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param teammateId (optional) 
     * @return Success
     */
    getAllFilteredTaskGroupedByRoom(locationId: string | undefined, teammateId: string | undefined): Observable<WokbenchTasksGroupedByRoom[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllFilteredTaskGroupedByRoom?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (teammateId === null)
            throw new Error("The parameter 'teammateId' cannot be null.");
        else if (teammateId !== undefined)
            url_ += "teammateId=" + encodeURIComponent("" + teammateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFilteredTaskGroupedByRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFilteredTaskGroupedByRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WokbenchTasksGroupedByRoom[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WokbenchTasksGroupedByRoom[]>;
        }));
    }

    protected processGetAllFilteredTaskGroupedByRoom(response: HttpResponseBase): Observable<WokbenchTasksGroupedByRoom[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WokbenchTasksGroupedByRoom.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStatistics(body: GetTaskStatisticsModel | undefined): Observable<TaskStatisticsModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetStatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskStatisticsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskStatisticsModel[]>;
        }));
    }

    protected processGetStatistics(response: HttpResponseBase): Observable<TaskStatisticsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TaskStatisticsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workbenchRoomTaskId (optional) 
     * @return Success
     */
    getRoomTaskById(workbenchRoomTaskId: string | undefined): Observable<WorkbenchRoomTaskModel> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetRoomTaskById?";
        if (workbenchRoomTaskId === null)
            throw new Error("The parameter 'workbenchRoomTaskId' cannot be null.");
        else if (workbenchRoomTaskId !== undefined)
            url_ += "workbenchRoomTaskId=" + encodeURIComponent("" + workbenchRoomTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchRoomTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchRoomTaskModel>;
        }));
    }

    protected processGetRoomTaskById(response: HttpResponseBase): Observable<WorkbenchRoomTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbenchRoomTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllFilteredRoomTasks(body: GetFilteredWorkbenchRoomTaskModel | undefined): Observable<WorkbenchRoomTaskModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllFilteredRoomTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFilteredRoomTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFilteredRoomTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchRoomTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchRoomTaskModel[]>;
        }));
    }

    protected processGetAllFilteredRoomTasks(response: HttpResponseBase): Observable<WorkbenchRoomTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchRoomTaskModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoomTask(body: CreateWorkbenchRoomTaskModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CreateRoomTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRoomTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRoomTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateRoomTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoomTask(body: UpdateWorkbenchRoomTaskModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateRoomTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoomTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoomTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateRoomTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workbenchRoomTaskId (optional) 
     * @return Success
     */
    deleteRoomTask(workbenchRoomTaskId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DeleteRoomTask?";
        if (workbenchRoomTaskId === null)
            throw new Error("The parameter 'workbenchRoomTaskId' cannot be null.");
        else if (workbenchRoomTaskId !== undefined)
            url_ += "workbenchRoomTaskId=" + encodeURIComponent("" + workbenchRoomTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRoomTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRoomTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteRoomTask(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAllRooms(locationId: string | undefined): Observable<WorkbenchRoomModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllRooms?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRooms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRooms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchRoomModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchRoomModel[]>;
        }));
    }

    protected processGetAllRooms(response: HttpResponseBase): Observable<WorkbenchRoomModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchRoomModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roomId (optional) 
     * @return Success
     */
    getRoomById(roomId: string | undefined): Observable<WorkbenchRoomModel> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetRoomById?";
        if (roomId === null)
            throw new Error("The parameter 'roomId' cannot be null.");
        else if (roomId !== undefined)
            url_ += "roomId=" + encodeURIComponent("" + roomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchRoomModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchRoomModel>;
        }));
    }

    protected processGetRoomById(response: HttpResponseBase): Observable<WorkbenchRoomModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbenchRoomModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoom(body: CreateWorkbenchRoomModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CreateRoom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateRoom(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoom(body: UpdateWorkbenchRoomModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateRoom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateRoom(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoomsOrder(body: WorkbenchRoomModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateRoomsOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoomsOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoomsOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateRoomsOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workbenchRoomId (optional) 
     * @return Success
     */
    deleteRoom(workbenchRoomId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DeleteRoom?";
        if (workbenchRoomId === null)
            throw new Error("The parameter 'workbenchRoomId' cannot be null.");
        else if (workbenchRoomId !== undefined)
            url_ += "workbenchRoomId=" + encodeURIComponent("" + workbenchRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRoom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRoom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteRoom(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param teammateId (optional) 
     * @return Success
     */
    getTeammate(locationId: string | undefined, teammateId: string | undefined): Observable<WorkbenchSettingsUserModel> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetTeammate?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (teammateId === null)
            throw new Error("The parameter 'teammateId' cannot be null.");
        else if (teammateId !== undefined)
            url_ += "teammateId=" + encodeURIComponent("" + teammateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeammate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeammate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchSettingsUserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchSettingsUserModel>;
        }));
    }

    protected processGetTeammate(response: HttpResponseBase): Observable<WorkbenchSettingsUserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbenchSettingsUserModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAllTeammates(locationId: string | undefined): Observable<WorkbenchSettingsUserModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllTeammates?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTeammates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTeammates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchSettingsUserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchSettingsUserModel[]>;
        }));
    }

    protected processGetAllTeammates(response: HttpResponseBase): Observable<WorkbenchSettingsUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchSettingsUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTeammate(body: UpdateTeammateModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateTeammate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTeammate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTeammate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateTeammate(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAllWorkflows(locationId: string | undefined): Observable<WorkbenchWorkflowModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetAllWorkflows?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkflows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkflows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchWorkflowModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchWorkflowModel[]>;
        }));
    }

    protected processGetAllWorkflows(response: HttpResponseBase): Observable<WorkbenchWorkflowModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchWorkflowModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkflow(body: UpdateWorkbenchWorkflowModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateWorkflow(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskPrototypeId (optional) 
     * @return Success
     */
    getTaskPrototypeById(taskPrototypeId: string | undefined): Observable<WorkbenchTaskPrototypeModel> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetTaskPrototypeById?";
        if (taskPrototypeId === null)
            throw new Error("The parameter 'taskPrototypeId' cannot be null.");
        else if (taskPrototypeId !== undefined)
            url_ += "taskPrototypeId=" + encodeURIComponent("" + taskPrototypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskPrototypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskPrototypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchTaskPrototypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchTaskPrototypeModel>;
        }));
    }

    protected processGetTaskPrototypeById(response: HttpResponseBase): Observable<WorkbenchTaskPrototypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbenchTaskPrototypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workflowId (optional) 
     * @return Success
     */
    getTaskPrototypesByWorkflowId(workflowId: string | undefined): Observable<WorkbenchTaskPrototypeModel[]> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetTaskPrototypesByWorkflowId?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskPrototypesByWorkflowId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskPrototypesByWorkflowId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkbenchTaskPrototypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkbenchTaskPrototypeModel[]>;
        }));
    }

    protected processGetTaskPrototypesByWorkflowId(response: HttpResponseBase): Observable<WorkbenchTaskPrototypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkbenchTaskPrototypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTaskPrototype(body: CreateWorkbenchTaskPrototypeModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CreateTaskPrototype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTaskPrototype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTaskPrototype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateTaskPrototype(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskPrototype(body: UpdateWorkbenchTaskPrototypeModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateTaskPrototype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskPrototype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskPrototype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateTaskPrototype(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskPrototypesOrder(body: WorkbenchTaskPrototypeModel[] | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateTaskPrototypesOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTaskPrototypesOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTaskPrototypesOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateTaskPrototypesOrder(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taskPrototypeId (optional) 
     * @return Success
     */
    deleteTaskPrototype(taskPrototypeId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DeleteTaskPrototype?";
        if (taskPrototypeId === null)
            throw new Error("The parameter 'taskPrototypeId' cannot be null.");
        else if (taskPrototypeId !== undefined)
            url_ += "taskPrototypeId=" + encodeURIComponent("" + taskPrototypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTaskPrototype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaskPrototype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteTaskPrototype(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWorkflow(body: CreateWorkflowModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/CreateWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCreateWorkflow(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWorkflowFull(body: UpdateWorkflowModel | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/UpdateWorkflowFull";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkflowFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkflowFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateWorkflowFull(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workflowId (optional) 
     * @return Success
     */
    getWorkflowFull(workflowId: string | undefined): Observable<GetUpdateWorkflowModel> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/GetWorkflowFull?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkflowFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkflowFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUpdateWorkflowModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUpdateWorkflowModel>;
        }));
    }

    protected processGetWorkflowFull(response: HttpResponseBase): Observable<GetUpdateWorkflowModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUpdateWorkflowModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param workflowId (optional) 
     * @return Success
     */
    deleteWorkflow(workflowId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/WorkbenchTask/DeleteWorkflow?";
        if (workflowId === null)
            throw new Error("The parameter 'workflowId' cannot be null.");
        else if (workflowId !== undefined)
            url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteWorkflow(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class XeroServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processWebhook(body: XeroInvoiceDto | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Xero/ProcessWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processProcessWebhook(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    callback(body: XeroRequestDto | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Xero/Callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getXeroConfigById(locationId: string | undefined): Observable<LocationXeroConfig> {
        let url_ = this.baseUrl + "/api/Xero/GetXeroConfigById?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXeroConfigById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXeroConfigById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationXeroConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationXeroConfig>;
        }));
    }

    protected processGetXeroConfigById(response: HttpResponseBase): Observable<LocationXeroConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationXeroConfig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateXeroConfig(body: LocationXeroConfig | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Xero/UpdateXeroConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateXeroConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateXeroConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processUpdateXeroConfig(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    deleteXeroConfig(locationId: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Xero/DeleteXeroConfig?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteXeroConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteXeroConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processDeleteXeroConfig(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    exportInvoice(id: string | undefined): Observable<ResultMessage> {
        let url_ = this.baseUrl + "/api/Xero/ExportInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessage>;
        }));
    }

    protected processExportInvoice(response: HttpResponseBase): Observable<ResultMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccountPracticeDoctorModel implements IAccountPracticeDoctorModel {
    locationId: string;
    locationName: string | undefined;
    practiceId: string;
    practiceName: string | undefined;
    doctorId: string;
    doctorName: string | undefined;
    practiceDentistListId: string;
    practiceDentistListName: string | undefined;

    constructor(data?: IAccountPracticeDoctorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.practiceId = _data["practiceId"];
            this.practiceName = _data["practiceName"];
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
        }
    }

    static fromJS(data: any): AccountPracticeDoctorModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPracticeDoctorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["practiceId"] = this.practiceId;
        data["practiceName"] = this.practiceName;
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        return data;
    }

    clone(): AccountPracticeDoctorModel {
        const json = this.toJSON();
        let result = new AccountPracticeDoctorModel();
        result.init(json);
        return result;
    }
}

export interface IAccountPracticeDoctorModel {
    locationId: string;
    locationName: string | undefined;
    practiceId: string;
    practiceName: string | undefined;
    doctorId: string;
    doctorName: string | undefined;
    practiceDentistListId: string;
    practiceDentistListName: string | undefined;
}

export class ActivityStatement implements IActivityStatement {
    practiceId: string;
    practice: Practice;
    dentistId: string | undefined;
    dentist: User;
    code: string | undefined;
    paymentTerms: string | undefined;
    totalAmount: number;
    amountDue: number;
    dateStart: Date;
    dateEnd: Date;
    isOpen: boolean;
    activityStatementItems: ActivityStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IActivityStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.dentistId = _data["dentistId"];
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.code = _data["code"];
            this.paymentTerms = _data["paymentTerms"];
            this.totalAmount = _data["totalAmount"];
            this.amountDue = _data["amountDue"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.isOpen = _data["isOpen"];
            if (Array.isArray(_data["activityStatementItems"])) {
                this.activityStatementItems = [] as any;
                for (let item of _data["activityStatementItems"])
                    this.activityStatementItems.push(ActivityStatementItem.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ActivityStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["dentistId"] = this.dentistId;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["paymentTerms"] = this.paymentTerms;
        data["totalAmount"] = this.totalAmount;
        data["amountDue"] = this.amountDue;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        if (Array.isArray(this.activityStatementItems)) {
            data["activityStatementItems"] = [];
            for (let item of this.activityStatementItems)
                data["activityStatementItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ActivityStatement {
        const json = this.toJSON();
        let result = new ActivityStatement();
        result.init(json);
        return result;
    }
}

export interface IActivityStatement {
    practiceId: string;
    practice: Practice;
    dentistId: string | undefined;
    dentist: User;
    code: string | undefined;
    paymentTerms: string | undefined;
    totalAmount: number;
    amountDue: number;
    dateStart: Date;
    dateEnd: Date;
    isOpen: boolean;
    activityStatementItems: ActivityStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ActivityStatementItem implements IActivityStatementItem {
    statementId: string;
    statement: ActivityStatement;
    name: string | undefined;
    date: Date;
    invoiceId: string | undefined;
    dueDate: Date | undefined;
    invoiceAmountDue: number | undefined;
    paymentAmount: number | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IActivityStatementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementId = _data["statementId"];
            this.statement = _data["statement"] ? ActivityStatement.fromJS(_data["statement"]) : <any>undefined;
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.invoiceAmountDue = _data["invoiceAmountDue"];
            this.paymentAmount = _data["paymentAmount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ActivityStatementItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementId"] = this.statementId;
        data["statement"] = this.statement ? this.statement.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["invoiceAmountDue"] = this.invoiceAmountDue;
        data["paymentAmount"] = this.paymentAmount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ActivityStatementItem {
        const json = this.toJSON();
        let result = new ActivityStatementItem();
        result.init(json);
        return result;
    }
}

export interface IActivityStatementItem {
    statementId: string;
    statement: ActivityStatement;
    name: string | undefined;
    date: Date;
    invoiceId: string | undefined;
    dueDate: Date | undefined;
    invoiceAmountDue: number | undefined;
    paymentAmount: number | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class Actor3shapeModel implements IActor3shapeModel {
    id: string;
    roles: string[] | undefined;
    email: string | undefined;
    name: string | undefined;

    constructor(data?: IActor3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles.push(item);
            }
            this.email = _data["Email"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): Actor3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Actor3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["Email"] = this.email;
        data["Name"] = this.name;
        return data;
    }

    clone(): Actor3shapeModel {
        const json = this.toJSON();
        let result = new Actor3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IActor3shapeModel {
    id: string;
    roles: string[] | undefined;
    email: string | undefined;
    name: string | undefined;
}

export class AddAddonOrderProductModel implements IAddAddonOrderProductModel {
    orderId: string;
    productsIds: number[] | undefined;

    constructor(data?: IAddAddonOrderProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["productsIds"])) {
                this.productsIds = [] as any;
                for (let item of _data["productsIds"])
                    this.productsIds.push(item);
            }
        }
    }

    static fromJS(data: any): AddAddonOrderProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddAddonOrderProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.productsIds)) {
            data["productsIds"] = [];
            for (let item of this.productsIds)
                data["productsIds"].push(item);
        }
        return data;
    }

    clone(): AddAddonOrderProductModel {
        const json = this.toJSON();
        let result = new AddAddonOrderProductModel();
        result.init(json);
        return result;
    }
}

export interface IAddAddonOrderProductModel {
    orderId: string;
    productsIds: number[] | undefined;
}

export class AddCreditNoteModel implements IAddCreditNoteModel {
    practiceId: string;
    dentistId: string;
    amount: number;
    reason: string | undefined;

    constructor(data?: IAddCreditNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.amount = _data["amount"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AddCreditNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCreditNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["amount"] = this.amount;
        data["reason"] = this.reason;
        return data;
    }

    clone(): AddCreditNoteModel {
        const json = this.toJSON();
        let result = new AddCreditNoteModel();
        result.init(json);
        return result;
    }
}

export interface IAddCreditNoteModel {
    practiceId: string;
    dentistId: string;
    amount: number;
    reason: string | undefined;
}

export class AddOrderNoteAttachmentModel implements IAddOrderNoteAttachmentModel {
    code: string | undefined;
    fileUrl: string | undefined;

    constructor(data?: IAddOrderNoteAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): AddOrderNoteAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderNoteAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["fileUrl"] = this.fileUrl;
        return data;
    }

    clone(): AddOrderNoteAttachmentModel {
        const json = this.toJSON();
        let result = new AddOrderNoteAttachmentModel();
        result.init(json);
        return result;
    }
}

export interface IAddOrderNoteAttachmentModel {
    code: string | undefined;
    fileUrl: string | undefined;
}

export class AddOrderNoteModel implements IAddOrderNoteModel {
    orderId: string;
    note: string | undefined;
    typeId: number;
    sendTime: Date;
    isResponseNeeded: boolean;
    orderNoteAttachments: AddOrderNoteAttachmentModel[] | undefined;

    constructor(data?: IAddOrderNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.note = _data["note"];
            this.typeId = _data["typeId"];
            this.sendTime = _data["sendTime"] ? new Date(_data["sendTime"].toString()) : <any>undefined;
            this.isResponseNeeded = _data["isResponseNeeded"];
            if (Array.isArray(_data["orderNoteAttachments"])) {
                this.orderNoteAttachments = [] as any;
                for (let item of _data["orderNoteAttachments"])
                    this.orderNoteAttachments.push(AddOrderNoteAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOrderNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["note"] = this.note;
        data["typeId"] = this.typeId;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["isResponseNeeded"] = this.isResponseNeeded;
        if (Array.isArray(this.orderNoteAttachments)) {
            data["orderNoteAttachments"] = [];
            for (let item of this.orderNoteAttachments)
                data["orderNoteAttachments"].push(item.toJSON());
        }
        return data;
    }

    clone(): AddOrderNoteModel {
        const json = this.toJSON();
        let result = new AddOrderNoteModel();
        result.init(json);
        return result;
    }
}

export interface IAddOrderNoteModel {
    orderId: string;
    note: string | undefined;
    typeId: number;
    sendTime: Date;
    isResponseNeeded: boolean;
    orderNoteAttachments: AddOrderNoteAttachmentModel[] | undefined;
}

export class AddOrderTagModel implements IAddOrderTagModel {
    orderId: string;
    name: string | undefined;

    constructor(data?: IAddOrderTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddOrderTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        return data;
    }

    clone(): AddOrderTagModel {
        const json = this.toJSON();
        let result = new AddOrderTagModel();
        result.init(json);
        return result;
    }
}

export interface IAddOrderTagModel {
    orderId: string;
    name: string | undefined;
}

export class AssignDoctorToPracticeModel implements IAssignDoctorToPracticeModel {
    userId: string;
    practiceId: string;

    constructor(data?: IAssignDoctorToPracticeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.practiceId = _data["practiceId"];
        }
    }

    static fromJS(data: any): AssignDoctorToPracticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignDoctorToPracticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["practiceId"] = this.practiceId;
        return data;
    }

    clone(): AssignDoctorToPracticeModel {
        const json = this.toJSON();
        let result = new AssignDoctorToPracticeModel();
        result.init(json);
        return result;
    }
}

export interface IAssignDoctorToPracticeModel {
    userId: string;
    practiceId: string;
}

export class Attachment3shapeModel implements IAttachment3shapeModel {
    id: string;
    name: string | undefined;
    hash: string | undefined;
    fileType: string | undefined;
    created: Date;
    updated: Date;
    href: string | undefined;
    type: string | undefined;
    imageHref: any | undefined;

    constructor(data?: IAttachment3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.hash = _data["Hash"];
            this.fileType = _data["FileType"];
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.updated = _data["Updated"] ? new Date(_data["Updated"].toString()) : <any>undefined;
            this.href = _data["Href"];
            this.type = _data["Type"];
            this.imageHref = _data["ImageHref"];
        }
    }

    static fromJS(data: any): Attachment3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Hash"] = this.hash;
        data["FileType"] = this.fileType;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["Updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["Href"] = this.href;
        data["Type"] = this.type;
        data["ImageHref"] = this.imageHref;
        return data;
    }

    clone(): Attachment3shapeModel {
        const json = this.toJSON();
        let result = new Attachment3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IAttachment3shapeModel {
    id: string;
    name: string | undefined;
    hash: string | undefined;
    fileType: string | undefined;
    created: Date;
    updated: Date;
    href: string | undefined;
    type: string | undefined;
    imageHref: any | undefined;
}

export class AuthenticateResult implements IAuthenticateResult {
    accessToken: string | undefined;

    constructor(data?: IAuthenticateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): AuthenticateResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    }

    clone(): AuthenticateResult {
        const json = this.toJSON();
        let result = new AuthenticateResult();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResult {
    accessToken: string | undefined;
}

export class Automation implements IAutomation {
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IAutomation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.automationType = _data["automationType"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Automation {
        data = typeof data === 'object' ? data : {};
        let result = new Automation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["automationType"] = this.automationType;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Automation {
        const json = this.toJSON();
        let result = new Automation();
        result.init(json);
        return result;
    }
}

export interface IAutomation {
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class AutomationCreateModel implements IAutomationCreateModel {
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;

    constructor(data?: IAutomationCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.automationType = _data["automationType"];
        }
    }

    static fromJS(data: any): AutomationCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["automationType"] = this.automationType;
        return data;
    }

    clone(): AutomationCreateModel {
        const json = this.toJSON();
        let result = new AutomationCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAutomationCreateModel {
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;
}

export class AutomationModel implements IAutomationModel {
    id: string;
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;

    constructor(data?: IAutomationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.automationType = _data["automationType"];
        }
    }

    static fromJS(data: any): AutomationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["automationType"] = this.automationType;
        return data;
    }

    clone(): AutomationModel {
        const json = this.toJSON();
        let result = new AutomationModel();
        result.init(json);
        return result;
    }
}

export interface IAutomationModel {
    id: string;
    locationId: string;
    name: string | undefined;
    automationType: AutomationType;
}

export enum AutomationType {
    ChangeStatusSelect = <any>"ChangeStatusSelect",
    ChangeStatusSubmitted = <any>"ChangeStatusSubmitted",
    ChangeStatusAccepted = <any>"ChangeStatusAccepted",
    ChangeStatusDesign = <any>"ChangeStatusDesign",
    ChangeStatusPlan = <any>"ChangeStatusPlan",
    ChangeStatusManufacturing = <any>"ChangeStatusManufacturing",
    ChangeStatusQC = <any>"ChangeStatusQC",
    ChangeStatusPackaging = <any>"ChangeStatusPackaging",
    ChangeStatusDispatched = <any>"ChangeStatusDispatched",
}

export class AutomationsUser implements IAutomationsUser {
    locationId: string;
    userId: string;
    location: Location;
    user: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IAutomationsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.userId = _data["userId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): AutomationsUser {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["userId"] = this.userId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): AutomationsUser {
        const json = this.toJSON();
        let result = new AutomationsUser();
        result.init(json);
        return result;
    }
}

export interface IAutomationsUser {
    locationId: string;
    userId: string;
    location: Location;
    user: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class AutomationsUserSimpleModel implements IAutomationsUserSimpleModel {
    locationId: string;
    userId: string;

    constructor(data?: IAutomationsUserSimpleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AutomationsUserSimpleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationsUserSimpleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AutomationsUserSimpleModel {
        const json = this.toJSON();
        let result = new AutomationsUserSimpleModel();
        result.init(json);
        return result;
    }
}

export interface IAutomationsUserSimpleModel {
    locationId: string;
    userId: string;
}

export class BillingDoctorStatisticsItemModel implements IBillingDoctorStatisticsItemModel {
    doctorName: string | undefined;
    practiceName: string | undefined;
    ordersCount: number;
    averageAmount: number;
    totalAmount: number;
    amountDue: number;
    currency: string | undefined;

    constructor(data?: IBillingDoctorStatisticsItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorName = _data["doctorName"];
            this.practiceName = _data["practiceName"];
            this.ordersCount = _data["ordersCount"];
            this.averageAmount = _data["averageAmount"];
            this.totalAmount = _data["totalAmount"];
            this.amountDue = _data["amountDue"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): BillingDoctorStatisticsItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDoctorStatisticsItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorName"] = this.doctorName;
        data["practiceName"] = this.practiceName;
        data["ordersCount"] = this.ordersCount;
        data["averageAmount"] = this.averageAmount;
        data["totalAmount"] = this.totalAmount;
        data["amountDue"] = this.amountDue;
        data["currency"] = this.currency;
        return data;
    }

    clone(): BillingDoctorStatisticsItemModel {
        const json = this.toJSON();
        let result = new BillingDoctorStatisticsItemModel();
        result.init(json);
        return result;
    }
}

export interface IBillingDoctorStatisticsItemModel {
    doctorName: string | undefined;
    practiceName: string | undefined;
    ordersCount: number;
    averageAmount: number;
    totalAmount: number;
    amountDue: number;
    currency: string | undefined;
}

export class BillingDoctorStatisticsItemModelInvoicePagedListDto implements IBillingDoctorStatisticsItemModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: BillingDoctorStatisticsItemModel[] | undefined;
    totalCount: number;

    constructor(data?: IBillingDoctorStatisticsItemModelInvoicePagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillingDoctorStatisticsItemModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillingDoctorStatisticsItemModelInvoicePagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDoctorStatisticsItemModelInvoicePagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillingDoctorStatisticsItemModelInvoicePagedListDto {
        const json = this.toJSON();
        let result = new BillingDoctorStatisticsItemModelInvoicePagedListDto();
        result.init(json);
        return result;
    }
}

export interface IBillingDoctorStatisticsItemModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: BillingDoctorStatisticsItemModel[] | undefined;
    totalCount: number;
}

export enum BillingEntityType {
    Invoice = <any>"Invoice",
    Consolidation = <any>"Consolidation",
    ActivityStatement = <any>"ActivityStatement",
    BillingStatement = <any>"BillingStatement",
}

export class BillingProductStatisticsItemModel implements IBillingProductStatisticsItemModel {
    productName: string | undefined;
    sku: string | undefined;
    categoryName: string | undefined;
    material: string | undefined;
    standard: string | undefined;
    salesCount: number;
    totalAmount: number;
    currency: string | undefined;

    constructor(data?: IBillingProductStatisticsItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.sku = _data["sku"];
            this.categoryName = _data["categoryName"];
            this.material = _data["material"];
            this.standard = _data["standard"];
            this.salesCount = _data["salesCount"];
            this.totalAmount = _data["totalAmount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): BillingProductStatisticsItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillingProductStatisticsItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["sku"] = this.sku;
        data["categoryName"] = this.categoryName;
        data["material"] = this.material;
        data["standard"] = this.standard;
        data["salesCount"] = this.salesCount;
        data["totalAmount"] = this.totalAmount;
        data["currency"] = this.currency;
        return data;
    }

    clone(): BillingProductStatisticsItemModel {
        const json = this.toJSON();
        let result = new BillingProductStatisticsItemModel();
        result.init(json);
        return result;
    }
}

export interface IBillingProductStatisticsItemModel {
    productName: string | undefined;
    sku: string | undefined;
    categoryName: string | undefined;
    material: string | undefined;
    standard: string | undefined;
    salesCount: number;
    totalAmount: number;
    currency: string | undefined;
}

export class BillingProductStatisticsItemModelPagedListDto implements IBillingProductStatisticsItemModelPagedListDto {
    items: BillingProductStatisticsItemModel[] | undefined;
    totalCount: number;

    constructor(data?: IBillingProductStatisticsItemModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillingProductStatisticsItemModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillingProductStatisticsItemModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingProductStatisticsItemModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillingProductStatisticsItemModelPagedListDto {
        const json = this.toJSON();
        let result = new BillingProductStatisticsItemModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IBillingProductStatisticsItemModelPagedListDto {
    items: BillingProductStatisticsItemModel[] | undefined;
    totalCount: number;
}

export class BillingStatement implements IBillingStatement {
    practiceId: string;
    practice: Practice;
    dentistId: string | undefined;
    dentist: User;
    code: string | undefined;
    paymentTerms: string | undefined;
    totalAmount: number;
    amountDue: number;
    date: Date;
    isOpen: boolean;
    isDisplayPatientInStatement: boolean;
    fileUrl: string | undefined;
    invoices: Invoice[] | undefined;
    isHistorical: boolean;
    historicalInvoices: BillingStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IBillingStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.dentistId = _data["dentistId"];
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.code = _data["code"];
            this.paymentTerms = _data["paymentTerms"];
            this.totalAmount = _data["totalAmount"];
            this.amountDue = _data["amountDue"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isOpen = _data["isOpen"];
            this.isDisplayPatientInStatement = _data["isDisplayPatientInStatement"];
            this.fileUrl = _data["fileUrl"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            this.isHistorical = _data["isHistorical"];
            if (Array.isArray(_data["historicalInvoices"])) {
                this.historicalInvoices = [] as any;
                for (let item of _data["historicalInvoices"])
                    this.historicalInvoices.push(BillingStatementItem.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): BillingStatement {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["dentistId"] = this.dentistId;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["paymentTerms"] = this.paymentTerms;
        data["totalAmount"] = this.totalAmount;
        data["amountDue"] = this.amountDue;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        data["isDisplayPatientInStatement"] = this.isDisplayPatientInStatement;
        data["fileUrl"] = this.fileUrl;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["isHistorical"] = this.isHistorical;
        if (Array.isArray(this.historicalInvoices)) {
            data["historicalInvoices"] = [];
            for (let item of this.historicalInvoices)
                data["historicalInvoices"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): BillingStatement {
        const json = this.toJSON();
        let result = new BillingStatement();
        result.init(json);
        return result;
    }
}

export interface IBillingStatement {
    practiceId: string;
    practice: Practice;
    dentistId: string | undefined;
    dentist: User;
    code: string | undefined;
    paymentTerms: string | undefined;
    totalAmount: number;
    amountDue: number;
    date: Date;
    isOpen: boolean;
    isDisplayPatientInStatement: boolean;
    fileUrl: string | undefined;
    invoices: Invoice[] | undefined;
    isHistorical: boolean;
    historicalInvoices: BillingStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class BillingStatementItem implements IBillingStatementItem {
    locationId: string;
    practiceId: string;
    billingStatementId: string;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    date: Date;
    dueDate: Date;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    isArchived: boolean;
    fileUrl: string | undefined;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    location: Location;
    practice: Practice;
    dentist: User;
    billingStatement: BillingStatement;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IBillingStatementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.billingStatementId = _data["billingStatementId"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.locationTaxNumber = _data["locationTaxNumber"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.billingAddress = _data["billingAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhone = _data["clientPhone"];
            this.patientName = _data["patientName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.clienNumber = _data["clienNumber"];
            this.comment = _data["comment"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.orderShortCode = _data["orderShortCode"];
            this.subTotal = _data["subTotal"];
            this.totalTax = _data["totalTax"];
            this.amountDue = _data["amountDue"];
            this.amountPaid = _data["amountPaid"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.isArchived = _data["isArchived"];
            this.fileUrl = _data["fileUrl"];
            this.integrationName = _data["integrationName"];
            this.isExportedToXero = _data["isExportedToXero"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.billingStatement = _data["billingStatement"] ? BillingStatement.fromJS(_data["billingStatement"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): BillingStatementItem {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["billingStatementId"] = this.billingStatementId;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["locationTaxNumber"] = this.locationTaxNumber;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["billingAddress"] = this.billingAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhone"] = this.clientPhone;
        data["patientName"] = this.patientName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["clienNumber"] = this.clienNumber;
        data["comment"] = this.comment;
        data["termsAndConditions"] = this.termsAndConditions;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["orderShortCode"] = this.orderShortCode;
        data["subTotal"] = this.subTotal;
        data["totalTax"] = this.totalTax;
        data["amountDue"] = this.amountDue;
        data["amountPaid"] = this.amountPaid;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["isArchived"] = this.isArchived;
        data["fileUrl"] = this.fileUrl;
        data["integrationName"] = this.integrationName;
        data["isExportedToXero"] = this.isExportedToXero;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["billingStatement"] = this.billingStatement ? this.billingStatement.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): BillingStatementItem {
        const json = this.toJSON();
        let result = new BillingStatementItem();
        result.init(json);
        return result;
    }
}

export interface IBillingStatementItem {
    locationId: string;
    practiceId: string;
    billingStatementId: string;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    date: Date;
    dueDate: Date;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    isArchived: boolean;
    fileUrl: string | undefined;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    location: Location;
    practice: Practice;
    dentist: User;
    billingStatement: BillingStatement;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class BillingStatementModel implements IBillingStatementModel {
    id: string;
    practice: PracticeModelWithLocationName;
    location: LocationModel;
    locationBillingSettings: LocationBillingSettingsModel;
    dentist: ShortUserModel;
    code: string | undefined;
    paymentTerms: string | undefined;
    accountCode: string | undefined;
    amountDue: number;
    totalAmount: number;
    isOpen: boolean;
    status: InvoiceStatus;
    date: Date;
    createdAt: Date;
    isDisplayPatientInStatement: boolean;
    isHistorical: boolean;
    invoices: InvoiceModel[] | undefined;

    constructor(data?: IBillingStatementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.practice = _data["practice"] ? PracticeModelWithLocationName.fromJS(_data["practice"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.locationBillingSettings = _data["locationBillingSettings"] ? LocationBillingSettingsModel.fromJS(_data["locationBillingSettings"]) : <any>undefined;
            this.dentist = _data["dentist"] ? ShortUserModel.fromJS(_data["dentist"]) : <any>undefined;
            this.code = _data["code"];
            this.paymentTerms = _data["paymentTerms"];
            this.accountCode = _data["accountCode"];
            this.amountDue = _data["amountDue"];
            this.totalAmount = _data["totalAmount"];
            this.isOpen = _data["isOpen"];
            this.status = _data["status"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isDisplayPatientInStatement = _data["isDisplayPatientInStatement"];
            this.isHistorical = _data["isHistorical"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(InvoiceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingStatementModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationBillingSettings"] = this.locationBillingSettings ? this.locationBillingSettings.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["paymentTerms"] = this.paymentTerms;
        data["accountCode"] = this.accountCode;
        data["amountDue"] = this.amountDue;
        data["totalAmount"] = this.totalAmount;
        data["isOpen"] = this.isOpen;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDisplayPatientInStatement"] = this.isDisplayPatientInStatement;
        data["isHistorical"] = this.isHistorical;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data;
    }

    clone(): BillingStatementModel {
        const json = this.toJSON();
        let result = new BillingStatementModel();
        result.init(json);
        return result;
    }
}

export interface IBillingStatementModel {
    id: string;
    practice: PracticeModelWithLocationName;
    location: LocationModel;
    locationBillingSettings: LocationBillingSettingsModel;
    dentist: ShortUserModel;
    code: string | undefined;
    paymentTerms: string | undefined;
    accountCode: string | undefined;
    amountDue: number;
    totalAmount: number;
    isOpen: boolean;
    status: InvoiceStatus;
    date: Date;
    createdAt: Date;
    isDisplayPatientInStatement: boolean;
    isHistorical: boolean;
    invoices: InvoiceModel[] | undefined;
}

export class BillingStatementModelInvoicePagedListDto implements IBillingStatementModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: BillingStatementModel[] | undefined;
    totalCount: number;

    constructor(data?: IBillingStatementModelInvoicePagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillingStatementModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillingStatementModelInvoicePagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStatementModelInvoicePagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillingStatementModelInvoicePagedListDto {
        const json = this.toJSON();
        let result = new BillingStatementModelInvoicePagedListDto();
        result.init(json);
        return result;
    }
}

export interface IBillingStatementModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: BillingStatementModel[] | undefined;
    totalCount: number;
}

export class Carrier implements ICarrier {
    carrierId: string | undefined;
    carrierCode: string | undefined;
    accountNumber: string | undefined;
    requiresFundedAmount: boolean;
    balance: number;
    nickname: string | undefined;
    friendlyName: string | undefined;
    primary: boolean;
    hasMultiPackageSupportingServices: boolean;
    supportsLabelMessages: boolean;
    services: Service[] | undefined;
    packages: PackageType[] | undefined;

    constructor(data?: ICarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.carrierCode = _data["carrierCode"];
            this.accountNumber = _data["accountNumber"];
            this.requiresFundedAmount = _data["requiresFundedAmount"];
            this.balance = _data["balance"];
            this.nickname = _data["nickname"];
            this.friendlyName = _data["friendlyName"];
            this.primary = _data["primary"];
            this.hasMultiPackageSupportingServices = _data["hasMultiPackageSupportingServices"];
            this.supportsLabelMessages = _data["supportsLabelMessages"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages.push(PackageType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Carrier {
        data = typeof data === 'object' ? data : {};
        let result = new Carrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrierCode"] = this.carrierCode;
        data["accountNumber"] = this.accountNumber;
        data["requiresFundedAmount"] = this.requiresFundedAmount;
        data["balance"] = this.balance;
        data["nickname"] = this.nickname;
        data["friendlyName"] = this.friendlyName;
        data["primary"] = this.primary;
        data["hasMultiPackageSupportingServices"] = this.hasMultiPackageSupportingServices;
        data["supportsLabelMessages"] = this.supportsLabelMessages;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        return data;
    }

    clone(): Carrier {
        const json = this.toJSON();
        let result = new Carrier();
        result.init(json);
        return result;
    }
}

export interface ICarrier {
    carrierId: string | undefined;
    carrierCode: string | undefined;
    accountNumber: string | undefined;
    requiresFundedAmount: boolean;
    balance: number;
    nickname: string | undefined;
    friendlyName: string | undefined;
    primary: boolean;
    hasMultiPackageSupportingServices: boolean;
    supportsLabelMessages: boolean;
    services: Service[] | undefined;
    packages: PackageType[] | undefined;
}

export class Case3shapeModel implements ICase3shapeModel {
    id: string;
    version: number;
    patientName: string | undefined;
    patient: Patient3shapeModel;
    created: Date;
    updatedOn: Date;
    receivedOn: Date;
    creatorId: string;
    state: string | undefined;
    stateFlag: string | undefined;
    deliveryDate: Date;
    orderNo: any | undefined;
    operatorId: string;
    scanSource: string | undefined;
    application: string | undefined;
    threeShapeOrderNo: string | undefined;
    manufacturingProductionTag: any | undefined;
    model3D: any | undefined;
    actors: Actor3shapeModel[] | undefined;
    comments: Comment3shapeModel[] | undefined;
    modelElements: ModelElement3shapeModel[] | undefined;
    scans: Scan3shapeModel[] | undefined;
    designs: any[] | undefined;
    attachments: Attachment3shapeModel[] | undefined;
    href: string | undefined;
    links: Links3shapeModel;

    constructor(data?: ICase3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.version = _data["Version"];
            this.patientName = _data["PatientName"];
            this.patient = _data["Patient"] ? Patient3shapeModel.fromJS(_data["Patient"]) : <any>undefined;
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.updatedOn = _data["UpdatedOn"] ? new Date(_data["UpdatedOn"].toString()) : <any>undefined;
            this.receivedOn = _data["ReceivedOn"] ? new Date(_data["ReceivedOn"].toString()) : <any>undefined;
            this.creatorId = _data["CreatorId"];
            this.state = _data["State"];
            this.stateFlag = _data["StateFlag"];
            this.deliveryDate = _data["DeliveryDate"] ? new Date(_data["DeliveryDate"].toString()) : <any>undefined;
            this.orderNo = _data["OrderNo"];
            this.operatorId = _data["OperatorId"];
            this.scanSource = _data["ScanSource"];
            this.application = _data["Application"];
            this.threeShapeOrderNo = _data["ThreeShapeOrderNo"];
            this.manufacturingProductionTag = _data["ManufacturingProductionTag"];
            this.model3D = _data["Model3D"];
            if (Array.isArray(_data["Actors"])) {
                this.actors = [] as any;
                for (let item of _data["Actors"])
                    this.actors.push(Actor3shapeModel.fromJS(item));
            }
            if (Array.isArray(_data["Comments"])) {
                this.comments = [] as any;
                for (let item of _data["Comments"])
                    this.comments.push(Comment3shapeModel.fromJS(item));
            }
            if (Array.isArray(_data["ModelElements"])) {
                this.modelElements = [] as any;
                for (let item of _data["ModelElements"])
                    this.modelElements.push(ModelElement3shapeModel.fromJS(item));
            }
            if (Array.isArray(_data["Scans"])) {
                this.scans = [] as any;
                for (let item of _data["Scans"])
                    this.scans.push(Scan3shapeModel.fromJS(item));
            }
            if (Array.isArray(_data["Designs"])) {
                this.designs = [] as any;
                for (let item of _data["Designs"])
                    this.designs.push(item);
            }
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments.push(Attachment3shapeModel.fromJS(item));
            }
            this.href = _data["Href"];
            this.links = _data["Links"] ? Links3shapeModel.fromJS(_data["Links"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Case3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Case3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Version"] = this.version;
        data["PatientName"] = this.patientName;
        data["Patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["UpdatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["ReceivedOn"] = this.receivedOn ? this.receivedOn.toISOString() : <any>undefined;
        data["CreatorId"] = this.creatorId;
        data["State"] = this.state;
        data["StateFlag"] = this.stateFlag;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["OrderNo"] = this.orderNo;
        data["OperatorId"] = this.operatorId;
        data["ScanSource"] = this.scanSource;
        data["Application"] = this.application;
        data["ThreeShapeOrderNo"] = this.threeShapeOrderNo;
        data["ManufacturingProductionTag"] = this.manufacturingProductionTag;
        data["Model3D"] = this.model3D;
        if (Array.isArray(this.actors)) {
            data["Actors"] = [];
            for (let item of this.actors)
                data["Actors"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["Comments"] = [];
            for (let item of this.comments)
                data["Comments"].push(item.toJSON());
        }
        if (Array.isArray(this.modelElements)) {
            data["ModelElements"] = [];
            for (let item of this.modelElements)
                data["ModelElements"].push(item.toJSON());
        }
        if (Array.isArray(this.scans)) {
            data["Scans"] = [];
            for (let item of this.scans)
                data["Scans"].push(item.toJSON());
        }
        if (Array.isArray(this.designs)) {
            data["Designs"] = [];
            for (let item of this.designs)
                data["Designs"].push(item);
        }
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item.toJSON());
        }
        data["Href"] = this.href;
        data["Links"] = this.links ? this.links.toJSON() : <any>undefined;
        return data;
    }

    clone(): Case3shapeModel {
        const json = this.toJSON();
        let result = new Case3shapeModel();
        result.init(json);
        return result;
    }
}

export interface ICase3shapeModel {
    id: string;
    version: number;
    patientName: string | undefined;
    patient: Patient3shapeModel;
    created: Date;
    updatedOn: Date;
    receivedOn: Date;
    creatorId: string;
    state: string | undefined;
    stateFlag: string | undefined;
    deliveryDate: Date;
    orderNo: any | undefined;
    operatorId: string;
    scanSource: string | undefined;
    application: string | undefined;
    threeShapeOrderNo: string | undefined;
    manufacturingProductionTag: any | undefined;
    model3D: any | undefined;
    actors: Actor3shapeModel[] | undefined;
    comments: Comment3shapeModel[] | undefined;
    modelElements: ModelElement3shapeModel[] | undefined;
    scans: Scan3shapeModel[] | undefined;
    designs: any[] | undefined;
    attachments: Attachment3shapeModel[] | undefined;
    href: string | undefined;
    links: Links3shapeModel;
}

export class CasesResponce3shapeModel implements ICasesResponce3shapeModel {
    cases: Case3shapeModel[] | undefined;
    count: number;

    constructor(data?: ICasesResponce3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Cases"])) {
                this.cases = [] as any;
                for (let item of _data["Cases"])
                    this.cases.push(Case3shapeModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): CasesResponce3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CasesResponce3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cases)) {
            data["Cases"] = [];
            for (let item of this.cases)
                data["Cases"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): CasesResponce3shapeModel {
        const json = this.toJSON();
        let result = new CasesResponce3shapeModel();
        result.init(json);
        return result;
    }
}

export interface ICasesResponce3shapeModel {
    cases: Case3shapeModel[] | undefined;
    count: number;
}

export class CategoryModel implements ICategoryModel {
    id: number;
    locationId: string | undefined;
    name: string | undefined;
    code: string | undefined;
    logoUrl: string | undefined;
    isOrthodontic: boolean;
    isHide: boolean;
    type: CategoryType;
    subcategories: SubCategoryModel[] | undefined;
    productMaterials: MaterialModel[] | undefined;

    constructor(data?: ICategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.logoUrl = _data["logoUrl"];
            this.isOrthodontic = _data["isOrthodontic"];
            this.isHide = _data["isHide"];
            this.type = _data["type"];
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(SubCategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["productMaterials"])) {
                this.productMaterials = [] as any;
                for (let item of _data["productMaterials"])
                    this.productMaterials.push(MaterialModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["logoUrl"] = this.logoUrl;
        data["isOrthodontic"] = this.isOrthodontic;
        data["isHide"] = this.isHide;
        data["type"] = this.type;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        if (Array.isArray(this.productMaterials)) {
            data["productMaterials"] = [];
            for (let item of this.productMaterials)
                data["productMaterials"].push(item.toJSON());
        }
        return data;
    }

    clone(): CategoryModel {
        const json = this.toJSON();
        let result = new CategoryModel();
        result.init(json);
        return result;
    }
}

export interface ICategoryModel {
    id: number;
    locationId: string | undefined;
    name: string | undefined;
    code: string | undefined;
    logoUrl: string | undefined;
    isOrthodontic: boolean;
    isHide: boolean;
    type: CategoryType;
    subcategories: SubCategoryModel[] | undefined;
    productMaterials: MaterialModel[] | undefined;
}

export enum CategoryType {
    SingleProduct = <any>"SingleProduct",
    MultiProduct = <any>"MultiProduct",
}

export class ClientListModel implements IClientListModel {
    userId: string;
    userName: string | undefined;
    fullName: string | undefined;
    isActive: boolean;
    roleId: string;
    roleName: string | undefined;

    constructor(data?: IClientListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.isActive = _data["isActive"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): ClientListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["isActive"] = this.isActive;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }

    clone(): ClientListModel {
        const json = this.toJSON();
        let result = new ClientListModel();
        result.init(json);
        return result;
    }
}

export interface IClientListModel {
    userId: string;
    userName: string | undefined;
    fullName: string | undefined;
    isActive: boolean;
    roleId: string;
    roleName: string | undefined;
}

export class ClientListModelPagedListDto implements IClientListModelPagedListDto {
    items: ClientListModel[] | undefined;
    totalCount: number;

    constructor(data?: IClientListModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClientListModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ClientListModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientListModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ClientListModelPagedListDto {
        const json = this.toJSON();
        let result = new ClientListModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IClientListModelPagedListDto {
    items: ClientListModel[] | undefined;
    totalCount: number;
}

export class Code3ShapeModel implements ICode3ShapeModel {
    code: string | undefined;
    locationId: string;
    clientId: string | undefined;

    constructor(data?: ICode3ShapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.locationId = _data["locationId"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): Code3ShapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Code3ShapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["locationId"] = this.locationId;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): Code3ShapeModel {
        const json = this.toJSON();
        let result = new Code3ShapeModel();
        result.init(json);
        return result;
    }
}

export interface ICode3ShapeModel {
    code: string | undefined;
    locationId: string;
    clientId: string | undefined;
}

export class Comment3shapeModel implements IComment3shapeModel {
    id: string;
    shortComment: string | undefined;
    author: string | undefined;
    timestamp: Date;
    importance: string | undefined;
    moreTextAvailable: boolean;
    fullCommentTextHref: string | undefined;
    attachments: any[] | undefined;

    constructor(data?: IComment3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.shortComment = _data["ShortComment"];
            this.author = _data["Author"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.importance = _data["Importance"];
            this.moreTextAvailable = _data["MoreTextAvailable"];
            this.fullCommentTextHref = _data["FullCommentTextHref"];
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments.push(item);
            }
        }
    }

    static fromJS(data: any): Comment3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Comment3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ShortComment"] = this.shortComment;
        data["Author"] = this.author;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["Importance"] = this.importance;
        data["MoreTextAvailable"] = this.moreTextAvailable;
        data["FullCommentTextHref"] = this.fullCommentTextHref;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item);
        }
        return data;
    }

    clone(): Comment3shapeModel {
        const json = this.toJSON();
        let result = new Comment3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IComment3shapeModel {
    id: string;
    shortComment: string | undefined;
    author: string | undefined;
    timestamp: Date;
    importance: string | undefined;
    moreTextAvailable: boolean;
    fullCommentTextHref: string | undefined;
    attachments: any[] | undefined;
}

export class Company implements ICompany {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;
    locations: Location[] | undefined;
    assignedUsers: User[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.logoUrl = _data["logoUrl"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(User.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["logoUrl"] = this.logoUrl;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;
    locations: Location[] | undefined;
    assignedUsers: User[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class CompanyCreateModel implements ICompanyCreateModel {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;

    constructor(data?: ICompanyCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): CompanyCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["logoUrl"] = this.logoUrl;
        return data;
    }

    clone(): CompanyCreateModel {
        const json = this.toJSON();
        let result = new CompanyCreateModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyCreateModel {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;
}

export class CompanyModel implements ICompanyModel {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.phone = _data["phone"];
            this.logoUrl = _data["logoUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["phone"] = this.phone;
        data["logoUrl"] = this.logoUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): CompanyModel {
        const json = this.toJSON();
        let result = new CompanyModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyModel {
    id: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    phone: string | undefined;
    logoUrl: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class CompanyModelPagedListDto implements ICompanyModelPagedListDto {
    items: CompanyModel[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyModelPagedListDto {
        const json = this.toJSON();
        let result = new CompanyModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyModelPagedListDto {
    items: CompanyModel[] | undefined;
    totalCount: number;
}

export class ConsolidatedInvoice implements IConsolidatedInvoice {
    locationId: string;
    location: Location;
    code: string | undefined;
    doctorName: string | undefined;
    billingAddress: string | undefined;
    invoices: Invoice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IConsolidatedInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.code = _data["code"];
            this.doctorName = _data["doctorName"];
            this.billingAddress = _data["billingAddress"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ConsolidatedInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidatedInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["doctorName"] = this.doctorName;
        data["billingAddress"] = this.billingAddress;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ConsolidatedInvoice {
        const json = this.toJSON();
        let result = new ConsolidatedInvoice();
        result.init(json);
        return result;
    }
}

export interface IConsolidatedInvoice {
    locationId: string;
    location: Location;
    code: string | undefined;
    doctorName: string | undefined;
    billingAddress: string | undefined;
    invoices: Invoice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ConsolidatedInvoiceModel implements IConsolidatedInvoiceModel {
    id: string;
    locationId: string;
    location: LocationModel;
    status: InvoiceStatus;
    code: string | undefined;
    doctorName: string | undefined;
    billingAddress: string | undefined;
    amount: number;
    outstanding: number;
    invoices: InvoiceModel[] | undefined;
    createdAt: Date;

    constructor(data?: IConsolidatedInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.status = _data["status"];
            this.code = _data["code"];
            this.doctorName = _data["doctorName"];
            this.billingAddress = _data["billingAddress"];
            this.amount = _data["amount"];
            this.outstanding = _data["outstanding"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(InvoiceModel.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsolidatedInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidatedInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["code"] = this.code;
        data["doctorName"] = this.doctorName;
        data["billingAddress"] = this.billingAddress;
        data["amount"] = this.amount;
        data["outstanding"] = this.outstanding;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): ConsolidatedInvoiceModel {
        const json = this.toJSON();
        let result = new ConsolidatedInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface IConsolidatedInvoiceModel {
    id: string;
    locationId: string;
    location: LocationModel;
    status: InvoiceStatus;
    code: string | undefined;
    doctorName: string | undefined;
    billingAddress: string | undefined;
    amount: number;
    outstanding: number;
    invoices: InvoiceModel[] | undefined;
    createdAt: Date;
}

export class ConsolidatedInvoiceModelInvoicePagedListDto implements IConsolidatedInvoiceModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: ConsolidatedInvoiceModel[] | undefined;
    totalCount: number;

    constructor(data?: IConsolidatedInvoiceModelInvoicePagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ConsolidatedInvoiceModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ConsolidatedInvoiceModelInvoicePagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidatedInvoiceModelInvoicePagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ConsolidatedInvoiceModelInvoicePagedListDto {
        const json = this.toJSON();
        let result = new ConsolidatedInvoiceModelInvoicePagedListDto();
        result.init(json);
        return result;
    }
}

export interface IConsolidatedInvoiceModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: ConsolidatedInvoiceModel[] | undefined;
    totalCount: number;
}

export class CountryModel implements ICountryModel {
    id: string;
    countryName: string | undefined;
    countryCode: string | undefined;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): CountryModel {
        const json = this.toJSON();
        let result = new CountryModel();
        result.init(json);
        return result;
    }
}

export interface ICountryModel {
    id: string;
    countryName: string | undefined;
    countryCode: string | undefined;
}

export class CreateBillingStatementModel implements ICreateBillingStatementModel {
    practiceId: string;
    dentistId: string | undefined;
    date: Date;
    isSubmit: boolean | undefined;

    constructor(data?: ICreateBillingStatementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isSubmit = _data["isSubmit"];
        }
    }

    static fromJS(data: any): CreateBillingStatementModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillingStatementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isSubmit"] = this.isSubmit;
        return data;
    }

    clone(): CreateBillingStatementModel {
        const json = this.toJSON();
        let result = new CreateBillingStatementModel();
        result.init(json);
        return result;
    }
}

export interface ICreateBillingStatementModel {
    practiceId: string;
    dentistId: string | undefined;
    date: Date;
    isSubmit: boolean | undefined;
}

export class CreateCategoryModel implements ICreateCategoryModel {
    locationId: string;
    name: string | undefined;
    logoUrl: string | undefined;
    isOrthodontic: boolean;
    type: CategoryType;
    subcategories: CreateSubCategoryModel[] | undefined;
    productMaterials: CreateMaterialModel[] | undefined;

    constructor(data?: ICreateCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.isOrthodontic = _data["isOrthodontic"];
            this.type = _data["type"];
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(CreateSubCategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["productMaterials"])) {
                this.productMaterials = [] as any;
                for (let item of _data["productMaterials"])
                    this.productMaterials.push(CreateMaterialModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["isOrthodontic"] = this.isOrthodontic;
        data["type"] = this.type;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        if (Array.isArray(this.productMaterials)) {
            data["productMaterials"] = [];
            for (let item of this.productMaterials)
                data["productMaterials"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateCategoryModel {
        const json = this.toJSON();
        let result = new CreateCategoryModel();
        result.init(json);
        return result;
    }
}

export interface ICreateCategoryModel {
    locationId: string;
    name: string | undefined;
    logoUrl: string | undefined;
    isOrthodontic: boolean;
    type: CategoryType;
    subcategories: CreateSubCategoryModel[] | undefined;
    productMaterials: CreateMaterialModel[] | undefined;
}

export class CreateConsolidatedInvoiceForBillingOwnerModel implements ICreateConsolidatedInvoiceForBillingOwnerModel {
    locationId: string;
    userId: string;
    billingAddress: string | undefined;
    dateStart: Date;
    dateEnd: Date;

    constructor(data?: ICreateConsolidatedInvoiceForBillingOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.userId = _data["userId"];
            this.billingAddress = _data["billingAddress"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateConsolidatedInvoiceForBillingOwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsolidatedInvoiceForBillingOwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["userId"] = this.userId;
        data["billingAddress"] = this.billingAddress;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateConsolidatedInvoiceForBillingOwnerModel {
        const json = this.toJSON();
        let result = new CreateConsolidatedInvoiceForBillingOwnerModel();
        result.init(json);
        return result;
    }
}

export interface ICreateConsolidatedInvoiceForBillingOwnerModel {
    locationId: string;
    userId: string;
    billingAddress: string | undefined;
    dateStart: Date;
    dateEnd: Date;
}

export class CreateConsolidatedInvoiceModel implements ICreateConsolidatedInvoiceModel {
    invoiceIds: string[] | undefined;
    locationId: string;
    doctorName: string | undefined;
    billingAddress: string | undefined;

    constructor(data?: ICreateConsolidatedInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds.push(item);
            }
            this.locationId = _data["locationId"];
            this.doctorName = _data["doctorName"];
            this.billingAddress = _data["billingAddress"];
        }
    }

    static fromJS(data: any): CreateConsolidatedInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsolidatedInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        data["locationId"] = this.locationId;
        data["doctorName"] = this.doctorName;
        data["billingAddress"] = this.billingAddress;
        return data;
    }

    clone(): CreateConsolidatedInvoiceModel {
        const json = this.toJSON();
        let result = new CreateConsolidatedInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface ICreateConsolidatedInvoiceModel {
    invoiceIds: string[] | undefined;
    locationId: string;
    doctorName: string | undefined;
    billingAddress: string | undefined;
}

export class CreateCustomStatementItemModel implements ICreateCustomStatementItemModel {
    statementId: string;
    name: string | undefined;
    paymentAmount: number;

    constructor(data?: ICreateCustomStatementItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementId = _data["statementId"];
            this.name = _data["name"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): CreateCustomStatementItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomStatementItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementId"] = this.statementId;
        data["name"] = this.name;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }

    clone(): CreateCustomStatementItemModel {
        const json = this.toJSON();
        let result = new CreateCustomStatementItemModel();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomStatementItemModel {
    statementId: string;
    name: string | undefined;
    paymentAmount: number;
}

export class CreateLocationExportGroupModel implements ICreateLocationExportGroupModel {
    locationId: string;
    name: string | undefined;

    constructor(data?: ICreateLocationExportGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateLocationExportGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationExportGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateLocationExportGroupModel {
        const json = this.toJSON();
        let result = new CreateLocationExportGroupModel();
        result.init(json);
        return result;
    }
}

export interface ICreateLocationExportGroupModel {
    locationId: string;
    name: string | undefined;
}

export class CreateMaterialModel implements ICreateMaterialModel {
    name: string | undefined;

    constructor(data?: ICreateMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateMaterialModel {
        const json = this.toJSON();
        let result = new CreateMaterialModel();
        result.init(json);
        return result;
    }
}

export interface ICreateMaterialModel {
    name: string | undefined;
}

export class CreateOrder3Shape implements ICreateOrder3Shape {
    case3Shape: Case3shapeModel;
    order: Order3ShapeModel;

    constructor(data?: ICreateOrder3Shape) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.case3Shape = _data["case3Shape"] ? Case3shapeModel.fromJS(_data["case3Shape"]) : <any>undefined;
            this.order = _data["order"] ? Order3ShapeModel.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrder3Shape {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrder3Shape();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["case3Shape"] = this.case3Shape ? this.case3Shape.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrder3Shape {
        const json = this.toJSON();
        let result = new CreateOrder3Shape();
        result.init(json);
        return result;
    }
}

export interface ICreateOrder3Shape {
    case3Shape: Case3shapeModel;
    order: Order3ShapeModel;
}

export class CreateShippingLabelsRequest implements ICreateShippingLabelsRequest {
    isSingleLabel: boolean;
    orderIds: string[] | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;

    constructor(data?: ICreateShippingLabelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSingleLabel = _data["isSingleLabel"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.carrierCode = _data["carrierCode"];
            this.serviceCode = _data["serviceCode"];
        }
    }

    static fromJS(data: any): CreateShippingLabelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateShippingLabelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSingleLabel"] = this.isSingleLabel;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["carrierCode"] = this.carrierCode;
        data["serviceCode"] = this.serviceCode;
        return data;
    }

    clone(): CreateShippingLabelsRequest {
        const json = this.toJSON();
        let result = new CreateShippingLabelsRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateShippingLabelsRequest {
    isSingleLabel: boolean;
    orderIds: string[] | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
}

export class CreateShippingLabelsResponse implements ICreateShippingLabelsResponse {
    shipmentLabels: ShipmentLabelResponse[] | undefined;
    invoiceResponse: ManualInvoiceResponseModel;

    constructor(data?: ICreateShippingLabelsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shipmentLabels"])) {
                this.shipmentLabels = [] as any;
                for (let item of _data["shipmentLabels"])
                    this.shipmentLabels.push(ShipmentLabelResponse.fromJS(item));
            }
            this.invoiceResponse = _data["invoiceResponse"] ? ManualInvoiceResponseModel.fromJS(_data["invoiceResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateShippingLabelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateShippingLabelsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shipmentLabels)) {
            data["shipmentLabels"] = [];
            for (let item of this.shipmentLabels)
                data["shipmentLabels"].push(item.toJSON());
        }
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateShippingLabelsResponse {
        const json = this.toJSON();
        let result = new CreateShippingLabelsResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateShippingLabelsResponse {
    shipmentLabels: ShipmentLabelResponse[] | undefined;
    invoiceResponse: ManualInvoiceResponseModel;
}

export class CreateStageModel implements ICreateStageModel {
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;

    constructor(data?: ICreateStageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stagesCategoryId = _data["stagesCategoryId"];
            this.name = _data["name"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): CreateStageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stagesCategoryId"] = this.stagesCategoryId;
        data["name"] = this.name;
        data["orderIndex"] = this.orderIndex;
        return data;
    }

    clone(): CreateStageModel {
        const json = this.toJSON();
        let result = new CreateStageModel();
        result.init(json);
        return result;
    }
}

export interface ICreateStageModel {
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;
}

export class CreateStatementModel implements ICreateStatementModel {
    practiceId: string;
    dentistId: string;
    dateStart: Date;
    dateEnd: Date;
    isSubmit: boolean | undefined;

    constructor(data?: ICreateStatementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.isSubmit = _data["isSubmit"];
        }
    }

    static fromJS(data: any): CreateStatementModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["isSubmit"] = this.isSubmit;
        return data;
    }

    clone(): CreateStatementModel {
        const json = this.toJSON();
        let result = new CreateStatementModel();
        result.init(json);
        return result;
    }
}

export interface ICreateStatementModel {
    practiceId: string;
    dentistId: string;
    dateStart: Date;
    dateEnd: Date;
    isSubmit: boolean | undefined;
}

export class CreateSubCategoryModel implements ICreateSubCategoryModel {
    name: string | undefined;
    logoUrl: string | undefined;
    type: SubCategoryType;

    constructor(data?: ICreateSubCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateSubCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        data["type"] = this.type;
        return data;
    }

    clone(): CreateSubCategoryModel {
        const json = this.toJSON();
        let result = new CreateSubCategoryModel();
        result.init(json);
        return result;
    }
}

export interface ICreateSubCategoryModel {
    name: string | undefined;
    logoUrl: string | undefined;
    type: SubCategoryType;
}

export class CreateWorkbenchRoomModel implements ICreateWorkbenchRoomModel {
    name: string | undefined;
    locationId: string;

    constructor(data?: ICreateWorkbenchRoomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): CreateWorkbenchRoomModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkbenchRoomModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): CreateWorkbenchRoomModel {
        const json = this.toJSON();
        let result = new CreateWorkbenchRoomModel();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkbenchRoomModel {
    name: string | undefined;
    locationId: string;
}

export class CreateWorkbenchRoomTaskModel implements ICreateWorkbenchRoomTaskModel {
    name: string | undefined;
    locationId: string;
    workbenchRoomId: string;
    defaultUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;

    constructor(data?: ICreateWorkbenchRoomTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.workbenchRoomId = _data["workbenchRoomId"];
            this.defaultUserId = _data["defaultUserId"];
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): CreateWorkbenchRoomTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkbenchRoomTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["workbenchRoomId"] = this.workbenchRoomId;
        data["defaultUserId"] = this.defaultUserId;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        return data;
    }

    clone(): CreateWorkbenchRoomTaskModel {
        const json = this.toJSON();
        let result = new CreateWorkbenchRoomTaskModel();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkbenchRoomTaskModel {
    name: string | undefined;
    locationId: string;
    workbenchRoomId: string;
    defaultUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;
}

export class CreateWorkbenchTaskModel implements ICreateWorkbenchTaskModel {
    locationId: string;
    orderId: string;
    workbenchRoomTaskIds: string[] | undefined;
    assignedUserId: string | undefined;
    commission: number | undefined;

    constructor(data?: ICreateWorkbenchTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["workbenchRoomTaskIds"])) {
                this.workbenchRoomTaskIds = [] as any;
                for (let item of _data["workbenchRoomTaskIds"])
                    this.workbenchRoomTaskIds.push(item);
            }
            this.assignedUserId = _data["assignedUserId"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): CreateWorkbenchTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkbenchTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.workbenchRoomTaskIds)) {
            data["workbenchRoomTaskIds"] = [];
            for (let item of this.workbenchRoomTaskIds)
                data["workbenchRoomTaskIds"].push(item);
        }
        data["assignedUserId"] = this.assignedUserId;
        data["commission"] = this.commission;
        return data;
    }

    clone(): CreateWorkbenchTaskModel {
        const json = this.toJSON();
        let result = new CreateWorkbenchTaskModel();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkbenchTaskModel {
    locationId: string;
    orderId: string;
    workbenchRoomTaskIds: string[] | undefined;
    assignedUserId: string | undefined;
    commission: number | undefined;
}

export class CreateWorkbenchTaskPrototypeModel implements ICreateWorkbenchTaskPrototypeModel {
    workbenchWorkflowId: string;
    workbenchRoomTaskId: string;
    assignedUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;

    constructor(data?: ICreateWorkbenchTaskPrototypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbenchWorkflowId = _data["workbenchWorkflowId"];
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.assignedUserId = _data["assignedUserId"];
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): CreateWorkbenchTaskPrototypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkbenchTaskPrototypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbenchWorkflowId"] = this.workbenchWorkflowId;
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["assignedUserId"] = this.assignedUserId;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        return data;
    }

    clone(): CreateWorkbenchTaskPrototypeModel {
        const json = this.toJSON();
        let result = new CreateWorkbenchTaskPrototypeModel();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkbenchTaskPrototypeModel {
    workbenchWorkflowId: string;
    workbenchRoomTaskId: string;
    assignedUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;
}

export class CreateWorkflowModel implements ICreateWorkflowModel {
    cloneTasksFromWorkflowId: string | undefined;
    assignTo: string | undefined;
    runImmediately: boolean | undefined;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;

    constructor(data?: ICreateWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cloneTasksFromWorkflowId = _data["cloneTasksFromWorkflowId"];
            this.assignTo = _data["assignTo"];
            this.runImmediately = _data["runImmediately"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.rules = _data["rules"] ? PredicateGroup.fromJS(_data["rules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cloneTasksFromWorkflowId"] = this.cloneTasksFromWorkflowId;
        data["assignTo"] = this.assignTo;
        data["runImmediately"] = this.runImmediately;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["rules"] = this.rules ? this.rules.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateWorkflowModel {
        const json = this.toJSON();
        let result = new CreateWorkflowModel();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkflowModel {
    cloneTasksFromWorkflowId: string | undefined;
    assignTo: string | undefined;
    runImmediately: boolean | undefined;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;
}

export class CurrencyModel implements ICurrencyModel {
    id: string;
    countryName: string | undefined;
    countryCode: string | undefined;
    currencyName: string | undefined;
    currencyCode: string | undefined;
    currencySymbol: string | undefined;

    constructor(data?: ICurrencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
            this.currencyName = _data["currencyName"];
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
        }
    }

    static fromJS(data: any): CurrencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        data["currencyName"] = this.currencyName;
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        return data;
    }

    clone(): CurrencyModel {
        const json = this.toJSON();
        let result = new CurrencyModel();
        result.init(json);
        return result;
    }
}

export interface ICurrencyModel {
    id: string;
    countryName: string | undefined;
    countryCode: string | undefined;
    currencyName: string | undefined;
    currencyCode: string | undefined;
    currencySymbol: string | undefined;
}

export class CustomPredicate implements ICustomPredicate {
    field: string | undefined;
    fieldComparisonOperator: FieldComparisonOperator;
    value: string | undefined;
    negative: boolean;

    constructor(data?: ICustomPredicate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.fieldComparisonOperator = _data["fieldComparisonOperator"];
            this.value = _data["value"];
            this.negative = _data["negative"];
        }
    }

    static fromJS(data: any): CustomPredicate {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPredicate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["fieldComparisonOperator"] = this.fieldComparisonOperator;
        data["value"] = this.value;
        data["negative"] = this.negative;
        return data;
    }

    clone(): CustomPredicate {
        const json = this.toJSON();
        let result = new CustomPredicate();
        result.init(json);
        return result;
    }
}

export interface ICustomPredicate {
    field: string | undefined;
    fieldComparisonOperator: FieldComparisonOperator;
    value: string | undefined;
    negative: boolean;
}

export class DashboardOverviewItem implements IDashboardOverviewItem {
    date: Date;
    countOfOrder: number;
    totalValue: number;

    constructor(data?: IDashboardOverviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.countOfOrder = _data["countOfOrder"];
            this.totalValue = _data["totalValue"];
        }
    }

    static fromJS(data: any): DashboardOverviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["countOfOrder"] = this.countOfOrder;
        data["totalValue"] = this.totalValue;
        return data;
    }

    clone(): DashboardOverviewItem {
        const json = this.toJSON();
        let result = new DashboardOverviewItem();
        result.init(json);
        return result;
    }
}

export interface IDashboardOverviewItem {
    date: Date;
    countOfOrder: number;
    totalValue: number;
}

export class DashboardOverviewResponceModel implements IDashboardOverviewResponceModel {
    totalCountOfOrder: number;
    totalValue: number;
    avarageValue: number;
    items: DashboardOverviewItem[] | undefined;

    constructor(data?: IDashboardOverviewResponceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCountOfOrder = _data["totalCountOfOrder"];
            this.totalValue = _data["totalValue"];
            this.avarageValue = _data["avarageValue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DashboardOverviewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOverviewResponceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewResponceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCountOfOrder"] = this.totalCountOfOrder;
        data["totalValue"] = this.totalValue;
        data["avarageValue"] = this.avarageValue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardOverviewResponceModel {
        const json = this.toJSON();
        let result = new DashboardOverviewResponceModel();
        result.init(json);
        return result;
    }
}

export interface IDashboardOverviewResponceModel {
    totalCountOfOrder: number;
    totalValue: number;
    avarageValue: number;
    items: DashboardOverviewItem[] | undefined;
}

export class DashboardResponse implements IDashboardResponse {
    url: string | undefined;

    constructor(data?: IDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): DashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): DashboardResponse {
        const json = this.toJSON();
        let result = new DashboardResponse();
        result.init(json);
        return result;
    }
}

export interface IDashboardResponse {
    url: string | undefined;
}

export class DashboardRevenueItem implements IDashboardRevenueItem {
    totalCountOfProducts: number;
    totalValue: number;
    date: Date;
    categories: DashboardRevenueItemCategory[] | undefined;

    constructor(data?: IDashboardRevenueItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCountOfProducts = _data["totalCountOfProducts"];
            this.totalValue = _data["totalValue"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(DashboardRevenueItemCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardRevenueItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardRevenueItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCountOfProducts"] = this.totalCountOfProducts;
        data["totalValue"] = this.totalValue;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardRevenueItem {
        const json = this.toJSON();
        let result = new DashboardRevenueItem();
        result.init(json);
        return result;
    }
}

export interface IDashboardRevenueItem {
    totalCountOfProducts: number;
    totalValue: number;
    date: Date;
    categories: DashboardRevenueItemCategory[] | undefined;
}

export class DashboardRevenueItemCategory implements IDashboardRevenueItemCategory {
    name: string | undefined;
    count: number;
    totalValue: number;

    constructor(data?: IDashboardRevenueItemCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
            this.totalValue = _data["totalValue"];
        }
    }

    static fromJS(data: any): DashboardRevenueItemCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardRevenueItemCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        data["totalValue"] = this.totalValue;
        return data;
    }

    clone(): DashboardRevenueItemCategory {
        const json = this.toJSON();
        let result = new DashboardRevenueItemCategory();
        result.init(json);
        return result;
    }
}

export interface IDashboardRevenueItemCategory {
    name: string | undefined;
    count: number;
    totalValue: number;
}

export class DashboardRevenueResponceModel implements IDashboardRevenueResponceModel {
    allCount: number;
    allPrice: number;
    submittedCount: number;
    submittedPrice: number;
    invoicedCount: number;
    invoicedPrice: number;
    itemsAll: DashboardRevenueItem[] | undefined;
    submitted: DashboardRevenueItem[] | undefined;
    invoiced: DashboardRevenueItem[] | undefined;

    constructor(data?: IDashboardRevenueResponceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allCount = _data["allCount"];
            this.allPrice = _data["allPrice"];
            this.submittedCount = _data["submittedCount"];
            this.submittedPrice = _data["submittedPrice"];
            this.invoicedCount = _data["invoicedCount"];
            this.invoicedPrice = _data["invoicedPrice"];
            if (Array.isArray(_data["itemsAll"])) {
                this.itemsAll = [] as any;
                for (let item of _data["itemsAll"])
                    this.itemsAll.push(DashboardRevenueItem.fromJS(item));
            }
            if (Array.isArray(_data["submitted"])) {
                this.submitted = [] as any;
                for (let item of _data["submitted"])
                    this.submitted.push(DashboardRevenueItem.fromJS(item));
            }
            if (Array.isArray(_data["invoiced"])) {
                this.invoiced = [] as any;
                for (let item of _data["invoiced"])
                    this.invoiced.push(DashboardRevenueItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardRevenueResponceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardRevenueResponceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allCount"] = this.allCount;
        data["allPrice"] = this.allPrice;
        data["submittedCount"] = this.submittedCount;
        data["submittedPrice"] = this.submittedPrice;
        data["invoicedCount"] = this.invoicedCount;
        data["invoicedPrice"] = this.invoicedPrice;
        if (Array.isArray(this.itemsAll)) {
            data["itemsAll"] = [];
            for (let item of this.itemsAll)
                data["itemsAll"].push(item.toJSON());
        }
        if (Array.isArray(this.submitted)) {
            data["submitted"] = [];
            for (let item of this.submitted)
                data["submitted"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiced)) {
            data["invoiced"] = [];
            for (let item of this.invoiced)
                data["invoiced"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardRevenueResponceModel {
        const json = this.toJSON();
        let result = new DashboardRevenueResponceModel();
        result.init(json);
        return result;
    }
}

export interface IDashboardRevenueResponceModel {
    allCount: number;
    allPrice: number;
    submittedCount: number;
    submittedPrice: number;
    invoicedCount: number;
    invoicedPrice: number;
    itemsAll: DashboardRevenueItem[] | undefined;
    submitted: DashboardRevenueItem[] | undefined;
    invoiced: DashboardRevenueItem[] | undefined;
}

export class DateFormatModel implements IDateFormatModel {
    id: string;
    formatName: string | undefined;
    formatPattern: string | undefined;
    example: string | undefined;
    countryCode: string | undefined;

    constructor(data?: IDateFormatModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formatName = _data["formatName"];
            this.formatPattern = _data["formatPattern"];
            this.example = _data["example"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): DateFormatModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormatModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formatName"] = this.formatName;
        data["formatPattern"] = this.formatPattern;
        data["example"] = this.example;
        data["countryCode"] = this.countryCode;
        return data;
    }

    clone(): DateFormatModel {
        const json = this.toJSON();
        let result = new DateFormatModel();
        result.init(json);
        return result;
    }
}

export interface IDateFormatModel {
    id: string;
    formatName: string | undefined;
    formatPattern: string | undefined;
    example: string | undefined;
    countryCode: string | undefined;
}

export class DeadlineDateChangeRequestModel implements IDeadlineDateChangeRequestModel {
    orderId: string;
    date: Date;

    constructor(data?: IDeadlineDateChangeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeadlineDateChangeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeadlineDateChangeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeadlineDateChangeRequestModel {
        const json = this.toJSON();
        let result = new DeadlineDateChangeRequestModel();
        result.init(json);
        return result;
    }
}

export interface IDeadlineDateChangeRequestModel {
    orderId: string;
    date: Date;
}

export class DeleteLogoModel implements IDeleteLogoModel {
    locationId: string;
    logoUrl: string | undefined;

    constructor(data?: IDeleteLogoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): DeleteLogoModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLogoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["logoUrl"] = this.logoUrl;
        return data;
    }

    clone(): DeleteLogoModel {
        const json = this.toJSON();
        let result = new DeleteLogoModel();
        result.init(json);
        return result;
    }
}

export interface IDeleteLogoModel {
    locationId: string;
    logoUrl: string | undefined;
}

export class DentistDetailModel implements IDentistDetailModel {
    id: string;
    dentistName: string | undefined;
    userName: string | undefined;
    companyName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    registeredDate: Date;
    dateFormat: string | undefined;
    practices: PracticeModelWithLocationName[] | undefined;
    orders: OrderModel[] | undefined;

    constructor(data?: IDentistDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dentistName = _data["dentistName"];
            this.userName = _data["userName"];
            this.companyName = _data["companyName"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(PracticeModelWithLocationName.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DentistDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new DentistDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dentistName"] = this.dentistName;
        data["userName"] = this.userName;
        data["companyName"] = this.companyName;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): DentistDetailModel {
        const json = this.toJSON();
        let result = new DentistDetailModel();
        result.init(json);
        return result;
    }
}

export interface IDentistDetailModel {
    id: string;
    dentistName: string | undefined;
    userName: string | undefined;
    companyName: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    registeredDate: Date;
    dateFormat: string | undefined;
    practices: PracticeModelWithLocationName[] | undefined;
    orders: OrderModel[] | undefined;
}

export class DentistModel implements IDentistModel {
    id: string;
    dentistName: string | undefined;
    userName: string | undefined;
    companyName: string | undefined;
    locationsName: string | undefined;
    isActive: boolean;
    registeredDate: Date;
    roleId: string;

    constructor(data?: IDentistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dentistName = _data["dentistName"];
            this.userName = _data["userName"];
            this.companyName = _data["companyName"];
            this.locationsName = _data["locationsName"];
            this.isActive = _data["isActive"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): DentistModel {
        data = typeof data === 'object' ? data : {};
        let result = new DentistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dentistName"] = this.dentistName;
        data["userName"] = this.userName;
        data["companyName"] = this.companyName;
        data["locationsName"] = this.locationsName;
        data["isActive"] = this.isActive;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): DentistModel {
        const json = this.toJSON();
        let result = new DentistModel();
        result.init(json);
        return result;
    }
}

export interface IDentistModel {
    id: string;
    dentistName: string | undefined;
    userName: string | undefined;
    companyName: string | undefined;
    locationsName: string | undefined;
    isActive: boolean;
    registeredDate: Date;
    roleId: string;
}

export class DentistModelPagedListDto implements IDentistModelPagedListDto {
    items: DentistModel[] | undefined;
    totalCount: number;

    constructor(data?: IDentistModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DentistModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DentistModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DentistModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DentistModelPagedListDto {
        const json = this.toJSON();
        let result = new DentistModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IDentistModelPagedListDto {
    items: DentistModel[] | undefined;
    totalCount: number;
}

export class DentistSearchModel implements IDentistSearchModel {
    page: number;
    take: number;
    searchString: string | undefined;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceIds: string[] | undefined;
    dentistIds: string[] | undefined;
    userIds: string[] | undefined;

    constructor(data?: IDentistSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.searchString = _data["searchString"];
            this.companyId = _data["companyId"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
            if (Array.isArray(_data["dentistIds"])) {
                this.dentistIds = [] as any;
                for (let item of _data["dentistIds"])
                    this.dentistIds.push(item);
            }
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
        }
    }

    static fromJS(data: any): DentistSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new DentistSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["searchString"] = this.searchString;
        data["companyId"] = this.companyId;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        if (Array.isArray(this.dentistIds)) {
            data["dentistIds"] = [];
            for (let item of this.dentistIds)
                data["dentistIds"].push(item);
        }
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): DentistSearchModel {
        const json = this.toJSON();
        let result = new DentistSearchModel();
        result.init(json);
        return result;
    }
}

export interface IDentistSearchModel {
    page: number;
    take: number;
    searchString: string | undefined;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceIds: string[] | undefined;
    dentistIds: string[] | undefined;
    userIds: string[] | undefined;
}

export class DentistWithPracticeModel implements IDentistWithPracticeModel {
    id: string;
    practiceId: string;
    practice: PracticeWithUsertModel;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IDentistWithPracticeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.practiceId = _data["practiceId"];
            this.practice = _data["practice"] ? PracticeWithUsertModel.fromJS(_data["practice"]) : <any>undefined;
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): DentistWithPracticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DentistWithPracticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["practiceId"] = this.practiceId;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): DentistWithPracticeModel {
        const json = this.toJSON();
        let result = new DentistWithPracticeModel();
        result.init(json);
        return result;
    }
}

export interface IDentistWithPracticeModel {
    id: string;
    practiceId: string;
    practice: PracticeWithUsertModel;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
}

export class Dimensions implements IDimensions {
    unit: string | undefined;
    length: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IDimensions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"];
            this.length = _data["length"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): Dimensions {
        data = typeof data === 'object' ? data : {};
        let result = new Dimensions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["length"] = this.length;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }

    clone(): Dimensions {
        const json = this.toJSON();
        let result = new Dimensions();
        result.init(json);
        return result;
    }
}

export interface IDimensions {
    unit: string | undefined;
    length: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class DoctorListModel implements IDoctorListModel {
    id: string;
    name: string | undefined;
    practices: string | undefined;
    isRegistered: boolean;

    constructor(data?: IDoctorListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.practices = _data["practices"];
            this.isRegistered = _data["isRegistered"];
        }
    }

    static fromJS(data: any): DoctorListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["practices"] = this.practices;
        data["isRegistered"] = this.isRegistered;
        return data;
    }

    clone(): DoctorListModel {
        const json = this.toJSON();
        let result = new DoctorListModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorListModel {
    id: string;
    name: string | undefined;
    practices: string | undefined;
    isRegistered: boolean;
}

export class DoctorListModelPagedListDto implements IDoctorListModelPagedListDto {
    items: DoctorListModel[] | undefined;
    totalCount: number;

    constructor(data?: IDoctorListModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DoctorListModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DoctorListModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorListModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DoctorListModelPagedListDto {
        const json = this.toJSON();
        let result = new DoctorListModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorListModelPagedListDto {
    items: DoctorListModel[] | undefined;
    totalCount: number;
}

export class DoctorPageOrdersRequestModel implements IDoctorPageOrdersRequestModel {
    page: number;
    take: number;
    userId: string;
    practiceIds: string[] | undefined;
    doctorIds: string[] | undefined;
    statusIds: number[] | undefined;
    tags: string[] | undefined;

    constructor(data?: IDoctorPageOrdersRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
            if (Array.isArray(_data["doctorIds"])) {
                this.doctorIds = [] as any;
                for (let item of _data["doctorIds"])
                    this.doctorIds.push(item);
            }
            if (Array.isArray(_data["statusIds"])) {
                this.statusIds = [] as any;
                for (let item of _data["statusIds"])
                    this.statusIds.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
        }
    }

    static fromJS(data: any): DoctorPageOrdersRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPageOrdersRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["userId"] = this.userId;
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        if (Array.isArray(this.doctorIds)) {
            data["doctorIds"] = [];
            for (let item of this.doctorIds)
                data["doctorIds"].push(item);
        }
        if (Array.isArray(this.statusIds)) {
            data["statusIds"] = [];
            for (let item of this.statusIds)
                data["statusIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): DoctorPageOrdersRequestModel {
        const json = this.toJSON();
        let result = new DoctorPageOrdersRequestModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorPageOrdersRequestModel {
    page: number;
    take: number;
    userId: string;
    practiceIds: string[] | undefined;
    doctorIds: string[] | undefined;
    statusIds: number[] | undefined;
    tags: string[] | undefined;
}

export class DoctorPaymentsModel implements IDoctorPaymentsModel {
    current: number[] | undefined;
    statements: number[] | undefined;
    total: number[] | undefined;
    month: number[] | undefined;
    currencyCode: string | undefined;

    constructor(data?: IDoctorPaymentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["current"])) {
                this.current = [] as any;
                for (let item of _data["current"])
                    this.current.push(item);
            }
            if (Array.isArray(_data["statements"])) {
                this.statements = [] as any;
                for (let item of _data["statements"])
                    this.statements.push(item);
            }
            if (Array.isArray(_data["total"])) {
                this.total = [] as any;
                for (let item of _data["total"])
                    this.total.push(item);
            }
            if (Array.isArray(_data["month"])) {
                this.month = [] as any;
                for (let item of _data["month"])
                    this.month.push(item);
            }
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): DoctorPaymentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPaymentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.current)) {
            data["current"] = [];
            for (let item of this.current)
                data["current"].push(item);
        }
        if (Array.isArray(this.statements)) {
            data["statements"] = [];
            for (let item of this.statements)
                data["statements"].push(item);
        }
        if (Array.isArray(this.total)) {
            data["total"] = [];
            for (let item of this.total)
                data["total"].push(item);
        }
        if (Array.isArray(this.month)) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        data["currencyCode"] = this.currencyCode;
        return data;
    }

    clone(): DoctorPaymentsModel {
        const json = this.toJSON();
        let result = new DoctorPaymentsModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorPaymentsModel {
    current: number[] | undefined;
    statements: number[] | undefined;
    total: number[] | undefined;
    month: number[] | undefined;
    currencyCode: string | undefined;
}

export class DoctorPracticeModel implements IDoctorPracticeModel {
    practiceId: string;
    practiceName: string | undefined;
    doctorId: string;
    doctorName: string | undefined;

    constructor(data?: IDoctorPracticeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.practiceName = _data["practiceName"];
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
        }
    }

    static fromJS(data: any): DoctorPracticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPracticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["practiceName"] = this.practiceName;
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        return data;
    }

    clone(): DoctorPracticeModel {
        const json = this.toJSON();
        let result = new DoctorPracticeModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorPracticeModel {
    practiceId: string;
    practiceName: string | undefined;
    doctorId: string;
    doctorName: string | undefined;
}

export class DoctorProfileModel implements IDoctorProfileModel {
    id: string;
    fullName: string | undefined;
    phone: string | undefined;
    phoneNumberCountryCode: string | undefined;
    email: string | undefined;
    username: string | undefined;
    dentalRegistrationNumber: string | undefined;
    registeredDate: Date;
    companyName: string | undefined;
    companyId: string;
    roleName: string | undefined;
    accountCode: string | undefined;
    isArchived: boolean;
    isRegistered: boolean;
    financialNote: string | undefined;
    patients: DoctorProfilePatient[] | undefined;
    practicesRoles: DoctorProfilePracticesRoles[] | undefined;
    notes: InternalNoteModel[] | undefined;

    constructor(data?: IDoctorProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.phoneNumberCountryCode = _data["phoneNumberCountryCode"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.roleName = _data["roleName"];
            this.accountCode = _data["accountCode"];
            this.isArchived = _data["isArchived"];
            this.isRegistered = _data["isRegistered"];
            this.financialNote = _data["financialNote"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(DoctorProfilePatient.fromJS(item));
            }
            if (Array.isArray(_data["practicesRoles"])) {
                this.practicesRoles = [] as any;
                for (let item of _data["practicesRoles"])
                    this.practicesRoles.push(DoctorProfilePracticesRoles.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(InternalNoteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoctorProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["phoneNumberCountryCode"] = this.phoneNumberCountryCode;
        data["email"] = this.email;
        data["username"] = this.username;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["roleName"] = this.roleName;
        data["accountCode"] = this.accountCode;
        data["isArchived"] = this.isArchived;
        data["isRegistered"] = this.isRegistered;
        data["financialNote"] = this.financialNote;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.practicesRoles)) {
            data["practicesRoles"] = [];
            for (let item of this.practicesRoles)
                data["practicesRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }

    clone(): DoctorProfileModel {
        const json = this.toJSON();
        let result = new DoctorProfileModel();
        result.init(json);
        return result;
    }
}

export interface IDoctorProfileModel {
    id: string;
    fullName: string | undefined;
    phone: string | undefined;
    phoneNumberCountryCode: string | undefined;
    email: string | undefined;
    username: string | undefined;
    dentalRegistrationNumber: string | undefined;
    registeredDate: Date;
    companyName: string | undefined;
    companyId: string;
    roleName: string | undefined;
    accountCode: string | undefined;
    isArchived: boolean;
    isRegistered: boolean;
    financialNote: string | undefined;
    patients: DoctorProfilePatient[] | undefined;
    practicesRoles: DoctorProfilePracticesRoles[] | undefined;
    notes: InternalNoteModel[] | undefined;
}

export class DoctorProfilePatient implements IDoctorProfilePatient {
    id: string;
    fullName: string | undefined;
    practiceName: string | undefined;
    isArchived: boolean;

    constructor(data?: IDoctorProfilePatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.practiceName = _data["practiceName"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): DoctorProfilePatient {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfilePatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["practiceName"] = this.practiceName;
        data["isArchived"] = this.isArchived;
        return data;
    }

    clone(): DoctorProfilePatient {
        const json = this.toJSON();
        let result = new DoctorProfilePatient();
        result.init(json);
        return result;
    }
}

export interface IDoctorProfilePatient {
    id: string;
    fullName: string | undefined;
    practiceName: string | undefined;
    isArchived: boolean;
}

export class DoctorProfilePracticesRoles implements IDoctorProfilePracticesRoles {
    id: string;
    name: string | undefined;
    role: string | undefined;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;

    constructor(data?: IDoctorProfilePracticesRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.idhPerformerNumber = _data["idhPerformerNumber"];
            this.accountCode = _data["accountCode"];
            this.creditLimit = _data["creditLimit"];
            this.isOnlyOwnOrdersAcess = _data["isOnlyOwnOrdersAcess"];
            this.isOnlyOwnPatientsAcess = _data["isOnlyOwnPatientsAcess"];
        }
    }

    static fromJS(data: any): DoctorProfilePracticesRoles {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfilePracticesRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        data["idhPerformerNumber"] = this.idhPerformerNumber;
        data["accountCode"] = this.accountCode;
        data["creditLimit"] = this.creditLimit;
        data["isOnlyOwnOrdersAcess"] = this.isOnlyOwnOrdersAcess;
        data["isOnlyOwnPatientsAcess"] = this.isOnlyOwnPatientsAcess;
        return data;
    }

    clone(): DoctorProfilePracticesRoles {
        const json = this.toJSON();
        let result = new DoctorProfilePracticesRoles();
        result.init(json);
        return result;
    }
}

export interface IDoctorProfilePracticesRoles {
    id: string;
    name: string | undefined;
    role: string | undefined;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
}

export class DoctorProfilePracticesRolesListDto implements IDoctorProfilePracticesRolesListDto {
    items: DoctorProfilePracticesRoles[] | undefined;

    constructor(data?: IDoctorProfilePracticesRolesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DoctorProfilePracticesRoles.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoctorProfilePracticesRolesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfilePracticesRolesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): DoctorProfilePracticesRolesListDto {
        const json = this.toJSON();
        let result = new DoctorProfilePracticesRolesListDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorProfilePracticesRolesListDto {
    items: DoctorProfilePracticesRoles[] | undefined;
}

export class Done3ShapeOrderModel implements IDone3ShapeOrderModel {
    order3ShapeOption: Order3ShapeOptionModel;
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    locationRoutName: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;

    constructor(data?: IDone3ShapeOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order3ShapeOption = _data["order3ShapeOption"] ? Order3ShapeOptionModel.fromJS(_data["order3ShapeOption"]) : <any>undefined;
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.orderStatusId = _data["orderStatusId"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.manufactureLocationId = _data["manufactureLocationId"];
            this.submanufactureLocationId = _data["submanufactureLocationId"];
            this.isDraft = _data["isDraft"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.status = _data["status"] ? OrderStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.dentistName = _data["dentistName"];
            this.practiceName = _data["practiceName"];
            this.patientName = _data["patientName"];
            this.categoryId = _data["categoryId"];
            this.orderSubmittedDate = _data["orderSubmittedDate"] ? new Date(_data["orderSubmittedDate"].toString()) : <any>undefined;
            this.scansImpressions = _data["scansImpressions"];
            this.scansImpressionsSend = _data["scansImpressionsSend"];
            this.code = _data["code"];
            this.isOrderAccepted = _data["isOrderAccepted"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.panNumber = _data["panNumber"];
            this.isArchived = _data["isArchived"];
            this.tagList = _data["tagList"];
            this.startStage = _data["startStage"];
            this.qcApprovedBy = _data["qcApprovedBy"];
            this.qcApprovedAt = _data["qcApprovedAt"] ? new Date(_data["qcApprovedAt"].toString()) : <any>undefined;
            this.isSimpleFlow = _data["isSimpleFlow"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
            this.requestedDueDate = _data["requestedDueDate"] ? new Date(_data["requestedDueDate"].toString()) : <any>undefined;
            this.scanId = _data["scanId"];
            this.locationRoutName = _data["locationRoutName"];
            if (Array.isArray(_data["orderLogs"])) {
                this.orderLogs = [] as any;
                for (let item of _data["orderLogs"])
                    this.orderLogs.push(OrderLogModel.fromJS(item));
            }
            this.isAdminSetupDueDate = _data["isAdminSetupDueDate"];
            this.receivingType = _data["receivingType"];
            this.receivingOption = _data["receivingOption"];
            this.receivingText = _data["receivingText"];
            this.orderOrthodonticsInformations = _data["orderOrthodonticsInformations"] ? OrderOrthodonticsInformationModel.fromJS(_data["orderOrthodonticsInformations"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFileModel.fromJS(item));
            }
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProductModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomFees"])) {
                this.orderCustomFees = [] as any;
                for (let item of _data["orderCustomFees"])
                    this.orderCustomFees.push(OrderCustomFeeModel.fromJS(item));
            }
            this.practiceDentistList = _data["practiceDentistList"] ? PracticeDentistListModel.fromJS(_data["practiceDentistList"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.category = _data["category"] ? ProductCategoryModel.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Done3ShapeOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new Done3ShapeOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order3ShapeOption"] = this.order3ShapeOption ? this.order3ShapeOption.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["orderStatusId"] = this.orderStatusId;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["manufactureLocationId"] = this.manufactureLocationId;
        data["submanufactureLocationId"] = this.submanufactureLocationId;
        data["isDraft"] = this.isDraft;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["dentistName"] = this.dentistName;
        data["practiceName"] = this.practiceName;
        data["patientName"] = this.patientName;
        data["categoryId"] = this.categoryId;
        data["orderSubmittedDate"] = this.orderSubmittedDate ? this.orderSubmittedDate.toISOString() : <any>undefined;
        data["scansImpressions"] = this.scansImpressions;
        data["scansImpressionsSend"] = this.scansImpressionsSend;
        data["code"] = this.code;
        data["isOrderAccepted"] = this.isOrderAccepted;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["panNumber"] = this.panNumber;
        data["isArchived"] = this.isArchived;
        data["tagList"] = this.tagList;
        data["startStage"] = this.startStage;
        data["qcApprovedBy"] = this.qcApprovedBy;
        data["qcApprovedAt"] = this.qcApprovedAt ? this.qcApprovedAt.toISOString() : <any>undefined;
        data["isSimpleFlow"] = this.isSimpleFlow;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        data["requestedDueDate"] = this.requestedDueDate ? this.requestedDueDate.toISOString() : <any>undefined;
        data["scanId"] = this.scanId;
        data["locationRoutName"] = this.locationRoutName;
        if (Array.isArray(this.orderLogs)) {
            data["orderLogs"] = [];
            for (let item of this.orderLogs)
                data["orderLogs"].push(item.toJSON());
        }
        data["isAdminSetupDueDate"] = this.isAdminSetupDueDate;
        data["receivingType"] = this.receivingType;
        data["receivingOption"] = this.receivingOption;
        data["receivingText"] = this.receivingText;
        data["orderOrthodonticsInformations"] = this.orderOrthodonticsInformations ? this.orderOrthodonticsInformations.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomFees)) {
            data["orderCustomFees"] = [];
            for (let item of this.orderCustomFees)
                data["orderCustomFees"].push(item.toJSON());
        }
        data["practiceDentistList"] = this.practiceDentistList ? this.practiceDentistList.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }

    clone(): Done3ShapeOrderModel {
        const json = this.toJSON();
        let result = new Done3ShapeOrderModel();
        result.init(json);
        return result;
    }
}

export interface IDone3ShapeOrderModel {
    order3ShapeOption: Order3ShapeOptionModel;
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    locationRoutName: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;
}

export class Done3ShapeOrderModelPagedListDto implements IDone3ShapeOrderModelPagedListDto {
    items: Done3ShapeOrderModel[] | undefined;
    totalCount: number;

    constructor(data?: IDone3ShapeOrderModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Done3ShapeOrderModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): Done3ShapeOrderModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new Done3ShapeOrderModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): Done3ShapeOrderModelPagedListDto {
        const json = this.toJSON();
        let result = new Done3ShapeOrderModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IDone3ShapeOrderModelPagedListDto {
    items: Done3ShapeOrderModel[] | undefined;
    totalCount: number;
}

export class Download implements IDownload {
    href: string | undefined;
    pdf: string | undefined;
    png: string | undefined;
    zpl: string | undefined;

    constructor(data?: IDownload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.pdf = _data["pdf"];
            this.png = _data["png"];
            this.zpl = _data["zpl"];
        }
    }

    static fromJS(data: any): Download {
        data = typeof data === 'object' ? data : {};
        let result = new Download();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["pdf"] = this.pdf;
        data["png"] = this.png;
        data["zpl"] = this.zpl;
        return data;
    }

    clone(): Download {
        const json = this.toJSON();
        let result = new Download();
        result.init(json);
        return result;
    }
}

export interface IDownload {
    href: string | undefined;
    pdf: string | undefined;
    png: string | undefined;
    zpl: string | undefined;
}

export class DueDateChangeRequestModel implements IDueDateChangeRequestModel {
    orderId: string;
    date: Date;

    constructor(data?: IDueDateChangeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DueDateChangeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DueDateChangeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }

    clone(): DueDateChangeRequestModel {
        const json = this.toJSON();
        let result = new DueDateChangeRequestModel();
        result.init(json);
        return result;
    }
}

export interface IDueDateChangeRequestModel {
    orderId: string;
    date: Date;
}

export class DueDateResponceModel implements IDueDateResponceModel {
    dueDate: Date;

    constructor(data?: IDueDateResponceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DueDateResponceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DueDateResponceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DueDateResponceModel {
        const json = this.toJSON();
        let result = new DueDateResponceModel();
        result.init(json);
        return result;
    }
}

export interface IDueDateResponceModel {
    dueDate: Date;
}

export class EstimateRatesRequestModel implements IEstimateRatesRequestModel {
    orderIds: string[] | undefined;
    carrierId: string | undefined;
    serviceCode: string | undefined;
    isSingleLabel: boolean;

    constructor(data?: IEstimateRatesRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds.push(item);
            }
            this.carrierId = _data["carrierId"];
            this.serviceCode = _data["serviceCode"];
            this.isSingleLabel = _data["isSingleLabel"];
        }
    }

    static fromJS(data: any): EstimateRatesRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateRatesRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["carrierId"] = this.carrierId;
        data["serviceCode"] = this.serviceCode;
        data["isSingleLabel"] = this.isSingleLabel;
        return data;
    }

    clone(): EstimateRatesRequestModel {
        const json = this.toJSON();
        let result = new EstimateRatesRequestModel();
        result.init(json);
        return result;
    }
}

export interface IEstimateRatesRequestModel {
    orderIds: string[] | undefined;
    carrierId: string | undefined;
    serviceCode: string | undefined;
    isSingleLabel: boolean;
}

export class ExportBillingRequestModel implements IExportBillingRequestModel {
    locationId: string;
    entityName: BillingEntityType;
    fields: string[] | undefined;
    dateStart: Date;
    dateEnd: Date;

    constructor(data?: IExportBillingRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.entityName = _data["entityName"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(item);
            }
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportBillingRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportBillingRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["entityName"] = this.entityName;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExportBillingRequestModel {
        const json = this.toJSON();
        let result = new ExportBillingRequestModel();
        result.init(json);
        return result;
    }
}

export interface IExportBillingRequestModel {
    locationId: string;
    entityName: BillingEntityType;
    fields: string[] | undefined;
    dateStart: Date;
    dateEnd: Date;
}

export class ExportProductRequestModel implements IExportProductRequestModel {
    pricelistIds: string[] | undefined;
    locationId: string;
    fields: string[] | undefined;

    constructor(data?: IExportProductRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pricelistIds"])) {
                this.pricelistIds = [] as any;
                for (let item of _data["pricelistIds"])
                    this.pricelistIds.push(item);
            }
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields.push(item);
            }
        }
    }

    static fromJS(data: any): ExportProductRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProductRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pricelistIds)) {
            data["pricelistIds"] = [];
            for (let item of this.pricelistIds)
                data["pricelistIds"].push(item);
        }
        data["locationId"] = this.locationId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        return data;
    }

    clone(): ExportProductRequestModel {
        const json = this.toJSON();
        let result = new ExportProductRequestModel();
        result.init(json);
        return result;
    }
}

export interface IExportProductRequestModel {
    pricelistIds: string[] | undefined;
    locationId: string;
    fields: string[] | undefined;
}

export class FastCheckerPricesModel implements IFastCheckerPricesModel {
    productName: string | undefined;
    productMaterialName: string | undefined;
    turnaroundTime: number;
    prices: PricesStandardModel[] | undefined;

    constructor(data?: IFastCheckerPricesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.productMaterialName = _data["productMaterialName"];
            this.turnaroundTime = _data["turnaroundTime"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices.push(PricesStandardModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FastCheckerPricesModel {
        data = typeof data === 'object' ? data : {};
        let result = new FastCheckerPricesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["productMaterialName"] = this.productMaterialName;
        data["turnaroundTime"] = this.turnaroundTime;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data;
    }

    clone(): FastCheckerPricesModel {
        const json = this.toJSON();
        let result = new FastCheckerPricesModel();
        result.init(json);
        return result;
    }
}

export interface IFastCheckerPricesModel {
    productName: string | undefined;
    productMaterialName: string | undefined;
    turnaroundTime: number;
    prices: PricesStandardModel[] | undefined;
}

export enum FieldComparisonOperator {
    Contains = <any>"Contains",
    DoesNotContain = <any>"DoesNotContain",
    Equals = <any>"Equals",
    DoesNotEqual = <any>"DoesNotEqual",
    IsIn = <any>"IsIn",
    IsNotIn = <any>"IsNotIn",
    StartsWith = <any>"StartsWith",
    DoesNotStartWith = <any>"DoesNotStartWith",
    EndsWith = <any>"EndsWith",
    GreaterThan = <any>"GreaterThan",
    LessThan = <any>"LessThan",
    NumberEquals = <any>"NumberEquals",
    Exists = <any>"Exists",
    DoesNotExist = <any>"DoesNotExist",
}

export class FinancialNoteEditModel implements IFinancialNoteEditModel {
    doctorId: string;
    note: string | undefined;

    constructor(data?: IFinancialNoteEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): FinancialNoteEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNoteEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["note"] = this.note;
        return data;
    }

    clone(): FinancialNoteEditModel {
        const json = this.toJSON();
        let result = new FinancialNoteEditModel();
        result.init(json);
        return result;
    }
}

export interface IFinancialNoteEditModel {
    doctorId: string;
    note: string | undefined;
}

export class ForgotUsernameModel implements IForgotUsernameModel {
    email: string | undefined;
    domain: string | undefined;

    constructor(data?: IForgotUsernameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ForgotUsernameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotUsernameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["domain"] = this.domain;
        return data;
    }

    clone(): ForgotUsernameModel {
        const json = this.toJSON();
        let result = new ForgotUsernameModel();
        result.init(json);
        return result;
    }
}

export interface IForgotUsernameModel {
    email: string | undefined;
    domain: string | undefined;
}

export class FrequentlyOrderedProductsModel implements IFrequentlyOrderedProductsModel {
    name: string | undefined;
    countInOrders: number;

    constructor(data?: IFrequentlyOrderedProductsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countInOrders = _data["countInOrders"];
        }
    }

    static fromJS(data: any): FrequentlyOrderedProductsModel {
        data = typeof data === 'object' ? data : {};
        let result = new FrequentlyOrderedProductsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countInOrders"] = this.countInOrders;
        return data;
    }

    clone(): FrequentlyOrderedProductsModel {
        const json = this.toJSON();
        let result = new FrequentlyOrderedProductsModel();
        result.init(json);
        return result;
    }
}

export interface IFrequentlyOrderedProductsModel {
    name: string | undefined;
    countInOrders: number;
}

export class GetBillingDoctorStatisticsModel implements IGetBillingDoctorStatisticsModel {
    page: number;
    take: number;
    dateStart: Date;
    dateEnd: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    practiceId: string | undefined;

    constructor(data?: IGetBillingDoctorStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.practiceId = _data["practiceId"];
        }
    }

    static fromJS(data: any): GetBillingDoctorStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillingDoctorStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["practiceId"] = this.practiceId;
        return data;
    }

    clone(): GetBillingDoctorStatisticsModel {
        const json = this.toJSON();
        let result = new GetBillingDoctorStatisticsModel();
        result.init(json);
        return result;
    }
}

export interface IGetBillingDoctorStatisticsModel {
    page: number;
    take: number;
    dateStart: Date;
    dateEnd: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    practiceId: string | undefined;
}

export class GetBillingProductStatisticsModel implements IGetBillingProductStatisticsModel {
    categoryId: number | undefined;
    page: number;
    take: number;
    dateStart: Date;
    dateEnd: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    practiceId: string | undefined;

    constructor(data?: IGetBillingProductStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.page = _data["page"];
            this.take = _data["take"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.practiceId = _data["practiceId"];
        }
    }

    static fromJS(data: any): GetBillingProductStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillingProductStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["page"] = this.page;
        data["take"] = this.take;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["practiceId"] = this.practiceId;
        return data;
    }

    clone(): GetBillingProductStatisticsModel {
        const json = this.toJSON();
        let result = new GetBillingProductStatisticsModel();
        result.init(json);
        return result;
    }
}

export interface IGetBillingProductStatisticsModel {
    categoryId: number | undefined;
    page: number;
    take: number;
    dateStart: Date;
    dateEnd: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    practiceId: string | undefined;
}

export class GetConsolidatedInvoiceModel implements IGetConsolidatedInvoiceModel {
    page: number;
    take: number;
    statuses: InvoiceStatus[] | undefined;
    startDate: Date;
    endDate: Date;
    searchString: string | undefined;

    constructor(data?: IGetConsolidatedInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): GetConsolidatedInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsolidatedInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["searchString"] = this.searchString;
        return data;
    }

    clone(): GetConsolidatedInvoiceModel {
        const json = this.toJSON();
        let result = new GetConsolidatedInvoiceModel();
        result.init(json);
        return result;
    }
}

export interface IGetConsolidatedInvoiceModel {
    page: number;
    take: number;
    statuses: InvoiceStatus[] | undefined;
    startDate: Date;
    endDate: Date;
    searchString: string | undefined;
}

export class GetDoctorsResponseModel implements IGetDoctorsResponseModel {
    total: number;
    doctors: DentistWithPracticeModel[] | undefined;

    constructor(data?: IGetDoctorsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors.push(DentistWithPracticeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDoctorsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDoctorsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDoctorsResponseModel {
        const json = this.toJSON();
        let result = new GetDoctorsResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetDoctorsResponseModel {
    total: number;
    doctors: DentistWithPracticeModel[] | undefined;
}

export class GetFilteredWorkbenchRoomTaskModel implements IGetFilteredWorkbenchRoomTaskModel {
    locationId: string;
    workbenchRoomId: string | undefined;
    workbenchRoomTaskId: string | undefined;
    teammateId: string | undefined;

    constructor(data?: IGetFilteredWorkbenchRoomTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.workbenchRoomId = _data["workbenchRoomId"];
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.teammateId = _data["teammateId"];
        }
    }

    static fromJS(data: any): GetFilteredWorkbenchRoomTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredWorkbenchRoomTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["workbenchRoomId"] = this.workbenchRoomId;
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["teammateId"] = this.teammateId;
        return data;
    }

    clone(): GetFilteredWorkbenchRoomTaskModel {
        const json = this.toJSON();
        let result = new GetFilteredWorkbenchRoomTaskModel();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredWorkbenchRoomTaskModel {
    locationId: string;
    workbenchRoomId: string | undefined;
    workbenchRoomTaskId: string | undefined;
    teammateId: string | undefined;
}

export class GetFilteredWorkbenchTasksModel implements IGetFilteredWorkbenchTasksModel {
    locationId: string;
    workbenchRoomIds: string[] | undefined;
    workbenchRoomTaskIds: string[] | undefined;
    teammateIds: string[] | undefined;
    isStarted: boolean;
    isFinished: boolean;

    constructor(data?: IGetFilteredWorkbenchTasksModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["workbenchRoomIds"])) {
                this.workbenchRoomIds = [] as any;
                for (let item of _data["workbenchRoomIds"])
                    this.workbenchRoomIds.push(item);
            }
            if (Array.isArray(_data["workbenchRoomTaskIds"])) {
                this.workbenchRoomTaskIds = [] as any;
                for (let item of _data["workbenchRoomTaskIds"])
                    this.workbenchRoomTaskIds.push(item);
            }
            if (Array.isArray(_data["teammateIds"])) {
                this.teammateIds = [] as any;
                for (let item of _data["teammateIds"])
                    this.teammateIds.push(item);
            }
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): GetFilteredWorkbenchTasksModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredWorkbenchTasksModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.workbenchRoomIds)) {
            data["workbenchRoomIds"] = [];
            for (let item of this.workbenchRoomIds)
                data["workbenchRoomIds"].push(item);
        }
        if (Array.isArray(this.workbenchRoomTaskIds)) {
            data["workbenchRoomTaskIds"] = [];
            for (let item of this.workbenchRoomTaskIds)
                data["workbenchRoomTaskIds"].push(item);
        }
        if (Array.isArray(this.teammateIds)) {
            data["teammateIds"] = [];
            for (let item of this.teammateIds)
                data["teammateIds"].push(item);
        }
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): GetFilteredWorkbenchTasksModel {
        const json = this.toJSON();
        let result = new GetFilteredWorkbenchTasksModel();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredWorkbenchTasksModel {
    locationId: string;
    workbenchRoomIds: string[] | undefined;
    workbenchRoomTaskIds: string[] | undefined;
    teammateIds: string[] | undefined;
    isStarted: boolean;
    isFinished: boolean;
}

export class GetListOptionsBilling implements IGetListOptionsBilling {
    statuses: InvoiceStatus[] | undefined;
    practiceId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    dueDateFrom: Date | undefined;
    dueDateTo: Date | undefined;
    timePeriod: number | undefined;
    page: number;
    take: number;
    searchString: string | undefined;

    constructor(data?: IGetListOptionsBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            this.practiceId = _data["practiceId"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.dueDateFrom = _data["dueDateFrom"] ? new Date(_data["dueDateFrom"].toString()) : <any>undefined;
            this.dueDateTo = _data["dueDateTo"] ? new Date(_data["dueDateTo"].toString()) : <any>undefined;
            this.timePeriod = _data["timePeriod"];
            this.page = _data["page"];
            this.take = _data["take"];
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): GetListOptionsBilling {
        data = typeof data === 'object' ? data : {};
        let result = new GetListOptionsBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["practiceId"] = this.practiceId;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["dueDateFrom"] = this.dueDateFrom ? this.dueDateFrom.toISOString() : <any>undefined;
        data["dueDateTo"] = this.dueDateTo ? this.dueDateTo.toISOString() : <any>undefined;
        data["timePeriod"] = this.timePeriod;
        data["page"] = this.page;
        data["take"] = this.take;
        data["searchString"] = this.searchString;
        return data;
    }

    clone(): GetListOptionsBilling {
        const json = this.toJSON();
        let result = new GetListOptionsBilling();
        result.init(json);
        return result;
    }
}

export interface IGetListOptionsBilling {
    statuses: InvoiceStatus[] | undefined;
    practiceId: string | undefined;
    locationId: string | undefined;
    dentistId: string | undefined;
    dueDateFrom: Date | undefined;
    dueDateTo: Date | undefined;
    timePeriod: number | undefined;
    page: number;
    take: number;
    searchString: string | undefined;
}

export class GetListOptionsDoctorList implements IGetListOptionsDoctorList {
    locationId: string | undefined;
    practiceId: string[] | undefined;
    page: number;
    take: number;
    searchString: string | undefined;

    constructor(data?: IGetListOptionsDoctorList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["practiceId"])) {
                this.practiceId = [] as any;
                for (let item of _data["practiceId"])
                    this.practiceId.push(item);
            }
            this.page = _data["page"];
            this.take = _data["take"];
            this.searchString = _data["searchString"];
        }
    }

    static fromJS(data: any): GetListOptionsDoctorList {
        data = typeof data === 'object' ? data : {};
        let result = new GetListOptionsDoctorList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.practiceId)) {
            data["practiceId"] = [];
            for (let item of this.practiceId)
                data["practiceId"].push(item);
        }
        data["page"] = this.page;
        data["take"] = this.take;
        data["searchString"] = this.searchString;
        return data;
    }

    clone(): GetListOptionsDoctorList {
        const json = this.toJSON();
        let result = new GetListOptionsDoctorList();
        result.init(json);
        return result;
    }
}

export interface IGetListOptionsDoctorList {
    locationId: string | undefined;
    practiceId: string[] | undefined;
    page: number;
    take: number;
    searchString: string | undefined;
}

export class GetStatementsModel implements IGetStatementsModel {
    page: number;
    take: number;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceId: string | undefined;
    dentistId: string | undefined;
    isOpen: boolean | undefined;
    startDate: Date;
    endDate: Date;
    searchString: string | undefined;
    timePeriod: number | undefined;
    isLatestOnly: boolean | undefined;

    constructor(data?: IGetStatementsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.companyId = _data["companyId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.isOpen = _data["isOpen"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.searchString = _data["searchString"];
            this.timePeriod = _data["timePeriod"];
            this.isLatestOnly = _data["isLatestOnly"];
        }
    }

    static fromJS(data: any): GetStatementsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatementsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["companyId"] = this.companyId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["isOpen"] = this.isOpen;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["searchString"] = this.searchString;
        data["timePeriod"] = this.timePeriod;
        data["isLatestOnly"] = this.isLatestOnly;
        return data;
    }

    clone(): GetStatementsModel {
        const json = this.toJSON();
        let result = new GetStatementsModel();
        result.init(json);
        return result;
    }
}

export interface IGetStatementsModel {
    page: number;
    take: number;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceId: string | undefined;
    dentistId: string | undefined;
    isOpen: boolean | undefined;
    startDate: Date;
    endDate: Date;
    searchString: string | undefined;
    timePeriod: number | undefined;
    isLatestOnly: boolean | undefined;
}

export class GetTaskStatisticsModel implements IGetTaskStatisticsModel {
    locationId: string;
    userId: string | undefined;
    startDate: Date;
    endDate: Date;

    constructor(data?: IGetTaskStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.userId = _data["userId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["userId"] = this.userId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetTaskStatisticsModel {
        const json = this.toJSON();
        let result = new GetTaskStatisticsModel();
        result.init(json);
        return result;
    }
}

export interface IGetTaskStatisticsModel {
    locationId: string;
    userId: string | undefined;
    startDate: Date;
    endDate: Date;
}

export class GetUpdateWorkflowModel implements IGetUpdateWorkflowModel {
    productCategory: ProductCategoryModel;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;

    constructor(data?: IGetUpdateWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCategory = _data["productCategory"] ? ProductCategoryModel.fromJS(_data["productCategory"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.rules = _data["rules"] ? PredicateGroup.fromJS(_data["rules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUpdateWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUpdateWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["rules"] = this.rules ? this.rules.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUpdateWorkflowModel {
        const json = this.toJSON();
        let result = new GetUpdateWorkflowModel();
        result.init(json);
        return result;
    }
}

export interface IGetUpdateWorkflowModel {
    productCategory: ProductCategoryModel;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;
}

export class GetWorkbenchTasksForUserModel implements IGetWorkbenchTasksForUserModel {
    locationId: string;
    isStarted: boolean;
    isFinished: boolean;

    constructor(data?: IGetWorkbenchTasksForUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): GetWorkbenchTasksForUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkbenchTasksForUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): GetWorkbenchTasksForUserModel {
        const json = this.toJSON();
        let result = new GetWorkbenchTasksForUserModel();
        result.init(json);
        return result;
    }
}

export interface IGetWorkbenchTasksForUserModel {
    locationId: string;
    isStarted: boolean;
    isFinished: boolean;
}

export class GuidIdentityUserRole implements IGuidIdentityUserRole {
    userId: string;
    roleId: string;

    constructor(data?: IGuidIdentityUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): GuidIdentityUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new GuidIdentityUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): GuidIdentityUserRole {
        const json = this.toJSON();
        let result = new GuidIdentityUserRole();
        result.init(json);
        return result;
    }
}

export interface IGuidIdentityUserRole {
    userId: string;
    roleId: string;
}

export class ImportDoctorsAndPracticesResponseModel implements IImportDoctorsAndPracticesResponseModel {
    doctorsCnt: number;
    practicesCnt: number;
    doctorEmailsCnt: number;
    practiceAddressLineCnt: number;
    practicePostCodeCnt: number;
    practicePhoneCnt: number;
    dentistsProfilesCnt: number;
    errors: string[] | undefined;
    info: string[] | undefined;

    constructor(data?: IImportDoctorsAndPracticesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorsCnt = _data["doctorsCnt"];
            this.practicesCnt = _data["practicesCnt"];
            this.doctorEmailsCnt = _data["doctorEmailsCnt"];
            this.practiceAddressLineCnt = _data["practiceAddressLineCnt"];
            this.practicePostCodeCnt = _data["practicePostCodeCnt"];
            this.practicePhoneCnt = _data["practicePhoneCnt"];
            this.dentistsProfilesCnt = _data["dentistsProfilesCnt"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            if (Array.isArray(_data["info"])) {
                this.info = [] as any;
                for (let item of _data["info"])
                    this.info.push(item);
            }
        }
    }

    static fromJS(data: any): ImportDoctorsAndPracticesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDoctorsAndPracticesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorsCnt"] = this.doctorsCnt;
        data["practicesCnt"] = this.practicesCnt;
        data["doctorEmailsCnt"] = this.doctorEmailsCnt;
        data["practiceAddressLineCnt"] = this.practiceAddressLineCnt;
        data["practicePostCodeCnt"] = this.practicePostCodeCnt;
        data["practicePhoneCnt"] = this.practicePhoneCnt;
        data["dentistsProfilesCnt"] = this.dentistsProfilesCnt;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.info)) {
            data["info"] = [];
            for (let item of this.info)
                data["info"].push(item);
        }
        return data;
    }

    clone(): ImportDoctorsAndPracticesResponseModel {
        const json = this.toJSON();
        let result = new ImportDoctorsAndPracticesResponseModel();
        result.init(json);
        return result;
    }
}

export interface IImportDoctorsAndPracticesResponseModel {
    doctorsCnt: number;
    practicesCnt: number;
    doctorEmailsCnt: number;
    practiceAddressLineCnt: number;
    practicePostCodeCnt: number;
    practicePhoneCnt: number;
    dentistsProfilesCnt: number;
    errors: string[] | undefined;
    info: string[] | undefined;
}

export class InternalNoteModel implements IInternalNoteModel {
    id: string;
    contents: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string;
    createdById: string;
    creatorFullName: string | undefined;
    creatorProfilePictureURL: string | undefined;

    constructor(data?: IInternalNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contents = _data["contents"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.creatorFullName = _data["creatorFullName"];
            this.creatorProfilePictureURL = _data["creatorProfilePictureURL"];
        }
    }

    static fromJS(data: any): InternalNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contents"] = this.contents;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["creatorFullName"] = this.creatorFullName;
        data["creatorProfilePictureURL"] = this.creatorProfilePictureURL;
        return data;
    }

    clone(): InternalNoteModel {
        const json = this.toJSON();
        let result = new InternalNoteModel();
        result.init(json);
        return result;
    }
}

export interface IInternalNoteModel {
    id: string;
    contents: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string;
    createdById: string;
    creatorFullName: string | undefined;
    creatorProfilePictureURL: string | undefined;
}

export class Invoice implements IInvoice {
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    dentistId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    date: Date;
    dueDate: Date;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    isArchived: boolean;
    fileUrl: string | undefined;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    integrationExportTime: Date | undefined;
    order: Order;
    location: Location;
    practice: Practice;
    dentist: User;
    consolidatedInvoice: ConsolidatedInvoice;
    invoiceItems: InvoiceItem[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    invoicePayments: InvoicePayment[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.consolidatedInvoiceId = _data["consolidatedInvoiceId"];
            this.dentistId = _data["dentistId"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.locationTaxNumber = _data["locationTaxNumber"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.billingAddress = _data["billingAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhone = _data["clientPhone"];
            this.patientName = _data["patientName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.clienNumber = _data["clienNumber"];
            this.comment = _data["comment"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.orderShortCode = _data["orderShortCode"];
            this.subTotal = _data["subTotal"];
            this.totalTax = _data["totalTax"];
            this.amountDue = _data["amountDue"];
            this.amountPaid = _data["amountPaid"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.isArchived = _data["isArchived"];
            this.fileUrl = _data["fileUrl"];
            this.integrationName = _data["integrationName"];
            this.isExportedToXero = _data["isExportedToXero"];
            this.integrationExportTime = _data["integrationExportTime"] ? new Date(_data["integrationExportTime"].toString()) : <any>undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.consolidatedInvoice = _data["consolidatedInvoice"] ? ConsolidatedInvoice.fromJS(_data["consolidatedInvoice"]) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatement.fromJS(item));
            }
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments.push(InvoicePayment.fromJS(item));
            }
            if (Array.isArray(_data["billingStatements"])) {
                this.billingStatements = [] as any;
                for (let item of _data["billingStatements"])
                    this.billingStatements.push(BillingStatement.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["consolidatedInvoiceId"] = this.consolidatedInvoiceId;
        data["dentistId"] = this.dentistId;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["locationTaxNumber"] = this.locationTaxNumber;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["billingAddress"] = this.billingAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhone"] = this.clientPhone;
        data["patientName"] = this.patientName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["clienNumber"] = this.clienNumber;
        data["comment"] = this.comment;
        data["termsAndConditions"] = this.termsAndConditions;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["orderShortCode"] = this.orderShortCode;
        data["subTotal"] = this.subTotal;
        data["totalTax"] = this.totalTax;
        data["amountDue"] = this.amountDue;
        data["amountPaid"] = this.amountPaid;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["isArchived"] = this.isArchived;
        data["fileUrl"] = this.fileUrl;
        data["integrationName"] = this.integrationName;
        data["isExportedToXero"] = this.isExportedToXero;
        data["integrationExportTime"] = this.integrationExportTime ? this.integrationExportTime.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["consolidatedInvoice"] = this.consolidatedInvoice ? this.consolidatedInvoice.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        if (Array.isArray(this.billingStatements)) {
            data["billingStatements"] = [];
            for (let item of this.billingStatements)
                data["billingStatements"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Invoice {
        const json = this.toJSON();
        let result = new Invoice();
        result.init(json);
        return result;
    }
}

export interface IInvoice {
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    dentistId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    date: Date;
    dueDate: Date;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    isArchived: boolean;
    fileUrl: string | undefined;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    integrationExportTime: Date | undefined;
    order: Order;
    location: Location;
    practice: Practice;
    dentist: User;
    consolidatedInvoice: ConsolidatedInvoice;
    invoiceItems: InvoiceItem[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    invoicePayments: InvoicePayment[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoiceBaseModel implements IInvoiceBaseModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    status: InvoiceStatus;
    accountCode: string | undefined;
    invoiceItems: InvoiceItemModel[] | undefined;
    patientStatements: PatientStatementModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoiceBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.consolidatedInvoiceId = _data["consolidatedInvoiceId"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.locationTaxNumber = _data["locationTaxNumber"];
            this.practiceName = _data["practiceName"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.billingAddress = _data["billingAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhone = _data["clientPhone"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.clienNumber = _data["clienNumber"];
            this.comment = _data["comment"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.orderShortCode = _data["orderShortCode"];
            this.subTotal = _data["subTotal"];
            this.totalTax = _data["totalTax"];
            this.amountDue = _data["amountDue"];
            this.amountPaid = _data["amountPaid"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.accountCode = _data["accountCode"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(InvoiceItemModel.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatementModel.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoiceBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["consolidatedInvoiceId"] = this.consolidatedInvoiceId;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["locationTaxNumber"] = this.locationTaxNumber;
        data["practiceName"] = this.practiceName;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["billingAddress"] = this.billingAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhone"] = this.clientPhone;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["invoiceNumber"] = this.invoiceNumber;
        data["clienNumber"] = this.clienNumber;
        data["comment"] = this.comment;
        data["termsAndConditions"] = this.termsAndConditions;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["orderShortCode"] = this.orderShortCode;
        data["subTotal"] = this.subTotal;
        data["totalTax"] = this.totalTax;
        data["amountDue"] = this.amountDue;
        data["amountPaid"] = this.amountPaid;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["accountCode"] = this.accountCode;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoiceBaseModel {
        const json = this.toJSON();
        let result = new InvoiceBaseModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceBaseModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    status: InvoiceStatus;
    accountCode: string | undefined;
    invoiceItems: InvoiceItemModel[] | undefined;
    patientStatements: PatientStatementModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export enum InvoiceDueDateRule {
    DaysAfterinvoiceDate = <any>"DaysAfterinvoiceDate",
    DaysAfterEndOfInvoiceMonth = <any>"DaysAfterEndOfInvoiceMonth",
    OfFollowingMonth = <any>"OfFollowingMonth",
}

export class InvoiceItem implements IInvoiceItem {
    invoiceId: string;
    description: string | undefined;
    sku: string | undefined;
    quantity: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    invoice: Invoice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.tax = _data["tax"];
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["tax"] = this.tax;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoiceItem {
        const json = this.toJSON();
        let result = new InvoiceItem();
        result.init(json);
        return result;
    }
}

export interface IInvoiceItem {
    invoiceId: string;
    description: string | undefined;
    sku: string | undefined;
    quantity: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    invoice: Invoice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoiceItemModel implements IInvoiceItemModel {
    id: string;
    invoiceId: string;
    description: string | undefined;
    sku: string | undefined;
    quantity: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoiceItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.tax = _data["tax"];
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoiceItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["tax"] = this.tax;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoiceItemModel {
        const json = this.toJSON();
        let result = new InvoiceItemModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceItemModel {
    id: string;
    invoiceId: string;
    description: string | undefined;
    sku: string | undefined;
    quantity: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoiceListModel implements IInvoiceListModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    accountCode: string | undefined;
    status: InvoiceStatus;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    patientStatements: PatientStatementModel[] | undefined;
    invoicePayments: InvoicePaymentModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoiceListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.consolidatedInvoiceId = _data["consolidatedInvoiceId"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.locationTaxNumber = _data["locationTaxNumber"];
            this.practiceName = _data["practiceName"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhone = _data["clientPhone"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.clienNumber = _data["clienNumber"];
            this.comment = _data["comment"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.orderShortCode = _data["orderShortCode"];
            this.subTotal = _data["subTotal"];
            this.totalTax = _data["totalTax"];
            this.amountDue = _data["amountDue"];
            this.amountPaid = _data["amountPaid"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.accountCode = _data["accountCode"];
            this.status = _data["status"];
            this.integrationName = _data["integrationName"];
            this.isExportedToXero = _data["isExportedToXero"];
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatementModel.fromJS(item));
            }
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentModel.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoiceListModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["consolidatedInvoiceId"] = this.consolidatedInvoiceId;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["locationTaxNumber"] = this.locationTaxNumber;
        data["practiceName"] = this.practiceName;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhone"] = this.clientPhone;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["invoiceNumber"] = this.invoiceNumber;
        data["clienNumber"] = this.clienNumber;
        data["comment"] = this.comment;
        data["termsAndConditions"] = this.termsAndConditions;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["orderShortCode"] = this.orderShortCode;
        data["subTotal"] = this.subTotal;
        data["totalTax"] = this.totalTax;
        data["amountDue"] = this.amountDue;
        data["amountPaid"] = this.amountPaid;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["accountCode"] = this.accountCode;
        data["status"] = this.status;
        data["integrationName"] = this.integrationName;
        data["isExportedToXero"] = this.isExportedToXero;
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoiceListModel {
        const json = this.toJSON();
        let result = new InvoiceListModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    accountCode: string | undefined;
    status: InvoiceStatus;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    patientStatements: PatientStatementModel[] | undefined;
    invoicePayments: InvoicePaymentModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoiceListModelInvoicePagedListDto implements IInvoiceListModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: InvoiceListModel[] | undefined;
    totalCount: number;

    constructor(data?: IInvoiceListModelInvoicePagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvoiceListModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceListModelInvoicePagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListModelInvoicePagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvoiceListModelInvoicePagedListDto {
        const json = this.toJSON();
        let result = new InvoiceListModelInvoicePagedListDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: InvoiceListModel[] | undefined;
    totalCount: number;
}

export class InvoiceModel implements IInvoiceModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    status: InvoiceStatus;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    integrationExportTime: Date | undefined;
    accountCode: string | undefined;
    order: OrderModel;
    location: LocationModel;
    practice: PracticeModel;
    locationBillingSettings: LocationBillingSettingsModel;
    invoiceItems: InvoiceItemModel[] | undefined;
    patientStatements: PatientStatementModel[] | undefined;
    invoicePayments: InvoicePaymentModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.consolidatedInvoiceId = _data["consolidatedInvoiceId"];
            this.locationName = _data["locationName"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.locationTaxNumber = _data["locationTaxNumber"];
            this.practiceName = _data["practiceName"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.billingAddress = _data["billingAddress"];
            this.clientEmail = _data["clientEmail"];
            this.clientPhone = _data["clientPhone"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.clienNumber = _data["clienNumber"];
            this.comment = _data["comment"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.orderShortCode = _data["orderShortCode"];
            this.subTotal = _data["subTotal"];
            this.totalTax = _data["totalTax"];
            this.amountDue = _data["amountDue"];
            this.amountPaid = _data["amountPaid"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.integrationName = _data["integrationName"];
            this.isExportedToXero = _data["isExportedToXero"];
            this.integrationExportTime = _data["integrationExportTime"] ? new Date(_data["integrationExportTime"].toString()) : <any>undefined;
            this.accountCode = _data["accountCode"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? PracticeModel.fromJS(_data["practice"]) : <any>undefined;
            this.locationBillingSettings = _data["locationBillingSettings"] ? LocationBillingSettingsModel.fromJS(_data["locationBillingSettings"]) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems.push(InvoiceItemModel.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatementModel.fromJS(item));
            }
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments.push(InvoicePaymentModel.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["consolidatedInvoiceId"] = this.consolidatedInvoiceId;
        data["locationName"] = this.locationName;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["locationTaxNumber"] = this.locationTaxNumber;
        data["practiceName"] = this.practiceName;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["billingAddress"] = this.billingAddress;
        data["clientEmail"] = this.clientEmail;
        data["clientPhone"] = this.clientPhone;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["invoiceNumber"] = this.invoiceNumber;
        data["clienNumber"] = this.clienNumber;
        data["comment"] = this.comment;
        data["termsAndConditions"] = this.termsAndConditions;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["orderShortCode"] = this.orderShortCode;
        data["subTotal"] = this.subTotal;
        data["totalTax"] = this.totalTax;
        data["amountDue"] = this.amountDue;
        data["amountPaid"] = this.amountPaid;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["integrationName"] = this.integrationName;
        data["isExportedToXero"] = this.isExportedToXero;
        data["integrationExportTime"] = this.integrationExportTime ? this.integrationExportTime.toISOString() : <any>undefined;
        data["accountCode"] = this.accountCode;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["locationBillingSettings"] = this.locationBillingSettings ? this.locationBillingSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoiceModel {
        const json = this.toJSON();
        let result = new InvoiceModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceModel {
    id: string;
    orderId: string | undefined;
    locationId: string;
    practiceId: string;
    consolidatedInvoiceId: string | undefined;
    locationName: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    locationTaxNumber: string | undefined;
    practiceName: string | undefined;
    clientName: string | undefined;
    clientAddress: string | undefined;
    billingAddress: string | undefined;
    clientEmail: string | undefined;
    clientPhone: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    date: Date;
    dueDate: Date;
    lastPaymentDate: Date | undefined;
    dateFormat: string | undefined;
    invoiceNumber: string | undefined;
    clienNumber: string | undefined;
    comment: string | undefined;
    termsAndConditions: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    orderShortCode: string | undefined;
    subTotal: number;
    totalTax: number;
    amountDue: number;
    amountPaid: number;
    discount: number;
    currency: string | undefined;
    status: InvoiceStatus;
    integrationName: string | undefined;
    isExportedToXero: boolean;
    integrationExportTime: Date | undefined;
    accountCode: string | undefined;
    order: OrderModel;
    location: LocationModel;
    practice: PracticeModel;
    locationBillingSettings: LocationBillingSettingsModel;
    invoiceItems: InvoiceItemModel[] | undefined;
    patientStatements: PatientStatementModel[] | undefined;
    invoicePayments: InvoicePaymentModel[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoicePayRequestModel implements IInvoicePayRequestModel {
    id: string;
    amount: number;

    constructor(data?: IInvoicePayRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): InvoicePayRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePayRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        return data;
    }

    clone(): InvoicePayRequestModel {
        const json = this.toJSON();
        let result = new InvoicePayRequestModel();
        result.init(json);
        return result;
    }
}

export interface IInvoicePayRequestModel {
    id: string;
    amount: number;
}

export class InvoicePayment implements IInvoicePayment {
    amount: number;
    invoiceId: string;
    invoice: Invoice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IInvoicePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): InvoicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): InvoicePayment {
        const json = this.toJSON();
        let result = new InvoicePayment();
        result.init(json);
        return result;
    }
}

export interface IInvoicePayment {
    amount: number;
    invoiceId: string;
    invoice: Invoice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class InvoicePaymentModel implements IInvoicePaymentModel {
    id: string;
    amount: number;
    invoiceId: string;
    createdBy: string | undefined;
    createdAt: Date;

    constructor(data?: IInvoicePaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.invoiceId = _data["invoiceId"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicePaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["invoiceId"] = this.invoiceId;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): InvoicePaymentModel {
        const json = this.toJSON();
        let result = new InvoicePaymentModel();
        result.init(json);
        return result;
    }
}

export interface IInvoicePaymentModel {
    id: string;
    amount: number;
    invoiceId: string;
    createdBy: string | undefined;
    createdAt: Date;
}

export enum InvoiceStatus {
    Due = <any>"Due",
    Partial = <any>"Partial",
    Paid = <any>"Paid",
    Overdue = <any>"Overdue",
    Null = <any>"Null",
}

export class LabelMessages implements ILabelMessages {
    reference1: string | undefined;
    reference2: string | undefined;
    reference3: string | undefined;

    constructor(data?: ILabelMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference1 = _data["reference1"];
            this.reference2 = _data["reference2"];
            this.reference3 = _data["reference3"];
        }
    }

    static fromJS(data: any): LabelMessages {
        data = typeof data === 'object' ? data : {};
        let result = new LabelMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference1"] = this.reference1;
        data["reference2"] = this.reference2;
        data["reference3"] = this.reference3;
        return data;
    }

    clone(): LabelMessages {
        const json = this.toJSON();
        let result = new LabelMessages();
        result.init(json);
        return result;
    }
}

export interface ILabelMessages {
    reference1: string | undefined;
    reference2: string | undefined;
    reference3: string | undefined;
}

export class LabelPackage implements ILabelPackage {
    packageId: number | undefined;
    packageCode: string | undefined;
    weight: Weight;
    dimensions: Dimensions;
    insuredValue: MonetaryValue;
    trackingNumber: string | undefined;
    labelMessages: LabelMessages;
    externalPackageId: string | undefined;
    sequence: number | undefined;

    constructor(data?: ILabelPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageCode = _data["packageCode"];
            this.weight = _data["weight"] ? Weight.fromJS(_data["weight"]) : <any>undefined;
            this.dimensions = _data["dimensions"] ? Dimensions.fromJS(_data["dimensions"]) : <any>undefined;
            this.insuredValue = _data["insuredValue"] ? MonetaryValue.fromJS(_data["insuredValue"]) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.labelMessages = _data["labelMessages"] ? LabelMessages.fromJS(_data["labelMessages"]) : <any>undefined;
            this.externalPackageId = _data["externalPackageId"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): LabelPackage {
        data = typeof data === 'object' ? data : {};
        let result = new LabelPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageCode"] = this.packageCode;
        data["weight"] = this.weight ? this.weight.toJSON() : <any>undefined;
        data["dimensions"] = this.dimensions ? this.dimensions.toJSON() : <any>undefined;
        data["insuredValue"] = this.insuredValue ? this.insuredValue.toJSON() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["labelMessages"] = this.labelMessages ? this.labelMessages.toJSON() : <any>undefined;
        data["externalPackageId"] = this.externalPackageId;
        data["sequence"] = this.sequence;
        return data;
    }

    clone(): LabelPackage {
        const json = this.toJSON();
        let result = new LabelPackage();
        result.init(json);
        return result;
    }
}

export interface ILabelPackage {
    packageId: number | undefined;
    packageCode: string | undefined;
    weight: Weight;
    dimensions: Dimensions;
    insuredValue: MonetaryValue;
    trackingNumber: string | undefined;
    labelMessages: LabelMessages;
    externalPackageId: string | undefined;
    sequence: number | undefined;
}

export class Link implements ILink {
    href: string | undefined;
    type: string | undefined;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["type"] = this.type;
        return data;
    }

    clone(): Link {
        const json = this.toJSON();
        let result = new Link();
        result.init(json);
        return result;
    }
}

export interface ILink {
    href: string | undefined;
    type: string | undefined;
}

export class Links3shapeModel implements ILinks3shapeModel {
    self: string | undefined;
    masterData: string | undefined;

    constructor(data?: ILinks3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.self = _data["Self"];
            this.masterData = _data["MasterData"];
        }
    }

    static fromJS(data: any): Links3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Links3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Self"] = this.self;
        data["MasterData"] = this.masterData;
        return data;
    }

    clone(): Links3shapeModel {
        const json = this.toJSON();
        let result = new Links3shapeModel();
        result.init(json);
        return result;
    }
}

export interface ILinks3shapeModel {
    self: string | undefined;
    masterData: string | undefined;
}

export class ListGuidIdModel implements IListGuidIdModel {
    usersIds: string[] | undefined;

    constructor(data?: IListGuidIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usersIds"])) {
                this.usersIds = [] as any;
                for (let item of _data["usersIds"])
                    this.usersIds.push(item);
            }
        }
    }

    static fromJS(data: any): ListGuidIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListGuidIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usersIds)) {
            data["usersIds"] = [];
            for (let item of this.usersIds)
                data["usersIds"].push(item);
        }
        return data;
    }

    clone(): ListGuidIdModel {
        const json = this.toJSON();
        let result = new ListGuidIdModel();
        result.init(json);
        return result;
    }
}

export interface IListGuidIdModel {
    usersIds: string[] | undefined;
}

export class Location implements ILocation {
    id: string;
    companyId: string;
    locationBillingSettingsId: string | undefined;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    shipEngineApiKey: string | undefined;
    shipEngineAccountId: number | undefined;
    idhLaboratoryAccountNumber: string | undefined;
    priceLists: PriceList[] | undefined;
    company: Company;
    practices: Practice[] | undefined;
    assignedUsers: User[] | undefined;
    usersAssignedLocation: UsersAssignedLocation[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    manufacturedOrders: Order[] | undefined;
    submanufacturedOrders: Order[] | undefined;
    tags: LocationsTag[] | undefined;
    invoices: Invoice[] | undefined;
    historicalInvoices: BillingStatementItem[] | undefined;
    notifications: Notification[] | undefined;
    locationRoutes: LocationRoute[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    locationSubdomainSettings: LocationSubdomainSettings[] | undefined;
    locationHolidays: LocationHoliday[] | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchRooms: WorkbenchRoom[] | undefined;
    workbenchRoomTasks: WorkbenchRoomTask[] | undefined;
    workbenchWorkflows: WorkbenchWorkflow[] | undefined;
    productCategoriesSettings: ProductCategoriesSetting[] | undefined;
    productStandardTierSetting: ProductStandardTierSetting[] | undefined;
    productMaterialSettings: ProductMaterialSetting[] | undefined;
    onboardingFinishedSteps: OnboardingFinishedStep[] | undefined;
    stageCategories: StageCategory[] | undefined;
    consolidatedInvoices: ConsolidatedInvoice[] | undefined;
    automations: Automation[] | undefined;
    automationsUsers: AutomationsUser[] | undefined;
    locationBillingSettings: LocationBillingSettings;
    locationExportGroups: LocationExportGroup[] | undefined;
    locationDocumentSettings: LocationDocumentSettings;
    userNotes: UserNote[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.locationBillingSettingsId = _data["locationBillingSettingsId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.billingEmail = _data["billingEmail"];
            this.phone = _data["phone"];
            this.scanHubEmail = _data["scanHubEmail"];
            this.logoUrl = _data["logoUrl"];
            this.taxNumber = _data["taxNumber"];
            this.currency = _data["currency"];
            this.dateFormat = _data["dateFormat"];
            this.teethType = _data["teethType"];
            this.shadeSystem = _data["shadeSystem"];
            this.shipEngineApiKey = _data["shipEngineApiKey"];
            this.shipEngineAccountId = _data["shipEngineAccountId"];
            this.idhLaboratoryAccountNumber = _data["idhLaboratoryAccountNumber"];
            if (Array.isArray(_data["priceLists"])) {
                this.priceLists = [] as any;
                for (let item of _data["priceLists"])
                    this.priceLists.push(PriceList.fromJS(item));
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(Practice.fromJS(item));
            }
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(User.fromJS(item));
            }
            if (Array.isArray(_data["usersAssignedLocation"])) {
                this.usersAssignedLocation = [] as any;
                for (let item of _data["usersAssignedLocation"])
                    this.usersAssignedLocation.push(UsersAssignedLocation.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(Patient.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["manufacturedOrders"])) {
                this.manufacturedOrders = [] as any;
                for (let item of _data["manufacturedOrders"])
                    this.manufacturedOrders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["submanufacturedOrders"])) {
                this.submanufacturedOrders = [] as any;
                for (let item of _data["submanufacturedOrders"])
                    this.submanufacturedOrders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(LocationsTag.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["historicalInvoices"])) {
                this.historicalInvoices = [] as any;
                for (let item of _data["historicalInvoices"])
                    this.historicalInvoices.push(BillingStatementItem.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(Notification.fromJS(item));
            }
            if (Array.isArray(_data["locationRoutes"])) {
                this.locationRoutes = [] as any;
                for (let item of _data["locationRoutes"])
                    this.locationRoutes.push(LocationRoute.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatement.fromJS(item));
            }
            if (Array.isArray(_data["locationSubdomainSettings"])) {
                this.locationSubdomainSettings = [] as any;
                for (let item of _data["locationSubdomainSettings"])
                    this.locationSubdomainSettings.push(LocationSubdomainSettings.fromJS(item));
            }
            if (Array.isArray(_data["locationHolidays"])) {
                this.locationHolidays = [] as any;
                for (let item of _data["locationHolidays"])
                    this.locationHolidays.push(LocationHoliday.fromJS(item));
            }
            if (Array.isArray(_data["workbenchTasks"])) {
                this.workbenchTasks = [] as any;
                for (let item of _data["workbenchTasks"])
                    this.workbenchTasks.push(WorkbenchTask.fromJS(item));
            }
            if (Array.isArray(_data["workbenchRooms"])) {
                this.workbenchRooms = [] as any;
                for (let item of _data["workbenchRooms"])
                    this.workbenchRooms.push(WorkbenchRoom.fromJS(item));
            }
            if (Array.isArray(_data["workbenchRoomTasks"])) {
                this.workbenchRoomTasks = [] as any;
                for (let item of _data["workbenchRoomTasks"])
                    this.workbenchRoomTasks.push(WorkbenchRoomTask.fromJS(item));
            }
            if (Array.isArray(_data["workbenchWorkflows"])) {
                this.workbenchWorkflows = [] as any;
                for (let item of _data["workbenchWorkflows"])
                    this.workbenchWorkflows.push(WorkbenchWorkflow.fromJS(item));
            }
            if (Array.isArray(_data["productCategoriesSettings"])) {
                this.productCategoriesSettings = [] as any;
                for (let item of _data["productCategoriesSettings"])
                    this.productCategoriesSettings.push(ProductCategoriesSetting.fromJS(item));
            }
            if (Array.isArray(_data["productStandardTierSetting"])) {
                this.productStandardTierSetting = [] as any;
                for (let item of _data["productStandardTierSetting"])
                    this.productStandardTierSetting.push(ProductStandardTierSetting.fromJS(item));
            }
            if (Array.isArray(_data["productMaterialSettings"])) {
                this.productMaterialSettings = [] as any;
                for (let item of _data["productMaterialSettings"])
                    this.productMaterialSettings.push(ProductMaterialSetting.fromJS(item));
            }
            if (Array.isArray(_data["onboardingFinishedSteps"])) {
                this.onboardingFinishedSteps = [] as any;
                for (let item of _data["onboardingFinishedSteps"])
                    this.onboardingFinishedSteps.push(OnboardingFinishedStep.fromJS(item));
            }
            if (Array.isArray(_data["stageCategories"])) {
                this.stageCategories = [] as any;
                for (let item of _data["stageCategories"])
                    this.stageCategories.push(StageCategory.fromJS(item));
            }
            if (Array.isArray(_data["consolidatedInvoices"])) {
                this.consolidatedInvoices = [] as any;
                for (let item of _data["consolidatedInvoices"])
                    this.consolidatedInvoices.push(ConsolidatedInvoice.fromJS(item));
            }
            if (Array.isArray(_data["automations"])) {
                this.automations = [] as any;
                for (let item of _data["automations"])
                    this.automations.push(Automation.fromJS(item));
            }
            if (Array.isArray(_data["automationsUsers"])) {
                this.automationsUsers = [] as any;
                for (let item of _data["automationsUsers"])
                    this.automationsUsers.push(AutomationsUser.fromJS(item));
            }
            this.locationBillingSettings = _data["locationBillingSettings"] ? LocationBillingSettings.fromJS(_data["locationBillingSettings"]) : <any>undefined;
            if (Array.isArray(_data["locationExportGroups"])) {
                this.locationExportGroups = [] as any;
                for (let item of _data["locationExportGroups"])
                    this.locationExportGroups.push(LocationExportGroup.fromJS(item));
            }
            this.locationDocumentSettings = _data["locationDocumentSettings"] ? LocationDocumentSettings.fromJS(_data["locationDocumentSettings"]) : <any>undefined;
            if (Array.isArray(_data["userNotes"])) {
                this.userNotes = [] as any;
                for (let item of _data["userNotes"])
                    this.userNotes.push(UserNote.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["locationBillingSettingsId"] = this.locationBillingSettingsId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["billingEmail"] = this.billingEmail;
        data["phone"] = this.phone;
        data["scanHubEmail"] = this.scanHubEmail;
        data["logoUrl"] = this.logoUrl;
        data["taxNumber"] = this.taxNumber;
        data["currency"] = this.currency;
        data["dateFormat"] = this.dateFormat;
        data["teethType"] = this.teethType;
        data["shadeSystem"] = this.shadeSystem;
        data["shipEngineApiKey"] = this.shipEngineApiKey;
        data["shipEngineAccountId"] = this.shipEngineAccountId;
        data["idhLaboratoryAccountNumber"] = this.idhLaboratoryAccountNumber;
        if (Array.isArray(this.priceLists)) {
            data["priceLists"] = [];
            for (let item of this.priceLists)
                data["priceLists"].push(item.toJSON());
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.usersAssignedLocation)) {
            data["usersAssignedLocation"] = [];
            for (let item of this.usersAssignedLocation)
                data["usersAssignedLocation"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.manufacturedOrders)) {
            data["manufacturedOrders"] = [];
            for (let item of this.manufacturedOrders)
                data["manufacturedOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.submanufacturedOrders)) {
            data["submanufacturedOrders"] = [];
            for (let item of this.submanufacturedOrders)
                data["submanufacturedOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.historicalInvoices)) {
            data["historicalInvoices"] = [];
            for (let item of this.historicalInvoices)
                data["historicalInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        if (Array.isArray(this.locationRoutes)) {
            data["locationRoutes"] = [];
            for (let item of this.locationRoutes)
                data["locationRoutes"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.locationSubdomainSettings)) {
            data["locationSubdomainSettings"] = [];
            for (let item of this.locationSubdomainSettings)
                data["locationSubdomainSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.locationHolidays)) {
            data["locationHolidays"] = [];
            for (let item of this.locationHolidays)
                data["locationHolidays"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchTasks)) {
            data["workbenchTasks"] = [];
            for (let item of this.workbenchTasks)
                data["workbenchTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchRooms)) {
            data["workbenchRooms"] = [];
            for (let item of this.workbenchRooms)
                data["workbenchRooms"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchRoomTasks)) {
            data["workbenchRoomTasks"] = [];
            for (let item of this.workbenchRoomTasks)
                data["workbenchRoomTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchWorkflows)) {
            data["workbenchWorkflows"] = [];
            for (let item of this.workbenchWorkflows)
                data["workbenchWorkflows"].push(item.toJSON());
        }
        if (Array.isArray(this.productCategoriesSettings)) {
            data["productCategoriesSettings"] = [];
            for (let item of this.productCategoriesSettings)
                data["productCategoriesSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.productStandardTierSetting)) {
            data["productStandardTierSetting"] = [];
            for (let item of this.productStandardTierSetting)
                data["productStandardTierSetting"].push(item.toJSON());
        }
        if (Array.isArray(this.productMaterialSettings)) {
            data["productMaterialSettings"] = [];
            for (let item of this.productMaterialSettings)
                data["productMaterialSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.onboardingFinishedSteps)) {
            data["onboardingFinishedSteps"] = [];
            for (let item of this.onboardingFinishedSteps)
                data["onboardingFinishedSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.stageCategories)) {
            data["stageCategories"] = [];
            for (let item of this.stageCategories)
                data["stageCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.consolidatedInvoices)) {
            data["consolidatedInvoices"] = [];
            for (let item of this.consolidatedInvoices)
                data["consolidatedInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.automations)) {
            data["automations"] = [];
            for (let item of this.automations)
                data["automations"].push(item.toJSON());
        }
        if (Array.isArray(this.automationsUsers)) {
            data["automationsUsers"] = [];
            for (let item of this.automationsUsers)
                data["automationsUsers"].push(item.toJSON());
        }
        data["locationBillingSettings"] = this.locationBillingSettings ? this.locationBillingSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.locationExportGroups)) {
            data["locationExportGroups"] = [];
            for (let item of this.locationExportGroups)
                data["locationExportGroups"].push(item.toJSON());
        }
        data["locationDocumentSettings"] = this.locationDocumentSettings ? this.locationDocumentSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.userNotes)) {
            data["userNotes"] = [];
            for (let item of this.userNotes)
                data["userNotes"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation {
    id: string;
    companyId: string;
    locationBillingSettingsId: string | undefined;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    shipEngineApiKey: string | undefined;
    shipEngineAccountId: number | undefined;
    idhLaboratoryAccountNumber: string | undefined;
    priceLists: PriceList[] | undefined;
    company: Company;
    practices: Practice[] | undefined;
    assignedUsers: User[] | undefined;
    usersAssignedLocation: UsersAssignedLocation[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    manufacturedOrders: Order[] | undefined;
    submanufacturedOrders: Order[] | undefined;
    tags: LocationsTag[] | undefined;
    invoices: Invoice[] | undefined;
    historicalInvoices: BillingStatementItem[] | undefined;
    notifications: Notification[] | undefined;
    locationRoutes: LocationRoute[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    locationSubdomainSettings: LocationSubdomainSettings[] | undefined;
    locationHolidays: LocationHoliday[] | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchRooms: WorkbenchRoom[] | undefined;
    workbenchRoomTasks: WorkbenchRoomTask[] | undefined;
    workbenchWorkflows: WorkbenchWorkflow[] | undefined;
    productCategoriesSettings: ProductCategoriesSetting[] | undefined;
    productStandardTierSetting: ProductStandardTierSetting[] | undefined;
    productMaterialSettings: ProductMaterialSetting[] | undefined;
    onboardingFinishedSteps: OnboardingFinishedStep[] | undefined;
    stageCategories: StageCategory[] | undefined;
    consolidatedInvoices: ConsolidatedInvoice[] | undefined;
    automations: Automation[] | undefined;
    automationsUsers: AutomationsUser[] | undefined;
    locationBillingSettings: LocationBillingSettings;
    locationExportGroups: LocationExportGroup[] | undefined;
    locationDocumentSettings: LocationDocumentSettings;
    userNotes: UserNote[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationAcessModel implements ILocationAcessModel {
    userId: string;
    locationId: string;

    constructor(data?: ILocationAcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): LocationAcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationAcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): LocationAcessModel {
        const json = this.toJSON();
        let result = new LocationAcessModel();
        result.init(json);
        return result;
    }
}

export interface ILocationAcessModel {
    userId: string;
    locationId: string;
}

export class LocationBillingSettings implements ILocationBillingSettings {
    locationId: string;
    location: Location;
    invoiceDue: number;
    invoiceDueDateRule: InvoiceDueDateRule;
    paymentTerms: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    nominalCode: string | undefined;
    isStatementsEnabled: boolean;
    isAutomaticallySubmitStatement: boolean;
    statementDay: number;
    statementTerms: string | undefined;
    isDisplayPatientInStatement: boolean;
    isSendInvoiceEmailOnlyToPractice: boolean;
    isSendCreditNoteEmailOnlyToPractice: boolean;
    isSendStatementEmailOnlyToPractice: boolean;
    isInvoiceEmailAutomated: boolean;
    isCreditNoteEmailAutomated: boolean;
    isStatementEmailAutomated: boolean;
    stripeAccountId: string | undefined;
    invoiceAutomationEnabled: boolean;
    invoiceAutomationStatusId: number;
    invoiceAutomationRules: PredicateGroup;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationBillingSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.invoiceDue = _data["invoiceDue"];
            this.invoiceDueDateRule = _data["invoiceDueDateRule"];
            this.paymentTerms = _data["paymentTerms"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.nominalCode = _data["nominalCode"];
            this.isStatementsEnabled = _data["isStatementsEnabled"];
            this.isAutomaticallySubmitStatement = _data["isAutomaticallySubmitStatement"];
            this.statementDay = _data["statementDay"];
            this.statementTerms = _data["statementTerms"];
            this.isDisplayPatientInStatement = _data["isDisplayPatientInStatement"];
            this.isSendInvoiceEmailOnlyToPractice = _data["isSendInvoiceEmailOnlyToPractice"];
            this.isSendCreditNoteEmailOnlyToPractice = _data["isSendCreditNoteEmailOnlyToPractice"];
            this.isSendStatementEmailOnlyToPractice = _data["isSendStatementEmailOnlyToPractice"];
            this.isInvoiceEmailAutomated = _data["isInvoiceEmailAutomated"];
            this.isCreditNoteEmailAutomated = _data["isCreditNoteEmailAutomated"];
            this.isStatementEmailAutomated = _data["isStatementEmailAutomated"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.invoiceAutomationEnabled = _data["invoiceAutomationEnabled"];
            this.invoiceAutomationStatusId = _data["invoiceAutomationStatusId"];
            this.invoiceAutomationRules = _data["invoiceAutomationRules"] ? PredicateGroup.fromJS(_data["invoiceAutomationRules"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationBillingSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LocationBillingSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["invoiceDue"] = this.invoiceDue;
        data["invoiceDueDateRule"] = this.invoiceDueDateRule;
        data["paymentTerms"] = this.paymentTerms;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["nominalCode"] = this.nominalCode;
        data["isStatementsEnabled"] = this.isStatementsEnabled;
        data["isAutomaticallySubmitStatement"] = this.isAutomaticallySubmitStatement;
        data["statementDay"] = this.statementDay;
        data["statementTerms"] = this.statementTerms;
        data["isDisplayPatientInStatement"] = this.isDisplayPatientInStatement;
        data["isSendInvoiceEmailOnlyToPractice"] = this.isSendInvoiceEmailOnlyToPractice;
        data["isSendCreditNoteEmailOnlyToPractice"] = this.isSendCreditNoteEmailOnlyToPractice;
        data["isSendStatementEmailOnlyToPractice"] = this.isSendStatementEmailOnlyToPractice;
        data["isInvoiceEmailAutomated"] = this.isInvoiceEmailAutomated;
        data["isCreditNoteEmailAutomated"] = this.isCreditNoteEmailAutomated;
        data["isStatementEmailAutomated"] = this.isStatementEmailAutomated;
        data["stripeAccountId"] = this.stripeAccountId;
        data["invoiceAutomationEnabled"] = this.invoiceAutomationEnabled;
        data["invoiceAutomationStatusId"] = this.invoiceAutomationStatusId;
        data["invoiceAutomationRules"] = this.invoiceAutomationRules ? this.invoiceAutomationRules.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationBillingSettings {
        const json = this.toJSON();
        let result = new LocationBillingSettings();
        result.init(json);
        return result;
    }
}

export interface ILocationBillingSettings {
    locationId: string;
    location: Location;
    invoiceDue: number;
    invoiceDueDateRule: InvoiceDueDateRule;
    paymentTerms: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    nominalCode: string | undefined;
    isStatementsEnabled: boolean;
    isAutomaticallySubmitStatement: boolean;
    statementDay: number;
    statementTerms: string | undefined;
    isDisplayPatientInStatement: boolean;
    isSendInvoiceEmailOnlyToPractice: boolean;
    isSendCreditNoteEmailOnlyToPractice: boolean;
    isSendStatementEmailOnlyToPractice: boolean;
    isInvoiceEmailAutomated: boolean;
    isCreditNoteEmailAutomated: boolean;
    isStatementEmailAutomated: boolean;
    stripeAccountId: string | undefined;
    invoiceAutomationEnabled: boolean;
    invoiceAutomationStatusId: number;
    invoiceAutomationRules: PredicateGroup;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationBillingSettingsModel implements ILocationBillingSettingsModel {
    id: string;
    locationId: string;
    invoiceDue: number;
    invoiceDueDateRule: number;
    paymentTerms: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    nominalCode: string | undefined;
    isStatementsEnabled: boolean;
    isAutomaticallySubmitStatement: boolean;
    statementDay: number;
    statementTerms: string | undefined;
    isNotificationsCreated: boolean;
    isDisplayPatientInStatement: boolean;
    isSendInvoiceEmailOnlyToPractice: boolean;
    isSendCreditNoteEmailOnlyToPractice: boolean;
    isSendStatementEmailOnlyToPractice: boolean;
    isInvoiceEmailAutomated: boolean;
    isCreditNoteEmailAutomated: boolean;
    isStatementEmailAutomated: boolean;
    stripeAccountId: string | undefined;
    invoiceAutomationEnabled: boolean;
    invoiceAutomationStatusId: number;
    invoiceAutomationRules: PredicateGroup;

    constructor(data?: ILocationBillingSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.invoiceDue = _data["invoiceDue"];
            this.invoiceDueDateRule = _data["invoiceDueDateRule"];
            this.paymentTerms = _data["paymentTerms"];
            this.bankingDetails = _data["bankingDetails"];
            this.taxNumber = _data["taxNumber"];
            this.nominalCode = _data["nominalCode"];
            this.isStatementsEnabled = _data["isStatementsEnabled"];
            this.isAutomaticallySubmitStatement = _data["isAutomaticallySubmitStatement"];
            this.statementDay = _data["statementDay"];
            this.statementTerms = _data["statementTerms"];
            this.isNotificationsCreated = _data["isNotificationsCreated"];
            this.isDisplayPatientInStatement = _data["isDisplayPatientInStatement"];
            this.isSendInvoiceEmailOnlyToPractice = _data["isSendInvoiceEmailOnlyToPractice"];
            this.isSendCreditNoteEmailOnlyToPractice = _data["isSendCreditNoteEmailOnlyToPractice"];
            this.isSendStatementEmailOnlyToPractice = _data["isSendStatementEmailOnlyToPractice"];
            this.isInvoiceEmailAutomated = _data["isInvoiceEmailAutomated"];
            this.isCreditNoteEmailAutomated = _data["isCreditNoteEmailAutomated"];
            this.isStatementEmailAutomated = _data["isStatementEmailAutomated"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.invoiceAutomationEnabled = _data["invoiceAutomationEnabled"];
            this.invoiceAutomationStatusId = _data["invoiceAutomationStatusId"];
            this.invoiceAutomationRules = _data["invoiceAutomationRules"] ? PredicateGroup.fromJS(_data["invoiceAutomationRules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationBillingSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationBillingSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["invoiceDue"] = this.invoiceDue;
        data["invoiceDueDateRule"] = this.invoiceDueDateRule;
        data["paymentTerms"] = this.paymentTerms;
        data["bankingDetails"] = this.bankingDetails;
        data["taxNumber"] = this.taxNumber;
        data["nominalCode"] = this.nominalCode;
        data["isStatementsEnabled"] = this.isStatementsEnabled;
        data["isAutomaticallySubmitStatement"] = this.isAutomaticallySubmitStatement;
        data["statementDay"] = this.statementDay;
        data["statementTerms"] = this.statementTerms;
        data["isNotificationsCreated"] = this.isNotificationsCreated;
        data["isDisplayPatientInStatement"] = this.isDisplayPatientInStatement;
        data["isSendInvoiceEmailOnlyToPractice"] = this.isSendInvoiceEmailOnlyToPractice;
        data["isSendCreditNoteEmailOnlyToPractice"] = this.isSendCreditNoteEmailOnlyToPractice;
        data["isSendStatementEmailOnlyToPractice"] = this.isSendStatementEmailOnlyToPractice;
        data["isInvoiceEmailAutomated"] = this.isInvoiceEmailAutomated;
        data["isCreditNoteEmailAutomated"] = this.isCreditNoteEmailAutomated;
        data["isStatementEmailAutomated"] = this.isStatementEmailAutomated;
        data["stripeAccountId"] = this.stripeAccountId;
        data["invoiceAutomationEnabled"] = this.invoiceAutomationEnabled;
        data["invoiceAutomationStatusId"] = this.invoiceAutomationStatusId;
        data["invoiceAutomationRules"] = this.invoiceAutomationRules ? this.invoiceAutomationRules.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationBillingSettingsModel {
        const json = this.toJSON();
        let result = new LocationBillingSettingsModel();
        result.init(json);
        return result;
    }
}

export interface ILocationBillingSettingsModel {
    id: string;
    locationId: string;
    invoiceDue: number;
    invoiceDueDateRule: number;
    paymentTerms: string | undefined;
    bankingDetails: string | undefined;
    taxNumber: string | undefined;
    nominalCode: string | undefined;
    isStatementsEnabled: boolean;
    isAutomaticallySubmitStatement: boolean;
    statementDay: number;
    statementTerms: string | undefined;
    isNotificationsCreated: boolean;
    isDisplayPatientInStatement: boolean;
    isSendInvoiceEmailOnlyToPractice: boolean;
    isSendCreditNoteEmailOnlyToPractice: boolean;
    isSendStatementEmailOnlyToPractice: boolean;
    isInvoiceEmailAutomated: boolean;
    isCreditNoteEmailAutomated: boolean;
    isStatementEmailAutomated: boolean;
    stripeAccountId: string | undefined;
    invoiceAutomationEnabled: boolean;
    invoiceAutomationStatusId: number;
    invoiceAutomationRules: PredicateGroup;
}

export class LocationCreateModel implements ILocationCreateModel {
    companyId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    idhLaboratoryAccountNumber: string | undefined;

    constructor(data?: ILocationCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.billingEmail = _data["billingEmail"];
            this.phone = _data["phone"];
            this.scanHubEmail = _data["scanHubEmail"];
            this.logoUrl = _data["logoUrl"];
            this.taxNumber = _data["taxNumber"];
            this.currency = _data["currency"];
            this.dateFormat = _data["dateFormat"];
            this.teethType = _data["teethType"];
            this.shadeSystem = _data["shadeSystem"];
            this.idhLaboratoryAccountNumber = _data["idhLaboratoryAccountNumber"];
        }
    }

    static fromJS(data: any): LocationCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["billingEmail"] = this.billingEmail;
        data["phone"] = this.phone;
        data["scanHubEmail"] = this.scanHubEmail;
        data["logoUrl"] = this.logoUrl;
        data["taxNumber"] = this.taxNumber;
        data["currency"] = this.currency;
        data["dateFormat"] = this.dateFormat;
        data["teethType"] = this.teethType;
        data["shadeSystem"] = this.shadeSystem;
        data["idhLaboratoryAccountNumber"] = this.idhLaboratoryAccountNumber;
        return data;
    }

    clone(): LocationCreateModel {
        const json = this.toJSON();
        let result = new LocationCreateModel();
        result.init(json);
        return result;
    }
}

export interface ILocationCreateModel {
    companyId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    idhLaboratoryAccountNumber: string | undefined;
}

export class LocationDocumentSettings implements ILocationDocumentSettings {
    locationId: string;
    location: Location;
    docketTitle: string | undefined;
    docketTermsConditions: string | undefined;
    docketFooter: string | undefined;
    docketFooterLogo: string | undefined;
    patientStatementTitle: string | undefined;
    patientStatementTermsConditions: string | undefined;
    patientStatementFooter: string | undefined;
    patientStatementFooterLogo: string | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationDocumentSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.docketTitle = _data["docketTitle"];
            this.docketTermsConditions = _data["docketTermsConditions"];
            this.docketFooter = _data["docketFooter"];
            this.docketFooterLogo = _data["docketFooterLogo"];
            this.patientStatementTitle = _data["patientStatementTitle"];
            this.patientStatementTermsConditions = _data["patientStatementTermsConditions"];
            this.patientStatementFooter = _data["patientStatementFooter"];
            this.patientStatementFooterLogo = _data["patientStatementFooterLogo"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationDocumentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDocumentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["docketTitle"] = this.docketTitle;
        data["docketTermsConditions"] = this.docketTermsConditions;
        data["docketFooter"] = this.docketFooter;
        data["docketFooterLogo"] = this.docketFooterLogo;
        data["patientStatementTitle"] = this.patientStatementTitle;
        data["patientStatementTermsConditions"] = this.patientStatementTermsConditions;
        data["patientStatementFooter"] = this.patientStatementFooter;
        data["patientStatementFooterLogo"] = this.patientStatementFooterLogo;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationDocumentSettings {
        const json = this.toJSON();
        let result = new LocationDocumentSettings();
        result.init(json);
        return result;
    }
}

export interface ILocationDocumentSettings {
    locationId: string;
    location: Location;
    docketTitle: string | undefined;
    docketTermsConditions: string | undefined;
    docketFooter: string | undefined;
    docketFooterLogo: string | undefined;
    patientStatementTitle: string | undefined;
    patientStatementTermsConditions: string | undefined;
    patientStatementFooter: string | undefined;
    patientStatementFooterLogo: string | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationDocumentSettingsModel implements ILocationDocumentSettingsModel {
    id: string;
    locationId: string;
    docketTitle: string | undefined;
    docketTermsConditions: string | undefined;
    docketFooter: string | undefined;
    docketFooterLogo: string | undefined;
    patientStatementTitle: string | undefined;
    patientStatementTermsConditions: string | undefined;
    patientStatementFooter: string | undefined;
    patientStatementFooterLogo: string | undefined;

    constructor(data?: ILocationDocumentSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.docketTitle = _data["docketTitle"];
            this.docketTermsConditions = _data["docketTermsConditions"];
            this.docketFooter = _data["docketFooter"];
            this.docketFooterLogo = _data["docketFooterLogo"];
            this.patientStatementTitle = _data["patientStatementTitle"];
            this.patientStatementTermsConditions = _data["patientStatementTermsConditions"];
            this.patientStatementFooter = _data["patientStatementFooter"];
            this.patientStatementFooterLogo = _data["patientStatementFooterLogo"];
        }
    }

    static fromJS(data: any): LocationDocumentSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDocumentSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["docketTitle"] = this.docketTitle;
        data["docketTermsConditions"] = this.docketTermsConditions;
        data["docketFooter"] = this.docketFooter;
        data["docketFooterLogo"] = this.docketFooterLogo;
        data["patientStatementTitle"] = this.patientStatementTitle;
        data["patientStatementTermsConditions"] = this.patientStatementTermsConditions;
        data["patientStatementFooter"] = this.patientStatementFooter;
        data["patientStatementFooterLogo"] = this.patientStatementFooterLogo;
        return data;
    }

    clone(): LocationDocumentSettingsModel {
        const json = this.toJSON();
        let result = new LocationDocumentSettingsModel();
        result.init(json);
        return result;
    }
}

export interface ILocationDocumentSettingsModel {
    id: string;
    locationId: string;
    docketTitle: string | undefined;
    docketTermsConditions: string | undefined;
    docketFooter: string | undefined;
    docketFooterLogo: string | undefined;
    patientStatementTitle: string | undefined;
    patientStatementTermsConditions: string | undefined;
    patientStatementFooter: string | undefined;
    patientStatementFooterLogo: string | undefined;
}

export class LocationExportGroup implements ILocationExportGroup {
    locationId: string;
    name: string | undefined;
    location: Location;
    practices: Practice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationExportGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(Practice.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationExportGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LocationExportGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationExportGroup {
        const json = this.toJSON();
        let result = new LocationExportGroup();
        result.init(json);
        return result;
    }
}

export interface ILocationExportGroup {
    locationId: string;
    name: string | undefined;
    location: Location;
    practices: Practice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationExportGroupList implements ILocationExportGroupList {
    locationExportGroups: LocationExportGroupModel[] | undefined;

    constructor(data?: ILocationExportGroupList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationExportGroups"])) {
                this.locationExportGroups = [] as any;
                for (let item of _data["locationExportGroups"])
                    this.locationExportGroups.push(LocationExportGroupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationExportGroupList {
        data = typeof data === 'object' ? data : {};
        let result = new LocationExportGroupList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationExportGroups)) {
            data["locationExportGroups"] = [];
            for (let item of this.locationExportGroups)
                data["locationExportGroups"].push(item.toJSON());
        }
        return data;
    }

    clone(): LocationExportGroupList {
        const json = this.toJSON();
        let result = new LocationExportGroupList();
        result.init(json);
        return result;
    }
}

export interface ILocationExportGroupList {
    locationExportGroups: LocationExportGroupModel[] | undefined;
}

export class LocationExportGroupModel implements ILocationExportGroupModel {
    id: string;
    locationId: string;
    name: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationExportGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationExportGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationExportGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationExportGroupModel {
        const json = this.toJSON();
        let result = new LocationExportGroupModel();
        result.init(json);
        return result;
    }
}

export interface ILocationExportGroupModel {
    id: string;
    locationId: string;
    name: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationHoliday implements ILocationHoliday {
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.startDay = _data["startDay"];
            this.startMounth = _data["startMounth"];
            this.endDay = _data["endDay"];
            this.endMounth = _data["endMounth"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationHoliday {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHoliday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["startDay"] = this.startDay;
        data["startMounth"] = this.startMounth;
        data["endDay"] = this.endDay;
        data["endMounth"] = this.endMounth;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationHoliday {
        const json = this.toJSON();
        let result = new LocationHoliday();
        result.init(json);
        return result;
    }
}

export interface ILocationHoliday {
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationHolidayCreateModel implements ILocationHolidayCreateModel {
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;

    constructor(data?: ILocationHolidayCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.startDay = _data["startDay"];
            this.startMounth = _data["startMounth"];
            this.endDay = _data["endDay"];
            this.endMounth = _data["endMounth"];
        }
    }

    static fromJS(data: any): LocationHolidayCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHolidayCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["startDay"] = this.startDay;
        data["startMounth"] = this.startMounth;
        data["endDay"] = this.endDay;
        data["endMounth"] = this.endMounth;
        return data;
    }

    clone(): LocationHolidayCreateModel {
        const json = this.toJSON();
        let result = new LocationHolidayCreateModel();
        result.init(json);
        return result;
    }
}

export interface ILocationHolidayCreateModel {
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;
}

export class LocationHolidayModel implements ILocationHolidayModel {
    id: string;
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;

    constructor(data?: ILocationHolidayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.startDay = _data["startDay"];
            this.startMounth = _data["startMounth"];
            this.endDay = _data["endDay"];
            this.endMounth = _data["endMounth"];
        }
    }

    static fromJS(data: any): LocationHolidayModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationHolidayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["startDay"] = this.startDay;
        data["startMounth"] = this.startMounth;
        data["endDay"] = this.endDay;
        data["endMounth"] = this.endMounth;
        return data;
    }

    clone(): LocationHolidayModel {
        const json = this.toJSON();
        let result = new LocationHolidayModel();
        result.init(json);
        return result;
    }
}

export interface ILocationHolidayModel {
    id: string;
    locationId: string;
    name: string | undefined;
    startDay: number;
    startMounth: number;
    endDay: number;
    endMounth: number;
}

export class LocationLocalizationModel implements ILocationLocalizationModel {
    locationId: string;
    currency: string | undefined;
    dateFormat: string | undefined;

    constructor(data?: ILocationLocalizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.currency = _data["currency"];
            this.dateFormat = _data["dateFormat"];
        }
    }

    static fromJS(data: any): LocationLocalizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLocalizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["currency"] = this.currency;
        data["dateFormat"] = this.dateFormat;
        return data;
    }

    clone(): LocationLocalizationModel {
        const json = this.toJSON();
        let result = new LocationLocalizationModel();
        result.init(json);
        return result;
    }
}

export interface ILocationLocalizationModel {
    locationId: string;
    currency: string | undefined;
    dateFormat: string | undefined;
}

export class LocationModel implements ILocationModel {
    id: string;
    companyId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    idhLaboratoryAccountNumber: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.billingEmail = _data["billingEmail"];
            this.phone = _data["phone"];
            this.scanHubEmail = _data["scanHubEmail"];
            this.logoUrl = _data["logoUrl"];
            this.taxNumber = _data["taxNumber"];
            this.currency = _data["currency"];
            this.dateFormat = _data["dateFormat"];
            this.teethType = _data["teethType"];
            this.shadeSystem = _data["shadeSystem"];
            this.idhLaboratoryAccountNumber = _data["idhLaboratoryAccountNumber"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["billingEmail"] = this.billingEmail;
        data["phone"] = this.phone;
        data["scanHubEmail"] = this.scanHubEmail;
        data["logoUrl"] = this.logoUrl;
        data["taxNumber"] = this.taxNumber;
        data["currency"] = this.currency;
        data["dateFormat"] = this.dateFormat;
        data["teethType"] = this.teethType;
        data["shadeSystem"] = this.shadeSystem;
        data["idhLaboratoryAccountNumber"] = this.idhLaboratoryAccountNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationModel {
        const json = this.toJSON();
        let result = new LocationModel();
        result.init(json);
        return result;
    }
}

export interface ILocationModel {
    id: string;
    companyId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    billingEmail: string | undefined;
    phone: string | undefined;
    scanHubEmail: string | undefined;
    logoUrl: string | undefined;
    taxNumber: string | undefined;
    currency: string | undefined;
    dateFormat: string | undefined;
    teethType: number;
    shadeSystem: number;
    idhLaboratoryAccountNumber: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationModelPagedListDto implements ILocationModelPagedListDto {
    items: LocationModel[] | undefined;
    totalCount: number;

    constructor(data?: ILocationModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationModelPagedListDto {
        const json = this.toJSON();
        let result = new LocationModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface ILocationModelPagedListDto {
    items: LocationModel[] | undefined;
    totalCount: number;
}

export class LocationRoute implements ILocationRoute {
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;
    isDefault: boolean;
    location: Location;
    practices: Practice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deliveryDays = _data["deliveryDays"];
            this.isDefault = _data["isDefault"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(Practice.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationRoute {
        data = typeof data === 'object' ? data : {};
        let result = new LocationRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deliveryDays"] = this.deliveryDays;
        data["isDefault"] = this.isDefault;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationRoute {
        const json = this.toJSON();
        let result = new LocationRoute();
        result.init(json);
        return result;
    }
}

export interface ILocationRoute {
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;
    isDefault: boolean;
    location: Location;
    practices: Practice[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationRouteCreateModel implements ILocationRouteCreateModel {
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;

    constructor(data?: ILocationRouteCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deliveryDays = _data["deliveryDays"];
        }
    }

    static fromJS(data: any): LocationRouteCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationRouteCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deliveryDays"] = this.deliveryDays;
        return data;
    }

    clone(): LocationRouteCreateModel {
        const json = this.toJSON();
        let result = new LocationRouteCreateModel();
        result.init(json);
        return result;
    }
}

export interface ILocationRouteCreateModel {
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;
}

export class LocationRouteModel implements ILocationRouteModel {
    id: string;
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;
    isDefault: boolean;

    constructor(data?: ILocationRouteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deliveryDays = _data["deliveryDays"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): LocationRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationRouteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deliveryDays"] = this.deliveryDays;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): LocationRouteModel {
        const json = this.toJSON();
        let result = new LocationRouteModel();
        result.init(json);
        return result;
    }
}

export interface ILocationRouteModel {
    id: string;
    locationId: string;
    name: string | undefined;
    description: string | undefined;
    deliveryDays: number;
    isDefault: boolean;
}

export class LocationSubdomainSettings implements ILocationSubdomainSettings {
    locationId: string;
    cloudflareRecordId: string | undefined;
    subdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationSubdomainSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.cloudflareRecordId = _data["cloudflareRecordId"];
            this.subdomain = _data["subdomain"];
            this.logoUrl = _data["logoUrl"];
            this.backgroundUrl = _data["backgroundUrl"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationSubdomainSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSubdomainSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["cloudflareRecordId"] = this.cloudflareRecordId;
        data["subdomain"] = this.subdomain;
        data["logoUrl"] = this.logoUrl;
        data["backgroundUrl"] = this.backgroundUrl;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationSubdomainSettings {
        const json = this.toJSON();
        let result = new LocationSubdomainSettings();
        result.init(json);
        return result;
    }
}

export interface ILocationSubdomainSettings {
    locationId: string;
    cloudflareRecordId: string | undefined;
    subdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationXeroConfig implements ILocationXeroConfig {
    locationId: string | undefined;
    accountType: string | undefined;
    sendAfterMinutes: number | undefined;
    sendEveryMinutes: number | undefined;
    sendAtTime: string | undefined;
    sendOnDayOfMonth: number | undefined;
    isLinked: boolean;

    constructor(data?: ILocationXeroConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.accountType = _data["accountType"];
            this.sendAfterMinutes = _data["sendAfterMinutes"];
            this.sendEveryMinutes = _data["sendEveryMinutes"];
            this.sendAtTime = _data["sendAtTime"];
            this.sendOnDayOfMonth = _data["sendOnDayOfMonth"];
            this.isLinked = _data["isLinked"];
        }
    }

    static fromJS(data: any): LocationXeroConfig {
        data = typeof data === 'object' ? data : {};
        let result = new LocationXeroConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["accountType"] = this.accountType;
        data["sendAfterMinutes"] = this.sendAfterMinutes;
        data["sendEveryMinutes"] = this.sendEveryMinutes;
        data["sendAtTime"] = this.sendAtTime;
        data["sendOnDayOfMonth"] = this.sendOnDayOfMonth;
        data["isLinked"] = this.isLinked;
        return data;
    }

    clone(): LocationXeroConfig {
        const json = this.toJSON();
        let result = new LocationXeroConfig();
        result.init(json);
        return result;
    }
}

export interface ILocationXeroConfig {
    locationId: string | undefined;
    accountType: string | undefined;
    sendAfterMinutes: number | undefined;
    sendEveryMinutes: number | undefined;
    sendAtTime: string | undefined;
    sendOnDayOfMonth: number | undefined;
    isLinked: boolean;
}

export class LocationsTag implements ILocationsTag {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationsTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.tag = _data["tag"];
            this.isDefault = _data["isDefault"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationsTag {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["tag"] = this.tag;
        data["isDefault"] = this.isDefault;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationsTag {
        const json = this.toJSON();
        let result = new LocationsTag();
        result.init(json);
        return result;
    }
}

export interface ILocationsTag {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class LocationsTagCreateModel implements ILocationsTagCreateModel {
    locationId: string;
    tag: string | undefined;

    constructor(data?: ILocationsTagCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): LocationsTagCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsTagCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["tag"] = this.tag;
        return data;
    }

    clone(): LocationsTagCreateModel {
        const json = this.toJSON();
        let result = new LocationsTagCreateModel();
        result.init(json);
        return result;
    }
}

export interface ILocationsTagCreateModel {
    locationId: string;
    tag: string | undefined;
}

export class LocationsTagListModel implements ILocationsTagListModel {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;

    constructor(data?: ILocationsTagListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.tag = _data["tag"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): LocationsTagListModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsTagListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["tag"] = this.tag;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): LocationsTagListModel {
        const json = this.toJSON();
        let result = new LocationsTagListModel();
        result.init(json);
        return result;
    }
}

export interface ILocationsTagListModel {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;
}

export class LocationsTagModel implements ILocationsTagModel {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ILocationsTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.tag = _data["tag"];
            this.isDefault = _data["isDefault"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): LocationsTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["tag"] = this.tag;
        data["isDefault"] = this.isDefault;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): LocationsTagModel {
        const json = this.toJSON();
        let result = new LocationsTagModel();
        result.init(json);
        return result;
    }
}

export interface ILocationsTagModel {
    id: string;
    locationId: string;
    tag: string | undefined;
    isDefault: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export enum LogicalOperator {
    And = <any>"And",
    Or = <any>"Or",
}

export class ManualInvoiceResponseModel implements IManualInvoiceResponseModel {
    orderId: string;
    invoiceId: string;
    statementId: string;

    constructor(data?: IManualInvoiceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.invoiceId = _data["invoiceId"];
            this.statementId = _data["statementId"];
        }
    }

    static fromJS(data: any): ManualInvoiceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualInvoiceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["invoiceId"] = this.invoiceId;
        data["statementId"] = this.statementId;
        return data;
    }

    clone(): ManualInvoiceResponseModel {
        const json = this.toJSON();
        let result = new ManualInvoiceResponseModel();
        result.init(json);
        return result;
    }
}

export interface IManualInvoiceResponseModel {
    orderId: string;
    invoiceId: string;
    statementId: string;
}

export class ManualInvoiceResponseModelResultMessage implements IManualInvoiceResponseModelResultMessage {
    model: ManualInvoiceResponseModel;
    result: boolean;
    message: string | undefined;

    constructor(data?: IManualInvoiceResponseModelResultMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? ManualInvoiceResponseModel.fromJS(_data["model"]) : <any>undefined;
            this.result = _data["result"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ManualInvoiceResponseModelResultMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ManualInvoiceResponseModelResultMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["result"] = this.result;
        data["message"] = this.message;
        return data;
    }

    clone(): ManualInvoiceResponseModelResultMessage {
        const json = this.toJSON();
        let result = new ManualInvoiceResponseModelResultMessage();
        result.init(json);
        return result;
    }
}

export interface IManualInvoiceResponseModelResultMessage {
    model: ManualInvoiceResponseModel;
    result: boolean;
    message: string | undefined;
}

export class MaterialModel implements IMaterialModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;

    constructor(data?: IMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isHide = _data["isHide"];
        }
    }

    static fromJS(data: any): MaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isHide"] = this.isHide;
        return data;
    }

    clone(): MaterialModel {
        const json = this.toJSON();
        let result = new MaterialModel();
        result.init(json);
        return result;
    }
}

export interface IMaterialModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;
}

export class ModelElement3shapeModel implements IModelElement3shapeModel {
    shade: string | undefined;
    shadeDisplayName: string | undefined;
    material: string | undefined;
    materialDisplayName: string | undefined;
    linkId: string | undefined;
    bridgeType: string | undefined;
    processStatus: string | undefined;
    ponticBaseShape: string | undefined;
    preparationLineFileName: any | undefined;
    deliveryDate: Date;
    modelElementIndex: number;
    scanModule: string | undefined;
    restorations: Restoration3shapeModel[] | undefined;

    constructor(data?: IModelElement3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shade = _data["Shade"];
            this.shadeDisplayName = _data["ShadeDisplayName"];
            this.material = _data["Material"];
            this.materialDisplayName = _data["MaterialDisplayName"];
            this.linkId = _data["LinkId"];
            this.bridgeType = _data["BridgeType"];
            this.processStatus = _data["ProcessStatus"];
            this.ponticBaseShape = _data["PonticBaseShape"];
            this.preparationLineFileName = _data["PreparationLineFileName"];
            this.deliveryDate = _data["DeliveryDate"] ? new Date(_data["DeliveryDate"].toString()) : <any>undefined;
            this.modelElementIndex = _data["ModelElementIndex"];
            this.scanModule = _data["ScanModule"];
            if (Array.isArray(_data["Restorations"])) {
                this.restorations = [] as any;
                for (let item of _data["Restorations"])
                    this.restorations.push(Restoration3shapeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelElement3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModelElement3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Shade"] = this.shade;
        data["ShadeDisplayName"] = this.shadeDisplayName;
        data["Material"] = this.material;
        data["MaterialDisplayName"] = this.materialDisplayName;
        data["LinkId"] = this.linkId;
        data["BridgeType"] = this.bridgeType;
        data["ProcessStatus"] = this.processStatus;
        data["PonticBaseShape"] = this.ponticBaseShape;
        data["PreparationLineFileName"] = this.preparationLineFileName;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["ModelElementIndex"] = this.modelElementIndex;
        data["ScanModule"] = this.scanModule;
        if (Array.isArray(this.restorations)) {
            data["Restorations"] = [];
            for (let item of this.restorations)
                data["Restorations"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModelElement3shapeModel {
        const json = this.toJSON();
        let result = new ModelElement3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IModelElement3shapeModel {
    shade: string | undefined;
    shadeDisplayName: string | undefined;
    material: string | undefined;
    materialDisplayName: string | undefined;
    linkId: string | undefined;
    bridgeType: string | undefined;
    processStatus: string | undefined;
    ponticBaseShape: string | undefined;
    preparationLineFileName: any | undefined;
    deliveryDate: Date;
    modelElementIndex: number;
    scanModule: string | undefined;
    restorations: Restoration3shapeModel[] | undefined;
}

export class MonetaryValue implements IMonetaryValue {
    currency: string | undefined;
    amount: number | undefined;

    constructor(data?: IMonetaryValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MonetaryValue {
        data = typeof data === 'object' ? data : {};
        let result = new MonetaryValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        return data;
    }

    clone(): MonetaryValue {
        const json = this.toJSON();
        let result = new MonetaryValue();
        result.init(json);
        return result;
    }
}

export interface IMonetaryValue {
    currency: string | undefined;
    amount: number | undefined;
}

export class NewStageModel implements INewStageModel {
    orderId: string;
    stage: string | undefined;
    orderProductsToAdd: OrderProductModel[] | undefined;

    constructor(data?: INewStageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.stage = _data["stage"];
            if (Array.isArray(_data["orderProductsToAdd"])) {
                this.orderProductsToAdd = [] as any;
                for (let item of _data["orderProductsToAdd"])
                    this.orderProductsToAdd.push(OrderProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewStageModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewStageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["stage"] = this.stage;
        if (Array.isArray(this.orderProductsToAdd)) {
            data["orderProductsToAdd"] = [];
            for (let item of this.orderProductsToAdd)
                data["orderProductsToAdd"].push(item.toJSON());
        }
        return data;
    }

    clone(): NewStageModel {
        const json = this.toJSON();
        let result = new NewStageModel();
        result.init(json);
        return result;
    }
}

export interface INewStageModel {
    orderId: string;
    stage: string | undefined;
    orderProductsToAdd: OrderProductModel[] | undefined;
}

export class Notification implements INotification {
    subject: string | undefined;
    content: string | undefined;
    notificationType: NotificationType;
    notificationRecipientType: NotificationRecipientType;
    senderIdentifier: string | undefined;
    senderName: string | undefined;
    isActive: boolean;
    triggerId: number;
    trigger: NotificationTrigger;
    locationId: string | undefined;
    location: Location;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.notificationType = _data["notificationType"];
            this.notificationRecipientType = _data["notificationRecipientType"];
            this.senderIdentifier = _data["senderIdentifier"];
            this.senderName = _data["senderName"];
            this.isActive = _data["isActive"];
            this.triggerId = _data["triggerId"];
            this.trigger = _data["trigger"] ? NotificationTrigger.fromJS(_data["trigger"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["notificationType"] = this.notificationType;
        data["notificationRecipientType"] = this.notificationRecipientType;
        data["senderIdentifier"] = this.senderIdentifier;
        data["senderName"] = this.senderName;
        data["isActive"] = this.isActive;
        data["triggerId"] = this.triggerId;
        data["trigger"] = this.trigger ? this.trigger.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Notification {
        const json = this.toJSON();
        let result = new Notification();
        result.init(json);
        return result;
    }
}

export interface INotification {
    subject: string | undefined;
    content: string | undefined;
    notificationType: NotificationType;
    notificationRecipientType: NotificationRecipientType;
    senderIdentifier: string | undefined;
    senderName: string | undefined;
    isActive: boolean;
    triggerId: number;
    trigger: NotificationTrigger;
    locationId: string | undefined;
    location: Location;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class NotificationModel implements INotificationModel {
    subject: string | undefined;
    content: string | undefined;
    notificationType: NotificationType;
    notificationRecipientType: NotificationRecipientType;
    senderIdentifier: string | undefined;
    senderName: string | undefined;
    isActive: boolean;
    triggerId: number;
    locationId: string | undefined;
    trigger: NotificationTriggerModel;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.notificationType = _data["notificationType"];
            this.notificationRecipientType = _data["notificationRecipientType"];
            this.senderIdentifier = _data["senderIdentifier"];
            this.senderName = _data["senderName"];
            this.isActive = _data["isActive"];
            this.triggerId = _data["triggerId"];
            this.locationId = _data["locationId"];
            this.trigger = _data["trigger"] ? NotificationTriggerModel.fromJS(_data["trigger"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["notificationType"] = this.notificationType;
        data["notificationRecipientType"] = this.notificationRecipientType;
        data["senderIdentifier"] = this.senderIdentifier;
        data["senderName"] = this.senderName;
        data["isActive"] = this.isActive;
        data["triggerId"] = this.triggerId;
        data["locationId"] = this.locationId;
        data["trigger"] = this.trigger ? this.trigger.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): NotificationModel {
        const json = this.toJSON();
        let result = new NotificationModel();
        result.init(json);
        return result;
    }
}

export interface INotificationModel {
    subject: string | undefined;
    content: string | undefined;
    notificationType: NotificationType;
    notificationRecipientType: NotificationRecipientType;
    senderIdentifier: string | undefined;
    senderName: string | undefined;
    isActive: boolean;
    triggerId: number;
    locationId: string | undefined;
    trigger: NotificationTriggerModel;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export enum NotificationRecipientType {
    Company = <any>"Company",
    Location = <any>"Location",
    Doctor = <any>"Doctor",
    User = <any>"User",
}

export class NotificationTrigger implements INotificationTrigger {
    id: number;
    name: string | undefined;
    code: string | undefined;
    variables: NotificationTriggerVariable[] | undefined;
    notifications: Notification[] | undefined;

    constructor(data?: INotificationTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["variables"])) {
                this.variables = [] as any;
                for (let item of _data["variables"])
                    this.variables.push(NotificationTriggerVariable.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(Notification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.variables)) {
            data["variables"] = [];
            for (let item of this.variables)
                data["variables"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }

    clone(): NotificationTrigger {
        const json = this.toJSON();
        let result = new NotificationTrigger();
        result.init(json);
        return result;
    }
}

export interface INotificationTrigger {
    id: number;
    name: string | undefined;
    code: string | undefined;
    variables: NotificationTriggerVariable[] | undefined;
    notifications: Notification[] | undefined;
}

export class NotificationTriggerModel implements INotificationTriggerModel {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: INotificationTriggerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): NotificationTriggerModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTriggerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): NotificationTriggerModel {
        const json = this.toJSON();
        let result = new NotificationTriggerModel();
        result.init(json);
        return result;
    }
}

export interface INotificationTriggerModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class NotificationTriggerVariable implements INotificationTriggerVariable {
    id: number;
    triggerId: number;
    trigger: NotificationTrigger;
    variableId: number;
    variable: NotificationVariable;

    constructor(data?: INotificationTriggerVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.triggerId = _data["triggerId"];
            this.trigger = _data["trigger"] ? NotificationTrigger.fromJS(_data["trigger"]) : <any>undefined;
            this.variableId = _data["variableId"];
            this.variable = _data["variable"] ? NotificationVariable.fromJS(_data["variable"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationTriggerVariable {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTriggerVariable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["triggerId"] = this.triggerId;
        data["trigger"] = this.trigger ? this.trigger.toJSON() : <any>undefined;
        data["variableId"] = this.variableId;
        data["variable"] = this.variable ? this.variable.toJSON() : <any>undefined;
        return data;
    }

    clone(): NotificationTriggerVariable {
        const json = this.toJSON();
        let result = new NotificationTriggerVariable();
        result.init(json);
        return result;
    }
}

export interface INotificationTriggerVariable {
    id: number;
    triggerId: number;
    trigger: NotificationTrigger;
    variableId: number;
    variable: NotificationVariable;
}

export enum NotificationType {
    Email = <any>"Email",
    SMS = <any>"SMS",
}

export class NotificationVariable implements INotificationVariable {
    id: number;
    name: string | undefined;
    code: string | undefined;
    triggers: NotificationTriggerVariable[] | undefined;

    constructor(data?: INotificationVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["triggers"])) {
                this.triggers = [] as any;
                for (let item of _data["triggers"])
                    this.triggers.push(NotificationTriggerVariable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationVariable {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationVariable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.triggers)) {
            data["triggers"] = [];
            for (let item of this.triggers)
                data["triggers"].push(item.toJSON());
        }
        return data;
    }

    clone(): NotificationVariable {
        const json = this.toJSON();
        let result = new NotificationVariable();
        result.init(json);
        return result;
    }
}

export interface INotificationVariable {
    id: number;
    name: string | undefined;
    code: string | undefined;
    triggers: NotificationTriggerVariable[] | undefined;
}

export class NotificationVariableModel implements INotificationVariableModel {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: INotificationVariableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): NotificationVariableModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationVariableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): NotificationVariableModel {
        const json = this.toJSON();
        let result = new NotificationVariableModel();
        result.init(json);
        return result;
    }
}

export interface INotificationVariableModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class OnboardingFinishedStep implements IOnboardingFinishedStep {
    userId: string;
    locationId: string;
    step: number;
    user: User;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOnboardingFinishedStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.locationId = _data["locationId"];
            this.step = _data["step"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OnboardingFinishedStep {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingFinishedStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["locationId"] = this.locationId;
        data["step"] = this.step;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OnboardingFinishedStep {
        const json = this.toJSON();
        let result = new OnboardingFinishedStep();
        result.init(json);
        return result;
    }
}

export interface IOnboardingFinishedStep {
    userId: string;
    locationId: string;
    step: number;
    user: User;
    location: Location;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OnboardingFinishedStepModel implements IOnboardingFinishedStepModel {
    id: string;
    userId: string;
    step: number;

    constructor(data?: IOnboardingFinishedStepModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): OnboardingFinishedStepModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingFinishedStepModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["step"] = this.step;
        return data;
    }

    clone(): OnboardingFinishedStepModel {
        const json = this.toJSON();
        let result = new OnboardingFinishedStepModel();
        result.init(json);
        return result;
    }
}

export interface IOnboardingFinishedStepModel {
    id: string;
    userId: string;
    step: number;
}

export class Order implements IOrder {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    masterOrderId: string | undefined;
    remakeReason: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    manufactureDate: Date | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    status: OrderStatus;
    manufactureLocation: Location;
    submanufactureLocation: Location;
    location: Location;
    practice: Practice;
    patient: Patient;
    dentist: User;
    category: ProductCategory;
    orderFiles: OrderFile[] | undefined;
    orderProducts: OrderProduct[] | undefined;
    orderNotes: OrderNote[] | undefined;
    tags: OrderTag[] | undefined;
    stages: OrderStage[] | undefined;
    treatmentPlans: TreatmentPlan[] | undefined;
    invoices: Invoice[] | undefined;
    orderLogs: OrderLog[] | undefined;
    shipments: OrderShipment[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    practiceDentistList: PracticeDentistList;
    workbenchTasks: WorkbenchTask[] | undefined;
    orderCustomFees: OrderCustomFee[] | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformation;
    order3ShapeOption: Order3ShapeOption;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.orderStatusId = _data["orderStatusId"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.manufactureLocationId = _data["manufactureLocationId"];
            this.submanufactureLocationId = _data["submanufactureLocationId"];
            this.isDraft = _data["isDraft"];
            this.categoryId = _data["categoryId"];
            this.orderSubmittedDate = _data["orderSubmittedDate"] ? new Date(_data["orderSubmittedDate"].toString()) : <any>undefined;
            this.scansImpressions = _data["scansImpressions"];
            this.scansImpressionsSend = _data["scansImpressionsSend"];
            this.code = _data["code"];
            this.isOrderAccepted = _data["isOrderAccepted"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.panNumber = _data["panNumber"];
            this.isArchived = _data["isArchived"];
            this.masterOrderId = _data["masterOrderId"];
            this.remakeReason = _data["remakeReason"];
            this.startStage = _data["startStage"];
            this.qcApprovedBy = _data["qcApprovedBy"];
            this.qcApprovedAt = _data["qcApprovedAt"] ? new Date(_data["qcApprovedAt"].toString()) : <any>undefined;
            this.isSimpleFlow = _data["isSimpleFlow"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
            this.manufactureDate = _data["manufactureDate"] ? new Date(_data["manufactureDate"].toString()) : <any>undefined;
            this.requestedDueDate = _data["requestedDueDate"] ? new Date(_data["requestedDueDate"].toString()) : <any>undefined;
            this.scanId = _data["scanId"];
            this.isAdminSetupDueDate = _data["isAdminSetupDueDate"];
            this.receivingType = _data["receivingType"];
            this.receivingOption = _data["receivingOption"];
            this.receivingText = _data["receivingText"];
            this.status = _data["status"] ? OrderStatus.fromJS(_data["status"]) : <any>undefined;
            this.manufactureLocation = _data["manufactureLocation"] ? Location.fromJS(_data["manufactureLocation"]) : <any>undefined;
            this.submanufactureLocation = _data["submanufactureLocation"] ? Location.fromJS(_data["submanufactureLocation"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.category = _data["category"] ? ProductCategory.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFile.fromJS(item));
            }
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProduct.fromJS(item));
            }
            if (Array.isArray(_data["orderNotes"])) {
                this.orderNotes = [] as any;
                for (let item of _data["orderNotes"])
                    this.orderNotes.push(OrderNote.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(OrderTag.fromJS(item));
            }
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages.push(OrderStage.fromJS(item));
            }
            if (Array.isArray(_data["treatmentPlans"])) {
                this.treatmentPlans = [] as any;
                for (let item of _data["treatmentPlans"])
                    this.treatmentPlans.push(TreatmentPlan.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["orderLogs"])) {
                this.orderLogs = [] as any;
                for (let item of _data["orderLogs"])
                    this.orderLogs.push(OrderLog.fromJS(item));
            }
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments.push(OrderShipment.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatement.fromJS(item));
            }
            this.practiceDentistList = _data["practiceDentistList"] ? PracticeDentistList.fromJS(_data["practiceDentistList"]) : <any>undefined;
            if (Array.isArray(_data["workbenchTasks"])) {
                this.workbenchTasks = [] as any;
                for (let item of _data["workbenchTasks"])
                    this.workbenchTasks.push(WorkbenchTask.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomFees"])) {
                this.orderCustomFees = [] as any;
                for (let item of _data["orderCustomFees"])
                    this.orderCustomFees.push(OrderCustomFee.fromJS(item));
            }
            this.orderOrthodonticsInformations = _data["orderOrthodonticsInformations"] ? OrderOrthodonticsInformation.fromJS(_data["orderOrthodonticsInformations"]) : <any>undefined;
            this.order3ShapeOption = _data["order3ShapeOption"] ? Order3ShapeOption.fromJS(_data["order3ShapeOption"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["orderStatusId"] = this.orderStatusId;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["manufactureLocationId"] = this.manufactureLocationId;
        data["submanufactureLocationId"] = this.submanufactureLocationId;
        data["isDraft"] = this.isDraft;
        data["categoryId"] = this.categoryId;
        data["orderSubmittedDate"] = this.orderSubmittedDate ? this.orderSubmittedDate.toISOString() : <any>undefined;
        data["scansImpressions"] = this.scansImpressions;
        data["scansImpressionsSend"] = this.scansImpressionsSend;
        data["code"] = this.code;
        data["isOrderAccepted"] = this.isOrderAccepted;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["panNumber"] = this.panNumber;
        data["isArchived"] = this.isArchived;
        data["masterOrderId"] = this.masterOrderId;
        data["remakeReason"] = this.remakeReason;
        data["startStage"] = this.startStage;
        data["qcApprovedBy"] = this.qcApprovedBy;
        data["qcApprovedAt"] = this.qcApprovedAt ? this.qcApprovedAt.toISOString() : <any>undefined;
        data["isSimpleFlow"] = this.isSimpleFlow;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        data["manufactureDate"] = this.manufactureDate ? this.manufactureDate.toISOString() : <any>undefined;
        data["requestedDueDate"] = this.requestedDueDate ? this.requestedDueDate.toISOString() : <any>undefined;
        data["scanId"] = this.scanId;
        data["isAdminSetupDueDate"] = this.isAdminSetupDueDate;
        data["receivingType"] = this.receivingType;
        data["receivingOption"] = this.receivingOption;
        data["receivingText"] = this.receivingText;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["manufactureLocation"] = this.manufactureLocation ? this.manufactureLocation.toJSON() : <any>undefined;
        data["submanufactureLocation"] = this.submanufactureLocation ? this.submanufactureLocation.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderNotes)) {
            data["orderNotes"] = [];
            for (let item of this.orderNotes)
                data["orderNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentPlans)) {
            data["treatmentPlans"] = [];
            for (let item of this.treatmentPlans)
                data["treatmentPlans"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.orderLogs)) {
            data["orderLogs"] = [];
            for (let item of this.orderLogs)
                data["orderLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        data["practiceDentistList"] = this.practiceDentistList ? this.practiceDentistList.toJSON() : <any>undefined;
        if (Array.isArray(this.workbenchTasks)) {
            data["workbenchTasks"] = [];
            for (let item of this.workbenchTasks)
                data["workbenchTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomFees)) {
            data["orderCustomFees"] = [];
            for (let item of this.orderCustomFees)
                data["orderCustomFees"].push(item.toJSON());
        }
        data["orderOrthodonticsInformations"] = this.orderOrthodonticsInformations ? this.orderOrthodonticsInformations.toJSON() : <any>undefined;
        data["order3ShapeOption"] = this.order3ShapeOption ? this.order3ShapeOption.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    masterOrderId: string | undefined;
    remakeReason: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    manufactureDate: Date | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    status: OrderStatus;
    manufactureLocation: Location;
    submanufactureLocation: Location;
    location: Location;
    practice: Practice;
    patient: Patient;
    dentist: User;
    category: ProductCategory;
    orderFiles: OrderFile[] | undefined;
    orderProducts: OrderProduct[] | undefined;
    orderNotes: OrderNote[] | undefined;
    tags: OrderTag[] | undefined;
    stages: OrderStage[] | undefined;
    treatmentPlans: TreatmentPlan[] | undefined;
    invoices: Invoice[] | undefined;
    orderLogs: OrderLog[] | undefined;
    shipments: OrderShipment[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    practiceDentistList: PracticeDentistList;
    workbenchTasks: WorkbenchTask[] | undefined;
    orderCustomFees: OrderCustomFee[] | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformation;
    order3ShapeOption: Order3ShapeOption;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class Order3ShapeModel implements IOrder3ShapeModel {
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    description: string | undefined;
    startStage: string | undefined;
    orderProducts: Order3ShapeProductModel[] | undefined;

    constructor(data?: IOrder3ShapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.description = _data["description"];
            this.startStage = _data["startStage"];
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(Order3ShapeProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order3ShapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Order3ShapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["description"] = this.description;
        data["startStage"] = this.startStage;
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): Order3ShapeModel {
        const json = this.toJSON();
        let result = new Order3ShapeModel();
        result.init(json);
        return result;
    }
}

export interface IOrder3ShapeModel {
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    description: string | undefined;
    startStage: string | undefined;
    orderProducts: Order3ShapeProductModel[] | undefined;
}

export class Order3ShapeOption implements IOrder3ShapeOption {
    orderId: string;
    locationId: string;
    external3ShapeId: string;
    created: Date;
    updatedOn: Date;
    creatorId: string;
    creatorName: string | undefined;
    creatorEmail: string | undefined;
    version: string | undefined;
    scanSource: string | undefined;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrder3ShapeOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.external3ShapeId = _data["external3ShapeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
            this.creatorName = _data["creatorName"];
            this.creatorEmail = _data["creatorEmail"];
            this.version = _data["version"];
            this.scanSource = _data["scanSource"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Order3ShapeOption {
        data = typeof data === 'object' ? data : {};
        let result = new Order3ShapeOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["external3ShapeId"] = this.external3ShapeId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["creatorName"] = this.creatorName;
        data["creatorEmail"] = this.creatorEmail;
        data["version"] = this.version;
        data["scanSource"] = this.scanSource;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Order3ShapeOption {
        const json = this.toJSON();
        let result = new Order3ShapeOption();
        result.init(json);
        return result;
    }
}

export interface IOrder3ShapeOption {
    orderId: string;
    locationId: string;
    external3ShapeId: string;
    created: Date;
    updatedOn: Date;
    creatorId: string;
    creatorName: string | undefined;
    creatorEmail: string | undefined;
    version: string | undefined;
    scanSource: string | undefined;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class Order3ShapeOptionModel implements IOrder3ShapeOptionModel {
    orderId: string;
    locationId: string;
    external3ShapeId: string;
    created: Date;
    updatedOn: Date;
    creatorId: string;
    creatorName: string | undefined;
    creatorEmail: string | undefined;
    version: string | undefined;
    scanSource: string | undefined;
    order: Order;

    constructor(data?: IOrder3ShapeOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.external3ShapeId = _data["external3ShapeId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
            this.creatorName = _data["creatorName"];
            this.creatorEmail = _data["creatorEmail"];
            this.version = _data["version"];
            this.scanSource = _data["scanSource"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Order3ShapeOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new Order3ShapeOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["external3ShapeId"] = this.external3ShapeId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["creatorName"] = this.creatorName;
        data["creatorEmail"] = this.creatorEmail;
        data["version"] = this.version;
        data["scanSource"] = this.scanSource;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }

    clone(): Order3ShapeOptionModel {
        const json = this.toJSON();
        let result = new Order3ShapeOptionModel();
        result.init(json);
        return result;
    }
}

export interface IOrder3ShapeOptionModel {
    orderId: string;
    locationId: string;
    external3ShapeId: string;
    created: Date;
    updatedOn: Date;
    creatorId: string;
    creatorName: string | undefined;
    creatorEmail: string | undefined;
    version: string | undefined;
    scanSource: string | undefined;
    order: Order;
}

export class Order3ShapeProductModel implements IOrder3ShapeProductModel {
    _3ShapeProductName: string | undefined;
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: ProductModel;
    orderProductColor: OrderProductColorModel;

    constructor(data?: IOrder3ShapeProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._3ShapeProductName = _data["_3ShapeProductName"];
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.materialName = _data["materialName"];
            this.standardTierName = _data["standardTierName"];
            this.teeth = _data["teeth"];
            this.arch = _data["arch"];
            this.shade = _data["shade"];
            this.shadeSystem = _data["shadeSystem"];
            this.implantSpecification = _data["implantSpecification"];
            this.implantScanbody = _data["implantScanbody"];
            this.implantScanbodyText = _data["implantScanbodyText"];
            this.isAddon = _data["isAddon"];
            this.discount = _data["discount"];
            this.isInvoiced = _data["isInvoiced"];
            this.quantity = _data["quantity"];
            this.isDefaultForOrder = _data["isDefaultForOrder"];
            this.product = _data["product"] ? ProductModel.fromJS(_data["product"]) : <any>undefined;
            this.orderProductColor = _data["orderProductColor"] ? OrderProductColorModel.fromJS(_data["orderProductColor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Order3ShapeProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new Order3ShapeProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_3ShapeProductName"] = this._3ShapeProductName;
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["materialName"] = this.materialName;
        data["standardTierName"] = this.standardTierName;
        data["teeth"] = this.teeth;
        data["arch"] = this.arch;
        data["shade"] = this.shade;
        data["shadeSystem"] = this.shadeSystem;
        data["implantSpecification"] = this.implantSpecification;
        data["implantScanbody"] = this.implantScanbody;
        data["implantScanbodyText"] = this.implantScanbodyText;
        data["isAddon"] = this.isAddon;
        data["discount"] = this.discount;
        data["isInvoiced"] = this.isInvoiced;
        data["quantity"] = this.quantity;
        data["isDefaultForOrder"] = this.isDefaultForOrder;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["orderProductColor"] = this.orderProductColor ? this.orderProductColor.toJSON() : <any>undefined;
        return data;
    }

    clone(): Order3ShapeProductModel {
        const json = this.toJSON();
        let result = new Order3ShapeProductModel();
        result.init(json);
        return result;
    }
}

export interface IOrder3ShapeProductModel {
    _3ShapeProductName: string | undefined;
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: ProductModel;
    orderProductColor: OrderProductColorModel;
}

export class OrderAccountHolderPracticeUpdateModel implements IOrderAccountHolderPracticeUpdateModel {
    orderId: string;
    practiceId: string;
    accountHolderId: string;
    patientId: string;

    constructor(data?: IOrderAccountHolderPracticeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.practiceId = _data["practiceId"];
            this.accountHolderId = _data["accountHolderId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): OrderAccountHolderPracticeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAccountHolderPracticeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["practiceId"] = this.practiceId;
        data["accountHolderId"] = this.accountHolderId;
        data["patientId"] = this.patientId;
        return data;
    }

    clone(): OrderAccountHolderPracticeUpdateModel {
        const json = this.toJSON();
        let result = new OrderAccountHolderPracticeUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IOrderAccountHolderPracticeUpdateModel {
    orderId: string;
    practiceId: string;
    accountHolderId: string;
    patientId: string;
}

export class OrderCreateModel implements IOrderCreateModel {
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    practiceDentistListId: string | undefined;

    constructor(data?: IOrderCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.practiceDentistListId = _data["practiceDentistListId"];
        }
    }

    static fromJS(data: any): OrderCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["practiceDentistListId"] = this.practiceDentistListId;
        return data;
    }

    clone(): OrderCreateModel {
        const json = this.toJSON();
        let result = new OrderCreateModel();
        result.init(json);
        return result;
    }
}

export interface IOrderCreateModel {
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    practiceDentistListId: string | undefined;
}

export class OrderCustomFee implements IOrderCustomFee {
    orderId: string;
    name: string | undefined;
    amount: number;
    isInvoiced: boolean;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderCustomFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.isInvoiced = _data["isInvoiced"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderCustomFee {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["isInvoiced"] = this.isInvoiced;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderCustomFee {
        const json = this.toJSON();
        let result = new OrderCustomFee();
        result.init(json);
        return result;
    }
}

export interface IOrderCustomFee {
    orderId: string;
    name: string | undefined;
    amount: number;
    isInvoiced: boolean;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderCustomFeeModel implements IOrderCustomFeeModel {
    id: string;
    orderId: string;
    name: string | undefined;
    amount: number;
    isInvoiced: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderCustomFeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.isInvoiced = _data["isInvoiced"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderCustomFeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomFeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["isInvoiced"] = this.isInvoiced;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderCustomFeeModel {
        const json = this.toJSON();
        let result = new OrderCustomFeeModel();
        result.init(json);
        return result;
    }
}

export interface IOrderCustomFeeModel {
    id: string;
    orderId: string;
    name: string | undefined;
    amount: number;
    isInvoiced: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderDetailModel implements IOrderDetailModel {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    dateFormat: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    dentistName: string | undefined;
    dentistPhoneNumber: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    logoUrl: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    isAdminSetupDueDate: boolean;
    status: OrderStatusModel;
    manufactureLocation: LocationModel;
    submanufactureLocation: LocationModel;
    location: LocationModel;
    practice: PracticeModel;
    patient: PatientModel;
    category: ProductCategoryModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderNotes: OrderNoteModel[] | undefined;
    tags: OrderTagModel[] | undefined;
    treatmentPlans: TreatmentPlanModel[] | undefined;
    stages: OrderStageModel[] | undefined;
    invoices: InvoiceBaseModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    locationDocumentSettings: LocationDocumentSettingsModel;
    dentistNotes: InternalNoteModel[] | undefined;
    practiceNotes: InternalNoteModel[] | undefined;
    patientNotes: InternalNoteModel[] | undefined;
    locationRoutId: string | undefined;
    locationRoutName: string | undefined;

    constructor(data?: IOrderDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.orderStatusId = _data["orderStatusId"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.manufactureLocationId = _data["manufactureLocationId"];
            this.submanufactureLocationId = _data["submanufactureLocationId"];
            this.isDraft = _data["isDraft"];
            this.dateFormat = _data["dateFormat"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.dentistName = _data["dentistName"];
            this.dentistPhoneNumber = _data["dentistPhoneNumber"];
            this.practiceName = _data["practiceName"];
            this.patientName = _data["patientName"];
            this.categoryId = _data["categoryId"];
            this.orderSubmittedDate = _data["orderSubmittedDate"] ? new Date(_data["orderSubmittedDate"].toString()) : <any>undefined;
            this.scansImpressions = _data["scansImpressions"];
            this.scansImpressionsSend = _data["scansImpressionsSend"];
            this.code = _data["code"];
            this.isOrderAccepted = _data["isOrderAccepted"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.panNumber = _data["panNumber"];
            this.isArchived = _data["isArchived"];
            this.qcApprovedBy = _data["qcApprovedBy"];
            this.qcApprovedAt = _data["qcApprovedAt"] ? new Date(_data["qcApprovedAt"].toString()) : <any>undefined;
            this.isSimpleFlow = _data["isSimpleFlow"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
            this.logoUrl = _data["logoUrl"];
            this.requestedDueDate = _data["requestedDueDate"] ? new Date(_data["requestedDueDate"].toString()) : <any>undefined;
            this.scanId = _data["scanId"];
            this.receivingType = _data["receivingType"];
            this.receivingOption = _data["receivingOption"];
            this.receivingText = _data["receivingText"];
            this.isAdminSetupDueDate = _data["isAdminSetupDueDate"];
            this.status = _data["status"] ? OrderStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.manufactureLocation = _data["manufactureLocation"] ? LocationModel.fromJS(_data["manufactureLocation"]) : <any>undefined;
            this.submanufactureLocation = _data["submanufactureLocation"] ? LocationModel.fromJS(_data["submanufactureLocation"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? PracticeModel.fromJS(_data["practice"]) : <any>undefined;
            this.patient = _data["patient"] ? PatientModel.fromJS(_data["patient"]) : <any>undefined;
            this.category = _data["category"] ? ProductCategoryModel.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFileModel.fromJS(item));
            }
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProductModel.fromJS(item));
            }
            if (Array.isArray(_data["orderNotes"])) {
                this.orderNotes = [] as any;
                for (let item of _data["orderNotes"])
                    this.orderNotes.push(OrderNoteModel.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(OrderTagModel.fromJS(item));
            }
            if (Array.isArray(_data["treatmentPlans"])) {
                this.treatmentPlans = [] as any;
                for (let item of _data["treatmentPlans"])
                    this.treatmentPlans.push(TreatmentPlanModel.fromJS(item));
            }
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages.push(OrderStageModel.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(InvoiceBaseModel.fromJS(item));
            }
            this.practiceDentistList = _data["practiceDentistList"] ? PracticeDentistListModel.fromJS(_data["practiceDentistList"]) : <any>undefined;
            if (Array.isArray(_data["orderCustomFees"])) {
                this.orderCustomFees = [] as any;
                for (let item of _data["orderCustomFees"])
                    this.orderCustomFees.push(OrderCustomFeeModel.fromJS(item));
            }
            this.orderOrthodonticsInformations = _data["orderOrthodonticsInformations"] ? OrderOrthodonticsInformationModel.fromJS(_data["orderOrthodonticsInformations"]) : <any>undefined;
            this.locationDocumentSettings = _data["locationDocumentSettings"] ? LocationDocumentSettingsModel.fromJS(_data["locationDocumentSettings"]) : <any>undefined;
            if (Array.isArray(_data["dentistNotes"])) {
                this.dentistNotes = [] as any;
                for (let item of _data["dentistNotes"])
                    this.dentistNotes.push(InternalNoteModel.fromJS(item));
            }
            if (Array.isArray(_data["practiceNotes"])) {
                this.practiceNotes = [] as any;
                for (let item of _data["practiceNotes"])
                    this.practiceNotes.push(InternalNoteModel.fromJS(item));
            }
            if (Array.isArray(_data["patientNotes"])) {
                this.patientNotes = [] as any;
                for (let item of _data["patientNotes"])
                    this.patientNotes.push(InternalNoteModel.fromJS(item));
            }
            this.locationRoutId = _data["locationRoutId"];
            this.locationRoutName = _data["locationRoutName"];
        }
    }

    static fromJS(data: any): OrderDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["orderStatusId"] = this.orderStatusId;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["manufactureLocationId"] = this.manufactureLocationId;
        data["submanufactureLocationId"] = this.submanufactureLocationId;
        data["isDraft"] = this.isDraft;
        data["dateFormat"] = this.dateFormat;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["dentistName"] = this.dentistName;
        data["dentistPhoneNumber"] = this.dentistPhoneNumber;
        data["practiceName"] = this.practiceName;
        data["patientName"] = this.patientName;
        data["categoryId"] = this.categoryId;
        data["orderSubmittedDate"] = this.orderSubmittedDate ? this.orderSubmittedDate.toISOString() : <any>undefined;
        data["scansImpressions"] = this.scansImpressions;
        data["scansImpressionsSend"] = this.scansImpressionsSend;
        data["code"] = this.code;
        data["isOrderAccepted"] = this.isOrderAccepted;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["panNumber"] = this.panNumber;
        data["isArchived"] = this.isArchived;
        data["qcApprovedBy"] = this.qcApprovedBy;
        data["qcApprovedAt"] = this.qcApprovedAt ? this.qcApprovedAt.toISOString() : <any>undefined;
        data["isSimpleFlow"] = this.isSimpleFlow;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        data["logoUrl"] = this.logoUrl;
        data["requestedDueDate"] = this.requestedDueDate ? this.requestedDueDate.toISOString() : <any>undefined;
        data["scanId"] = this.scanId;
        data["receivingType"] = this.receivingType;
        data["receivingOption"] = this.receivingOption;
        data["receivingText"] = this.receivingText;
        data["isAdminSetupDueDate"] = this.isAdminSetupDueDate;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["manufactureLocation"] = this.manufactureLocation ? this.manufactureLocation.toJSON() : <any>undefined;
        data["submanufactureLocation"] = this.submanufactureLocation ? this.submanufactureLocation.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderNotes)) {
            data["orderNotes"] = [];
            for (let item of this.orderNotes)
                data["orderNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentPlans)) {
            data["treatmentPlans"] = [];
            for (let item of this.treatmentPlans)
                data["treatmentPlans"].push(item.toJSON());
        }
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["practiceDentistList"] = this.practiceDentistList ? this.practiceDentistList.toJSON() : <any>undefined;
        if (Array.isArray(this.orderCustomFees)) {
            data["orderCustomFees"] = [];
            for (let item of this.orderCustomFees)
                data["orderCustomFees"].push(item.toJSON());
        }
        data["orderOrthodonticsInformations"] = this.orderOrthodonticsInformations ? this.orderOrthodonticsInformations.toJSON() : <any>undefined;
        data["locationDocumentSettings"] = this.locationDocumentSettings ? this.locationDocumentSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.dentistNotes)) {
            data["dentistNotes"] = [];
            for (let item of this.dentistNotes)
                data["dentistNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceNotes)) {
            data["practiceNotes"] = [];
            for (let item of this.practiceNotes)
                data["practiceNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.patientNotes)) {
            data["patientNotes"] = [];
            for (let item of this.patientNotes)
                data["patientNotes"].push(item.toJSON());
        }
        data["locationRoutId"] = this.locationRoutId;
        data["locationRoutName"] = this.locationRoutName;
        return data;
    }

    clone(): OrderDetailModel {
        const json = this.toJSON();
        let result = new OrderDetailModel();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailModel {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    dateFormat: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    dentistName: string | undefined;
    dentistPhoneNumber: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    logoUrl: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    isAdminSetupDueDate: boolean;
    status: OrderStatusModel;
    manufactureLocation: LocationModel;
    submanufactureLocation: LocationModel;
    location: LocationModel;
    practice: PracticeModel;
    patient: PatientModel;
    category: ProductCategoryModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderNotes: OrderNoteModel[] | undefined;
    tags: OrderTagModel[] | undefined;
    treatmentPlans: TreatmentPlanModel[] | undefined;
    stages: OrderStageModel[] | undefined;
    invoices: InvoiceBaseModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    locationDocumentSettings: LocationDocumentSettingsModel;
    dentistNotes: InternalNoteModel[] | undefined;
    practiceNotes: InternalNoteModel[] | undefined;
    patientNotes: InternalNoteModel[] | undefined;
    locationRoutId: string | undefined;
    locationRoutName: string | undefined;
}

export class OrderDueDateChangeModel implements IOrderDueDateChangeModel {
    orderId: string;
    dueDate: Date;

    constructor(data?: IOrderDueDateChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDueDateChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDueDateChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): OrderDueDateChangeModel {
        const json = this.toJSON();
        let result = new OrderDueDateChangeModel();
        result.init(json);
        return result;
    }
}

export interface IOrderDueDateChangeModel {
    orderId: string;
    dueDate: Date;
}

export class OrderFile implements IOrderFile {
    id: string;
    orderId: string;
    typeId: number;
    url: string | undefined;
    order: Order;
    type: OrderFileType;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.typeId = _data["typeId"];
            this.url = _data["url"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.type = _data["type"] ? OrderFileType.fromJS(_data["type"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderFile {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["typeId"] = this.typeId;
        data["url"] = this.url;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderFile {
        const json = this.toJSON();
        let result = new OrderFile();
        result.init(json);
        return result;
    }
}

export interface IOrderFile {
    id: string;
    orderId: string;
    typeId: number;
    url: string | undefined;
    order: Order;
    type: OrderFileType;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderFileModel implements IOrderFileModel {
    id: string;
    orderId: string;
    typeId: number;
    url: string | undefined;
    typeName: string | undefined;

    constructor(data?: IOrderFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.typeId = _data["typeId"];
            this.url = _data["url"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): OrderFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["typeId"] = this.typeId;
        data["url"] = this.url;
        data["typeName"] = this.typeName;
        return data;
    }

    clone(): OrderFileModel {
        const json = this.toJSON();
        let result = new OrderFileModel();
        result.init(json);
        return result;
    }
}

export interface IOrderFileModel {
    id: string;
    orderId: string;
    typeId: number;
    url: string | undefined;
    typeName: string | undefined;
}

export class OrderFileType implements IOrderFileType {
    id: number;
    name: string | undefined;
    orderFiles: OrderFile[] | undefined;

    constructor(data?: IOrderFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderFileType {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderFileType {
        const json = this.toJSON();
        let result = new OrderFileType();
        result.init(json);
        return result;
    }
}

export interface IOrderFileType {
    id: number;
    name: string | undefined;
    orderFiles: OrderFile[] | undefined;
}

export class OrderListResponse implements IOrderListResponse {
    orders: OrderModel[] | undefined;

    constructor(data?: IOrderListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderListResponse {
        const json = this.toJSON();
        let result = new OrderListResponse();
        result.init(json);
        return result;
    }
}

export interface IOrderListResponse {
    orders: OrderModel[] | undefined;
}

export class OrderListWithRoutResponse implements IOrderListWithRoutResponse {
    orders: OrderWithRoutModel[] | undefined;

    constructor(data?: IOrderListWithRoutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderWithRoutModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderListWithRoutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListWithRoutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderListWithRoutResponse {
        const json = this.toJSON();
        let result = new OrderListWithRoutResponse();
        result.init(json);
        return result;
    }
}

export interface IOrderListWithRoutResponse {
    orders: OrderWithRoutModel[] | undefined;
}

export class OrderLog implements IOrderLog {
    text: string | undefined;
    userFullName: string | undefined;
    orderId: string;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.userFullName = _data["userFullName"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderLog {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["userFullName"] = this.userFullName;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderLog {
        const json = this.toJSON();
        let result = new OrderLog();
        result.init(json);
        return result;
    }
}

export interface IOrderLog {
    text: string | undefined;
    userFullName: string | undefined;
    orderId: string;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderLogModel implements IOrderLogModel {
    id: string;
    createdAt: Date;
    createdById: string | undefined;
    text: string | undefined;
    userFullName: string | undefined;
    orderId: string;

    constructor(data?: IOrderLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.text = _data["text"];
            this.userFullName = _data["userFullName"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): OrderLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["text"] = this.text;
        data["userFullName"] = this.userFullName;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): OrderLogModel {
        const json = this.toJSON();
        let result = new OrderLogModel();
        result.init(json);
        return result;
    }
}

export interface IOrderLogModel {
    id: string;
    createdAt: Date;
    createdById: string | undefined;
    text: string | undefined;
    userFullName: string | undefined;
    orderId: string;
}

export class OrderModel implements IOrderModel {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    locationRoutName: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;

    constructor(data?: IOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.orderStatusId = _data["orderStatusId"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.manufactureLocationId = _data["manufactureLocationId"];
            this.submanufactureLocationId = _data["submanufactureLocationId"];
            this.isDraft = _data["isDraft"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.status = _data["status"] ? OrderStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.dentistName = _data["dentistName"];
            this.practiceName = _data["practiceName"];
            this.patientName = _data["patientName"];
            this.categoryId = _data["categoryId"];
            this.orderSubmittedDate = _data["orderSubmittedDate"] ? new Date(_data["orderSubmittedDate"].toString()) : <any>undefined;
            this.scansImpressions = _data["scansImpressions"];
            this.scansImpressionsSend = _data["scansImpressionsSend"];
            this.code = _data["code"];
            this.isOrderAccepted = _data["isOrderAccepted"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.panNumber = _data["panNumber"];
            this.isArchived = _data["isArchived"];
            this.tagList = _data["tagList"];
            this.startStage = _data["startStage"];
            this.qcApprovedBy = _data["qcApprovedBy"];
            this.qcApprovedAt = _data["qcApprovedAt"] ? new Date(_data["qcApprovedAt"].toString()) : <any>undefined;
            this.isSimpleFlow = _data["isSimpleFlow"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
            this.requestedDueDate = _data["requestedDueDate"] ? new Date(_data["requestedDueDate"].toString()) : <any>undefined;
            this.scanId = _data["scanId"];
            this.locationRoutName = _data["locationRoutName"];
            if (Array.isArray(_data["orderLogs"])) {
                this.orderLogs = [] as any;
                for (let item of _data["orderLogs"])
                    this.orderLogs.push(OrderLogModel.fromJS(item));
            }
            this.isAdminSetupDueDate = _data["isAdminSetupDueDate"];
            this.receivingType = _data["receivingType"];
            this.receivingOption = _data["receivingOption"];
            this.receivingText = _data["receivingText"];
            this.orderOrthodonticsInformations = _data["orderOrthodonticsInformations"] ? OrderOrthodonticsInformationModel.fromJS(_data["orderOrthodonticsInformations"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFileModel.fromJS(item));
            }
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProductModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomFees"])) {
                this.orderCustomFees = [] as any;
                for (let item of _data["orderCustomFees"])
                    this.orderCustomFees.push(OrderCustomFeeModel.fromJS(item));
            }
            this.practiceDentistList = _data["practiceDentistList"] ? PracticeDentistListModel.fromJS(_data["practiceDentistList"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.category = _data["category"] ? ProductCategoryModel.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["orderStatusId"] = this.orderStatusId;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["manufactureLocationId"] = this.manufactureLocationId;
        data["submanufactureLocationId"] = this.submanufactureLocationId;
        data["isDraft"] = this.isDraft;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["dentistName"] = this.dentistName;
        data["practiceName"] = this.practiceName;
        data["patientName"] = this.patientName;
        data["categoryId"] = this.categoryId;
        data["orderSubmittedDate"] = this.orderSubmittedDate ? this.orderSubmittedDate.toISOString() : <any>undefined;
        data["scansImpressions"] = this.scansImpressions;
        data["scansImpressionsSend"] = this.scansImpressionsSend;
        data["code"] = this.code;
        data["isOrderAccepted"] = this.isOrderAccepted;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["panNumber"] = this.panNumber;
        data["isArchived"] = this.isArchived;
        data["tagList"] = this.tagList;
        data["startStage"] = this.startStage;
        data["qcApprovedBy"] = this.qcApprovedBy;
        data["qcApprovedAt"] = this.qcApprovedAt ? this.qcApprovedAt.toISOString() : <any>undefined;
        data["isSimpleFlow"] = this.isSimpleFlow;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        data["requestedDueDate"] = this.requestedDueDate ? this.requestedDueDate.toISOString() : <any>undefined;
        data["scanId"] = this.scanId;
        data["locationRoutName"] = this.locationRoutName;
        if (Array.isArray(this.orderLogs)) {
            data["orderLogs"] = [];
            for (let item of this.orderLogs)
                data["orderLogs"].push(item.toJSON());
        }
        data["isAdminSetupDueDate"] = this.isAdminSetupDueDate;
        data["receivingType"] = this.receivingType;
        data["receivingOption"] = this.receivingOption;
        data["receivingText"] = this.receivingText;
        data["orderOrthodonticsInformations"] = this.orderOrthodonticsInformations ? this.orderOrthodonticsInformations.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomFees)) {
            data["orderCustomFees"] = [];
            for (let item of this.orderCustomFees)
                data["orderCustomFees"].push(item.toJSON());
        }
        data["practiceDentistList"] = this.practiceDentistList ? this.practiceDentistList.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderModel {
        const json = this.toJSON();
        let result = new OrderModel();
        result.init(json);
        return result;
    }
}

export interface IOrderModel {
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    locationRoutName: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;
}

export class OrderModelPagedListDto implements IOrderModelPagedListDto {
    items: OrderModel[] | undefined;
    totalCount: number;

    constructor(data?: IOrderModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderModelPagedListDto {
        const json = this.toJSON();
        let result = new OrderModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IOrderModelPagedListDto {
    items: OrderModel[] | undefined;
    totalCount: number;
}

export class OrderNote implements IOrderNote {
    id: string;
    orderId: string;
    sendTime: Date;
    userFullName: string | undefined;
    text: string | undefined;
    typeId: number;
    isDoctorResponseNeeded: boolean;
    isLocationResponseNeeded: boolean;
    order: Order;
    type: OrderNoteType;
    orderNoteAttachments: OrderNoteAttachment[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.sendTime = _data["sendTime"] ? new Date(_data["sendTime"].toString()) : <any>undefined;
            this.userFullName = _data["userFullName"];
            this.text = _data["text"];
            this.typeId = _data["typeId"];
            this.isDoctorResponseNeeded = _data["isDoctorResponseNeeded"];
            this.isLocationResponseNeeded = _data["isLocationResponseNeeded"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.type = _data["type"] ? OrderNoteType.fromJS(_data["type"]) : <any>undefined;
            if (Array.isArray(_data["orderNoteAttachments"])) {
                this.orderNoteAttachments = [] as any;
                for (let item of _data["orderNoteAttachments"])
                    this.orderNoteAttachments.push(OrderNoteAttachment.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderNote {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["userFullName"] = this.userFullName;
        data["text"] = this.text;
        data["typeId"] = this.typeId;
        data["isDoctorResponseNeeded"] = this.isDoctorResponseNeeded;
        data["isLocationResponseNeeded"] = this.isLocationResponseNeeded;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (Array.isArray(this.orderNoteAttachments)) {
            data["orderNoteAttachments"] = [];
            for (let item of this.orderNoteAttachments)
                data["orderNoteAttachments"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderNote {
        const json = this.toJSON();
        let result = new OrderNote();
        result.init(json);
        return result;
    }
}

export interface IOrderNote {
    id: string;
    orderId: string;
    sendTime: Date;
    userFullName: string | undefined;
    text: string | undefined;
    typeId: number;
    isDoctorResponseNeeded: boolean;
    isLocationResponseNeeded: boolean;
    order: Order;
    type: OrderNoteType;
    orderNoteAttachments: OrderNoteAttachment[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderNoteAttachment implements IOrderNoteAttachment {
    id: string;
    orderNoteId: string;
    code: string | undefined;
    fileUrl: string | undefined;
    orderNote: OrderNote;

    constructor(data?: IOrderNoteAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNoteId = _data["orderNoteId"];
            this.code = _data["code"];
            this.fileUrl = _data["fileUrl"];
            this.orderNote = _data["orderNote"] ? OrderNote.fromJS(_data["orderNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderNoteAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNoteId"] = this.orderNoteId;
        data["code"] = this.code;
        data["fileUrl"] = this.fileUrl;
        data["orderNote"] = this.orderNote ? this.orderNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderNoteAttachment {
        const json = this.toJSON();
        let result = new OrderNoteAttachment();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteAttachment {
    id: string;
    orderNoteId: string;
    code: string | undefined;
    fileUrl: string | undefined;
    orderNote: OrderNote;
}

export class OrderNoteAttachmentModel implements IOrderNoteAttachmentModel {
    id: string;
    orderNoteId: string;
    code: string | undefined;
    fileUrl: string | undefined;

    constructor(data?: IOrderNoteAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNoteId = _data["orderNoteId"];
            this.code = _data["code"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): OrderNoteAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNoteId"] = this.orderNoteId;
        data["code"] = this.code;
        data["fileUrl"] = this.fileUrl;
        return data;
    }

    clone(): OrderNoteAttachmentModel {
        const json = this.toJSON();
        let result = new OrderNoteAttachmentModel();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteAttachmentModel {
    id: string;
    orderNoteId: string;
    code: string | undefined;
    fileUrl: string | undefined;
}

export class OrderNoteModel implements IOrderNoteModel {
    id: string;
    orderId: string;
    text: string | undefined;
    typeId: number;
    isDoctorResponseNeeded: boolean;
    isLocationResponseNeeded: boolean;
    userFullName: string | undefined;
    sendTime: Date;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    orderNoteAttachments: OrderNoteAttachmentModel[] | undefined;

    constructor(data?: IOrderNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.text = _data["text"];
            this.typeId = _data["typeId"];
            this.isDoctorResponseNeeded = _data["isDoctorResponseNeeded"];
            this.isLocationResponseNeeded = _data["isLocationResponseNeeded"];
            this.userFullName = _data["userFullName"];
            this.sendTime = _data["sendTime"] ? new Date(_data["sendTime"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            if (Array.isArray(_data["orderNoteAttachments"])) {
                this.orderNoteAttachments = [] as any;
                for (let item of _data["orderNoteAttachments"])
                    this.orderNoteAttachments.push(OrderNoteAttachmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["text"] = this.text;
        data["typeId"] = this.typeId;
        data["isDoctorResponseNeeded"] = this.isDoctorResponseNeeded;
        data["isLocationResponseNeeded"] = this.isLocationResponseNeeded;
        data["userFullName"] = this.userFullName;
        data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        if (Array.isArray(this.orderNoteAttachments)) {
            data["orderNoteAttachments"] = [];
            for (let item of this.orderNoteAttachments)
                data["orderNoteAttachments"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderNoteModel {
        const json = this.toJSON();
        let result = new OrderNoteModel();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteModel {
    id: string;
    orderId: string;
    text: string | undefined;
    typeId: number;
    isDoctorResponseNeeded: boolean;
    isLocationResponseNeeded: boolean;
    userFullName: string | undefined;
    sendTime: Date;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    orderNoteAttachments: OrderNoteAttachmentModel[] | undefined;
}

export class OrderNoteType implements IOrderNoteType {
    id: number;
    name: string | undefined;
    orderNotes: OrderNote[] | undefined;

    constructor(data?: IOrderNoteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["orderNotes"])) {
                this.orderNotes = [] as any;
                for (let item of _data["orderNotes"])
                    this.orderNotes.push(OrderNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderNoteType {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNoteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.orderNotes)) {
            data["orderNotes"] = [];
            for (let item of this.orderNotes)
                data["orderNotes"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderNoteType {
        const json = this.toJSON();
        let result = new OrderNoteType();
        result.init(json);
        return result;
    }
}

export interface IOrderNoteType {
    id: number;
    name: string | undefined;
    orderNotes: OrderNote[] | undefined;
}

export class OrderOrthodonticsInformation implements IOrderOrthodonticsInformation {
    orderId: string;
    teethRestrictedFromMoving: string | undefined;
    teethNotReceiveAttachments: string | undefined;
    teethExtracted: string | undefined;
    limitOfSteps: number;
    resolveCrowing: string | undefined;
    resolveCrowingComment: string | undefined;
    treatOpenbite: string | undefined;
    treatOpenbiteComment: string | undefined;
    treatDeepbite: string | undefined;
    treatDeepbiteComment: string | undefined;
    treatMidlineDiscrepencies: string | undefined;
    treatMidlineDiscrepenciesComment: string | undefined;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderOrthodonticsInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.teethRestrictedFromMoving = _data["teethRestrictedFromMoving"];
            this.teethNotReceiveAttachments = _data["teethNotReceiveAttachments"];
            this.teethExtracted = _data["teethExtracted"];
            this.limitOfSteps = _data["limitOfSteps"];
            this.resolveCrowing = _data["resolveCrowing"];
            this.resolveCrowingComment = _data["resolveCrowingComment"];
            this.treatOpenbite = _data["treatOpenbite"];
            this.treatOpenbiteComment = _data["treatOpenbiteComment"];
            this.treatDeepbite = _data["treatDeepbite"];
            this.treatDeepbiteComment = _data["treatDeepbiteComment"];
            this.treatMidlineDiscrepencies = _data["treatMidlineDiscrepencies"];
            this.treatMidlineDiscrepenciesComment = _data["treatMidlineDiscrepenciesComment"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderOrthodonticsInformation {
        data = typeof data === 'object' ? data : {};
        let result = new OrderOrthodonticsInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["teethRestrictedFromMoving"] = this.teethRestrictedFromMoving;
        data["teethNotReceiveAttachments"] = this.teethNotReceiveAttachments;
        data["teethExtracted"] = this.teethExtracted;
        data["limitOfSteps"] = this.limitOfSteps;
        data["resolveCrowing"] = this.resolveCrowing;
        data["resolveCrowingComment"] = this.resolveCrowingComment;
        data["treatOpenbite"] = this.treatOpenbite;
        data["treatOpenbiteComment"] = this.treatOpenbiteComment;
        data["treatDeepbite"] = this.treatDeepbite;
        data["treatDeepbiteComment"] = this.treatDeepbiteComment;
        data["treatMidlineDiscrepencies"] = this.treatMidlineDiscrepencies;
        data["treatMidlineDiscrepenciesComment"] = this.treatMidlineDiscrepenciesComment;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderOrthodonticsInformation {
        const json = this.toJSON();
        let result = new OrderOrthodonticsInformation();
        result.init(json);
        return result;
    }
}

export interface IOrderOrthodonticsInformation {
    orderId: string;
    teethRestrictedFromMoving: string | undefined;
    teethNotReceiveAttachments: string | undefined;
    teethExtracted: string | undefined;
    limitOfSteps: number;
    resolveCrowing: string | undefined;
    resolveCrowingComment: string | undefined;
    treatOpenbite: string | undefined;
    treatOpenbiteComment: string | undefined;
    treatDeepbite: string | undefined;
    treatDeepbiteComment: string | undefined;
    treatMidlineDiscrepencies: string | undefined;
    treatMidlineDiscrepenciesComment: string | undefined;
    order: Order;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderOrthodonticsInformationModel implements IOrderOrthodonticsInformationModel {
    id: string;
    orderId: string;
    teethRestrictedFromMoving: string | undefined;
    teethNotReceiveAttachments: string | undefined;
    teethExtracted: string | undefined;
    limitOfSteps: number;
    resolveCrowing: string | undefined;
    resolveCrowingComment: string | undefined;
    treatOpenbite: string | undefined;
    treatOpenbiteComment: string | undefined;
    treatDeepbite: string | undefined;
    treatDeepbiteComment: string | undefined;
    treatMidlineDiscrepencies: string | undefined;
    treatMidlineDiscrepenciesComment: string | undefined;

    constructor(data?: IOrderOrthodonticsInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.teethRestrictedFromMoving = _data["teethRestrictedFromMoving"];
            this.teethNotReceiveAttachments = _data["teethNotReceiveAttachments"];
            this.teethExtracted = _data["teethExtracted"];
            this.limitOfSteps = _data["limitOfSteps"];
            this.resolveCrowing = _data["resolveCrowing"];
            this.resolveCrowingComment = _data["resolveCrowingComment"];
            this.treatOpenbite = _data["treatOpenbite"];
            this.treatOpenbiteComment = _data["treatOpenbiteComment"];
            this.treatDeepbite = _data["treatDeepbite"];
            this.treatDeepbiteComment = _data["treatDeepbiteComment"];
            this.treatMidlineDiscrepencies = _data["treatMidlineDiscrepencies"];
            this.treatMidlineDiscrepenciesComment = _data["treatMidlineDiscrepenciesComment"];
        }
    }

    static fromJS(data: any): OrderOrthodonticsInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderOrthodonticsInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["teethRestrictedFromMoving"] = this.teethRestrictedFromMoving;
        data["teethNotReceiveAttachments"] = this.teethNotReceiveAttachments;
        data["teethExtracted"] = this.teethExtracted;
        data["limitOfSteps"] = this.limitOfSteps;
        data["resolveCrowing"] = this.resolveCrowing;
        data["resolveCrowingComment"] = this.resolveCrowingComment;
        data["treatOpenbite"] = this.treatOpenbite;
        data["treatOpenbiteComment"] = this.treatOpenbiteComment;
        data["treatDeepbite"] = this.treatDeepbite;
        data["treatDeepbiteComment"] = this.treatDeepbiteComment;
        data["treatMidlineDiscrepencies"] = this.treatMidlineDiscrepencies;
        data["treatMidlineDiscrepenciesComment"] = this.treatMidlineDiscrepenciesComment;
        return data;
    }

    clone(): OrderOrthodonticsInformationModel {
        const json = this.toJSON();
        let result = new OrderOrthodonticsInformationModel();
        result.init(json);
        return result;
    }
}

export interface IOrderOrthodonticsInformationModel {
    id: string;
    orderId: string;
    teethRestrictedFromMoving: string | undefined;
    teethNotReceiveAttachments: string | undefined;
    teethExtracted: string | undefined;
    limitOfSteps: number;
    resolveCrowing: string | undefined;
    resolveCrowingComment: string | undefined;
    treatOpenbite: string | undefined;
    treatOpenbiteComment: string | undefined;
    treatDeepbite: string | undefined;
    treatDeepbiteComment: string | undefined;
    treatMidlineDiscrepencies: string | undefined;
    treatMidlineDiscrepenciesComment: string | undefined;
}

export class OrderProduct implements IOrderProduct {
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: Product;
    order: Order;
    orderProductColor: OrderProductColor;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.materialName = _data["materialName"];
            this.standardTierName = _data["standardTierName"];
            this.teeth = _data["teeth"];
            this.arch = _data["arch"];
            this.shade = _data["shade"];
            this.shadeSystem = _data["shadeSystem"];
            this.implantSpecification = _data["implantSpecification"];
            this.implantScanbody = _data["implantScanbody"];
            this.implantScanbodyText = _data["implantScanbodyText"];
            this.isAddon = _data["isAddon"];
            this.discount = _data["discount"];
            this.isInvoiced = _data["isInvoiced"];
            this.quantity = _data["quantity"];
            this.isDefaultForOrder = _data["isDefaultForOrder"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.orderProductColor = _data["orderProductColor"] ? OrderProductColor.fromJS(_data["orderProductColor"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderProduct {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["materialName"] = this.materialName;
        data["standardTierName"] = this.standardTierName;
        data["teeth"] = this.teeth;
        data["arch"] = this.arch;
        data["shade"] = this.shade;
        data["shadeSystem"] = this.shadeSystem;
        data["implantSpecification"] = this.implantSpecification;
        data["implantScanbody"] = this.implantScanbody;
        data["implantScanbodyText"] = this.implantScanbodyText;
        data["isAddon"] = this.isAddon;
        data["discount"] = this.discount;
        data["isInvoiced"] = this.isInvoiced;
        data["quantity"] = this.quantity;
        data["isDefaultForOrder"] = this.isDefaultForOrder;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["orderProductColor"] = this.orderProductColor ? this.orderProductColor.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderProduct {
        const json = this.toJSON();
        let result = new OrderProduct();
        result.init(json);
        return result;
    }
}

export interface IOrderProduct {
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: Product;
    order: Order;
    orderProductColor: OrderProductColor;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderProductColor implements IOrderProductColor {
    orderProductId: string;
    upperColorCount: number;
    upperColor1: string | undefined;
    upperColor2: string | undefined;
    upperColor3: string | undefined;
    upperColor4: string | undefined;
    upperColor5: string | undefined;
    lowerColorCount: number;
    lowerColor1: string | undefined;
    lowerColor2: string | undefined;
    lowerColor3: string | undefined;
    lowerColor4: string | undefined;
    lowerColor5: string | undefined;
    orderProduct: OrderProduct;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderProductColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderProductId = _data["orderProductId"];
            this.upperColorCount = _data["upperColorCount"];
            this.upperColor1 = _data["upperColor1"];
            this.upperColor2 = _data["upperColor2"];
            this.upperColor3 = _data["upperColor3"];
            this.upperColor4 = _data["upperColor4"];
            this.upperColor5 = _data["upperColor5"];
            this.lowerColorCount = _data["lowerColorCount"];
            this.lowerColor1 = _data["lowerColor1"];
            this.lowerColor2 = _data["lowerColor2"];
            this.lowerColor3 = _data["lowerColor3"];
            this.lowerColor4 = _data["lowerColor4"];
            this.lowerColor5 = _data["lowerColor5"];
            this.orderProduct = _data["orderProduct"] ? OrderProduct.fromJS(_data["orderProduct"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderProductColor {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderProductId"] = this.orderProductId;
        data["upperColorCount"] = this.upperColorCount;
        data["upperColor1"] = this.upperColor1;
        data["upperColor2"] = this.upperColor2;
        data["upperColor3"] = this.upperColor3;
        data["upperColor4"] = this.upperColor4;
        data["upperColor5"] = this.upperColor5;
        data["lowerColorCount"] = this.lowerColorCount;
        data["lowerColor1"] = this.lowerColor1;
        data["lowerColor2"] = this.lowerColor2;
        data["lowerColor3"] = this.lowerColor3;
        data["lowerColor4"] = this.lowerColor4;
        data["lowerColor5"] = this.lowerColor5;
        data["orderProduct"] = this.orderProduct ? this.orderProduct.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderProductColor {
        const json = this.toJSON();
        let result = new OrderProductColor();
        result.init(json);
        return result;
    }
}

export interface IOrderProductColor {
    orderProductId: string;
    upperColorCount: number;
    upperColor1: string | undefined;
    upperColor2: string | undefined;
    upperColor3: string | undefined;
    upperColor4: string | undefined;
    upperColor5: string | undefined;
    lowerColorCount: number;
    lowerColor1: string | undefined;
    lowerColor2: string | undefined;
    lowerColor3: string | undefined;
    lowerColor4: string | undefined;
    lowerColor5: string | undefined;
    orderProduct: OrderProduct;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderProductColorModel implements IOrderProductColorModel {
    id: string;
    orderProductId: string;
    upperColorCount: number;
    upperColor1: string | undefined;
    upperColor2: string | undefined;
    upperColor3: string | undefined;
    upperColor4: string | undefined;
    upperColor5: string | undefined;
    lowerColorCount: number;
    lowerColor1: string | undefined;
    lowerColor2: string | undefined;
    lowerColor3: string | undefined;
    lowerColor4: string | undefined;
    lowerColor5: string | undefined;

    constructor(data?: IOrderProductColorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderProductId = _data["orderProductId"];
            this.upperColorCount = _data["upperColorCount"];
            this.upperColor1 = _data["upperColor1"];
            this.upperColor2 = _data["upperColor2"];
            this.upperColor3 = _data["upperColor3"];
            this.upperColor4 = _data["upperColor4"];
            this.upperColor5 = _data["upperColor5"];
            this.lowerColorCount = _data["lowerColorCount"];
            this.lowerColor1 = _data["lowerColor1"];
            this.lowerColor2 = _data["lowerColor2"];
            this.lowerColor3 = _data["lowerColor3"];
            this.lowerColor4 = _data["lowerColor4"];
            this.lowerColor5 = _data["lowerColor5"];
        }
    }

    static fromJS(data: any): OrderProductColorModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductColorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderProductId"] = this.orderProductId;
        data["upperColorCount"] = this.upperColorCount;
        data["upperColor1"] = this.upperColor1;
        data["upperColor2"] = this.upperColor2;
        data["upperColor3"] = this.upperColor3;
        data["upperColor4"] = this.upperColor4;
        data["upperColor5"] = this.upperColor5;
        data["lowerColorCount"] = this.lowerColorCount;
        data["lowerColor1"] = this.lowerColor1;
        data["lowerColor2"] = this.lowerColor2;
        data["lowerColor3"] = this.lowerColor3;
        data["lowerColor4"] = this.lowerColor4;
        data["lowerColor5"] = this.lowerColor5;
        return data;
    }

    clone(): OrderProductColorModel {
        const json = this.toJSON();
        let result = new OrderProductColorModel();
        result.init(json);
        return result;
    }
}

export interface IOrderProductColorModel {
    id: string;
    orderProductId: string;
    upperColorCount: number;
    upperColor1: string | undefined;
    upperColor2: string | undefined;
    upperColor3: string | undefined;
    upperColor4: string | undefined;
    upperColor5: string | undefined;
    lowerColorCount: number;
    lowerColor1: string | undefined;
    lowerColor2: string | undefined;
    lowerColor3: string | undefined;
    lowerColor4: string | undefined;
    lowerColor5: string | undefined;
}

export class OrderProductModel implements IOrderProductModel {
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: ProductModel;
    orderProductColor: OrderProductColorModel;

    constructor(data?: IOrderProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.materialName = _data["materialName"];
            this.standardTierName = _data["standardTierName"];
            this.teeth = _data["teeth"];
            this.arch = _data["arch"];
            this.shade = _data["shade"];
            this.shadeSystem = _data["shadeSystem"];
            this.implantSpecification = _data["implantSpecification"];
            this.implantScanbody = _data["implantScanbody"];
            this.implantScanbodyText = _data["implantScanbodyText"];
            this.isAddon = _data["isAddon"];
            this.discount = _data["discount"];
            this.isInvoiced = _data["isInvoiced"];
            this.quantity = _data["quantity"];
            this.isDefaultForOrder = _data["isDefaultForOrder"];
            this.product = _data["product"] ? ProductModel.fromJS(_data["product"]) : <any>undefined;
            this.orderProductColor = _data["orderProductColor"] ? OrderProductColorModel.fromJS(_data["orderProductColor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["materialName"] = this.materialName;
        data["standardTierName"] = this.standardTierName;
        data["teeth"] = this.teeth;
        data["arch"] = this.arch;
        data["shade"] = this.shade;
        data["shadeSystem"] = this.shadeSystem;
        data["implantSpecification"] = this.implantSpecification;
        data["implantScanbody"] = this.implantScanbody;
        data["implantScanbodyText"] = this.implantScanbodyText;
        data["isAddon"] = this.isAddon;
        data["discount"] = this.discount;
        data["isInvoiced"] = this.isInvoiced;
        data["quantity"] = this.quantity;
        data["isDefaultForOrder"] = this.isDefaultForOrder;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["orderProductColor"] = this.orderProductColor ? this.orderProductColor.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderProductModel {
        const json = this.toJSON();
        let result = new OrderProductModel();
        result.init(json);
        return result;
    }
}

export interface IOrderProductModel {
    id: string;
    orderId: string;
    productId: number;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardTierName: string | undefined;
    teeth: string | undefined;
    arch: string | undefined;
    shade: string | undefined;
    shadeSystem: string | undefined;
    implantSpecification: string | undefined;
    implantScanbody: string | undefined;
    implantScanbodyText: string | undefined;
    isAddon: boolean;
    discount: number;
    isInvoiced: boolean;
    quantity: number;
    isDefaultForOrder: boolean;
    product: ProductModel;
    orderProductColor: OrderProductColorModel;
}

export enum OrderScansImpressionsSend {
    SelfDispatch = <any>"SelfDispatch",
    PickupRequest = <any>"PickupRequest",
}

export class OrderShipment implements IOrderShipment {
    orderId: string;
    order: Order;
    labelId: string | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    trackingNumber: string | undefined;
    imageLabelHref: string | undefined;
    voided: string | undefined;
    voidedAt: Date | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderShipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.labelId = _data["labelId"];
            this.carrierCode = _data["carrierCode"];
            this.serviceCode = _data["serviceCode"];
            this.packageCode = _data["packageCode"];
            this.trackingNumber = _data["trackingNumber"];
            this.imageLabelHref = _data["imageLabelHref"];
            this.voided = _data["voided"];
            this.voidedAt = _data["voidedAt"] ? new Date(_data["voidedAt"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderShipment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderShipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["labelId"] = this.labelId;
        data["carrierCode"] = this.carrierCode;
        data["serviceCode"] = this.serviceCode;
        data["packageCode"] = this.packageCode;
        data["trackingNumber"] = this.trackingNumber;
        data["imageLabelHref"] = this.imageLabelHref;
        data["voided"] = this.voided;
        data["voidedAt"] = this.voidedAt ? this.voidedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderShipment {
        const json = this.toJSON();
        let result = new OrderShipment();
        result.init(json);
        return result;
    }
}

export interface IOrderShipment {
    orderId: string;
    order: Order;
    labelId: string | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    trackingNumber: string | undefined;
    imageLabelHref: string | undefined;
    voided: string | undefined;
    voidedAt: Date | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderShipmentModel implements IOrderShipmentModel {
    orderId: string;
    order: OrderModel;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    trackingNumber: string | undefined;
    imageLabelHref: string | undefined;
    voided: string | undefined;
    voidedAt: Date | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderShipmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.carrierCode = _data["carrierCode"];
            this.serviceCode = _data["serviceCode"];
            this.packageCode = _data["packageCode"];
            this.trackingNumber = _data["trackingNumber"];
            this.imageLabelHref = _data["imageLabelHref"];
            this.voided = _data["voided"];
            this.voidedAt = _data["voidedAt"] ? new Date(_data["voidedAt"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderShipmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderShipmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["carrierCode"] = this.carrierCode;
        data["serviceCode"] = this.serviceCode;
        data["packageCode"] = this.packageCode;
        data["trackingNumber"] = this.trackingNumber;
        data["imageLabelHref"] = this.imageLabelHref;
        data["voided"] = this.voided;
        data["voidedAt"] = this.voidedAt ? this.voidedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderShipmentModel {
        const json = this.toJSON();
        let result = new OrderShipmentModel();
        result.init(json);
        return result;
    }
}

export interface IOrderShipmentModel {
    orderId: string;
    order: OrderModel;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    trackingNumber: string | undefined;
    imageLabelHref: string | undefined;
    voided: string | undefined;
    voidedAt: Date | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderStage implements IOrderStage {
    id: string;
    orderId: string;
    name: string | undefined;
    status: string | undefined;
    trackingNumber: string | undefined;
    startDate: Date;
    endDate: Date;
    isFinished: boolean;
    order: Order;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.trackingNumber = _data["trackingNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderStage {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["trackingNumber"] = this.trackingNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderStage {
        const json = this.toJSON();
        let result = new OrderStage();
        result.init(json);
        return result;
    }
}

export interface IOrderStage {
    id: string;
    orderId: string;
    name: string | undefined;
    status: string | undefined;
    trackingNumber: string | undefined;
    startDate: Date;
    endDate: Date;
    isFinished: boolean;
    order: Order;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderStageModel implements IOrderStageModel {
    id: string;
    orderId: string;
    name: string | undefined;
    status: string | undefined;
    trackingNumber: string | undefined;
    startDate: Date;
    endDate: Date;
    isFinished: boolean;

    constructor(data?: IOrderStageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.trackingNumber = _data["trackingNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): OrderStageModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["trackingNumber"] = this.trackingNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): OrderStageModel {
        const json = this.toJSON();
        let result = new OrderStageModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStageModel {
    id: string;
    orderId: string;
    name: string | undefined;
    status: string | undefined;
    trackingNumber: string | undefined;
    startDate: Date;
    endDate: Date;
    isFinished: boolean;
}

export class OrderStatus implements IOrderStatus {
    name: string | undefined;
    code: string | undefined;
    orders: Order[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderStatus {
        const json = this.toJSON();
        let result = new OrderStatus();
        result.init(json);
        return result;
    }
}

export interface IOrderStatus {
    name: string | undefined;
    code: string | undefined;
    orders: Order[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderStatusModel implements IOrderStatusModel {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IOrderStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): OrderStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): OrderStatusModel {
        const json = this.toJSON();
        let result = new OrderStatusModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class OrderTag implements IOrderTag {
    id: string;
    orderId: string;
    name: string | undefined;
    order: Order;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IOrderTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): OrderTag {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): OrderTag {
        const json = this.toJSON();
        let result = new OrderTag();
        result.init(json);
        return result;
    }
}

export interface IOrderTag {
    id: string;
    orderId: string;
    name: string | undefined;
    order: Order;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class OrderTagModel implements IOrderTagModel {
    id: string;
    name: string | undefined;

    constructor(data?: IOrderTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrderTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): OrderTagModel {
        const json = this.toJSON();
        let result = new OrderTagModel();
        result.init(json);
        return result;
    }
}

export interface IOrderTagModel {
    id: string;
    name: string | undefined;
}

export class OrderWithRoutModel implements IOrderWithRoutModel {
    locationRoutName: string | undefined;
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;

    constructor(data?: IOrderWithRoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationRoutName = _data["locationRoutName"];
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.orderStatusId = _data["orderStatusId"];
            this.description = _data["description"];
            this.totalPrice = _data["totalPrice"];
            this.manufactureLocationId = _data["manufactureLocationId"];
            this.submanufactureLocationId = _data["submanufactureLocationId"];
            this.isDraft = _data["isDraft"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.status = _data["status"] ? OrderStatusModel.fromJS(_data["status"]) : <any>undefined;
            this.dentistName = _data["dentistName"];
            this.practiceName = _data["practiceName"];
            this.patientName = _data["patientName"];
            this.categoryId = _data["categoryId"];
            this.orderSubmittedDate = _data["orderSubmittedDate"] ? new Date(_data["orderSubmittedDate"].toString()) : <any>undefined;
            this.scansImpressions = _data["scansImpressions"];
            this.scansImpressionsSend = _data["scansImpressionsSend"];
            this.code = _data["code"];
            this.isOrderAccepted = _data["isOrderAccepted"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.trackingNumber = _data["trackingNumber"];
            this.panNumber = _data["panNumber"];
            this.isArchived = _data["isArchived"];
            this.tagList = _data["tagList"];
            this.startStage = _data["startStage"];
            this.qcApprovedBy = _data["qcApprovedBy"];
            this.qcApprovedAt = _data["qcApprovedAt"] ? new Date(_data["qcApprovedAt"].toString()) : <any>undefined;
            this.isSimpleFlow = _data["isSimpleFlow"];
            this.practiceDentistListId = _data["practiceDentistListId"];
            this.practiceDentistListName = _data["practiceDentistListName"];
            this.requestedDueDate = _data["requestedDueDate"] ? new Date(_data["requestedDueDate"].toString()) : <any>undefined;
            this.scanId = _data["scanId"];
            if (Array.isArray(_data["orderLogs"])) {
                this.orderLogs = [] as any;
                for (let item of _data["orderLogs"])
                    this.orderLogs.push(OrderLogModel.fromJS(item));
            }
            this.isAdminSetupDueDate = _data["isAdminSetupDueDate"];
            this.receivingType = _data["receivingType"];
            this.receivingOption = _data["receivingOption"];
            this.receivingText = _data["receivingText"];
            this.orderOrthodonticsInformations = _data["orderOrthodonticsInformations"] ? OrderOrthodonticsInformationModel.fromJS(_data["orderOrthodonticsInformations"]) : <any>undefined;
            if (Array.isArray(_data["orderFiles"])) {
                this.orderFiles = [] as any;
                for (let item of _data["orderFiles"])
                    this.orderFiles.push(OrderFileModel.fromJS(item));
            }
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProductModel.fromJS(item));
            }
            if (Array.isArray(_data["orderCustomFees"])) {
                this.orderCustomFees = [] as any;
                for (let item of _data["orderCustomFees"])
                    this.orderCustomFees.push(OrderCustomFeeModel.fromJS(item));
            }
            this.practiceDentistList = _data["practiceDentistList"] ? PracticeDentistListModel.fromJS(_data["practiceDentistList"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.category = _data["category"] ? ProductCategoryModel.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderWithRoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderWithRoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationRoutName"] = this.locationRoutName;
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["orderStatusId"] = this.orderStatusId;
        data["description"] = this.description;
        data["totalPrice"] = this.totalPrice;
        data["manufactureLocationId"] = this.manufactureLocationId;
        data["submanufactureLocationId"] = this.submanufactureLocationId;
        data["isDraft"] = this.isDraft;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["dentistName"] = this.dentistName;
        data["practiceName"] = this.practiceName;
        data["patientName"] = this.patientName;
        data["categoryId"] = this.categoryId;
        data["orderSubmittedDate"] = this.orderSubmittedDate ? this.orderSubmittedDate.toISOString() : <any>undefined;
        data["scansImpressions"] = this.scansImpressions;
        data["scansImpressionsSend"] = this.scansImpressionsSend;
        data["code"] = this.code;
        data["isOrderAccepted"] = this.isOrderAccepted;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["trackingNumber"] = this.trackingNumber;
        data["panNumber"] = this.panNumber;
        data["isArchived"] = this.isArchived;
        data["tagList"] = this.tagList;
        data["startStage"] = this.startStage;
        data["qcApprovedBy"] = this.qcApprovedBy;
        data["qcApprovedAt"] = this.qcApprovedAt ? this.qcApprovedAt.toISOString() : <any>undefined;
        data["isSimpleFlow"] = this.isSimpleFlow;
        data["practiceDentistListId"] = this.practiceDentistListId;
        data["practiceDentistListName"] = this.practiceDentistListName;
        data["requestedDueDate"] = this.requestedDueDate ? this.requestedDueDate.toISOString() : <any>undefined;
        data["scanId"] = this.scanId;
        if (Array.isArray(this.orderLogs)) {
            data["orderLogs"] = [];
            for (let item of this.orderLogs)
                data["orderLogs"].push(item.toJSON());
        }
        data["isAdminSetupDueDate"] = this.isAdminSetupDueDate;
        data["receivingType"] = this.receivingType;
        data["receivingOption"] = this.receivingOption;
        data["receivingText"] = this.receivingText;
        data["orderOrthodonticsInformations"] = this.orderOrthodonticsInformations ? this.orderOrthodonticsInformations.toJSON() : <any>undefined;
        if (Array.isArray(this.orderFiles)) {
            data["orderFiles"] = [];
            for (let item of this.orderFiles)
                data["orderFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCustomFees)) {
            data["orderCustomFees"] = [];
            for (let item of this.orderCustomFees)
                data["orderCustomFees"].push(item.toJSON());
        }
        data["practiceDentistList"] = this.practiceDentistList ? this.practiceDentistList.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderWithRoutModel {
        const json = this.toJSON();
        let result = new OrderWithRoutModel();
        result.init(json);
        return result;
    }
}

export interface IOrderWithRoutModel {
    locationRoutName: string | undefined;
    id: string;
    patientId: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    orderStatusId: number | undefined;
    description: string | undefined;
    totalPrice: number;
    manufactureLocationId: string | undefined;
    submanufactureLocationId: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    status: OrderStatusModel;
    dentistName: string | undefined;
    practiceName: string | undefined;
    patientName: string | undefined;
    categoryId: number | undefined;
    orderSubmittedDate: Date;
    scansImpressions: number | undefined;
    scansImpressionsSend: OrderScansImpressionsSend;
    code: string | undefined;
    isOrderAccepted: boolean;
    deliveryDate: Date;
    deadlineDate: Date;
    trackingNumber: string | undefined;
    panNumber: string | undefined;
    isArchived: boolean;
    tagList: string | undefined;
    startStage: string | undefined;
    qcApprovedBy: string | undefined;
    qcApprovedAt: Date | undefined;
    isSimpleFlow: boolean;
    practiceDentistListId: string | undefined;
    practiceDentistListName: string | undefined;
    requestedDueDate: Date | undefined;
    scanId: string | undefined;
    orderLogs: OrderLogModel[] | undefined;
    isAdminSetupDueDate: boolean;
    receivingType: string | undefined;
    receivingOption: string | undefined;
    receivingText: string | undefined;
    orderOrthodonticsInformations: OrderOrthodonticsInformationModel;
    orderFiles: OrderFileModel[] | undefined;
    orderProducts: OrderProductModel[] | undefined;
    orderCustomFees: OrderCustomFeeModel[] | undefined;
    practiceDentistList: PracticeDentistListModel;
    location: LocationModel;
    category: ProductCategoryModel;
}

export class PackageType implements IPackageType {
    packageId: string | undefined;
    packageCode: string | undefined;
    name: string | undefined;
    dimensions: Dimensions;
    description: string | undefined;

    constructor(data?: IPackageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageCode = _data["packageCode"];
            this.name = _data["name"];
            this.dimensions = _data["dimensions"] ? Dimensions.fromJS(_data["dimensions"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PackageType {
        data = typeof data === 'object' ? data : {};
        let result = new PackageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageCode"] = this.packageCode;
        data["name"] = this.name;
        data["dimensions"] = this.dimensions ? this.dimensions.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): PackageType {
        const json = this.toJSON();
        let result = new PackageType();
        result.init(json);
        return result;
    }
}

export interface IPackageType {
    packageId: string | undefined;
    packageCode: string | undefined;
    name: string | undefined;
    dimensions: Dimensions;
    description: string | undefined;
}

export class PatiendProfileModel implements IPatiendProfileModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    locationName: string | undefined;
    practiceName: string | undefined;
    dentistName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    orders: OrderModel[] | undefined;
    images: ProfileFileModel[] | undefined;
    files: ProfileFileModel[] | undefined;
    notes: InternalNoteModel[] | undefined;

    constructor(data?: IPatiendProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.locationName = _data["locationName"];
            this.practiceName = _data["practiceName"];
            this.dentistName = _data["dentistName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderModel.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(ProfileFileModel.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(ProfileFileModel.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(InternalNoteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatiendProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatiendProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["locationName"] = this.locationName;
        data["practiceName"] = this.practiceName;
        data["dentistName"] = this.dentistName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatiendProfileModel {
        const json = this.toJSON();
        let result = new PatiendProfileModel();
        result.init(json);
        return result;
    }
}

export interface IPatiendProfileModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string;
    locationName: string | undefined;
    practiceName: string | undefined;
    dentistName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    orders: OrderModel[] | undefined;
    images: ProfileFileModel[] | undefined;
    files: ProfileFileModel[] | undefined;
    notes: InternalNoteModel[] | undefined;
}

export class Patient implements IPatient {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    patientsNotes: PatientsNote[] | undefined;
    location: Location;
    practice: Practice;
    dentist: User;
    orders: Order[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["patientsNotes"])) {
                this.patientsNotes = [] as any;
                for (let item of _data["patientsNotes"])
                    this.patientsNotes.push(PatientsNote.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatement.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Patient {
        data = typeof data === 'object' ? data : {};
        let result = new Patient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.patientsNotes)) {
            data["patientsNotes"] = [];
            for (let item of this.patientsNotes)
                data["patientsNotes"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Patient {
        const json = this.toJSON();
        let result = new Patient();
        result.init(json);
        return result;
    }
}

export interface IPatient {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    patientsNotes: PatientsNote[] | undefined;
    location: Location;
    practice: Practice;
    dentist: User;
    orders: Order[] | undefined;
    patientStatements: PatientStatement[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class Patient3shapeModel implements IPatient3shapeModel {
    firstName: string | undefined;
    lastName: string | undefined;
    externalId: any | undefined;
    patientRefNo: number | undefined;

    constructor(data?: IPatient3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.externalId = _data["ExternalId"];
            this.patientRefNo = _data["PatientRefNo"];
        }
    }

    static fromJS(data: any): Patient3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Patient3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["ExternalId"] = this.externalId;
        data["PatientRefNo"] = this.patientRefNo;
        return data;
    }

    clone(): Patient3shapeModel {
        const json = this.toJSON();
        let result = new Patient3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IPatient3shapeModel {
    firstName: string | undefined;
    lastName: string | undefined;
    externalId: any | undefined;
    patientRefNo: number | undefined;
}

export class PatientCreateModel implements IPatientCreateModel {
    locationId: string;
    practiceId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;

    constructor(data?: IPatientCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): PatientCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        return data;
    }

    clone(): PatientCreateModel {
        const json = this.toJSON();
        let result = new PatientCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPatientCreateModel {
    locationId: string;
    practiceId: string;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
}

export class PatientDetailModel implements IPatientDetailModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    dateFormat: string | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    practice: PracticeModel;
    orders: OrderModel[] | undefined;

    constructor(data?: IPatientDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.gender = _data["gender"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.practice = _data["practice"] ? PracticeModel.fromJS(_data["practice"]) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(OrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["gender"] = this.gender;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): PatientDetailModel {
        const json = this.toJSON();
        let result = new PatientDetailModel();
        result.init(json);
        return result;
    }
}

export interface IPatientDetailModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    dateFormat: string | undefined;
    gender: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    practice: PracticeModel;
    orders: OrderModel[] | undefined;
}

export class PatientModel implements IPatientModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    practice: PracticeModel;

    constructor(data?: IPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentistId = _data["dentistId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.isArchived = _data["isArchived"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.dateFormat = _data["dateFormat"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.practice = _data["practice"] ? PracticeModel.fromJS(_data["practice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentistId"] = this.dentistId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["isArchived"] = this.isArchived;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["dateFormat"] = this.dateFormat;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        return data;
    }

    clone(): PatientModel {
        const json = this.toJSON();
        let result = new PatientModel();
        result.init(json);
        return result;
    }
}

export interface IPatientModel {
    id: string;
    locationId: string;
    practiceId: string;
    dentistId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    gender: string | undefined;
    isArchived: boolean;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    dateFormat: string | undefined;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    practice: PracticeModel;
}

export class PatientModelPagedListDto implements IPatientModelPagedListDto {
    items: PatientModel[] | undefined;
    totalCount: number;

    constructor(data?: IPatientModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PatientModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientModelPagedListDto {
        const json = this.toJSON();
        let result = new PatientModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IPatientModelPagedListDto {
    items: PatientModel[] | undefined;
    totalCount: number;
}

export class PatientStatement implements IPatientStatement {
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;
    order: Order;
    location: Location;
    practice: Practice;
    patient: Patient;
    invoice: Invoice;
    patientStatementItems: PatientStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPatientStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.patientId = _data["patientId"];
            this.invoiceId = _data["invoiceId"];
            this.statementNumber = _data["statementNumber"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.orderShortCode = _data["orderShortCode"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.practiceName = _data["practiceName"];
            this.practiceAddress = _data["practiceAddress"];
            this.orderManufactureDate = _data["orderManufactureDate"] ? new Date(_data["orderManufactureDate"].toString()) : <any>undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            if (Array.isArray(_data["patientStatementItems"])) {
                this.patientStatementItems = [] as any;
                for (let item of _data["patientStatementItems"])
                    this.patientStatementItems.push(PatientStatementItem.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PatientStatement {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["patientId"] = this.patientId;
        data["invoiceId"] = this.invoiceId;
        data["statementNumber"] = this.statementNumber;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["orderShortCode"] = this.orderShortCode;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["practiceName"] = this.practiceName;
        data["practiceAddress"] = this.practiceAddress;
        data["orderManufactureDate"] = this.orderManufactureDate ? this.orderManufactureDate.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        if (Array.isArray(this.patientStatementItems)) {
            data["patientStatementItems"] = [];
            for (let item of this.patientStatementItems)
                data["patientStatementItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PatientStatement {
        const json = this.toJSON();
        let result = new PatientStatement();
        result.init(json);
        return result;
    }
}

export interface IPatientStatement {
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;
    order: Order;
    location: Location;
    practice: Practice;
    patient: Patient;
    invoice: Invoice;
    patientStatementItems: PatientStatementItem[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PatientStatementItem implements IPatientStatementItem {
    patientStatementId: string;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardName: string | undefined;
    quantity: number;
    patientStatement: PatientStatement;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPatientStatementItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientStatementId = _data["patientStatementId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.materialName = _data["materialName"];
            this.standardName = _data["standardName"];
            this.quantity = _data["quantity"];
            this.patientStatement = _data["patientStatement"] ? PatientStatement.fromJS(_data["patientStatement"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PatientStatementItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatementItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientStatementId"] = this.patientStatementId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["materialName"] = this.materialName;
        data["standardName"] = this.standardName;
        data["quantity"] = this.quantity;
        data["patientStatement"] = this.patientStatement ? this.patientStatement.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PatientStatementItem {
        const json = this.toJSON();
        let result = new PatientStatementItem();
        result.init(json);
        return result;
    }
}

export interface IPatientStatementItem {
    patientStatementId: string;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardName: string | undefined;
    quantity: number;
    patientStatement: PatientStatement;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PatientStatementItemModel implements IPatientStatementItemModel {
    id: string;
    patientStatementId: string;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardName: string | undefined;
    quantity: number;

    constructor(data?: IPatientStatementItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientStatementId = _data["patientStatementId"];
            this.sku = _data["sku"];
            this.productName = _data["productName"];
            this.materialName = _data["materialName"];
            this.standardName = _data["standardName"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): PatientStatementItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatementItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientStatementId"] = this.patientStatementId;
        data["sku"] = this.sku;
        data["productName"] = this.productName;
        data["materialName"] = this.materialName;
        data["standardName"] = this.standardName;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): PatientStatementItemModel {
        const json = this.toJSON();
        let result = new PatientStatementItemModel();
        result.init(json);
        return result;
    }
}

export interface IPatientStatementItemModel {
    id: string;
    patientStatementId: string;
    sku: string | undefined;
    productName: string | undefined;
    materialName: string | undefined;
    standardName: string | undefined;
    quantity: number;
}

export class PatientStatementListModel implements IPatientStatementListModel {
    id: string;
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;

    constructor(data?: IPatientStatementListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.patientId = _data["patientId"];
            this.invoiceId = _data["invoiceId"];
            this.statementNumber = _data["statementNumber"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.orderShortCode = _data["orderShortCode"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.practiceName = _data["practiceName"];
            this.practiceAddress = _data["practiceAddress"];
            this.orderManufactureDate = _data["orderManufactureDate"] ? new Date(_data["orderManufactureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientStatementListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatementListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["patientId"] = this.patientId;
        data["invoiceId"] = this.invoiceId;
        data["statementNumber"] = this.statementNumber;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["orderShortCode"] = this.orderShortCode;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["practiceName"] = this.practiceName;
        data["practiceAddress"] = this.practiceAddress;
        data["orderManufactureDate"] = this.orderManufactureDate ? this.orderManufactureDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): PatientStatementListModel {
        const json = this.toJSON();
        let result = new PatientStatementListModel();
        result.init(json);
        return result;
    }
}

export interface IPatientStatementListModel {
    id: string;
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;
}

export class PatientStatementListModelPagedListDto implements IPatientStatementListModelPagedListDto {
    items: PatientStatementListModel[] | undefined;
    totalCount: number;

    constructor(data?: IPatientStatementListModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PatientStatementListModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PatientStatementListModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatementListModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PatientStatementListModelPagedListDto {
        const json = this.toJSON();
        let result = new PatientStatementListModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IPatientStatementListModelPagedListDto {
    items: PatientStatementListModel[] | undefined;
    totalCount: number;
}

export class PatientStatementModel implements IPatientStatementModel {
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;
    order: OrderModel;
    location: LocationModel;
    patientStatementItems: PatientStatementItemModel[] | undefined;
    locationDocumentSettings: LocationDocumentSettingsModel;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPatientStatementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.patientId = _data["patientId"];
            this.invoiceId = _data["invoiceId"];
            this.statementNumber = _data["statementNumber"];
            this.locationAddress = _data["locationAddress"];
            this.locationEmail = _data["locationEmail"];
            this.locationPhone = _data["locationPhone"];
            this.orderShortCode = _data["orderShortCode"];
            this.patientName = _data["patientName"];
            this.doctorName = _data["doctorName"];
            this.practiceName = _data["practiceName"];
            this.practiceAddress = _data["practiceAddress"];
            this.orderManufactureDate = _data["orderManufactureDate"] ? new Date(_data["orderManufactureDate"].toString()) : <any>undefined;
            this.order = _data["order"] ? OrderModel.fromJS(_data["order"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["patientStatementItems"])) {
                this.patientStatementItems = [] as any;
                for (let item of _data["patientStatementItems"])
                    this.patientStatementItems.push(PatientStatementItemModel.fromJS(item));
            }
            this.locationDocumentSettings = _data["locationDocumentSettings"] ? LocationDocumentSettingsModel.fromJS(_data["locationDocumentSettings"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PatientStatementModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["patientId"] = this.patientId;
        data["invoiceId"] = this.invoiceId;
        data["statementNumber"] = this.statementNumber;
        data["locationAddress"] = this.locationAddress;
        data["locationEmail"] = this.locationEmail;
        data["locationPhone"] = this.locationPhone;
        data["orderShortCode"] = this.orderShortCode;
        data["patientName"] = this.patientName;
        data["doctorName"] = this.doctorName;
        data["practiceName"] = this.practiceName;
        data["practiceAddress"] = this.practiceAddress;
        data["orderManufactureDate"] = this.orderManufactureDate ? this.orderManufactureDate.toISOString() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.patientStatementItems)) {
            data["patientStatementItems"] = [];
            for (let item of this.patientStatementItems)
                data["patientStatementItems"].push(item.toJSON());
        }
        data["locationDocumentSettings"] = this.locationDocumentSettings ? this.locationDocumentSettings.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PatientStatementModel {
        const json = this.toJSON();
        let result = new PatientStatementModel();
        result.init(json);
        return result;
    }
}

export interface IPatientStatementModel {
    orderId: string;
    locationId: string;
    practiceId: string;
    patientId: string;
    invoiceId: string;
    statementNumber: string | undefined;
    locationAddress: string | undefined;
    locationEmail: string | undefined;
    locationPhone: string | undefined;
    orderShortCode: string | undefined;
    patientName: string | undefined;
    doctorName: string | undefined;
    practiceName: string | undefined;
    practiceAddress: string | undefined;
    orderManufactureDate: Date;
    order: OrderModel;
    location: LocationModel;
    patientStatementItems: PatientStatementItemModel[] | undefined;
    locationDocumentSettings: LocationDocumentSettingsModel;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PatientsNote implements IPatientsNote {
    id: string;
    patientId: string;
    note: string | undefined;
    creatorId: string;
    patient: Patient;
    creator: User;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPatientsNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.note = _data["note"];
            this.creatorId = _data["creatorId"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.creator = _data["creator"] ? User.fromJS(_data["creator"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PatientsNote {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["note"] = this.note;
        data["creatorId"] = this.creatorId;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PatientsNote {
        const json = this.toJSON();
        let result = new PatientsNote();
        result.init(json);
        return result;
    }
}

export interface IPatientsNote {
    id: string;
    patientId: string;
    note: string | undefined;
    creatorId: string;
    patient: Patient;
    creator: User;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class Practice implements IPractice {
    id: string;
    locationId: string;
    dentistId: string;
    locationExportGroupId: string | undefined;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    routNumber: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    priceList: PriceList;
    location: Location;
    dentist: User;
    billingOwner: User;
    assignedUsers: User[] | undefined;
    usersAssignedPractice: UsersAssignedPractice[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    invoices: Invoice[] | undefined;
    historicalInvoices: BillingStatementItem[] | undefined;
    practiceDentistList: PracticeDentistList[] | undefined;
    locationRoute: LocationRoute;
    patientStatements: PatientStatement[] | undefined;
    activityStatements: ActivityStatement[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    locationExportGroup: LocationExportGroup;
    notes: PracticeNote[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPractice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.locationExportGroupId = _data["locationExportGroupId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.routNumber = _data["routNumber"];
            this.billingEmail = _data["billingEmail"];
            this.locationRouteId = _data["locationRouteId"];
            this.priceListId = _data["priceListId"];
            this.state = _data["state"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.billingOwnerId = _data["billingOwnerId"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.priceList = _data["priceList"] ? PriceList.fromJS(_data["priceList"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.dentist = _data["dentist"] ? User.fromJS(_data["dentist"]) : <any>undefined;
            this.billingOwner = _data["billingOwner"] ? User.fromJS(_data["billingOwner"]) : <any>undefined;
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(User.fromJS(item));
            }
            if (Array.isArray(_data["usersAssignedPractice"])) {
                this.usersAssignedPractice = [] as any;
                for (let item of _data["usersAssignedPractice"])
                    this.usersAssignedPractice.push(UsersAssignedPractice.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(Patient.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["historicalInvoices"])) {
                this.historicalInvoices = [] as any;
                for (let item of _data["historicalInvoices"])
                    this.historicalInvoices.push(BillingStatementItem.fromJS(item));
            }
            if (Array.isArray(_data["practiceDentistList"])) {
                this.practiceDentistList = [] as any;
                for (let item of _data["practiceDentistList"])
                    this.practiceDentistList.push(PracticeDentistList.fromJS(item));
            }
            this.locationRoute = _data["locationRoute"] ? LocationRoute.fromJS(_data["locationRoute"]) : <any>undefined;
            if (Array.isArray(_data["patientStatements"])) {
                this.patientStatements = [] as any;
                for (let item of _data["patientStatements"])
                    this.patientStatements.push(PatientStatement.fromJS(item));
            }
            if (Array.isArray(_data["activityStatements"])) {
                this.activityStatements = [] as any;
                for (let item of _data["activityStatements"])
                    this.activityStatements.push(ActivityStatement.fromJS(item));
            }
            if (Array.isArray(_data["billingStatements"])) {
                this.billingStatements = [] as any;
                for (let item of _data["billingStatements"])
                    this.billingStatements.push(BillingStatement.fromJS(item));
            }
            this.locationExportGroup = _data["locationExportGroup"] ? LocationExportGroup.fromJS(_data["locationExportGroup"]) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(PracticeNote.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Practice {
        data = typeof data === 'object' ? data : {};
        let result = new Practice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["locationExportGroupId"] = this.locationExportGroupId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["routNumber"] = this.routNumber;
        data["billingEmail"] = this.billingEmail;
        data["locationRouteId"] = this.locationRouteId;
        data["priceListId"] = this.priceListId;
        data["state"] = this.state;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["billingOwnerId"] = this.billingOwnerId;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["billingOwner"] = this.billingOwner ? this.billingOwner.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.usersAssignedPractice)) {
            data["usersAssignedPractice"] = [];
            for (let item of this.usersAssignedPractice)
                data["usersAssignedPractice"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.historicalInvoices)) {
            data["historicalInvoices"] = [];
            for (let item of this.historicalInvoices)
                data["historicalInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.practiceDentistList)) {
            data["practiceDentistList"] = [];
            for (let item of this.practiceDentistList)
                data["practiceDentistList"].push(item.toJSON());
        }
        data["locationRoute"] = this.locationRoute ? this.locationRoute.toJSON() : <any>undefined;
        if (Array.isArray(this.patientStatements)) {
            data["patientStatements"] = [];
            for (let item of this.patientStatements)
                data["patientStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.activityStatements)) {
            data["activityStatements"] = [];
            for (let item of this.activityStatements)
                data["activityStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.billingStatements)) {
            data["billingStatements"] = [];
            for (let item of this.billingStatements)
                data["billingStatements"].push(item.toJSON());
        }
        data["locationExportGroup"] = this.locationExportGroup ? this.locationExportGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Practice {
        const json = this.toJSON();
        let result = new Practice();
        result.init(json);
        return result;
    }
}

export interface IPractice {
    id: string;
    locationId: string;
    dentistId: string;
    locationExportGroupId: string | undefined;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    routNumber: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    priceList: PriceList;
    location: Location;
    dentist: User;
    billingOwner: User;
    assignedUsers: User[] | undefined;
    usersAssignedPractice: UsersAssignedPractice[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    invoices: Invoice[] | undefined;
    historicalInvoices: BillingStatementItem[] | undefined;
    practiceDentistList: PracticeDentistList[] | undefined;
    locationRoute: LocationRoute;
    patientStatements: PatientStatement[] | undefined;
    activityStatements: ActivityStatement[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    locationExportGroup: LocationExportGroup;
    notes: PracticeNote[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PracticeAcessModel implements IPracticeAcessModel {
    userId: string;
    practiceId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;

    constructor(data?: IPracticeAcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.practiceId = _data["practiceId"];
            this.isOnlyOwnOrdersAcess = _data["isOnlyOwnOrdersAcess"];
            this.isOnlyOwnPatientsAcess = _data["isOnlyOwnPatientsAcess"];
            this.idhPerformerNumber = _data["idhPerformerNumber"];
            this.accountCode = _data["accountCode"];
            this.creditLimit = _data["creditLimit"];
        }
    }

    static fromJS(data: any): PracticeAcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeAcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["practiceId"] = this.practiceId;
        data["isOnlyOwnOrdersAcess"] = this.isOnlyOwnOrdersAcess;
        data["isOnlyOwnPatientsAcess"] = this.isOnlyOwnPatientsAcess;
        data["idhPerformerNumber"] = this.idhPerformerNumber;
        data["accountCode"] = this.accountCode;
        data["creditLimit"] = this.creditLimit;
        return data;
    }

    clone(): PracticeAcessModel {
        const json = this.toJSON();
        let result = new PracticeAcessModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeAcessModel {
    userId: string;
    practiceId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
}

export class PracticeAssignedUsersModel implements IPracticeAssignedUsersModel {
    fullName: string | undefined;
    userId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;

    constructor(data?: IPracticeAssignedUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.userId = _data["userId"];
            this.isOnlyOwnOrdersAcess = _data["isOnlyOwnOrdersAcess"];
            this.isOnlyOwnPatientsAcess = _data["isOnlyOwnPatientsAcess"];
            this.idhPerformerNumber = _data["idhPerformerNumber"];
            this.accountCode = _data["accountCode"];
            this.creditLimit = _data["creditLimit"];
        }
    }

    static fromJS(data: any): PracticeAssignedUsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeAssignedUsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["userId"] = this.userId;
        data["isOnlyOwnOrdersAcess"] = this.isOnlyOwnOrdersAcess;
        data["isOnlyOwnPatientsAcess"] = this.isOnlyOwnPatientsAcess;
        data["idhPerformerNumber"] = this.idhPerformerNumber;
        data["accountCode"] = this.accountCode;
        data["creditLimit"] = this.creditLimit;
        return data;
    }

    clone(): PracticeAssignedUsersModel {
        const json = this.toJSON();
        let result = new PracticeAssignedUsersModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeAssignedUsersModel {
    fullName: string | undefined;
    userId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
}

export class PracticeCreateModel implements IPracticeCreateModel {
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;

    constructor(data?: IPracticeCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.state = _data["state"];
            this.billingEmail = _data["billingEmail"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.billingOwnerId = _data["billingOwnerId"];
            this.locationRouteId = _data["locationRouteId"];
            this.priceListId = _data["priceListId"];
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.locationExportGroupId = _data["locationExportGroupId"];
        }
    }

    static fromJS(data: any): PracticeCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["state"] = this.state;
        data["billingEmail"] = this.billingEmail;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["billingOwnerId"] = this.billingOwnerId;
        data["locationRouteId"] = this.locationRouteId;
        data["priceListId"] = this.priceListId;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["locationExportGroupId"] = this.locationExportGroupId;
        return data;
    }

    clone(): PracticeCreateModel {
        const json = this.toJSON();
        let result = new PracticeCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeCreateModel {
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
}

export class PracticeCreateNewModel implements IPracticeCreateNewModel {
    clients: PracticeAssignedUsersModel[] | undefined;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;

    constructor(data?: IPracticeCreateNewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(PracticeAssignedUsersModel.fromJS(item));
            }
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.state = _data["state"];
            this.billingEmail = _data["billingEmail"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.billingOwnerId = _data["billingOwnerId"];
            this.locationRouteId = _data["locationRouteId"];
            this.priceListId = _data["priceListId"];
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.locationExportGroupId = _data["locationExportGroupId"];
        }
    }

    static fromJS(data: any): PracticeCreateNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeCreateNewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["state"] = this.state;
        data["billingEmail"] = this.billingEmail;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["billingOwnerId"] = this.billingOwnerId;
        data["locationRouteId"] = this.locationRouteId;
        data["priceListId"] = this.priceListId;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["locationExportGroupId"] = this.locationExportGroupId;
        return data;
    }

    clone(): PracticeCreateNewModel {
        const json = this.toJSON();
        let result = new PracticeCreateNewModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeCreateNewModel {
    clients: PracticeAssignedUsersModel[] | undefined;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    state: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
}

export class PracticeDentistForCreateOrderModel implements IPracticeDentistForCreateOrderModel {
    practiceId: string;
    practiceDentistId: string;
    practiceDentistName: string | undefined;
    countOfOrders: number;

    constructor(data?: IPracticeDentistForCreateOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.practiceDentistId = _data["practiceDentistId"];
            this.practiceDentistName = _data["practiceDentistName"];
            this.countOfOrders = _data["countOfOrders"];
        }
    }

    static fromJS(data: any): PracticeDentistForCreateOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeDentistForCreateOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["practiceDentistId"] = this.practiceDentistId;
        data["practiceDentistName"] = this.practiceDentistName;
        data["countOfOrders"] = this.countOfOrders;
        return data;
    }

    clone(): PracticeDentistForCreateOrderModel {
        const json = this.toJSON();
        let result = new PracticeDentistForCreateOrderModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeDentistForCreateOrderModel {
    practiceId: string;
    practiceDentistId: string;
    practiceDentistName: string | undefined;
    countOfOrders: number;
}

export class PracticeDentistList implements IPracticeDentistList {
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    dentalRegistrationNumber: string | undefined;
    practice: Practice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPracticeDentistList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PracticeDentistList {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeDentistList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PracticeDentistList {
        const json = this.toJSON();
        let result = new PracticeDentistList();
        result.init(json);
        return result;
    }
}

export interface IPracticeDentistList {
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    dentalRegistrationNumber: string | undefined;
    practice: Practice;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PracticeDentistListCreateModel implements IPracticeDentistListCreateModel {
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IPracticeDentistListCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): PracticeDentistListCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeDentistListCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): PracticeDentistListCreateModel {
        const json = this.toJSON();
        let result = new PracticeDentistListCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeDentistListCreateModel {
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
}

export class PracticeDentistListModel implements IPracticeDentistListModel {
    id: string;
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;

    constructor(data?: IPracticeDentistListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.practiceId = _data["practiceId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): PracticeDentistListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeDentistListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["practiceId"] = this.practiceId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }

    clone(): PracticeDentistListModel {
        const json = this.toJSON();
        let result = new PracticeDentistListModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeDentistListModel {
    id: string;
    practiceId: string;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
}

export class PracticeModel implements IPracticeModel {
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPracticeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.billingEmail = _data["billingEmail"];
            this.locationRouteId = _data["locationRouteId"];
            this.priceListId = _data["priceListId"];
            this.state = _data["state"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.billingOwnerId = _data["billingOwnerId"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.locationExportGroupId = _data["locationExportGroupId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PracticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["billingEmail"] = this.billingEmail;
        data["locationRouteId"] = this.locationRouteId;
        data["priceListId"] = this.priceListId;
        data["state"] = this.state;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["billingOwnerId"] = this.billingOwnerId;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["locationExportGroupId"] = this.locationExportGroupId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PracticeModel {
        const json = this.toJSON();
        let result = new PracticeModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeModel {
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PracticeModelListDto implements IPracticeModelListDto {
    items: PracticeModel[] | undefined;

    constructor(data?: IPracticeModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PracticeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PracticeModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PracticeModelListDto {
        const json = this.toJSON();
        let result = new PracticeModelListDto();
        result.init(json);
        return result;
    }
}

export interface IPracticeModelListDto {
    items: PracticeModel[] | undefined;
}

export class PracticeModelPagedListDto implements IPracticeModelPagedListDto {
    items: PracticeModel[] | undefined;
    totalCount: number;

    constructor(data?: IPracticeModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PracticeModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PracticeModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PracticeModelPagedListDto {
        const json = this.toJSON();
        let result = new PracticeModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IPracticeModelPagedListDto {
    items: PracticeModel[] | undefined;
    totalCount: number;
}

export class PracticeModelWithLocationName implements IPracticeModelWithLocationName {
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    locationRouteId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    locationName: string | undefined;
    dateFormat: string | undefined;
    currency: string | undefined;

    constructor(data?: IPracticeModelWithLocationName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.billingEmail = _data["billingEmail"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.locationRouteId = _data["locationRouteId"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.locationExportGroupId = _data["locationExportGroupId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.locationName = _data["locationName"];
            this.dateFormat = _data["dateFormat"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): PracticeModelWithLocationName {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeModelWithLocationName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["billingEmail"] = this.billingEmail;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["locationRouteId"] = this.locationRouteId;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["locationExportGroupId"] = this.locationExportGroupId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["locationName"] = this.locationName;
        data["dateFormat"] = this.dateFormat;
        data["currency"] = this.currency;
        return data;
    }

    clone(): PracticeModelWithLocationName {
        const json = this.toJSON();
        let result = new PracticeModelWithLocationName();
        result.init(json);
        return result;
    }
}

export interface IPracticeModelWithLocationName {
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    locationRouteId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    locationName: string | undefined;
    dateFormat: string | undefined;
    currency: string | undefined;
}

export class PracticeNote implements IPracticeNote {
    contents: string | undefined;
    practiceId: string;
    creatorId: string;
    practice: Practice;
    creator: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPracticeNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contents = _data["contents"];
            this.practiceId = _data["practiceId"];
            this.creatorId = _data["creatorId"];
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.creator = _data["creator"] ? User.fromJS(_data["creator"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PracticeNote {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contents"] = this.contents;
        data["practiceId"] = this.practiceId;
        data["creatorId"] = this.creatorId;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PracticeNote {
        const json = this.toJSON();
        let result = new PracticeNote();
        result.init(json);
        return result;
    }
}

export interface IPracticeNote {
    contents: string | undefined;
    practiceId: string;
    creatorId: string;
    practice: Practice;
    creator: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PracticeProfileClientModel implements IPracticeProfileClientModel {
    id: string;
    fullName: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    username: string | undefined;
    dentalRegistrationNumber: string | undefined;
    registeredDate: Date;
    role: string | undefined;
    isArchived: boolean;

    constructor(data?: IPracticeProfileClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.role = _data["role"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): PracticeProfileClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeProfileClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["username"] = this.username;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["role"] = this.role;
        data["isArchived"] = this.isArchived;
        return data;
    }

    clone(): PracticeProfileClientModel {
        const json = this.toJSON();
        let result = new PracticeProfileClientModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeProfileClientModel {
    id: string;
    fullName: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    username: string | undefined;
    dentalRegistrationNumber: string | undefined;
    registeredDate: Date;
    role: string | undefined;
    isArchived: boolean;
}

export class PracticeProfileClientModelListDto implements IPracticeProfileClientModelListDto {
    items: PracticeProfileClientModel[] | undefined;

    constructor(data?: IPracticeProfileClientModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PracticeProfileClientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PracticeProfileClientModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeProfileClientModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PracticeProfileClientModelListDto {
        const json = this.toJSON();
        let result = new PracticeProfileClientModelListDto();
        result.init(json);
        return result;
    }
}

export interface IPracticeProfileClientModelListDto {
    items: PracticeProfileClientModel[] | undefined;
}

export class PracticeProfileModel implements IPracticeProfileModel {
    companyId: string;
    clients: PracticeProfileClientModel[] | undefined;
    patients: DoctorProfilePatient[] | undefined;
    notes: InternalNoteModel[] | undefined;
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPracticeProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(PracticeProfileClientModel.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(DoctorProfilePatient.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(InternalNoteModel.fromJS(item));
            }
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.dentistId = _data["dentistId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.town = _data["town"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.phone = _data["phone"];
            this.billingEmail = _data["billingEmail"];
            this.locationRouteId = _data["locationRouteId"];
            this.priceListId = _data["priceListId"];
            this.state = _data["state"];
            this.billingCountry = _data["billingCountry"];
            this.billingState = _data["billingState"];
            this.billingAddress = _data["billingAddress"];
            this.billingAddress2 = _data["billingAddress2"];
            this.billingCity = _data["billingCity"];
            this.billingPostCode = _data["billingPostCode"];
            this.billingOwnerId = _data["billingOwnerId"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.idhPracticeNumber = _data["idhPracticeNumber"];
            this.locationExportGroupId = _data["locationExportGroupId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PracticeProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["dentistId"] = this.dentistId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["country"] = this.country;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["town"] = this.town;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["billingEmail"] = this.billingEmail;
        data["locationRouteId"] = this.locationRouteId;
        data["priceListId"] = this.priceListId;
        data["state"] = this.state;
        data["billingCountry"] = this.billingCountry;
        data["billingState"] = this.billingState;
        data["billingAddress"] = this.billingAddress;
        data["billingAddress2"] = this.billingAddress2;
        data["billingCity"] = this.billingCity;
        data["billingPostCode"] = this.billingPostCode;
        data["billingOwnerId"] = this.billingOwnerId;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["idhPracticeNumber"] = this.idhPracticeNumber;
        data["locationExportGroupId"] = this.locationExportGroupId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PracticeProfileModel {
        const json = this.toJSON();
        let result = new PracticeProfileModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeProfileModel {
    companyId: string;
    clients: PracticeProfileClientModel[] | undefined;
    patients: DoctorProfilePatient[] | undefined;
    notes: InternalNoteModel[] | undefined;
    id: string;
    locationId: string;
    dentistId: string;
    name: string | undefined;
    email: string | undefined;
    country: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    town: string | undefined;
    city: string | undefined;
    postCode: string | undefined;
    phone: string | undefined;
    billingEmail: string | undefined;
    locationRouteId: string | undefined;
    priceListId: string | undefined;
    state: string | undefined;
    billingCountry: string | undefined;
    billingState: string | undefined;
    billingAddress: string | undefined;
    billingAddress2: string | undefined;
    billingCity: string | undefined;
    billingPostCode: string | undefined;
    billingOwnerId: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    idhPracticeNumber: string | undefined;
    locationExportGroupId: string | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PracticeWithUsertModel implements IPracticeWithUsertModel {
    id: string;
    dentistId: string;
    dentist: UserModel;
    name: string | undefined;
    email: string | undefined;
    address: string | undefined;
    phone: string | undefined;

    constructor(data?: IPracticeWithUsertModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dentistId = _data["dentistId"];
            this.dentist = _data["dentist"] ? UserModel.fromJS(_data["dentist"]) : <any>undefined;
            this.name = _data["name"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): PracticeWithUsertModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeWithUsertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dentistId"] = this.dentistId;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["email"] = this.email;
        data["address"] = this.address;
        data["phone"] = this.phone;
        return data;
    }

    clone(): PracticeWithUsertModel {
        const json = this.toJSON();
        let result = new PracticeWithUsertModel();
        result.init(json);
        return result;
    }
}

export interface IPracticeWithUsertModel {
    id: string;
    dentistId: string;
    dentist: UserModel;
    name: string | undefined;
    email: string | undefined;
    address: string | undefined;
    phone: string | undefined;
}

export class PredicateGroup implements IPredicateGroup {
    logicalOperator: LogicalOperator;
    predicates: CustomPredicate[] | undefined;
    predicateGroups: PredicateGroup[] | undefined;
    negative: boolean;

    constructor(data?: IPredicateGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logicalOperator = _data["logicalOperator"];
            if (Array.isArray(_data["predicates"])) {
                this.predicates = [] as any;
                for (let item of _data["predicates"])
                    this.predicates.push(CustomPredicate.fromJS(item));
            }
            if (Array.isArray(_data["predicateGroups"])) {
                this.predicateGroups = [] as any;
                for (let item of _data["predicateGroups"])
                    this.predicateGroups.push(PredicateGroup.fromJS(item));
            }
            this.negative = _data["negative"];
        }
    }

    static fromJS(data: any): PredicateGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PredicateGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logicalOperator"] = this.logicalOperator;
        if (Array.isArray(this.predicates)) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        if (Array.isArray(this.predicateGroups)) {
            data["predicateGroups"] = [];
            for (let item of this.predicateGroups)
                data["predicateGroups"].push(item.toJSON());
        }
        data["negative"] = this.negative;
        return data;
    }

    clone(): PredicateGroup {
        const json = this.toJSON();
        let result = new PredicateGroup();
        result.init(json);
        return result;
    }
}

export interface IPredicateGroup {
    logicalOperator: LogicalOperator;
    predicates: CustomPredicate[] | undefined;
    predicateGroups: PredicateGroup[] | undefined;
    negative: boolean;
}

export class PriceList implements IPriceList {
    id: string;
    name: string | undefined;
    locationId: string;
    priceListItems: PriceListItem[] | undefined;
    practices: Practice[] | undefined;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["priceListItems"])) {
                this.priceListItems = [] as any;
                for (let item of _data["priceListItems"])
                    this.priceListItems.push(PriceListItem.fromJS(item));
            }
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(Practice.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PriceList {
        data = typeof data === 'object' ? data : {};
        let result = new PriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.priceListItems)) {
            data["priceListItems"] = [];
            for (let item of this.priceListItems)
                data["priceListItems"].push(item.toJSON());
        }
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PriceList {
        const json = this.toJSON();
        let result = new PriceList();
        result.init(json);
        return result;
    }
}

export interface IPriceList {
    id: string;
    name: string | undefined;
    locationId: string;
    priceListItems: PriceListItem[] | undefined;
    practices: Practice[] | undefined;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PriceListCreateModel implements IPriceListCreateModel {
    name: string | undefined;
    locationId: string;
    isDefaultPrice: boolean;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    practiceIds: string[] | undefined;

    constructor(data?: IPriceListCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.isDefaultPrice = _data["isDefaultPrice"];
            this.percentageChange = _data["percentageChange"];
            this.absoluteChange = _data["absoluteChange"];
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
        }
    }

    static fromJS(data: any): PriceListCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["isDefaultPrice"] = this.isDefaultPrice;
        data["percentageChange"] = this.percentageChange;
        data["absoluteChange"] = this.absoluteChange;
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        return data;
    }

    clone(): PriceListCreateModel {
        const json = this.toJSON();
        let result = new PriceListCreateModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListCreateModel {
    name: string | undefined;
    locationId: string;
    isDefaultPrice: boolean;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    practiceIds: string[] | undefined;
}

export class PriceListItem implements IPriceListItem {
    price: number;
    practiceId: string;
    productId: number;
    priceListId: string;
    product: Product;
    priceList: PriceList;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IPriceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.practiceId = _data["practiceId"];
            this.productId = _data["productId"];
            this.priceListId = _data["priceListId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.priceList = _data["priceList"] ? PriceList.fromJS(_data["priceList"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): PriceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["practiceId"] = this.practiceId;
        data["productId"] = this.productId;
        data["priceListId"] = this.priceListId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): PriceListItem {
        const json = this.toJSON();
        let result = new PriceListItem();
        result.init(json);
        return result;
    }
}

export interface IPriceListItem {
    price: number;
    practiceId: string;
    productId: number;
    priceListId: string;
    product: Product;
    priceList: PriceList;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class PriceListItemModel implements IPriceListItemModel {
    id: number;
    price: number;
    productId: number;
    priceListId: string;

    constructor(data?: IPriceListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.priceListId = _data["priceListId"];
        }
    }

    static fromJS(data: any): PriceListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["priceListId"] = this.priceListId;
        return data;
    }

    clone(): PriceListItemModel {
        const json = this.toJSON();
        let result = new PriceListItemModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListItemModel {
    id: number;
    price: number;
    productId: number;
    priceListId: string;
}

export class PriceListModel implements IPriceListModel {
    id: string;
    name: string | undefined;
    priceListItems: PriceListItemModel[] | undefined;
    practices: string[] | undefined;

    constructor(data?: IPriceListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["priceListItems"])) {
                this.priceListItems = [] as any;
                for (let item of _data["priceListItems"])
                    this.priceListItems.push(PriceListItemModel.fromJS(item));
            }
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices.push(item);
            }
        }
    }

    static fromJS(data: any): PriceListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.priceListItems)) {
            data["priceListItems"] = [];
            for (let item of this.priceListItems)
                data["priceListItems"].push(item.toJSON());
        }
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item);
        }
        return data;
    }

    clone(): PriceListModel {
        const json = this.toJSON();
        let result = new PriceListModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListModel {
    id: string;
    name: string | undefined;
    priceListItems: PriceListItemModel[] | undefined;
    practices: string[] | undefined;
}

export class PriceListProductsUpdateModel implements IPriceListProductsUpdateModel {
    isChangeProductPrices: boolean;
    locationId: string;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    productIds: number[] | undefined;
    priceListId: string;
    categoryId: number;
    subCategoryId: number;
    materialId: number;
    standardTierId: number;

    constructor(data?: IPriceListProductsUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChangeProductPrices = _data["isChangeProductPrices"];
            this.locationId = _data["locationId"];
            this.percentageChange = _data["percentageChange"];
            this.absoluteChange = _data["absoluteChange"];
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds.push(item);
            }
            this.priceListId = _data["priceListId"];
            this.categoryId = _data["categoryId"];
            this.subCategoryId = _data["subCategoryId"];
            this.materialId = _data["materialId"];
            this.standardTierId = _data["standardTierId"];
        }
    }

    static fromJS(data: any): PriceListProductsUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListProductsUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChangeProductPrices"] = this.isChangeProductPrices;
        data["locationId"] = this.locationId;
        data["percentageChange"] = this.percentageChange;
        data["absoluteChange"] = this.absoluteChange;
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        data["priceListId"] = this.priceListId;
        data["categoryId"] = this.categoryId;
        data["subCategoryId"] = this.subCategoryId;
        data["materialId"] = this.materialId;
        data["standardTierId"] = this.standardTierId;
        return data;
    }

    clone(): PriceListProductsUpdateModel {
        const json = this.toJSON();
        let result = new PriceListProductsUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListProductsUpdateModel {
    isChangeProductPrices: boolean;
    locationId: string;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    productIds: number[] | undefined;
    priceListId: string;
    categoryId: number;
    subCategoryId: number;
    materialId: number;
    standardTierId: number;
}

export class PriceListUpdateModel implements IPriceListUpdateModel {
    id: string;
    name: string | undefined;
    locationId: string;
    isDefaultPrice: boolean;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    practiceIds: string[] | undefined;

    constructor(data?: IPriceListUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.isDefaultPrice = _data["isDefaultPrice"];
            this.percentageChange = _data["percentageChange"];
            this.absoluteChange = _data["absoluteChange"];
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
        }
    }

    static fromJS(data: any): PriceListUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["isDefaultPrice"] = this.isDefaultPrice;
        data["percentageChange"] = this.percentageChange;
        data["absoluteChange"] = this.absoluteChange;
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        return data;
    }

    clone(): PriceListUpdateModel {
        const json = this.toJSON();
        let result = new PriceListUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListUpdateModel {
    id: string;
    name: string | undefined;
    locationId: string;
    isDefaultPrice: boolean;
    percentageChange: number | undefined;
    absoluteChange: number | undefined;
    practiceIds: string[] | undefined;
}

export class PriceListitemUpdateModel implements IPriceListitemUpdateModel {
    priceListId: string;
    price: number;
    productId: number;

    constructor(data?: IPriceListitemUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceListId = _data["priceListId"];
            this.price = _data["price"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): PriceListitemUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListitemUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceListId"] = this.priceListId;
        data["price"] = this.price;
        data["productId"] = this.productId;
        return data;
    }

    clone(): PriceListitemUpdateModel {
        const json = this.toJSON();
        let result = new PriceListitemUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IPriceListitemUpdateModel {
    priceListId: string;
    price: number;
    productId: number;
}

export class PricesStandardModel implements IPricesStandardModel {
    productId: number;
    standardName: string | undefined;
    price: number;
    sku: string | undefined;

    constructor(data?: IPricesStandardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.standardName = _data["standardName"];
            this.price = _data["price"];
            this.sku = _data["sku"];
        }
    }

    static fromJS(data: any): PricesStandardModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricesStandardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["standardName"] = this.standardName;
        data["price"] = this.price;
        data["sku"] = this.sku;
        return data;
    }

    clone(): PricesStandardModel {
        const json = this.toJSON();
        let result = new PricesStandardModel();
        result.init(json);
        return result;
    }
}

export interface IPricesStandardModel {
    productId: number;
    standardName: string | undefined;
    price: number;
    sku: string | undefined;
}

export class Product implements IProduct {
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    isCreatedByUser: boolean;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number | undefined;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;
    priceItems: PriceListItem[] | undefined;
    category: ProductCategory;
    subcategory: ProductSubcategory;
    material: ProductMaterial;
    standardTier: ProductStandardTier;
    orderProducts: OrderProduct[] | undefined;
    location: Location;
    stageProducts: StageProduct[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.categoryId = _data["categoryId"];
            this.subcategoryId = _data["subcategoryId"];
            this.materialId = _data["materialId"];
            this.standardTierId = _data["standardTierId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.price = _data["price"];
            this.cogs = _data["cogs"];
            this.productionTime = _data["productionTime"];
            this.isCreatedByUser = _data["isCreatedByUser"];
            this.shade = _data["shade"];
            this.implantSpecifications = _data["implantSpecifications"];
            this.tax = _data["tax"];
            this.minCountTeeh = _data["minCountTeeh"];
            this.maxCountTeeth = _data["maxCountTeeth"];
            this.isFullArchUL = _data["isFullArchUL"];
            this.isBothArch = _data["isBothArch"];
            this.isDefaultForAllOrders = _data["isDefaultForAllOrders"];
            this.pricePer = _data["pricePer"];
            this.weight = _data["weight"];
            this.isHide = _data["isHide"];
            this.orthoColours = _data["orthoColours"];
            this.laboratoryItemCode = _data["laboratoryItemCode"];
            this.laboratoryItemDescription = _data["laboratoryItemDescription"];
            if (Array.isArray(_data["priceItems"])) {
                this.priceItems = [] as any;
                for (let item of _data["priceItems"])
                    this.priceItems.push(PriceListItem.fromJS(item));
            }
            this.category = _data["category"] ? ProductCategory.fromJS(_data["category"]) : <any>undefined;
            this.subcategory = _data["subcategory"] ? ProductSubcategory.fromJS(_data["subcategory"]) : <any>undefined;
            this.material = _data["material"] ? ProductMaterial.fromJS(_data["material"]) : <any>undefined;
            this.standardTier = _data["standardTier"] ? ProductStandardTier.fromJS(_data["standardTier"]) : <any>undefined;
            if (Array.isArray(_data["orderProducts"])) {
                this.orderProducts = [] as any;
                for (let item of _data["orderProducts"])
                    this.orderProducts.push(OrderProduct.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["stageProducts"])) {
                this.stageProducts = [] as any;
                for (let item of _data["stageProducts"])
                    this.stageProducts.push(StageProduct.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["categoryId"] = this.categoryId;
        data["subcategoryId"] = this.subcategoryId;
        data["materialId"] = this.materialId;
        data["standardTierId"] = this.standardTierId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["price"] = this.price;
        data["cogs"] = this.cogs;
        data["productionTime"] = this.productionTime;
        data["isCreatedByUser"] = this.isCreatedByUser;
        data["shade"] = this.shade;
        data["implantSpecifications"] = this.implantSpecifications;
        data["tax"] = this.tax;
        data["minCountTeeh"] = this.minCountTeeh;
        data["maxCountTeeth"] = this.maxCountTeeth;
        data["isFullArchUL"] = this.isFullArchUL;
        data["isBothArch"] = this.isBothArch;
        data["isDefaultForAllOrders"] = this.isDefaultForAllOrders;
        data["pricePer"] = this.pricePer;
        data["weight"] = this.weight;
        data["isHide"] = this.isHide;
        data["orthoColours"] = this.orthoColours;
        data["laboratoryItemCode"] = this.laboratoryItemCode;
        data["laboratoryItemDescription"] = this.laboratoryItemDescription;
        if (Array.isArray(this.priceItems)) {
            data["priceItems"] = [];
            for (let item of this.priceItems)
                data["priceItems"].push(item.toJSON());
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["subcategory"] = this.subcategory ? this.subcategory.toJSON() : <any>undefined;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["standardTier"] = this.standardTier ? this.standardTier.toJSON() : <any>undefined;
        if (Array.isArray(this.orderProducts)) {
            data["orderProducts"] = [];
            for (let item of this.orderProducts)
                data["orderProducts"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.stageProducts)) {
            data["stageProducts"] = [];
            for (let item of this.stageProducts)
                data["stageProducts"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    isCreatedByUser: boolean;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number | undefined;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;
    priceItems: PriceListItem[] | undefined;
    category: ProductCategory;
    subcategory: ProductSubcategory;
    material: ProductMaterial;
    standardTier: ProductStandardTier;
    orderProducts: OrderProduct[] | undefined;
    location: Location;
    stageProducts: StageProduct[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductCategoriesSetting implements IProductCategoriesSetting {
    locationId: string;
    productCategoryId: number;
    isTurnedOff: boolean;
    location: Location;
    productCategory: ProductCategory;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductCategoriesSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productCategoryId = _data["productCategoryId"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductCategoriesSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoriesSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productCategoryId"] = this.productCategoryId;
        data["isTurnedOff"] = this.isTurnedOff;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductCategoriesSetting {
        const json = this.toJSON();
        let result = new ProductCategoriesSetting();
        result.init(json);
        return result;
    }
}

export interface IProductCategoriesSetting {
    locationId: string;
    productCategoryId: number;
    isTurnedOff: boolean;
    location: Location;
    productCategory: ProductCategory;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductCategoriesSettingModel implements IProductCategoriesSettingModel {
    id: string;
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isTurnedOff: boolean;
    isDefault: boolean;

    constructor(data?: IProductCategoriesSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.productCategoryId = _data["productCategoryId"];
            this.categoryName = _data["categoryName"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ProductCategoriesSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoriesSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["productCategoryId"] = this.productCategoryId;
        data["categoryName"] = this.categoryName;
        data["isTurnedOff"] = this.isTurnedOff;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): ProductCategoriesSettingModel {
        const json = this.toJSON();
        let result = new ProductCategoriesSettingModel();
        result.init(json);
        return result;
    }
}

export interface IProductCategoriesSettingModel {
    id: string;
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isTurnedOff: boolean;
    isDefault: boolean;
}

export class ProductCategory implements IProductCategory {
    name: string | undefined;
    code: string | undefined;
    locationId: string | undefined;
    logoUrl: string | undefined;
    isHide: boolean;
    isOrthodontic: boolean;
    type: CategoryType;
    products: Product[] | undefined;
    subcategories: ProductSubcategory[] | undefined;
    productMaterials: ProductMaterial[] | undefined;
    orders: Order[] | undefined;
    productCategoriesSettings: ProductCategoriesSetting[] | undefined;
    workbenchWorkflows: WorkbenchWorkflow[] | undefined;
    stageCategories: StageCategory[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.locationId = _data["locationId"];
            this.logoUrl = _data["logoUrl"];
            this.isHide = _data["isHide"];
            this.isOrthodontic = _data["isOrthodontic"];
            this.type = _data["type"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(ProductSubcategory.fromJS(item));
            }
            if (Array.isArray(_data["productMaterials"])) {
                this.productMaterials = [] as any;
                for (let item of _data["productMaterials"])
                    this.productMaterials.push(ProductMaterial.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["productCategoriesSettings"])) {
                this.productCategoriesSettings = [] as any;
                for (let item of _data["productCategoriesSettings"])
                    this.productCategoriesSettings.push(ProductCategoriesSetting.fromJS(item));
            }
            if (Array.isArray(_data["workbenchWorkflows"])) {
                this.workbenchWorkflows = [] as any;
                for (let item of _data["workbenchWorkflows"])
                    this.workbenchWorkflows.push(WorkbenchWorkflow.fromJS(item));
            }
            if (Array.isArray(_data["stageCategories"])) {
                this.stageCategories = [] as any;
                for (let item of _data["stageCategories"])
                    this.stageCategories.push(StageCategory.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["locationId"] = this.locationId;
        data["logoUrl"] = this.logoUrl;
        data["isHide"] = this.isHide;
        data["isOrthodontic"] = this.isOrthodontic;
        data["type"] = this.type;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        if (Array.isArray(this.productMaterials)) {
            data["productMaterials"] = [];
            for (let item of this.productMaterials)
                data["productMaterials"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.productCategoriesSettings)) {
            data["productCategoriesSettings"] = [];
            for (let item of this.productCategoriesSettings)
                data["productCategoriesSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchWorkflows)) {
            data["workbenchWorkflows"] = [];
            for (let item of this.workbenchWorkflows)
                data["workbenchWorkflows"].push(item.toJSON());
        }
        if (Array.isArray(this.stageCategories)) {
            data["stageCategories"] = [];
            for (let item of this.stageCategories)
                data["stageCategories"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductCategory {
        const json = this.toJSON();
        let result = new ProductCategory();
        result.init(json);
        return result;
    }
}

export interface IProductCategory {
    name: string | undefined;
    code: string | undefined;
    locationId: string | undefined;
    logoUrl: string | undefined;
    isHide: boolean;
    isOrthodontic: boolean;
    type: CategoryType;
    products: Product[] | undefined;
    subcategories: ProductSubcategory[] | undefined;
    productMaterials: ProductMaterial[] | undefined;
    orders: Order[] | undefined;
    productCategoriesSettings: ProductCategoriesSetting[] | undefined;
    workbenchWorkflows: WorkbenchWorkflow[] | undefined;
    stageCategories: StageCategory[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductCategoryModel implements IProductCategoryModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
    subcategories: ProductSubcategoryModel[] | undefined;

    constructor(data?: IProductCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(ProductSubcategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductCategoryModel {
        const json = this.toJSON();
        let result = new ProductCategoryModel();
        result.init(json);
        return result;
    }
}

export interface IProductCategoryModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
    subcategories: ProductSubcategoryModel[] | undefined;
}

export class ProductCreateModel implements IProductCreateModel {
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number | undefined;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;

    constructor(data?: IProductCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.categoryId = _data["categoryId"];
            this.subcategoryId = _data["subcategoryId"];
            this.materialId = _data["materialId"];
            this.standardTierId = _data["standardTierId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.price = _data["price"];
            this.cogs = _data["cogs"];
            this.productionTime = _data["productionTime"];
            this.shade = _data["shade"];
            this.implantSpecifications = _data["implantSpecifications"];
            this.tax = _data["tax"];
            this.minCountTeeh = _data["minCountTeeh"];
            this.maxCountTeeth = _data["maxCountTeeth"];
            this.isFullArchUL = _data["isFullArchUL"];
            this.isBothArch = _data["isBothArch"];
            this.isDefaultForAllOrders = _data["isDefaultForAllOrders"];
            this.pricePer = _data["pricePer"];
            this.weight = _data["weight"];
            this.isHide = _data["isHide"];
            this.orthoColours = _data["orthoColours"];
            this.laboratoryItemCode = _data["laboratoryItemCode"];
            this.laboratoryItemDescription = _data["laboratoryItemDescription"];
        }
    }

    static fromJS(data: any): ProductCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["categoryId"] = this.categoryId;
        data["subcategoryId"] = this.subcategoryId;
        data["materialId"] = this.materialId;
        data["standardTierId"] = this.standardTierId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["price"] = this.price;
        data["cogs"] = this.cogs;
        data["productionTime"] = this.productionTime;
        data["shade"] = this.shade;
        data["implantSpecifications"] = this.implantSpecifications;
        data["tax"] = this.tax;
        data["minCountTeeh"] = this.minCountTeeh;
        data["maxCountTeeth"] = this.maxCountTeeth;
        data["isFullArchUL"] = this.isFullArchUL;
        data["isBothArch"] = this.isBothArch;
        data["isDefaultForAllOrders"] = this.isDefaultForAllOrders;
        data["pricePer"] = this.pricePer;
        data["weight"] = this.weight;
        data["isHide"] = this.isHide;
        data["orthoColours"] = this.orthoColours;
        data["laboratoryItemCode"] = this.laboratoryItemCode;
        data["laboratoryItemDescription"] = this.laboratoryItemDescription;
        return data;
    }

    clone(): ProductCreateModel {
        const json = this.toJSON();
        let result = new ProductCreateModel();
        result.init(json);
        return result;
    }
}

export interface IProductCreateModel {
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number | undefined;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;
}

export class ProductListModel implements IProductListModel {
    id: number;
    locationId: string;
    categoryId: number;
    categoryName: string | undefined;
    subcategoryId: number;
    subcategoryName: string | undefined;
    materialId: number;
    materialName: string | undefined;
    standardTierId: number;
    standardTierName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    isCreatedByUser: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number;
    checked: boolean;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;

    constructor(data?: IProductListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.subcategoryId = _data["subcategoryId"];
            this.subcategoryName = _data["subcategoryName"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.standardTierId = _data["standardTierId"];
            this.standardTierName = _data["standardTierName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.price = _data["price"];
            this.cogs = _data["cogs"];
            this.productionTime = _data["productionTime"];
            this.shade = _data["shade"];
            this.implantSpecifications = _data["implantSpecifications"];
            this.tax = _data["tax"];
            this.minCountTeeh = _data["minCountTeeh"];
            this.maxCountTeeth = _data["maxCountTeeth"];
            this.isFullArchUL = _data["isFullArchUL"];
            this.isBothArch = _data["isBothArch"];
            this.isDefaultForAllOrders = _data["isDefaultForAllOrders"];
            this.isCreatedByUser = _data["isCreatedByUser"];
            this.pricePer = _data["pricePer"];
            this.weight = _data["weight"];
            this.isHide = _data["isHide"];
            this.orthoColours = _data["orthoColours"];
            this.checked = _data["checked"];
            this.laboratoryItemCode = _data["laboratoryItemCode"];
            this.laboratoryItemDescription = _data["laboratoryItemDescription"];
        }
    }

    static fromJS(data: any): ProductListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["subcategoryId"] = this.subcategoryId;
        data["subcategoryName"] = this.subcategoryName;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["standardTierId"] = this.standardTierId;
        data["standardTierName"] = this.standardTierName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["price"] = this.price;
        data["cogs"] = this.cogs;
        data["productionTime"] = this.productionTime;
        data["shade"] = this.shade;
        data["implantSpecifications"] = this.implantSpecifications;
        data["tax"] = this.tax;
        data["minCountTeeh"] = this.minCountTeeh;
        data["maxCountTeeth"] = this.maxCountTeeth;
        data["isFullArchUL"] = this.isFullArchUL;
        data["isBothArch"] = this.isBothArch;
        data["isDefaultForAllOrders"] = this.isDefaultForAllOrders;
        data["isCreatedByUser"] = this.isCreatedByUser;
        data["pricePer"] = this.pricePer;
        data["weight"] = this.weight;
        data["isHide"] = this.isHide;
        data["orthoColours"] = this.orthoColours;
        data["checked"] = this.checked;
        data["laboratoryItemCode"] = this.laboratoryItemCode;
        data["laboratoryItemDescription"] = this.laboratoryItemDescription;
        return data;
    }

    clone(): ProductListModel {
        const json = this.toJSON();
        let result = new ProductListModel();
        result.init(json);
        return result;
    }
}

export interface IProductListModel {
    id: number;
    locationId: string;
    categoryId: number;
    categoryName: string | undefined;
    subcategoryId: number;
    subcategoryName: string | undefined;
    materialId: number;
    materialName: string | undefined;
    standardTierId: number;
    standardTierName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    isCreatedByUser: boolean;
    pricePer: ProductPricePer;
    weight: number;
    isHide: boolean;
    orthoColours: number;
    checked: boolean;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;
}

export class ProductListModelPagedListDto implements IProductListModelPagedListDto {
    items: ProductListModel[] | undefined;
    totalCount: number;

    constructor(data?: IProductListModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductListModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductListModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductListModelPagedListDto {
        const json = this.toJSON();
        let result = new ProductListModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IProductListModelPagedListDto {
    items: ProductListModel[] | undefined;
    totalCount: number;
}

export class ProductMaterial implements IProductMaterial {
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;
    category: ProductCategory;
    products: Product[] | undefined;
    productMaterialSettings: ProductMaterialSetting[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isHide = _data["isHide"];
            this.category = _data["category"] ? ProductCategory.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["productMaterialSettings"])) {
                this.productMaterialSettings = [] as any;
                for (let item of _data["productMaterialSettings"])
                    this.productMaterialSettings.push(ProductMaterialSetting.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isHide"] = this.isHide;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.productMaterialSettings)) {
            data["productMaterialSettings"] = [];
            for (let item of this.productMaterialSettings)
                data["productMaterialSettings"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductMaterial {
        const json = this.toJSON();
        let result = new ProductMaterial();
        result.init(json);
        return result;
    }
}

export interface IProductMaterial {
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;
    category: ProductCategory;
    products: Product[] | undefined;
    productMaterialSettings: ProductMaterialSetting[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductMaterialModel implements IProductMaterialModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IProductMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProductMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): ProductMaterialModel {
        const json = this.toJSON();
        let result = new ProductMaterialModel();
        result.init(json);
        return result;
    }
}

export interface IProductMaterialModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
}

export class ProductMaterialSetting implements IProductMaterialSetting {
    locationId: string;
    productMaterialId: number;
    isTurnedOff: boolean;
    location: Location;
    productMaterial: ProductMaterial;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductMaterialSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productMaterialId = _data["productMaterialId"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.productMaterial = _data["productMaterial"] ? ProductMaterial.fromJS(_data["productMaterial"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductMaterialSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterialSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productMaterialId"] = this.productMaterialId;
        data["isTurnedOff"] = this.isTurnedOff;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["productMaterial"] = this.productMaterial ? this.productMaterial.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductMaterialSetting {
        const json = this.toJSON();
        let result = new ProductMaterialSetting();
        result.init(json);
        return result;
    }
}

export interface IProductMaterialSetting {
    locationId: string;
    productMaterialId: number;
    isTurnedOff: boolean;
    location: Location;
    productMaterial: ProductMaterial;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductMaterialSettingModel implements IProductMaterialSettingModel {
    id: string;
    locationId: string;
    productMaterialId: number;
    isTurnedOff: boolean;
    materialName: string | undefined;
    categoryId: number;

    constructor(data?: IProductMaterialSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.productMaterialId = _data["productMaterialId"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.materialName = _data["materialName"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): ProductMaterialSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterialSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["productMaterialId"] = this.productMaterialId;
        data["isTurnedOff"] = this.isTurnedOff;
        data["materialName"] = this.materialName;
        data["categoryId"] = this.categoryId;
        return data;
    }

    clone(): ProductMaterialSettingModel {
        const json = this.toJSON();
        let result = new ProductMaterialSettingModel();
        result.init(json);
        return result;
    }
}

export interface IProductMaterialSettingModel {
    id: string;
    locationId: string;
    productMaterialId: number;
    isTurnedOff: boolean;
    materialName: string | undefined;
    categoryId: number;
}

export class ProductModel implements IProductModel {
    id: number;
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    customPrice: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    isCreatedByUser: boolean;
    pricePer: ProductPricePer;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    weight: number;
    isHide: boolean;
    orthoColours: number;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;

    constructor(data?: IProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.categoryId = _data["categoryId"];
            this.subcategoryId = _data["subcategoryId"];
            this.materialId = _data["materialId"];
            this.standardTierId = _data["standardTierId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sku = _data["sku"];
            this.price = _data["price"];
            this.customPrice = _data["customPrice"];
            this.cogs = _data["cogs"];
            this.productionTime = _data["productionTime"];
            this.shade = _data["shade"];
            this.implantSpecifications = _data["implantSpecifications"];
            this.tax = _data["tax"];
            this.minCountTeeh = _data["minCountTeeh"];
            this.maxCountTeeth = _data["maxCountTeeth"];
            this.isFullArchUL = _data["isFullArchUL"];
            this.isBothArch = _data["isBothArch"];
            this.isDefaultForAllOrders = _data["isDefaultForAllOrders"];
            this.isCreatedByUser = _data["isCreatedByUser"];
            this.pricePer = _data["pricePer"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
            this.weight = _data["weight"];
            this.isHide = _data["isHide"];
            this.orthoColours = _data["orthoColours"];
            this.laboratoryItemCode = _data["laboratoryItemCode"];
            this.laboratoryItemDescription = _data["laboratoryItemDescription"];
        }
    }

    static fromJS(data: any): ProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["categoryId"] = this.categoryId;
        data["subcategoryId"] = this.subcategoryId;
        data["materialId"] = this.materialId;
        data["standardTierId"] = this.standardTierId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sku"] = this.sku;
        data["price"] = this.price;
        data["customPrice"] = this.customPrice;
        data["cogs"] = this.cogs;
        data["productionTime"] = this.productionTime;
        data["shade"] = this.shade;
        data["implantSpecifications"] = this.implantSpecifications;
        data["tax"] = this.tax;
        data["minCountTeeh"] = this.minCountTeeh;
        data["maxCountTeeth"] = this.maxCountTeeth;
        data["isFullArchUL"] = this.isFullArchUL;
        data["isBothArch"] = this.isBothArch;
        data["isDefaultForAllOrders"] = this.isDefaultForAllOrders;
        data["isCreatedByUser"] = this.isCreatedByUser;
        data["pricePer"] = this.pricePer;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        data["weight"] = this.weight;
        data["isHide"] = this.isHide;
        data["orthoColours"] = this.orthoColours;
        data["laboratoryItemCode"] = this.laboratoryItemCode;
        data["laboratoryItemDescription"] = this.laboratoryItemDescription;
        return data;
    }

    clone(): ProductModel {
        const json = this.toJSON();
        let result = new ProductModel();
        result.init(json);
        return result;
    }
}

export interface IProductModel {
    id: number;
    locationId: string;
    categoryId: number;
    subcategoryId: number;
    materialId: number;
    standardTierId: number;
    name: string | undefined;
    description: string | undefined;
    sku: string | undefined;
    price: number;
    customPrice: number;
    cogs: number;
    productionTime: number | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    isDefaultForAllOrders: boolean;
    isCreatedByUser: boolean;
    pricePer: ProductPricePer;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
    weight: number;
    isHide: boolean;
    orthoColours: number;
    laboratoryItemCode: string | undefined;
    laboratoryItemDescription: string | undefined;
}

export class ProductNameModel implements IProductNameModel {
    name: string | undefined;

    constructor(data?: IProductNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): ProductNameModel {
        const json = this.toJSON();
        let result = new ProductNameModel();
        result.init(json);
        return result;
    }
}

export interface IProductNameModel {
    name: string | undefined;
}

export enum ProductPricePer {
    Tooth = <any>"Tooth",
    Arch = <any>"Arch",
    Product = <any>"Product",
}

export class ProductStandardTier implements IProductStandardTier {
    name: string | undefined;
    code: string | undefined;
    products: Product[] | undefined;
    productStandardTierSettings: ProductStandardTierSetting[] | undefined;
    productStandardTierCustomNames: ProductStandardTierCustomName[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductStandardTier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["productStandardTierSettings"])) {
                this.productStandardTierSettings = [] as any;
                for (let item of _data["productStandardTierSettings"])
                    this.productStandardTierSettings.push(ProductStandardTierSetting.fromJS(item));
            }
            if (Array.isArray(_data["productStandardTierCustomNames"])) {
                this.productStandardTierCustomNames = [] as any;
                for (let item of _data["productStandardTierCustomNames"])
                    this.productStandardTierCustomNames.push(ProductStandardTierCustomName.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductStandardTier {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStandardTier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.productStandardTierSettings)) {
            data["productStandardTierSettings"] = [];
            for (let item of this.productStandardTierSettings)
                data["productStandardTierSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.productStandardTierCustomNames)) {
            data["productStandardTierCustomNames"] = [];
            for (let item of this.productStandardTierCustomNames)
                data["productStandardTierCustomNames"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductStandardTier {
        const json = this.toJSON();
        let result = new ProductStandardTier();
        result.init(json);
        return result;
    }
}

export interface IProductStandardTier {
    name: string | undefined;
    code: string | undefined;
    products: Product[] | undefined;
    productStandardTierSettings: ProductStandardTierSetting[] | undefined;
    productStandardTierCustomNames: ProductStandardTierCustomName[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductStandardTierCustomName implements IProductStandardTierCustomName {
    name: string | undefined;
    locationId: string;
    productStandardTierId: number;
    productStandardTier: ProductStandardTier;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductStandardTierCustomName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.productStandardTierId = _data["productStandardTierId"];
            this.productStandardTier = _data["productStandardTier"] ? ProductStandardTier.fromJS(_data["productStandardTier"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductStandardTierCustomName {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStandardTierCustomName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["productStandardTierId"] = this.productStandardTierId;
        data["productStandardTier"] = this.productStandardTier ? this.productStandardTier.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductStandardTierCustomName {
        const json = this.toJSON();
        let result = new ProductStandardTierCustomName();
        result.init(json);
        return result;
    }
}

export interface IProductStandardTierCustomName {
    name: string | undefined;
    locationId: string;
    productStandardTierId: number;
    productStandardTier: ProductStandardTier;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductStandardTierSetting implements IProductStandardTierSetting {
    locationId: string;
    productStandardTierId: number;
    isTurnedOff: boolean;
    location: Location;
    productStandardTier: ProductStandardTier;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductStandardTierSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productStandardTierId = _data["productStandardTierId"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.productStandardTier = _data["productStandardTier"] ? ProductStandardTier.fromJS(_data["productStandardTier"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductStandardTierSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStandardTierSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productStandardTierId"] = this.productStandardTierId;
        data["isTurnedOff"] = this.isTurnedOff;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["productStandardTier"] = this.productStandardTier ? this.productStandardTier.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductStandardTierSetting {
        const json = this.toJSON();
        let result = new ProductStandardTierSetting();
        result.init(json);
        return result;
    }
}

export interface IProductStandardTierSetting {
    locationId: string;
    productStandardTierId: number;
    isTurnedOff: boolean;
    location: Location;
    productStandardTier: ProductStandardTier;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductStandardTierSettingModel implements IProductStandardTierSettingModel {
    id: string;
    locationId: string;
    productStandardTierId: number;
    isTurnedOff: boolean;
    standardTierName: string | undefined;

    constructor(data?: IProductStandardTierSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.productStandardTierId = _data["productStandardTierId"];
            this.isTurnedOff = _data["isTurnedOff"];
            this.standardTierName = _data["standardTierName"];
        }
    }

    static fromJS(data: any): ProductStandardTierSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStandardTierSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["productStandardTierId"] = this.productStandardTierId;
        data["isTurnedOff"] = this.isTurnedOff;
        data["standardTierName"] = this.standardTierName;
        return data;
    }

    clone(): ProductStandardTierSettingModel {
        const json = this.toJSON();
        let result = new ProductStandardTierSettingModel();
        result.init(json);
        return result;
    }
}

export interface IProductStandardTierSettingModel {
    id: string;
    locationId: string;
    productStandardTierId: number;
    isTurnedOff: boolean;
    standardTierName: string | undefined;
}

export class ProductSubcategory implements IProductSubcategory {
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    logoUrl: string | undefined;
    isHide: boolean;
    type: SubCategoryType;
    category: ProductCategory;
    products: Product[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IProductSubcategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.logoUrl = _data["logoUrl"];
            this.isHide = _data["isHide"];
            this.type = _data["type"];
            this.category = _data["category"] ? ProductCategory.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(Product.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): ProductSubcategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubcategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["logoUrl"] = this.logoUrl;
        data["isHide"] = this.isHide;
        data["type"] = this.type;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): ProductSubcategory {
        const json = this.toJSON();
        let result = new ProductSubcategory();
        result.init(json);
        return result;
    }
}

export interface IProductSubcategory {
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    logoUrl: string | undefined;
    isHide: boolean;
    type: SubCategoryType;
    category: ProductCategory;
    products: Product[] | undefined;
    id: number;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ProductSubcategoryModel implements IProductSubcategoryModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IProductSubcategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProductSubcategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubcategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): ProductSubcategoryModel {
        const json = this.toJSON();
        let result = new ProductSubcategoryModel();
        result.init(json);
        return result;
    }
}

export interface IProductSubcategoryModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
}

export class ProductWithStandardTier implements IProductWithStandardTier {
    id: number;
    name: string | undefined;
    sku: string | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    standardTierId: number;
    standardTierName: string | undefined;
    standardTierCode: string | undefined;
    isStages: boolean;
    stagesNames: string[] | undefined;
    orthoColours: number;

    constructor(data?: IProductWithStandardTier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.shade = _data["shade"];
            this.implantSpecifications = _data["implantSpecifications"];
            this.tax = _data["tax"];
            this.minCountTeeh = _data["minCountTeeh"];
            this.maxCountTeeth = _data["maxCountTeeth"];
            this.isFullArchUL = _data["isFullArchUL"];
            this.isBothArch = _data["isBothArch"];
            this.standardTierId = _data["standardTierId"];
            this.standardTierName = _data["standardTierName"];
            this.standardTierCode = _data["standardTierCode"];
            this.isStages = _data["isStages"];
            if (Array.isArray(_data["stagesNames"])) {
                this.stagesNames = [] as any;
                for (let item of _data["stagesNames"])
                    this.stagesNames.push(item);
            }
            this.orthoColours = _data["orthoColours"];
        }
    }

    static fromJS(data: any): ProductWithStandardTier {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWithStandardTier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["shade"] = this.shade;
        data["implantSpecifications"] = this.implantSpecifications;
        data["tax"] = this.tax;
        data["minCountTeeh"] = this.minCountTeeh;
        data["maxCountTeeth"] = this.maxCountTeeth;
        data["isFullArchUL"] = this.isFullArchUL;
        data["isBothArch"] = this.isBothArch;
        data["standardTierId"] = this.standardTierId;
        data["standardTierName"] = this.standardTierName;
        data["standardTierCode"] = this.standardTierCode;
        data["isStages"] = this.isStages;
        if (Array.isArray(this.stagesNames)) {
            data["stagesNames"] = [];
            for (let item of this.stagesNames)
                data["stagesNames"].push(item);
        }
        data["orthoColours"] = this.orthoColours;
        return data;
    }

    clone(): ProductWithStandardTier {
        const json = this.toJSON();
        let result = new ProductWithStandardTier();
        result.init(json);
        return result;
    }
}

export interface IProductWithStandardTier {
    id: number;
    name: string | undefined;
    sku: string | undefined;
    shade: boolean;
    implantSpecifications: boolean;
    tax: number;
    minCountTeeh: number;
    maxCountTeeth: number;
    isFullArchUL: boolean;
    isBothArch: boolean;
    standardTierId: number;
    standardTierName: string | undefined;
    standardTierCode: string | undefined;
    isStages: boolean;
    stagesNames: string[] | undefined;
    orthoColours: number;
}

export class ProfileFileModel implements IProfileFileModel {
    id: string;
    orderId: string;
    typeId: number;
    typeName: string | undefined;
    url: string | undefined;

    constructor(data?: IProfileFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ProfileFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["url"] = this.url;
        return data;
    }

    clone(): ProfileFileModel {
        const json = this.toJSON();
        let result = new ProfileFileModel();
        result.init(json);
        return result;
    }
}

export interface IProfileFileModel {
    id: string;
    orderId: string;
    typeId: number;
    typeName: string | undefined;
    url: string | undefined;
}

export class QuickbooksRequestDto implements IQuickbooksRequestDto {
    code: string | undefined;
    userName: string | undefined;
    userId: string | undefined;
    userTime: number;
    locationId: string;
    realmId: string | undefined;

    constructor(data?: IQuickbooksRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.userTime = _data["userTime"];
            this.locationId = _data["locationId"];
            this.realmId = _data["realmId"];
        }
    }

    static fromJS(data: any): QuickbooksRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuickbooksRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["userTime"] = this.userTime;
        data["locationId"] = this.locationId;
        data["realmId"] = this.realmId;
        return data;
    }

    clone(): QuickbooksRequestDto {
        const json = this.toJSON();
        let result = new QuickbooksRequestDto();
        result.init(json);
        return result;
    }
}

export interface IQuickbooksRequestDto {
    code: string | undefined;
    userName: string | undefined;
    userId: string | undefined;
    userTime: number;
    locationId: string;
    realmId: string | undefined;
}

export class ReceivingOptionModel implements IReceivingOptionModel {
    id: string;
    receivingSettingsId: string;
    name: string | undefined;
    order: number;
    type: ReceivingOptionType;

    constructor(data?: IReceivingOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receivingSettingsId = _data["receivingSettingsId"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ReceivingOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivingOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receivingSettingsId"] = this.receivingSettingsId;
        data["name"] = this.name;
        data["order"] = this.order;
        data["type"] = this.type;
        return data;
    }

    clone(): ReceivingOptionModel {
        const json = this.toJSON();
        let result = new ReceivingOptionModel();
        result.init(json);
        return result;
    }
}

export interface IReceivingOptionModel {
    id: string;
    receivingSettingsId: string;
    name: string | undefined;
    order: number;
    type: ReceivingOptionType;
}

export enum ReceivingOptionType {
    Digital = <any>"Digital",
    Analogue = <any>"Analogue",
}

export class ReceivingSettingsModel implements IReceivingSettingsModel {
    id: string;
    locationId: string;
    digitalDisplayName: string | undefined;
    isActiveDigital: boolean;
    analogueDisplayName: string | undefined;
    isActiveAnalogue: boolean;
    analogueUnitsLimit: number;
    notAppicableDisplayName: string | undefined;
    isActiveNotAppicable: boolean;
    receivingOptions: ReceivingOptionModel[] | undefined;

    constructor(data?: IReceivingSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.digitalDisplayName = _data["digitalDisplayName"];
            this.isActiveDigital = _data["isActiveDigital"];
            this.analogueDisplayName = _data["analogueDisplayName"];
            this.isActiveAnalogue = _data["isActiveAnalogue"];
            this.analogueUnitsLimit = _data["analogueUnitsLimit"];
            this.notAppicableDisplayName = _data["notAppicableDisplayName"];
            this.isActiveNotAppicable = _data["isActiveNotAppicable"];
            if (Array.isArray(_data["receivingOptions"])) {
                this.receivingOptions = [] as any;
                for (let item of _data["receivingOptions"])
                    this.receivingOptions.push(ReceivingOptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceivingSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivingSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["digitalDisplayName"] = this.digitalDisplayName;
        data["isActiveDigital"] = this.isActiveDigital;
        data["analogueDisplayName"] = this.analogueDisplayName;
        data["isActiveAnalogue"] = this.isActiveAnalogue;
        data["analogueUnitsLimit"] = this.analogueUnitsLimit;
        data["notAppicableDisplayName"] = this.notAppicableDisplayName;
        data["isActiveNotAppicable"] = this.isActiveNotAppicable;
        if (Array.isArray(this.receivingOptions)) {
            data["receivingOptions"] = [];
            for (let item of this.receivingOptions)
                data["receivingOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReceivingSettingsModel {
        const json = this.toJSON();
        let result = new ReceivingSettingsModel();
        result.init(json);
        return result;
    }
}

export interface IReceivingSettingsModel {
    id: string;
    locationId: string;
    digitalDisplayName: string | undefined;
    isActiveDigital: boolean;
    analogueDisplayName: string | undefined;
    isActiveAnalogue: boolean;
    analogueUnitsLimit: number;
    notAppicableDisplayName: string | undefined;
    isActiveNotAppicable: boolean;
    receivingOptions: ReceivingOptionModel[] | undefined;
}

export class RemakeOrderModel implements IRemakeOrderModel {
    orderId: string;
    reason: string | undefined;
    orderProductsIds: string[] | undefined;
    note: string | undefined;

    constructor(data?: IRemakeOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["orderProductsIds"])) {
                this.orderProductsIds = [] as any;
                for (let item of _data["orderProductsIds"])
                    this.orderProductsIds.push(item);
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): RemakeOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemakeOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["reason"] = this.reason;
        if (Array.isArray(this.orderProductsIds)) {
            data["orderProductsIds"] = [];
            for (let item of this.orderProductsIds)
                data["orderProductsIds"].push(item);
        }
        data["note"] = this.note;
        return data;
    }

    clone(): RemakeOrderModel {
        const json = this.toJSON();
        let result = new RemakeOrderModel();
        result.init(json);
        return result;
    }
}

export interface IRemakeOrderModel {
    orderId: string;
    reason: string | undefined;
    orderProductsIds: string[] | undefined;
    note: string | undefined;
}

export class RemoveAddonOrderProductModel implements IRemoveAddonOrderProductModel {
    orderId: string;
    orderProductId: string;

    constructor(data?: IRemoveAddonOrderProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderProductId = _data["orderProductId"];
        }
    }

    static fromJS(data: any): RemoveAddonOrderProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveAddonOrderProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderProductId"] = this.orderProductId;
        return data;
    }

    clone(): RemoveAddonOrderProductModel {
        const json = this.toJSON();
        let result = new RemoveAddonOrderProductModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveAddonOrderProductModel {
    orderId: string;
    orderProductId: string;
}

export class ReportRequestModel implements IReportRequestModel {
    locationId: string;
    startTime: Date;
    endTime: Date;

    constructor(data?: IReportRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReportRequestModel {
        const json = this.toJSON();
        let result = new ReportRequestModel();
        result.init(json);
        return result;
    }
}

export interface IReportRequestModel {
    locationId: string;
    startTime: Date;
    endTime: Date;
}

export class ResetPasswordModel implements IResetPasswordModel {
    username: string | undefined;
    newPassword: string | undefined;
    token: string | undefined;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.newPassword = _data["newPassword"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["newPassword"] = this.newPassword;
        data["token"] = this.token;
        return data;
    }

    clone(): ResetPasswordModel {
        const json = this.toJSON();
        let result = new ResetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordModel {
    username: string | undefined;
    newPassword: string | undefined;
    token: string | undefined;
}

export class Restoration3shapeModel implements IRestoration3shapeModel {
    practiceRestorationType: string | undefined;
    unn: number;
    restorationType: string | undefined;
    implantManufacturer: any | undefined;
    implantSystem: any | undefined;
    implantPlatformType: any | undefined;
    implantDiameter: any | undefined;
    implantLength: any | undefined;
    globalImplantConnectionId: any | undefined;
    abutmentKitID: any | undefined;
    anatomical: any | undefined;

    constructor(data?: IRestoration3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceRestorationType = _data["PracticeRestorationType"];
            this.unn = _data["Unn"];
            this.restorationType = _data["RestorationType"];
            this.implantManufacturer = _data["ImplantManufacturer"];
            this.implantSystem = _data["ImplantSystem"];
            this.implantPlatformType = _data["ImplantPlatformType"];
            this.implantDiameter = _data["ImplantDiameter"];
            this.implantLength = _data["ImplantLength"];
            this.globalImplantConnectionId = _data["GlobalImplantConnectionId"];
            this.abutmentKitID = _data["AbutmentKitID"];
            this.anatomical = _data["Anatomical"];
        }
    }

    static fromJS(data: any): Restoration3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Restoration3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PracticeRestorationType"] = this.practiceRestorationType;
        data["Unn"] = this.unn;
        data["RestorationType"] = this.restorationType;
        data["ImplantManufacturer"] = this.implantManufacturer;
        data["ImplantSystem"] = this.implantSystem;
        data["ImplantPlatformType"] = this.implantPlatformType;
        data["ImplantDiameter"] = this.implantDiameter;
        data["ImplantLength"] = this.implantLength;
        data["GlobalImplantConnectionId"] = this.globalImplantConnectionId;
        data["AbutmentKitID"] = this.abutmentKitID;
        data["Anatomical"] = this.anatomical;
        return data;
    }

    clone(): Restoration3shapeModel {
        const json = this.toJSON();
        let result = new Restoration3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IRestoration3shapeModel {
    practiceRestorationType: string | undefined;
    unn: number;
    restorationType: string | undefined;
    implantManufacturer: any | undefined;
    implantSystem: any | undefined;
    implantPlatformType: any | undefined;
    implantDiameter: any | undefined;
    implantLength: any | undefined;
    globalImplantConnectionId: any | undefined;
    abutmentKitID: any | undefined;
    anatomical: any | undefined;
}

export class ResultMessage implements IResultMessage {
    result: boolean;
    message: string | undefined;

    constructor(data?: IResultMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResultMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["message"] = this.message;
        return data;
    }

    clone(): ResultMessage {
        const json = this.toJSON();
        let result = new ResultMessage();
        result.init(json);
        return result;
    }
}

export interface IResultMessage {
    result: boolean;
    message: string | undefined;
}

export class RunAutomationRequestModel implements IRunAutomationRequestModel {
    automationId: string;
    userId: string | undefined;
    statusId: number | undefined;
    orderCode: string | undefined;

    constructor(data?: IRunAutomationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.automationId = _data["automationId"];
            this.userId = _data["userId"];
            this.statusId = _data["statusId"];
            this.orderCode = _data["orderCode"];
        }
    }

    static fromJS(data: any): RunAutomationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new RunAutomationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["automationId"] = this.automationId;
        data["userId"] = this.userId;
        data["statusId"] = this.statusId;
        data["orderCode"] = this.orderCode;
        return data;
    }

    clone(): RunAutomationRequestModel {
        const json = this.toJSON();
        let result = new RunAutomationRequestModel();
        result.init(json);
        return result;
    }
}

export interface IRunAutomationRequestModel {
    automationId: string;
    userId: string | undefined;
    statusId: number | undefined;
    orderCode: string | undefined;
}

export class Scan3shapeModel implements IScan3shapeModel {
    scanTimestamp: Date;
    jawType: string | undefined;
    id: string;
    type: string | undefined;
    href: string | undefined;
    hash: string | undefined;
    fileType: string | undefined;

    constructor(data?: IScan3shapeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scanTimestamp = _data["ScanTimestamp"] ? new Date(_data["ScanTimestamp"].toString()) : <any>undefined;
            this.jawType = _data["JawType"];
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.href = _data["Href"];
            this.hash = _data["Hash"];
            this.fileType = _data["FileType"];
        }
    }

    static fromJS(data: any): Scan3shapeModel {
        data = typeof data === 'object' ? data : {};
        let result = new Scan3shapeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScanTimestamp"] = this.scanTimestamp ? this.scanTimestamp.toISOString() : <any>undefined;
        data["JawType"] = this.jawType;
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Href"] = this.href;
        data["Hash"] = this.hash;
        data["FileType"] = this.fileType;
        return data;
    }

    clone(): Scan3shapeModel {
        const json = this.toJSON();
        let result = new Scan3shapeModel();
        result.init(json);
        return result;
    }
}

export interface IScan3shapeModel {
    scanTimestamp: Date;
    jawType: string | undefined;
    id: string;
    type: string | undefined;
    href: string | undefined;
    hash: string | undefined;
    fileType: string | undefined;
}

export class Service implements IService {
    carrierId: string | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    name: string | undefined;
    domestic: boolean;
    international: boolean;
    isMultiPackageSupported: boolean;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.carrierCode = _data["carrierCode"];
            this.serviceCode = _data["serviceCode"];
            this.name = _data["name"];
            this.domestic = _data["domestic"];
            this.international = _data["international"];
            this.isMultiPackageSupported = _data["isMultiPackageSupported"];
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["carrierCode"] = this.carrierCode;
        data["serviceCode"] = this.serviceCode;
        data["name"] = this.name;
        data["domestic"] = this.domestic;
        data["international"] = this.international;
        data["isMultiPackageSupported"] = this.isMultiPackageSupported;
        return data;
    }

    clone(): Service {
        const json = this.toJSON();
        let result = new Service();
        result.init(json);
        return result;
    }
}

export interface IService {
    carrierId: string | undefined;
    carrierCode: string | undefined;
    serviceCode: string | undefined;
    name: string | undefined;
    domestic: boolean;
    international: boolean;
    isMultiPackageSupported: boolean;
}

export class ShipmentLabelResponse implements IShipmentLabelResponse {
    labelId: string | undefined;
    status: string | undefined;
    shipmentId: string | undefined;
    shipDate: Date;
    createdAt: Date;
    shipmentCost: MonetaryValue;
    insuranceCost: MonetaryValue;
    requestedComparisonAmount: MonetaryValue;
    rateDetails: any[] | undefined;
    trackingNumber: string | undefined;
    isReturnLabel: boolean;
    rmaNumber: string | undefined;
    isInternational: boolean;
    batchId: string | undefined;
    carrierId: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    voided: boolean;
    voidedAt: Date | undefined;
    labelFormat: string | undefined;
    displayScheme: string | undefined;
    labelLayout: string | undefined;
    trackable: boolean;
    labelImageId: string | undefined;
    carrierCode: string | undefined;
    trackingStatus: string | undefined;
    labelDownload: Download;
    formDownload: Link;
    qrCodeDownload: Download;
    insuranceClaim: Link;
    packages: LabelPackage[] | undefined;
    chargeEvent: string | undefined;
    alternativeIdentifiers: any[] | undefined;
    success: boolean;
    errorMessage: string | undefined;

    constructor(data?: IShipmentLabelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelId = _data["labelId"];
            this.status = _data["status"];
            this.shipmentId = _data["shipmentId"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.shipmentCost = _data["shipmentCost"] ? MonetaryValue.fromJS(_data["shipmentCost"]) : <any>undefined;
            this.insuranceCost = _data["insuranceCost"] ? MonetaryValue.fromJS(_data["insuranceCost"]) : <any>undefined;
            this.requestedComparisonAmount = _data["requestedComparisonAmount"] ? MonetaryValue.fromJS(_data["requestedComparisonAmount"]) : <any>undefined;
            if (Array.isArray(_data["rateDetails"])) {
                this.rateDetails = [] as any;
                for (let item of _data["rateDetails"])
                    this.rateDetails.push(item);
            }
            this.trackingNumber = _data["trackingNumber"];
            this.isReturnLabel = _data["isReturnLabel"];
            this.rmaNumber = _data["rmaNumber"];
            this.isInternational = _data["isInternational"];
            this.batchId = _data["batchId"];
            this.carrierId = _data["carrierId"];
            this.serviceCode = _data["serviceCode"];
            this.packageCode = _data["packageCode"];
            this.voided = _data["voided"];
            this.voidedAt = _data["voidedAt"] ? new Date(_data["voidedAt"].toString()) : <any>undefined;
            this.labelFormat = _data["labelFormat"];
            this.displayScheme = _data["displayScheme"];
            this.labelLayout = _data["labelLayout"];
            this.trackable = _data["trackable"];
            this.labelImageId = _data["labelImageId"];
            this.carrierCode = _data["carrierCode"];
            this.trackingStatus = _data["trackingStatus"];
            this.labelDownload = _data["labelDownload"] ? Download.fromJS(_data["labelDownload"]) : <any>undefined;
            this.formDownload = _data["formDownload"] ? Link.fromJS(_data["formDownload"]) : <any>undefined;
            this.qrCodeDownload = _data["qrCodeDownload"] ? Download.fromJS(_data["qrCodeDownload"]) : <any>undefined;
            this.insuranceClaim = _data["insuranceClaim"] ? Link.fromJS(_data["insuranceClaim"]) : <any>undefined;
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages.push(LabelPackage.fromJS(item));
            }
            this.chargeEvent = _data["chargeEvent"];
            if (Array.isArray(_data["alternativeIdentifiers"])) {
                this.alternativeIdentifiers = [] as any;
                for (let item of _data["alternativeIdentifiers"])
                    this.alternativeIdentifiers.push(item);
            }
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ShipmentLabelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentLabelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelId"] = this.labelId;
        data["status"] = this.status;
        data["shipmentId"] = this.shipmentId;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["shipmentCost"] = this.shipmentCost ? this.shipmentCost.toJSON() : <any>undefined;
        data["insuranceCost"] = this.insuranceCost ? this.insuranceCost.toJSON() : <any>undefined;
        data["requestedComparisonAmount"] = this.requestedComparisonAmount ? this.requestedComparisonAmount.toJSON() : <any>undefined;
        if (Array.isArray(this.rateDetails)) {
            data["rateDetails"] = [];
            for (let item of this.rateDetails)
                data["rateDetails"].push(item);
        }
        data["trackingNumber"] = this.trackingNumber;
        data["isReturnLabel"] = this.isReturnLabel;
        data["rmaNumber"] = this.rmaNumber;
        data["isInternational"] = this.isInternational;
        data["batchId"] = this.batchId;
        data["carrierId"] = this.carrierId;
        data["serviceCode"] = this.serviceCode;
        data["packageCode"] = this.packageCode;
        data["voided"] = this.voided;
        data["voidedAt"] = this.voidedAt ? this.voidedAt.toISOString() : <any>undefined;
        data["labelFormat"] = this.labelFormat;
        data["displayScheme"] = this.displayScheme;
        data["labelLayout"] = this.labelLayout;
        data["trackable"] = this.trackable;
        data["labelImageId"] = this.labelImageId;
        data["carrierCode"] = this.carrierCode;
        data["trackingStatus"] = this.trackingStatus;
        data["labelDownload"] = this.labelDownload ? this.labelDownload.toJSON() : <any>undefined;
        data["formDownload"] = this.formDownload ? this.formDownload.toJSON() : <any>undefined;
        data["qrCodeDownload"] = this.qrCodeDownload ? this.qrCodeDownload.toJSON() : <any>undefined;
        data["insuranceClaim"] = this.insuranceClaim ? this.insuranceClaim.toJSON() : <any>undefined;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["chargeEvent"] = this.chargeEvent;
        if (Array.isArray(this.alternativeIdentifiers)) {
            data["alternativeIdentifiers"] = [];
            for (let item of this.alternativeIdentifiers)
                data["alternativeIdentifiers"].push(item);
        }
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): ShipmentLabelResponse {
        const json = this.toJSON();
        let result = new ShipmentLabelResponse();
        result.init(json);
        return result;
    }
}

export interface IShipmentLabelResponse {
    labelId: string | undefined;
    status: string | undefined;
    shipmentId: string | undefined;
    shipDate: Date;
    createdAt: Date;
    shipmentCost: MonetaryValue;
    insuranceCost: MonetaryValue;
    requestedComparisonAmount: MonetaryValue;
    rateDetails: any[] | undefined;
    trackingNumber: string | undefined;
    isReturnLabel: boolean;
    rmaNumber: string | undefined;
    isInternational: boolean;
    batchId: string | undefined;
    carrierId: string | undefined;
    serviceCode: string | undefined;
    packageCode: string | undefined;
    voided: boolean;
    voidedAt: Date | undefined;
    labelFormat: string | undefined;
    displayScheme: string | undefined;
    labelLayout: string | undefined;
    trackable: boolean;
    labelImageId: string | undefined;
    carrierCode: string | undefined;
    trackingStatus: string | undefined;
    labelDownload: Download;
    formDownload: Link;
    qrCodeDownload: Download;
    insuranceClaim: Link;
    packages: LabelPackage[] | undefined;
    chargeEvent: string | undefined;
    alternativeIdentifiers: any[] | undefined;
    success: boolean;
    errorMessage: string | undefined;
}

export class ShortUserModel implements IShortUserModel {
    id: string;
    email: string | undefined;
    username: string | undefined;
    fullName: string | undefined;

    constructor(data?: IShortUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ShortUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShortUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): ShortUserModel {
        const json = this.toJSON();
        let result = new ShortUserModel();
        result.init(json);
        return result;
    }
}

export interface IShortUserModel {
    id: string;
    email: string | undefined;
    username: string | undefined;
    fullName: string | undefined;
}

export class ShowHideProductModel implements IShowHideProductModel {
    productId: number;
    isHide: boolean;

    constructor(data?: IShowHideProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.isHide = _data["isHide"];
        }
    }

    static fromJS(data: any): ShowHideProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowHideProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["isHide"] = this.isHide;
        return data;
    }

    clone(): ShowHideProductModel {
        const json = this.toJSON();
        let result = new ShowHideProductModel();
        result.init(json);
        return result;
    }
}

export interface IShowHideProductModel {
    productId: number;
    isHide: boolean;
}

export class Stage implements IStage {
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;
    stagesCategory: StageCategory;
    stageProducts: StageProduct[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stagesCategoryId = _data["stagesCategoryId"];
            this.name = _data["name"];
            this.orderIndex = _data["orderIndex"];
            this.stagesCategory = _data["stagesCategory"] ? StageCategory.fromJS(_data["stagesCategory"]) : <any>undefined;
            if (Array.isArray(_data["stageProducts"])) {
                this.stageProducts = [] as any;
                for (let item of _data["stageProducts"])
                    this.stageProducts.push(StageProduct.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): Stage {
        data = typeof data === 'object' ? data : {};
        let result = new Stage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stagesCategoryId"] = this.stagesCategoryId;
        data["name"] = this.name;
        data["orderIndex"] = this.orderIndex;
        data["stagesCategory"] = this.stagesCategory ? this.stagesCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.stageProducts)) {
            data["stageProducts"] = [];
            for (let item of this.stageProducts)
                data["stageProducts"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): Stage {
        const json = this.toJSON();
        let result = new Stage();
        result.init(json);
        return result;
    }
}

export interface IStage {
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;
    stagesCategory: StageCategory;
    stageProducts: StageProduct[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class StageCategory implements IStageCategory {
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isActive: boolean;
    orderIndex: number;
    location: Location;
    productCategory: ProductCategory;
    stages: Stage[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IStageCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productCategoryId = _data["productCategoryId"];
            this.categoryName = _data["categoryName"];
            this.isActive = _data["isActive"];
            this.orderIndex = _data["orderIndex"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages.push(Stage.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): StageCategory {
        data = typeof data === 'object' ? data : {};
        let result = new StageCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productCategoryId"] = this.productCategoryId;
        data["categoryName"] = this.categoryName;
        data["isActive"] = this.isActive;
        data["orderIndex"] = this.orderIndex;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): StageCategory {
        const json = this.toJSON();
        let result = new StageCategory();
        result.init(json);
        return result;
    }
}

export interface IStageCategory {
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isActive: boolean;
    orderIndex: number;
    location: Location;
    productCategory: ProductCategory;
    stages: Stage[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class StageCategoryActive implements IStageCategoryActive {
    id: string;
    isActive: boolean;

    constructor(data?: IStageCategoryActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StageCategoryActive {
        data = typeof data === 'object' ? data : {};
        let result = new StageCategoryActive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): StageCategoryActive {
        const json = this.toJSON();
        let result = new StageCategoryActive();
        result.init(json);
        return result;
    }
}

export interface IStageCategoryActive {
    id: string;
    isActive: boolean;
}

export class StageCategoryModel implements IStageCategoryModel {
    id: string;
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isActive: boolean;
    orderIndex: number;
    productCategory: ProductCategoryModel;
    stages: StageModel[] | undefined;

    constructor(data?: IStageCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.productCategoryId = _data["productCategoryId"];
            this.categoryName = _data["categoryName"];
            this.isActive = _data["isActive"];
            this.orderIndex = _data["orderIndex"];
            this.productCategory = _data["productCategory"] ? ProductCategoryModel.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages.push(StageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StageCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["productCategoryId"] = this.productCategoryId;
        data["categoryName"] = this.categoryName;
        data["isActive"] = this.isActive;
        data["orderIndex"] = this.orderIndex;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        return data;
    }

    clone(): StageCategoryModel {
        const json = this.toJSON();
        let result = new StageCategoryModel();
        result.init(json);
        return result;
    }
}

export interface IStageCategoryModel {
    id: string;
    locationId: string;
    productCategoryId: number;
    categoryName: string | undefined;
    isActive: boolean;
    orderIndex: number;
    productCategory: ProductCategoryModel;
    stages: StageModel[] | undefined;
}

export class StageModel implements IStageModel {
    id: string;
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;
    stagesCategory: StageCategoryModel;
    stageProducts: StageProductModel[] | undefined;

    constructor(data?: IStageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stagesCategoryId = _data["stagesCategoryId"];
            this.name = _data["name"];
            this.orderIndex = _data["orderIndex"];
            this.stagesCategory = _data["stagesCategory"] ? StageCategoryModel.fromJS(_data["stagesCategory"]) : <any>undefined;
            if (Array.isArray(_data["stageProducts"])) {
                this.stageProducts = [] as any;
                for (let item of _data["stageProducts"])
                    this.stageProducts.push(StageProductModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StageModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stagesCategoryId"] = this.stagesCategoryId;
        data["name"] = this.name;
        data["orderIndex"] = this.orderIndex;
        data["stagesCategory"] = this.stagesCategory ? this.stagesCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.stageProducts)) {
            data["stageProducts"] = [];
            for (let item of this.stageProducts)
                data["stageProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): StageModel {
        const json = this.toJSON();
        let result = new StageModel();
        result.init(json);
        return result;
    }
}

export interface IStageModel {
    id: string;
    stagesCategoryId: string;
    name: string | undefined;
    orderIndex: number;
    stagesCategory: StageCategoryModel;
    stageProducts: StageProductModel[] | undefined;
}

export class StageOrderIndexModel implements IStageOrderIndexModel {
    stageId: string;
    orderIndex: number;

    constructor(data?: IStageOrderIndexModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stageId = _data["stageId"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): StageOrderIndexModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageOrderIndexModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stageId"] = this.stageId;
        data["orderIndex"] = this.orderIndex;
        return data;
    }

    clone(): StageOrderIndexModel {
        const json = this.toJSON();
        let result = new StageOrderIndexModel();
        result.init(json);
        return result;
    }
}

export interface IStageOrderIndexModel {
    stageId: string;
    orderIndex: number;
}

export class StageProduct implements IStageProduct {
    stageId: string;
    productId: number;
    stage: Stage;
    product: Product;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IStageProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stageId = _data["stageId"];
            this.productId = _data["productId"];
            this.stage = _data["stage"] ? Stage.fromJS(_data["stage"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): StageProduct {
        data = typeof data === 'object' ? data : {};
        let result = new StageProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stageId"] = this.stageId;
        data["productId"] = this.productId;
        data["stage"] = this.stage ? this.stage.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): StageProduct {
        const json = this.toJSON();
        let result = new StageProduct();
        result.init(json);
        return result;
    }
}

export interface IStageProduct {
    stageId: string;
    productId: number;
    stage: Stage;
    product: Product;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class StageProductModel implements IStageProductModel {
    id: string;
    stageId: string;
    productId: number;
    stage: StageModel;
    product: ProductListModel;

    constructor(data?: IStageProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stageId = _data["stageId"];
            this.productId = _data["productId"];
            this.stage = _data["stage"] ? StageModel.fromJS(_data["stage"]) : <any>undefined;
            this.product = _data["product"] ? ProductListModel.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StageProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stageId"] = this.stageId;
        data["productId"] = this.productId;
        data["stage"] = this.stage ? this.stage.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): StageProductModel {
        const json = this.toJSON();
        let result = new StageProductModel();
        result.init(json);
        return result;
    }
}

export interface IStageProductModel {
    id: string;
    stageId: string;
    productId: number;
    stage: StageModel;
    product: ProductListModel;
}

export class StageProductsAddModel implements IStageProductsAddModel {
    stageId: string;
    productsIds: number[] | undefined;

    constructor(data?: IStageProductsAddModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stageId = _data["stageId"];
            if (Array.isArray(_data["productsIds"])) {
                this.productsIds = [] as any;
                for (let item of _data["productsIds"])
                    this.productsIds.push(item);
            }
        }
    }

    static fromJS(data: any): StageProductsAddModel {
        data = typeof data === 'object' ? data : {};
        let result = new StageProductsAddModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stageId"] = this.stageId;
        if (Array.isArray(this.productsIds)) {
            data["productsIds"] = [];
            for (let item of this.productsIds)
                data["productsIds"].push(item);
        }
        return data;
    }

    clone(): StageProductsAddModel {
        const json = this.toJSON();
        let result = new StageProductsAddModel();
        result.init(json);
        return result;
    }
}

export interface IStageProductsAddModel {
    stageId: string;
    productsIds: number[] | undefined;
}

export class StandartTierCustomNameModel implements IStandartTierCustomNameModel {
    locationId: string;
    productStandardTierId: number;
    name: string | undefined;

    constructor(data?: IStandartTierCustomNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.productStandardTierId = _data["productStandardTierId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StandartTierCustomNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new StandartTierCustomNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["productStandardTierId"] = this.productStandardTierId;
        data["name"] = this.name;
        return data;
    }

    clone(): StandartTierCustomNameModel {
        const json = this.toJSON();
        let result = new StandartTierCustomNameModel();
        result.init(json);
        return result;
    }
}

export interface IStandartTierCustomNameModel {
    locationId: string;
    productStandardTierId: number;
    name: string | undefined;
}

export class StatementItemModel implements IStatementItemModel {
    statementId: string;
    name: string | undefined;
    date: Date;
    invoiceId: string | undefined;
    dueDate: Date | undefined;
    invoiceAmountDue: number | undefined;
    paymentAmount: number | undefined;

    constructor(data?: IStatementItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementId = _data["statementId"];
            this.name = _data["name"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.invoiceAmountDue = _data["invoiceAmountDue"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): StatementItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatementItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementId"] = this.statementId;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["invoiceAmountDue"] = this.invoiceAmountDue;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }

    clone(): StatementItemModel {
        const json = this.toJSON();
        let result = new StatementItemModel();
        result.init(json);
        return result;
    }
}

export interface IStatementItemModel {
    statementId: string;
    name: string | undefined;
    date: Date;
    invoiceId: string | undefined;
    dueDate: Date | undefined;
    invoiceAmountDue: number | undefined;
    paymentAmount: number | undefined;
}

export class StatementModel implements IStatementModel {
    id: string;
    practice: PracticeModelWithLocationName;
    location: LocationModel;
    locationBillingSettings: LocationBillingSettingsModel;
    dentist: ShortUserModel;
    code: string | undefined;
    paymentTerms: string | undefined;
    amountDue: number;
    totalAmount: number;
    isOpen: boolean;
    status: InvoiceStatus;
    dateStart: Date;
    dateEnd: Date;
    createdAt: Date;
    accountCode: string | undefined;
    statementItems: StatementItemModel[] | undefined;

    constructor(data?: IStatementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.practice = _data["practice"] ? PracticeModelWithLocationName.fromJS(_data["practice"]) : <any>undefined;
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : <any>undefined;
            this.locationBillingSettings = _data["locationBillingSettings"] ? LocationBillingSettingsModel.fromJS(_data["locationBillingSettings"]) : <any>undefined;
            this.dentist = _data["dentist"] ? ShortUserModel.fromJS(_data["dentist"]) : <any>undefined;
            this.code = _data["code"];
            this.paymentTerms = _data["paymentTerms"];
            this.amountDue = _data["amountDue"];
            this.totalAmount = _data["totalAmount"];
            this.isOpen = _data["isOpen"];
            this.status = _data["status"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.accountCode = _data["accountCode"];
            if (Array.isArray(_data["statementItems"])) {
                this.statementItems = [] as any;
                for (let item of _data["statementItems"])
                    this.statementItems.push(StatementItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationBillingSettings"] = this.locationBillingSettings ? this.locationBillingSettings.toJSON() : <any>undefined;
        data["dentist"] = this.dentist ? this.dentist.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["paymentTerms"] = this.paymentTerms;
        data["amountDue"] = this.amountDue;
        data["totalAmount"] = this.totalAmount;
        data["isOpen"] = this.isOpen;
        data["status"] = this.status;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["accountCode"] = this.accountCode;
        if (Array.isArray(this.statementItems)) {
            data["statementItems"] = [];
            for (let item of this.statementItems)
                data["statementItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): StatementModel {
        const json = this.toJSON();
        let result = new StatementModel();
        result.init(json);
        return result;
    }
}

export interface IStatementModel {
    id: string;
    practice: PracticeModelWithLocationName;
    location: LocationModel;
    locationBillingSettings: LocationBillingSettingsModel;
    dentist: ShortUserModel;
    code: string | undefined;
    paymentTerms: string | undefined;
    amountDue: number;
    totalAmount: number;
    isOpen: boolean;
    status: InvoiceStatus;
    dateStart: Date;
    dateEnd: Date;
    createdAt: Date;
    accountCode: string | undefined;
    statementItems: StatementItemModel[] | undefined;
}

export class StatementModelInvoicePagedListDto implements IStatementModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: StatementModel[] | undefined;
    totalCount: number;

    constructor(data?: IStatementModelInvoicePagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StatementModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StatementModelInvoicePagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementModelInvoicePagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StatementModelInvoicePagedListDto {
        const json = this.toJSON();
        let result = new StatementModelInvoicePagedListDto();
        result.init(json);
        return result;
    }
}

export interface IStatementModelInvoicePagedListDto {
    totalAmount: number;
    totalAmountDue: number;
    items: StatementModel[] | undefined;
    totalCount: number;
}

export class StatementPayRequestModel implements IStatementPayRequestModel {
    id: string;
    dentistId: string;
    amount: number;

    constructor(data?: IStatementPayRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dentistId = _data["dentistId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): StatementPayRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatementPayRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dentistId"] = this.dentistId;
        data["amount"] = this.amount;
        return data;
    }

    clone(): StatementPayRequestModel {
        const json = this.toJSON();
        let result = new StatementPayRequestModel();
        result.init(json);
        return result;
    }
}

export interface IStatementPayRequestModel {
    id: string;
    dentistId: string;
    amount: number;
}

export class SubCategoryModel implements ISubCategoryModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;
    logoUrl: string | undefined;
    type: SubCategoryType;

    constructor(data?: ISubCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isHide = _data["isHide"];
            this.logoUrl = _data["logoUrl"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SubCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isHide"] = this.isHide;
        data["logoUrl"] = this.logoUrl;
        data["type"] = this.type;
        return data;
    }

    clone(): SubCategoryModel {
        const json = this.toJSON();
        let result = new SubCategoryModel();
        result.init(json);
        return result;
    }
}

export interface ISubCategoryModel {
    id: number;
    categoryId: number;
    name: string | undefined;
    code: string | undefined;
    isHide: boolean;
    logoUrl: string | undefined;
    type: SubCategoryType;
}

export enum SubCategoryType {
    Default = <any>"Default",
    Aligner = <any>"Aligner",
}

export class SubdomainCreateModel implements ISubdomainCreateModel {
    locationId: string;
    subdomain: string | undefined;
    newSubdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;

    constructor(data?: ISubdomainCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.subdomain = _data["subdomain"];
            this.newSubdomain = _data["newSubdomain"];
            this.logoUrl = _data["logoUrl"];
            this.backgroundUrl = _data["backgroundUrl"];
        }
    }

    static fromJS(data: any): SubdomainCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubdomainCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["subdomain"] = this.subdomain;
        data["newSubdomain"] = this.newSubdomain;
        data["logoUrl"] = this.logoUrl;
        data["backgroundUrl"] = this.backgroundUrl;
        return data;
    }

    clone(): SubdomainCreateModel {
        const json = this.toJSON();
        let result = new SubdomainCreateModel();
        result.init(json);
        return result;
    }
}

export interface ISubdomainCreateModel {
    locationId: string;
    subdomain: string | undefined;
    newSubdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;
}

export class SubdomainDeleteModel implements ISubdomainDeleteModel {
    locationId: string;
    subdomain: string | undefined;

    constructor(data?: ISubdomainDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.subdomain = _data["subdomain"];
        }
    }

    static fromJS(data: any): SubdomainDeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubdomainDeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["subdomain"] = this.subdomain;
        return data;
    }

    clone(): SubdomainDeleteModel {
        const json = this.toJSON();
        let result = new SubdomainDeleteModel();
        result.init(json);
        return result;
    }
}

export interface ISubdomainDeleteModel {
    locationId: string;
    subdomain: string | undefined;
}

export class SubdomainFileDeleteModel implements ISubdomainFileDeleteModel {
    locationId: string;
    url: string | undefined;

    constructor(data?: ISubdomainFileDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SubdomainFileDeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubdomainFileDeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["url"] = this.url;
        return data;
    }

    clone(): SubdomainFileDeleteModel {
        const json = this.toJSON();
        let result = new SubdomainFileDeleteModel();
        result.init(json);
        return result;
    }
}

export interface ISubdomainFileDeleteModel {
    locationId: string;
    url: string | undefined;
}

export class SubdomainFileUploadResponseModel implements ISubdomainFileUploadResponseModel {
    url: string | undefined;

    constructor(data?: ISubdomainFileUploadResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SubdomainFileUploadResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubdomainFileUploadResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): SubdomainFileUploadResponseModel {
        const json = this.toJSON();
        let result = new SubdomainFileUploadResponseModel();
        result.init(json);
        return result;
    }
}

export interface ISubdomainFileUploadResponseModel {
    url: string | undefined;
}

export class SubdomainModel implements ISubdomainModel {
    locationId: string;
    subdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;

    constructor(data?: ISubdomainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.subdomain = _data["subdomain"];
            this.logoUrl = _data["logoUrl"];
            this.backgroundUrl = _data["backgroundUrl"];
        }
    }

    static fromJS(data: any): SubdomainModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubdomainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["subdomain"] = this.subdomain;
        data["logoUrl"] = this.logoUrl;
        data["backgroundUrl"] = this.backgroundUrl;
        return data;
    }

    clone(): SubdomainModel {
        const json = this.toJSON();
        let result = new SubdomainModel();
        result.init(json);
        return result;
    }
}

export interface ISubdomainModel {
    locationId: string;
    subdomain: string | undefined;
    logoUrl: string | undefined;
    backgroundUrl: string | undefined;
}

export class TaskStatisticsModel implements ITaskStatisticsModel {
    taskName: string | undefined;
    completedTasksCount: number;
    totalTime: string;
    averageTime: string;
    commission: number;

    constructor(data?: ITaskStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.completedTasksCount = _data["completedTasksCount"];
            this.totalTime = _data["totalTime"];
            this.averageTime = _data["averageTime"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): TaskStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["completedTasksCount"] = this.completedTasksCount;
        data["totalTime"] = this.totalTime;
        data["averageTime"] = this.averageTime;
        data["commission"] = this.commission;
        return data;
    }

    clone(): TaskStatisticsModel {
        const json = this.toJSON();
        let result = new TaskStatisticsModel();
        result.init(json);
        return result;
    }
}

export interface ITaskStatisticsModel {
    taskName: string | undefined;
    completedTasksCount: number;
    totalTime: string;
    averageTime: string;
    commission: number;
}

export enum TeamFilter {
    All = <any>"All",
    Team = <any>"Team",
    Doctors = <any>"Doctors",
}

export class TrackingEvent implements ITrackingEvent {
    occurredAt: Date | undefined;
    carrierOccurredAt: Date | undefined;
    description: string | undefined;
    cityLocality: string | undefined;
    stateProvince: string | undefined;
    postalCode: string | undefined;
    countryCode: string | undefined;
    companyName: string | undefined;
    signer: string | undefined;
    eventCode: string | undefined;
    carrierDetailCode: string | undefined;
    statusCode: string | undefined;
    statusDescription: string | undefined;
    carrierStatusCode: string | undefined;
    carrierStatusDescription: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;

    constructor(data?: ITrackingEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
            this.carrierOccurredAt = _data["carrierOccurredAt"] ? new Date(_data["carrierOccurredAt"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.cityLocality = _data["cityLocality"];
            this.stateProvince = _data["stateProvince"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.companyName = _data["companyName"];
            this.signer = _data["signer"];
            this.eventCode = _data["eventCode"];
            this.carrierDetailCode = _data["carrierDetailCode"];
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.carrierStatusCode = _data["carrierStatusCode"];
            this.carrierStatusDescription = _data["carrierStatusDescription"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): TrackingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        data["carrierOccurredAt"] = this.carrierOccurredAt ? this.carrierOccurredAt.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["cityLocality"] = this.cityLocality;
        data["stateProvince"] = this.stateProvince;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["companyName"] = this.companyName;
        data["signer"] = this.signer;
        data["eventCode"] = this.eventCode;
        data["carrierDetailCode"] = this.carrierDetailCode;
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["carrierStatusCode"] = this.carrierStatusCode;
        data["carrierStatusDescription"] = this.carrierStatusDescription;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): TrackingEvent {
        const json = this.toJSON();
        let result = new TrackingEvent();
        result.init(json);
        return result;
    }
}

export interface ITrackingEvent {
    occurredAt: Date | undefined;
    carrierOccurredAt: Date | undefined;
    description: string | undefined;
    cityLocality: string | undefined;
    stateProvince: string | undefined;
    postalCode: string | undefined;
    countryCode: string | undefined;
    companyName: string | undefined;
    signer: string | undefined;
    eventCode: string | undefined;
    carrierDetailCode: string | undefined;
    statusCode: string | undefined;
    statusDescription: string | undefined;
    carrierStatusCode: string | undefined;
    carrierStatusDescription: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
}

export class TrackingResponse implements ITrackingResponse {
    trackingNumber: string | undefined;
    trackingUrl: string | undefined;
    statusCode: string | undefined;
    carrierCode: string | undefined;
    carrierId: string | undefined;
    statusDescription: string | undefined;
    carrierStatusCode: string | undefined;
    carrierDetailCode: string | undefined;
    carrierStatusDescription: string | undefined;
    shipDate: Date | undefined;
    estimatedDeliveryDate: Date | undefined;
    actualDeliveryDate: Date | undefined;
    exceptionDescription: string | undefined;
    events: TrackingEvent[] | undefined;

    constructor(data?: ITrackingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingNumber = _data["trackingNumber"];
            this.trackingUrl = _data["trackingUrl"];
            this.statusCode = _data["statusCode"];
            this.carrierCode = _data["carrierCode"];
            this.carrierId = _data["carrierId"];
            this.statusDescription = _data["statusDescription"];
            this.carrierStatusCode = _data["carrierStatusCode"];
            this.carrierDetailCode = _data["carrierDetailCode"];
            this.carrierStatusDescription = _data["carrierStatusDescription"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            this.estimatedDeliveryDate = _data["estimatedDeliveryDate"] ? new Date(_data["estimatedDeliveryDate"].toString()) : <any>undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
            this.exceptionDescription = _data["exceptionDescription"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events.push(TrackingEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingNumber"] = this.trackingNumber;
        data["trackingUrl"] = this.trackingUrl;
        data["statusCode"] = this.statusCode;
        data["carrierCode"] = this.carrierCode;
        data["carrierId"] = this.carrierId;
        data["statusDescription"] = this.statusDescription;
        data["carrierStatusCode"] = this.carrierStatusCode;
        data["carrierDetailCode"] = this.carrierDetailCode;
        data["carrierStatusDescription"] = this.carrierStatusDescription;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["estimatedDeliveryDate"] = this.estimatedDeliveryDate ? this.estimatedDeliveryDate.toISOString() : <any>undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
        data["exceptionDescription"] = this.exceptionDescription;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }

    clone(): TrackingResponse {
        const json = this.toJSON();
        let result = new TrackingResponse();
        result.init(json);
        return result;
    }
}

export interface ITrackingResponse {
    trackingNumber: string | undefined;
    trackingUrl: string | undefined;
    statusCode: string | undefined;
    carrierCode: string | undefined;
    carrierId: string | undefined;
    statusDescription: string | undefined;
    carrierStatusCode: string | undefined;
    carrierDetailCode: string | undefined;
    carrierStatusDescription: string | undefined;
    shipDate: Date | undefined;
    estimatedDeliveryDate: Date | undefined;
    actualDeliveryDate: Date | undefined;
    exceptionDescription: string | undefined;
    events: TrackingEvent[] | undefined;
}

export class TreatmentPlan implements ITreatmentPlan {
    orderId: string;
    treatmentPlanURL: string | undefined;
    comment: string | undefined;
    type: TreatmentPlanType;
    uppers: number | undefined;
    lowers: number | undefined;
    isPublished: boolean;
    publishDate: Date | undefined;
    isConfirmed: boolean;
    confirmedDate: Date | undefined;
    isArchived: boolean;
    order: Order;
    instructions: TreatmentPlanInstruction[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ITreatmentPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.treatmentPlanURL = _data["treatmentPlanURL"];
            this.comment = _data["comment"];
            this.type = _data["type"];
            this.uppers = _data["uppers"];
            this.lowers = _data["lowers"];
            this.isPublished = _data["isPublished"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions.push(TreatmentPlanInstruction.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): TreatmentPlan {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["treatmentPlanURL"] = this.treatmentPlanURL;
        data["comment"] = this.comment;
        data["type"] = this.type;
        data["uppers"] = this.uppers;
        data["lowers"] = this.lowers;
        data["isPublished"] = this.isPublished;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): TreatmentPlan {
        const json = this.toJSON();
        let result = new TreatmentPlan();
        result.init(json);
        return result;
    }
}

export interface ITreatmentPlan {
    orderId: string;
    treatmentPlanURL: string | undefined;
    comment: string | undefined;
    type: TreatmentPlanType;
    uppers: number | undefined;
    lowers: number | undefined;
    isPublished: boolean;
    publishDate: Date | undefined;
    isConfirmed: boolean;
    confirmedDate: Date | undefined;
    isArchived: boolean;
    order: Order;
    instructions: TreatmentPlanInstruction[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class TreatmentPlanInstruction implements ITreatmentPlanInstruction {
    treatmentPlanId: string;
    amount: number | undefined;
    toothNumber: string | undefined;
    beforeStep: number | undefined;
    treatmentInstructionType: TreatmentPlanInstructionType;
    treatmentPlan: TreatmentPlan;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ITreatmentPlanInstruction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treatmentPlanId = _data["treatmentPlanId"];
            this.amount = _data["amount"];
            this.toothNumber = _data["toothNumber"];
            this.beforeStep = _data["beforeStep"];
            this.treatmentInstructionType = _data["treatmentInstructionType"];
            this.treatmentPlan = _data["treatmentPlan"] ? TreatmentPlan.fromJS(_data["treatmentPlan"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): TreatmentPlanInstruction {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentPlanInstruction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treatmentPlanId"] = this.treatmentPlanId;
        data["amount"] = this.amount;
        data["toothNumber"] = this.toothNumber;
        data["beforeStep"] = this.beforeStep;
        data["treatmentInstructionType"] = this.treatmentInstructionType;
        data["treatmentPlan"] = this.treatmentPlan ? this.treatmentPlan.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): TreatmentPlanInstruction {
        const json = this.toJSON();
        let result = new TreatmentPlanInstruction();
        result.init(json);
        return result;
    }
}

export interface ITreatmentPlanInstruction {
    treatmentPlanId: string;
    amount: number | undefined;
    toothNumber: string | undefined;
    beforeStep: number | undefined;
    treatmentInstructionType: TreatmentPlanInstructionType;
    treatmentPlan: TreatmentPlan;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class TreatmentPlanInstructionModel implements ITreatmentPlanInstructionModel {
    id: string;
    treatmentPlanId: string;
    amount: number | undefined;
    toothNumber: string | undefined;
    beforeStep: number | undefined;
    treatmentInstructionType: TreatmentPlanInstructionType;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ITreatmentPlanInstructionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treatmentPlanId = _data["treatmentPlanId"];
            this.amount = _data["amount"];
            this.toothNumber = _data["toothNumber"];
            this.beforeStep = _data["beforeStep"];
            this.treatmentInstructionType = _data["treatmentInstructionType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): TreatmentPlanInstructionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentPlanInstructionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treatmentPlanId"] = this.treatmentPlanId;
        data["amount"] = this.amount;
        data["toothNumber"] = this.toothNumber;
        data["beforeStep"] = this.beforeStep;
        data["treatmentInstructionType"] = this.treatmentInstructionType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): TreatmentPlanInstructionModel {
        const json = this.toJSON();
        let result = new TreatmentPlanInstructionModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentPlanInstructionModel {
    id: string;
    treatmentPlanId: string;
    amount: number | undefined;
    toothNumber: string | undefined;
    beforeStep: number | undefined;
    treatmentInstructionType: TreatmentPlanInstructionType;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export enum TreatmentPlanInstructionType {
    Attachments = <any>"Attachments",
    Extractions = <any>"Extractions",
    IPR = <any>"IPR",
}

export class TreatmentPlanModel implements ITreatmentPlanModel {
    orderId: string;
    comment: string | undefined;
    type: TreatmentPlanType;
    treatmentPlanURL: string | undefined;
    uppers: number | undefined;
    lowers: number | undefined;
    isPublished: boolean;
    publishDate: Date | undefined;
    isConfirmed: boolean;
    confirmedDate: Date | undefined;
    isArchived: boolean;
    instructions: TreatmentPlanInstructionModel[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: ITreatmentPlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.comment = _data["comment"];
            this.type = _data["type"];
            this.treatmentPlanURL = _data["treatmentPlanURL"];
            this.uppers = _data["uppers"];
            this.lowers = _data["lowers"];
            this.isPublished = _data["isPublished"];
            this.publishDate = _data["publishDate"] ? new Date(_data["publishDate"].toString()) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions.push(TreatmentPlanInstructionModel.fromJS(item));
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): TreatmentPlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentPlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["comment"] = this.comment;
        data["type"] = this.type;
        data["treatmentPlanURL"] = this.treatmentPlanURL;
        data["uppers"] = this.uppers;
        data["lowers"] = this.lowers;
        data["isPublished"] = this.isPublished;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): TreatmentPlanModel {
        const json = this.toJSON();
        let result = new TreatmentPlanModel();
        result.init(json);
        return result;
    }
}

export interface ITreatmentPlanModel {
    orderId: string;
    comment: string | undefined;
    type: TreatmentPlanType;
    treatmentPlanURL: string | undefined;
    uppers: number | undefined;
    lowers: number | undefined;
    isPublished: boolean;
    publishDate: Date | undefined;
    isConfirmed: boolean;
    confirmedDate: Date | undefined;
    isArchived: boolean;
    instructions: TreatmentPlanInstructionModel[] | undefined;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export enum TreatmentPlanType {
    Exocad = <any>"Exocad",
    Onyx = <any>"Onyx",
}

export class UpdateOrderStatusModel implements IUpdateOrderStatusModel {
    orderId: string;
    statusId: number;
    note: string | undefined;
    trackingNumber: string | undefined;
    userId: string | undefined;

    constructor(data?: IUpdateOrderStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.statusId = _data["statusId"];
            this.note = _data["note"];
            this.trackingNumber = _data["trackingNumber"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateOrderStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["statusId"] = this.statusId;
        data["note"] = this.note;
        data["trackingNumber"] = this.trackingNumber;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UpdateOrderStatusModel {
        const json = this.toJSON();
        let result = new UpdateOrderStatusModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrderStatusModel {
    orderId: string;
    statusId: number;
    note: string | undefined;
    trackingNumber: string | undefined;
    userId: string | undefined;
}

export class UpdatePanNumberModel implements IUpdatePanNumberModel {
    orderId: string;
    panNumber: string | undefined;

    constructor(data?: IUpdatePanNumberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.panNumber = _data["panNumber"];
        }
    }

    static fromJS(data: any): UpdatePanNumberModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePanNumberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["panNumber"] = this.panNumber;
        return data;
    }

    clone(): UpdatePanNumberModel {
        const json = this.toJSON();
        let result = new UpdatePanNumberModel();
        result.init(json);
        return result;
    }
}

export interface IUpdatePanNumberModel {
    orderId: string;
    panNumber: string | undefined;
}

export class UpdateStagesOrderIndexModel implements IUpdateStagesOrderIndexModel {
    stages: StageOrderIndexModel[] | undefined;

    constructor(data?: IUpdateStagesOrderIndexModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages.push(StageOrderIndexModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStagesOrderIndexModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStagesOrderIndexModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateStagesOrderIndexModel {
        const json = this.toJSON();
        let result = new UpdateStagesOrderIndexModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateStagesOrderIndexModel {
    stages: StageOrderIndexModel[] | undefined;
}

export class UpdateTeammateModel implements IUpdateTeammateModel {
    teammateId: string;
    roomIds: string[] | undefined;

    constructor(data?: IUpdateTeammateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teammateId = _data["teammateId"];
            if (Array.isArray(_data["roomIds"])) {
                this.roomIds = [] as any;
                for (let item of _data["roomIds"])
                    this.roomIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTeammateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeammateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teammateId"] = this.teammateId;
        if (Array.isArray(this.roomIds)) {
            data["roomIds"] = [];
            for (let item of this.roomIds)
                data["roomIds"].push(item);
        }
        return data;
    }

    clone(): UpdateTeammateModel {
        const json = this.toJSON();
        let result = new UpdateTeammateModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateTeammateModel {
    teammateId: string;
    roomIds: string[] | undefined;
}

export class UpdateUserModel implements IUpdateUserModel {
    userId: string;
    fullName: string | undefined;
    email: string | undefined;
    isDashboardOn: boolean;
    isOrdersOn: boolean;
    isDoctorsOn: boolean;
    isBillingOn: boolean;
    isWorkbenchOn: boolean;
    isCoShareOn: boolean;
    isInboxOn: boolean;
    isSettingsOn: boolean;

    constructor(data?: IUpdateUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.isDashboardOn = _data["isDashboardOn"];
            this.isOrdersOn = _data["isOrdersOn"];
            this.isDoctorsOn = _data["isDoctorsOn"];
            this.isBillingOn = _data["isBillingOn"];
            this.isWorkbenchOn = _data["isWorkbenchOn"];
            this.isCoShareOn = _data["isCoShareOn"];
            this.isInboxOn = _data["isInboxOn"];
            this.isSettingsOn = _data["isSettingsOn"];
        }
    }

    static fromJS(data: any): UpdateUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["isDashboardOn"] = this.isDashboardOn;
        data["isOrdersOn"] = this.isOrdersOn;
        data["isDoctorsOn"] = this.isDoctorsOn;
        data["isBillingOn"] = this.isBillingOn;
        data["isWorkbenchOn"] = this.isWorkbenchOn;
        data["isCoShareOn"] = this.isCoShareOn;
        data["isInboxOn"] = this.isInboxOn;
        data["isSettingsOn"] = this.isSettingsOn;
        return data;
    }

    clone(): UpdateUserModel {
        const json = this.toJSON();
        let result = new UpdateUserModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserModel {
    userId: string;
    fullName: string | undefined;
    email: string | undefined;
    isDashboardOn: boolean;
    isOrdersOn: boolean;
    isDoctorsOn: boolean;
    isBillingOn: boolean;
    isWorkbenchOn: boolean;
    isCoShareOn: boolean;
    isInboxOn: boolean;
    isSettingsOn: boolean;
}

export class UpdateWorkbenchRoomModel implements IUpdateWorkbenchRoomModel {
    workbenchRoomId: string;
    name: string | undefined;
    locationId: string;

    constructor(data?: IUpdateWorkbenchRoomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbenchRoomId = _data["workbenchRoomId"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): UpdateWorkbenchRoomModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkbenchRoomModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbenchRoomId"] = this.workbenchRoomId;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): UpdateWorkbenchRoomModel {
        const json = this.toJSON();
        let result = new UpdateWorkbenchRoomModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkbenchRoomModel {
    workbenchRoomId: string;
    name: string | undefined;
    locationId: string;
}

export class UpdateWorkbenchRoomTaskModel implements IUpdateWorkbenchRoomTaskModel {
    workbenchRoomTaskId: string;
    name: string | undefined;
    locationId: string;
    workbenchRoomId: string;
    defaultUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;

    constructor(data?: IUpdateWorkbenchRoomTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.workbenchRoomId = _data["workbenchRoomId"];
            this.defaultUserId = _data["defaultUserId"];
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): UpdateWorkbenchRoomTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkbenchRoomTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["workbenchRoomId"] = this.workbenchRoomId;
        data["defaultUserId"] = this.defaultUserId;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        return data;
    }

    clone(): UpdateWorkbenchRoomTaskModel {
        const json = this.toJSON();
        let result = new UpdateWorkbenchRoomTaskModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkbenchRoomTaskModel {
    workbenchRoomTaskId: string;
    name: string | undefined;
    locationId: string;
    workbenchRoomId: string;
    defaultUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;
}

export class UpdateWorkbenchTaskModel implements IUpdateWorkbenchTaskModel {
    locationId: string;
    orderId: string;
    workbenchRoomTaskId: string;
    assignedUserId: string | undefined;
    commission: number | undefined;
    workbenchTaskId: string;

    constructor(data?: IUpdateWorkbenchTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            this.orderId = _data["orderId"];
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.assignedUserId = _data["assignedUserId"];
            this.commission = _data["commission"];
            this.workbenchTaskId = _data["workbenchTaskId"];
        }
    }

    static fromJS(data: any): UpdateWorkbenchTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkbenchTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["orderId"] = this.orderId;
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["assignedUserId"] = this.assignedUserId;
        data["commission"] = this.commission;
        data["workbenchTaskId"] = this.workbenchTaskId;
        return data;
    }

    clone(): UpdateWorkbenchTaskModel {
        const json = this.toJSON();
        let result = new UpdateWorkbenchTaskModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkbenchTaskModel {
    locationId: string;
    orderId: string;
    workbenchRoomTaskId: string;
    assignedUserId: string | undefined;
    commission: number | undefined;
    workbenchTaskId: string;
}

export class UpdateWorkbenchTaskPrototypeModel implements IUpdateWorkbenchTaskPrototypeModel {
    id: string;
    assignedUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;

    constructor(data?: IUpdateWorkbenchTaskPrototypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assignedUserId = _data["assignedUserId"];
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): UpdateWorkbenchTaskPrototypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkbenchTaskPrototypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assignedUserId"] = this.assignedUserId;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): UpdateWorkbenchTaskPrototypeModel {
        const json = this.toJSON();
        let result = new UpdateWorkbenchTaskPrototypeModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkbenchTaskPrototypeModel {
    id: string;
    assignedUserId: string | undefined;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;
}

export class UpdateWorkbenchWorkflowModel implements IUpdateWorkbenchWorkflowModel {
    id: string;
    isDisabled: boolean;

    constructor(data?: IUpdateWorkbenchWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): UpdateWorkbenchWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkbenchWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): UpdateWorkbenchWorkflowModel {
        const json = this.toJSON();
        let result = new UpdateWorkbenchWorkflowModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkbenchWorkflowModel {
    id: string;
    isDisabled: boolean;
}

export class UpdateWorkflowModel implements IUpdateWorkflowModel {
    id: string;
    cloneTasksFromWorkflowId: string | undefined;
    assignTo: string | undefined;
    runImmediately: boolean | undefined;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;

    constructor(data?: IUpdateWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cloneTasksFromWorkflowId = _data["cloneTasksFromWorkflowId"];
            this.assignTo = _data["assignTo"];
            this.runImmediately = _data["runImmediately"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.rules = _data["rules"] ? PredicateGroup.fromJS(_data["rules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cloneTasksFromWorkflowId"] = this.cloneTasksFromWorkflowId;
        data["assignTo"] = this.assignTo;
        data["runImmediately"] = this.runImmediately;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["rules"] = this.rules ? this.rules.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateWorkflowModel {
        const json = this.toJSON();
        let result = new UpdateWorkflowModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkflowModel {
    id: string;
    cloneTasksFromWorkflowId: string | undefined;
    assignTo: string | undefined;
    runImmediately: boolean | undefined;
    locationId: string;
    name: string | undefined;
    productCategoryId: number | undefined;
    rules: PredicateGroup;
}

export class UploadOrderFileResponseModel implements IUploadOrderFileResponseModel {
    url: string | undefined;

    constructor(data?: IUploadOrderFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadOrderFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadOrderFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): UploadOrderFileResponseModel {
        const json = this.toJSON();
        let result = new UploadOrderFileResponseModel();
        result.init(json);
        return result;
    }
}

export interface IUploadOrderFileResponseModel {
    url: string | undefined;
}

export class User implements IUser {
    fullName: string | undefined;
    registeredDate: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceId: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    nominalCode: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    phoneNumberCountryCode: string | undefined;
    financialNote: string | undefined;
    company: Company;
    location: Location;
    practice: Practice;
    ownedPractices: Practice[] | undefined;
    billingPractices: Practice[] | undefined;
    usersAssignedPractice: UsersAssignedPractice[] | undefined;
    usersAssignedLocation: UsersAssignedLocation[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    userRole: GuidIdentityUserRole[] | undefined;
    workbenchRooms: WorkbenchRoom[] | undefined;
    workbenchRoomsTasks: WorkbenchRoomTask[] | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchTaskFragments: WorkbenchTaskFragment[] | undefined;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;
    onboardingFinishedSteps: OnboardingFinishedStep[] | undefined;
    automations: AutomationsUser[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    activityStatements: ActivityStatement[] | undefined;
    invoices: Invoice[] | undefined;
    notes: UserNote[] | undefined;
    id: string;
    userName: string | undefined;
    normalizedUserName: string | undefined;
    email: string | undefined;
    normalizedEmail: string | undefined;
    emailConfirmed: boolean;
    passwordHash: string | undefined;
    securityStamp: string | undefined;
    concurrencyStamp: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd: Date | undefined;
    lockoutEnabled: boolean;
    accessFailedCount: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.locationId = _data["locationId"];
            this.practiceId = _data["practiceId"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.accountCode = _data["accountCode"];
            this.nominalCode = _data["nominalCode"];
            this.isArchived = _data["isArchived"];
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : <any>undefined;
            this.phoneNumberCountryCode = _data["phoneNumberCountryCode"];
            this.financialNote = _data["financialNote"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            if (Array.isArray(_data["ownedPractices"])) {
                this.ownedPractices = [] as any;
                for (let item of _data["ownedPractices"])
                    this.ownedPractices.push(Practice.fromJS(item));
            }
            if (Array.isArray(_data["billingPractices"])) {
                this.billingPractices = [] as any;
                for (let item of _data["billingPractices"])
                    this.billingPractices.push(Practice.fromJS(item));
            }
            if (Array.isArray(_data["usersAssignedPractice"])) {
                this.usersAssignedPractice = [] as any;
                for (let item of _data["usersAssignedPractice"])
                    this.usersAssignedPractice.push(UsersAssignedPractice.fromJS(item));
            }
            if (Array.isArray(_data["usersAssignedLocation"])) {
                this.usersAssignedLocation = [] as any;
                for (let item of _data["usersAssignedLocation"])
                    this.usersAssignedLocation.push(UsersAssignedLocation.fromJS(item));
            }
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients.push(Patient.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["userRole"])) {
                this.userRole = [] as any;
                for (let item of _data["userRole"])
                    this.userRole.push(GuidIdentityUserRole.fromJS(item));
            }
            if (Array.isArray(_data["workbenchRooms"])) {
                this.workbenchRooms = [] as any;
                for (let item of _data["workbenchRooms"])
                    this.workbenchRooms.push(WorkbenchRoom.fromJS(item));
            }
            if (Array.isArray(_data["workbenchRoomsTasks"])) {
                this.workbenchRoomsTasks = [] as any;
                for (let item of _data["workbenchRoomsTasks"])
                    this.workbenchRoomsTasks.push(WorkbenchRoomTask.fromJS(item));
            }
            if (Array.isArray(_data["workbenchTasks"])) {
                this.workbenchTasks = [] as any;
                for (let item of _data["workbenchTasks"])
                    this.workbenchTasks.push(WorkbenchTask.fromJS(item));
            }
            if (Array.isArray(_data["workbenchTaskFragments"])) {
                this.workbenchTaskFragments = [] as any;
                for (let item of _data["workbenchTaskFragments"])
                    this.workbenchTaskFragments.push(WorkbenchTaskFragment.fromJS(item));
            }
            if (Array.isArray(_data["workbenchTaskPrototypes"])) {
                this.workbenchTaskPrototypes = [] as any;
                for (let item of _data["workbenchTaskPrototypes"])
                    this.workbenchTaskPrototypes.push(WorkbenchTaskPrototype.fromJS(item));
            }
            if (Array.isArray(_data["onboardingFinishedSteps"])) {
                this.onboardingFinishedSteps = [] as any;
                for (let item of _data["onboardingFinishedSteps"])
                    this.onboardingFinishedSteps.push(OnboardingFinishedStep.fromJS(item));
            }
            if (Array.isArray(_data["automations"])) {
                this.automations = [] as any;
                for (let item of _data["automations"])
                    this.automations.push(AutomationsUser.fromJS(item));
            }
            if (Array.isArray(_data["billingStatements"])) {
                this.billingStatements = [] as any;
                for (let item of _data["billingStatements"])
                    this.billingStatements.push(BillingStatement.fromJS(item));
            }
            if (Array.isArray(_data["activityStatements"])) {
                this.activityStatements = [] as any;
                for (let item of _data["activityStatements"])
                    this.activityStatements.push(ActivityStatement.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes.push(UserNote.fromJS(item));
            }
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["locationId"] = this.locationId;
        data["practiceId"] = this.practiceId;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["accountCode"] = this.accountCode;
        data["nominalCode"] = this.nominalCode;
        data["isArchived"] = this.isArchived;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : <any>undefined;
        data["phoneNumberCountryCode"] = this.phoneNumberCountryCode;
        data["financialNote"] = this.financialNote;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        if (Array.isArray(this.ownedPractices)) {
            data["ownedPractices"] = [];
            for (let item of this.ownedPractices)
                data["ownedPractices"].push(item.toJSON());
        }
        if (Array.isArray(this.billingPractices)) {
            data["billingPractices"] = [];
            for (let item of this.billingPractices)
                data["billingPractices"].push(item.toJSON());
        }
        if (Array.isArray(this.usersAssignedPractice)) {
            data["usersAssignedPractice"] = [];
            for (let item of this.usersAssignedPractice)
                data["usersAssignedPractice"].push(item.toJSON());
        }
        if (Array.isArray(this.usersAssignedLocation)) {
            data["usersAssignedLocation"] = [];
            for (let item of this.usersAssignedLocation)
                data["usersAssignedLocation"].push(item.toJSON());
        }
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.userRole)) {
            data["userRole"] = [];
            for (let item of this.userRole)
                data["userRole"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchRooms)) {
            data["workbenchRooms"] = [];
            for (let item of this.workbenchRooms)
                data["workbenchRooms"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchRoomsTasks)) {
            data["workbenchRoomsTasks"] = [];
            for (let item of this.workbenchRoomsTasks)
                data["workbenchRoomsTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchTasks)) {
            data["workbenchTasks"] = [];
            for (let item of this.workbenchTasks)
                data["workbenchTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchTaskFragments)) {
            data["workbenchTaskFragments"] = [];
            for (let item of this.workbenchTaskFragments)
                data["workbenchTaskFragments"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchTaskPrototypes)) {
            data["workbenchTaskPrototypes"] = [];
            for (let item of this.workbenchTaskPrototypes)
                data["workbenchTaskPrototypes"].push(item.toJSON());
        }
        if (Array.isArray(this.onboardingFinishedSteps)) {
            data["onboardingFinishedSteps"] = [];
            for (let item of this.onboardingFinishedSteps)
                data["onboardingFinishedSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.automations)) {
            data["automations"] = [];
            for (let item of this.automations)
                data["automations"].push(item.toJSON());
        }
        if (Array.isArray(this.billingStatements)) {
            data["billingStatements"] = [];
            for (let item of this.billingStatements)
                data["billingStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.activityStatements)) {
            data["activityStatements"] = [];
            for (let item of this.activityStatements)
                data["activityStatements"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    fullName: string | undefined;
    registeredDate: Date;
    companyId: string | undefined;
    locationId: string | undefined;
    practiceId: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    nominalCode: string | undefined;
    isArchived: boolean;
    archivedDate: Date;
    phoneNumberCountryCode: string | undefined;
    financialNote: string | undefined;
    company: Company;
    location: Location;
    practice: Practice;
    ownedPractices: Practice[] | undefined;
    billingPractices: Practice[] | undefined;
    usersAssignedPractice: UsersAssignedPractice[] | undefined;
    usersAssignedLocation: UsersAssignedLocation[] | undefined;
    patients: Patient[] | undefined;
    orders: Order[] | undefined;
    userRole: GuidIdentityUserRole[] | undefined;
    workbenchRooms: WorkbenchRoom[] | undefined;
    workbenchRoomsTasks: WorkbenchRoomTask[] | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchTaskFragments: WorkbenchTaskFragment[] | undefined;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;
    onboardingFinishedSteps: OnboardingFinishedStep[] | undefined;
    automations: AutomationsUser[] | undefined;
    billingStatements: BillingStatement[] | undefined;
    activityStatements: ActivityStatement[] | undefined;
    invoices: Invoice[] | undefined;
    notes: UserNote[] | undefined;
    id: string;
    userName: string | undefined;
    normalizedUserName: string | undefined;
    email: string | undefined;
    normalizedEmail: string | undefined;
    emailConfirmed: boolean;
    passwordHash: string | undefined;
    securityStamp: string | undefined;
    concurrencyStamp: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd: Date | undefined;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export class UserActivationDTO implements IUserActivationDTO {
    username: string | undefined;
    token: string | undefined;
    password: string | undefined;

    constructor(data?: IUserActivationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserActivationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }

    clone(): UserActivationDTO {
        const json = this.toJSON();
        let result = new UserActivationDTO();
        result.init(json);
        return result;
    }
}

export interface IUserActivationDTO {
    username: string | undefined;
    token: string | undefined;
    password: string | undefined;
}

export class UserConfirmationLinkResult implements IUserConfirmationLinkResult {
    link: string | undefined;
    userId: string;

    constructor(data?: IUserConfirmationLinkResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserConfirmationLinkResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserConfirmationLinkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserConfirmationLinkResult {
        const json = this.toJSON();
        let result = new UserConfirmationLinkResult();
        result.init(json);
        return result;
    }
}

export interface IUserConfirmationLinkResult {
    link: string | undefined;
    userId: string;
}

export class UserDTO implements IUserDTO {
    username: string | undefined;
    password: string | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }

    clone(): UserDTO {
        const json = this.toJSON();
        let result = new UserDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDTO {
    username: string | undefined;
    password: string | undefined;
}

export class UserDetailsIntecom implements IUserDetailsIntecom {
    company: string | undefined;
    locations: string | undefined;
    role: string | undefined;
    id: string;
    email: string | undefined;
    username: string | undefined;
    fullName: string | undefined;

    constructor(data?: IUserDetailsIntecom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.locations = _data["locations"];
            this.role = _data["role"];
            this.id = _data["id"];
            this.email = _data["email"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserDetailsIntecom {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsIntecom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["locations"] = this.locations;
        data["role"] = this.role;
        data["id"] = this.id;
        data["email"] = this.email;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): UserDetailsIntecom {
        const json = this.toJSON();
        let result = new UserDetailsIntecom();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsIntecom {
    company: string | undefined;
    locations: string | undefined;
    role: string | undefined;
    id: string;
    email: string | undefined;
    username: string | undefined;
    fullName: string | undefined;
}

export class UserInviteDTO implements IUserInviteDTO {
    companyId: string;
    locationIds: string[] | undefined;
    practiceIds: string[] | undefined;
    email: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    userRole: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    phone: string | undefined;

    constructor(data?: IUserInviteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds.push(item);
            }
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.accountCode = _data["accountCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UserInviteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInviteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["accountCode"] = this.accountCode;
        data["phone"] = this.phone;
        return data;
    }

    clone(): UserInviteDTO {
        const json = this.toJSON();
        let result = new UserInviteDTO();
        result.init(json);
        return result;
    }
}

export interface IUserInviteDTO {
    companyId: string;
    locationIds: string[] | undefined;
    practiceIds: string[] | undefined;
    email: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    userRole: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    phone: string | undefined;
}

export class UserInviteNewDTO implements IUserInviteNewDTO {
    companyId: string;
    locationIds: string[] | undefined;
    practiceIds: UserInvitePractices[] | undefined;
    email: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    userRole: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IUserInviteNewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds.push(item);
            }
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(UserInvitePractices.fromJS(item));
            }
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.userRole = _data["userRole"];
            this.dentalRegistrationNumber = _data["dentalRegistrationNumber"];
            this.accountCode = _data["accountCode"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserInviteNewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserInviteNewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item.toJSON());
        }
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["userRole"] = this.userRole;
        data["dentalRegistrationNumber"] = this.dentalRegistrationNumber;
        data["accountCode"] = this.accountCode;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UserInviteNewDTO {
        const json = this.toJSON();
        let result = new UserInviteNewDTO();
        result.init(json);
        return result;
    }
}

export interface IUserInviteNewDTO {
    companyId: string;
    locationIds: string[] | undefined;
    practiceIds: UserInvitePractices[] | undefined;
    email: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    userRole: string | undefined;
    dentalRegistrationNumber: string | undefined;
    accountCode: string | undefined;
    phoneNumber: string | undefined;
}

export class UserInvitePractices implements IUserInvitePractices {
    practiceId: string;
    isOwnOrders: boolean;
    isOwnPatients: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;

    constructor(data?: IUserInvitePractices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.practiceId = _data["practiceId"];
            this.isOwnOrders = _data["isOwnOrders"];
            this.isOwnPatients = _data["isOwnPatients"];
            this.idhPerformerNumber = _data["idhPerformerNumber"];
            this.accountCode = _data["accountCode"];
            this.creditLimit = _data["creditLimit"];
        }
    }

    static fromJS(data: any): UserInvitePractices {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvitePractices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceId"] = this.practiceId;
        data["isOwnOrders"] = this.isOwnOrders;
        data["isOwnPatients"] = this.isOwnPatients;
        data["idhPerformerNumber"] = this.idhPerformerNumber;
        data["accountCode"] = this.accountCode;
        data["creditLimit"] = this.creditLimit;
        return data;
    }

    clone(): UserInvitePractices {
        const json = this.toJSON();
        let result = new UserInvitePractices();
        result.init(json);
        return result;
    }
}

export interface IUserInvitePractices {
    practiceId: string;
    isOwnOrders: boolean;
    isOwnPatients: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
}

export class UserModel implements IUserModel {
    id: string;
    email: string | undefined;
    fullName: string | undefined;
    companyId: string;
    companyName: string | undefined;
    roleId: string;
    roleName: string | undefined;
    emailConfirmed: boolean;
    registeredDate: Date;
    username: string | undefined;
    accountCode: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.registeredDate = _data["registeredDate"] ? new Date(_data["registeredDate"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.accountCode = _data["accountCode"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["emailConfirmed"] = this.emailConfirmed;
        data["registeredDate"] = this.registeredDate ? this.registeredDate.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["accountCode"] = this.accountCode;
        return data;
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

export interface IUserModel {
    id: string;
    email: string | undefined;
    fullName: string | undefined;
    companyId: string;
    companyName: string | undefined;
    roleId: string;
    roleName: string | undefined;
    emailConfirmed: boolean;
    registeredDate: Date;
    username: string | undefined;
    accountCode: string | undefined;
}

export class UserModelPagedListDto implements IUserModelPagedListDto {
    items: UserModel[] | undefined;
    totalCount: number;

    constructor(data?: IUserModelPagedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserModelPagedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelPagedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserModelPagedListDto {
        const json = this.toJSON();
        let result = new UserModelPagedListDto();
        result.init(json);
        return result;
    }
}

export interface IUserModelPagedListDto {
    items: UserModel[] | undefined;
    totalCount: number;
}

export class UserNamePhoneModel implements IUserNamePhoneModel {
    id: string;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberCountryCode: string | undefined;
    email: string | undefined;
    accountCode: string | undefined;

    constructor(data?: IUserNamePhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberCountryCode = _data["phoneNumberCountryCode"];
            this.email = _data["email"];
            this.accountCode = _data["accountCode"];
        }
    }

    static fromJS(data: any): UserNamePhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserNamePhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberCountryCode"] = this.phoneNumberCountryCode;
        data["email"] = this.email;
        data["accountCode"] = this.accountCode;
        return data;
    }

    clone(): UserNamePhoneModel {
        const json = this.toJSON();
        let result = new UserNamePhoneModel();
        result.init(json);
        return result;
    }
}

export interface IUserNamePhoneModel {
    id: string;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberCountryCode: string | undefined;
    email: string | undefined;
    accountCode: string | undefined;
}

export class UserNote implements IUserNote {
    contents: string | undefined;
    userId: string;
    locationId: string;
    creatorId: string;
    user: User;
    location: Location;
    creator: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IUserNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contents = _data["contents"];
            this.userId = _data["userId"];
            this.locationId = _data["locationId"];
            this.creatorId = _data["creatorId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.creator = _data["creator"] ? User.fromJS(_data["creator"]) : <any>undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): UserNote {
        data = typeof data === 'object' ? data : {};
        let result = new UserNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contents"] = this.contents;
        data["userId"] = this.userId;
        data["locationId"] = this.locationId;
        data["creatorId"] = this.creatorId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): UserNote {
        const json = this.toJSON();
        let result = new UserNote();
        result.init(json);
        return result;
    }
}

export interface IUserNote {
    contents: string | undefined;
    userId: string;
    locationId: string;
    creatorId: string;
    user: User;
    location: Location;
    creator: User;
    id: string;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class UserPracticeDoctorModel implements IUserPracticeDoctorModel {
    user: UserModel;
    practice: PracticeModel;
    doctor: PracticeDentistListModel;

    constructor(data?: IUserPracticeDoctorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : <any>undefined;
            this.practice = _data["practice"] ? PracticeModel.fromJS(_data["practice"]) : <any>undefined;
            this.doctor = _data["doctor"] ? PracticeDentistListModel.fromJS(_data["doctor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPracticeDoctorModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPracticeDoctorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserPracticeDoctorModel {
        const json = this.toJSON();
        let result = new UserPracticeDoctorModel();
        result.init(json);
        return result;
    }
}

export interface IUserPracticeDoctorModel {
    user: UserModel;
    practice: PracticeModel;
    doctor: PracticeDentistListModel;
}

export class UsersAssignedLocation implements IUsersAssignedLocation {
    id: string;
    userId: string;
    locationId: string;
    user: User;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IUsersAssignedLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.locationId = _data["locationId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): UsersAssignedLocation {
        data = typeof data === 'object' ? data : {};
        let result = new UsersAssignedLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["locationId"] = this.locationId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): UsersAssignedLocation {
        const json = this.toJSON();
        let result = new UsersAssignedLocation();
        result.init(json);
        return result;
    }
}

export interface IUsersAssignedLocation {
    id: string;
    userId: string;
    locationId: string;
    user: User;
    location: Location;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class UsersAssignedPractice implements IUsersAssignedPractice {
    id: string;
    userId: string;
    practiceId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
    user: User;
    practice: Practice;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IUsersAssignedPractice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.practiceId = _data["practiceId"];
            this.isOnlyOwnOrdersAcess = _data["isOnlyOwnOrdersAcess"];
            this.isOnlyOwnPatientsAcess = _data["isOnlyOwnPatientsAcess"];
            this.idhPerformerNumber = _data["idhPerformerNumber"];
            this.accountCode = _data["accountCode"];
            this.creditLimit = _data["creditLimit"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.practice = _data["practice"] ? Practice.fromJS(_data["practice"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): UsersAssignedPractice {
        data = typeof data === 'object' ? data : {};
        let result = new UsersAssignedPractice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["practiceId"] = this.practiceId;
        data["isOnlyOwnOrdersAcess"] = this.isOnlyOwnOrdersAcess;
        data["isOnlyOwnPatientsAcess"] = this.isOnlyOwnPatientsAcess;
        data["idhPerformerNumber"] = this.idhPerformerNumber;
        data["accountCode"] = this.accountCode;
        data["creditLimit"] = this.creditLimit;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): UsersAssignedPractice {
        const json = this.toJSON();
        let result = new UsersAssignedPractice();
        result.init(json);
        return result;
    }
}

export interface IUsersAssignedPractice {
    id: string;
    userId: string;
    practiceId: string;
    isOnlyOwnOrdersAcess: boolean;
    isOnlyOwnPatientsAcess: boolean;
    idhPerformerNumber: string | undefined;
    accountCode: string | undefined;
    creditLimit: string | undefined;
    user: User;
    practice: Practice;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class ValidateAddressResponse implements IValidateAddressResponse {
    status: string | undefined;
    isLocation: boolean;
    id: string;
    name: string | undefined;
    messages: ValidationMessage[] | undefined;

    constructor(data?: IValidateAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.isLocation = _data["isLocation"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages.push(ValidationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["isLocation"] = this.isLocation;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }

    clone(): ValidateAddressResponse {
        const json = this.toJSON();
        let result = new ValidateAddressResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateAddressResponse {
    status: string | undefined;
    isLocation: boolean;
    id: string;
    name: string | undefined;
    messages: ValidationMessage[] | undefined;
}

export class ValidateAddressesRequest implements IValidateAddressesRequest {
    locationId: string;
    practiceIds: string[] | undefined;

    constructor(data?: IValidateAddressesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateAddressesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAddressesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        return data;
    }

    clone(): ValidateAddressesRequest {
        const json = this.toJSON();
        let result = new ValidateAddressesRequest();
        result.init(json);
        return result;
    }
}

export interface IValidateAddressesRequest {
    locationId: string;
    practiceIds: string[] | undefined;
}

export class ValidationMessage implements IValidationMessage {
    code: string | undefined;
    message: string | undefined;
    type: string | undefined;
    detailCode: string | undefined;

    constructor(data?: IValidationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.detailCode = _data["detailCode"];
        }
    }

    static fromJS(data: any): ValidationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["type"] = this.type;
        data["detailCode"] = this.detailCode;
        return data;
    }

    clone(): ValidationMessage {
        const json = this.toJSON();
        let result = new ValidationMessage();
        result.init(json);
        return result;
    }
}

export interface IValidationMessage {
    code: string | undefined;
    message: string | undefined;
    type: string | undefined;
    detailCode: string | undefined;
}

export class Weight implements IWeight {
    value: number | undefined;
    unit: string | undefined;

    constructor(data?: IWeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Weight {
        data = typeof data === 'object' ? data : {};
        let result = new Weight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }

    clone(): Weight {
        const json = this.toJSON();
        let result = new Weight();
        result.init(json);
        return result;
    }
}

export interface IWeight {
    value: number | undefined;
    unit: string | undefined;
}

export class WokbenchTasksGroupedByRoom implements IWokbenchTasksGroupedByRoom {
    workbenchRoom: WorkbenchRoomModel;
    tasks: WorkbenchTaskModel[] | undefined;

    constructor(data?: IWokbenchTasksGroupedByRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbenchRoom = _data["workbenchRoom"] ? WorkbenchRoomModel.fromJS(_data["workbenchRoom"]) : <any>undefined;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks.push(WorkbenchTaskModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WokbenchTasksGroupedByRoom {
        data = typeof data === 'object' ? data : {};
        let result = new WokbenchTasksGroupedByRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbenchRoom"] = this.workbenchRoom ? this.workbenchRoom.toJSON() : <any>undefined;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): WokbenchTasksGroupedByRoom {
        const json = this.toJSON();
        let result = new WokbenchTasksGroupedByRoom();
        result.init(json);
        return result;
    }
}

export interface IWokbenchTasksGroupedByRoom {
    workbenchRoom: WorkbenchRoomModel;
    tasks: WorkbenchTaskModel[] | undefined;
}

export class WorkbenchOrderModel implements IWorkbenchOrderModel {
    id: string;
    deadlineDate: Date;
    orderStatusId: number | undefined;
    code: string | undefined;
    patient: WorkbenchPatientModel;
    panNumber: string | undefined;
    tagList: string | undefined;

    constructor(data?: IWorkbenchOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.code = _data["code"];
            this.patient = _data["patient"] ? WorkbenchPatientModel.fromJS(_data["patient"]) : <any>undefined;
            this.panNumber = _data["panNumber"];
            this.tagList = _data["tagList"];
        }
    }

    static fromJS(data: any): WorkbenchOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deadlineDate"] = this.deadlineDate ? this.deadlineDate.toISOString() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["code"] = this.code;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["panNumber"] = this.panNumber;
        data["tagList"] = this.tagList;
        return data;
    }

    clone(): WorkbenchOrderModel {
        const json = this.toJSON();
        let result = new WorkbenchOrderModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchOrderModel {
    id: string;
    deadlineDate: Date;
    orderStatusId: number | undefined;
    code: string | undefined;
    patient: WorkbenchPatientModel;
    panNumber: string | undefined;
    tagList: string | undefined;
}

export class WorkbenchPatientModel implements IWorkbenchPatientModel {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;

    constructor(data?: IWorkbenchPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): WorkbenchPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): WorkbenchPatientModel {
        const json = this.toJSON();
        let result = new WorkbenchPatientModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchPatientModel {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
}

export class WorkbenchRoom implements IWorkbenchRoom {
    id: string;
    locationId: string;
    location: Location;
    name: string | undefined;
    positionIndex: number;
    users: User[] | undefined;
    workbenchRoomTasks: WorkbenchRoomTask[] | undefined;

    constructor(data?: IWorkbenchRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.name = _data["name"];
            this.positionIndex = _data["positionIndex"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(User.fromJS(item));
            }
            if (Array.isArray(_data["workbenchRoomTasks"])) {
                this.workbenchRoomTasks = [] as any;
                for (let item of _data["workbenchRoomTasks"])
                    this.workbenchRoomTasks.push(WorkbenchRoomTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbenchRoom {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["positionIndex"] = this.positionIndex;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchRoomTasks)) {
            data["workbenchRoomTasks"] = [];
            for (let item of this.workbenchRoomTasks)
                data["workbenchRoomTasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkbenchRoom {
        const json = this.toJSON();
        let result = new WorkbenchRoom();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchRoom {
    id: string;
    locationId: string;
    location: Location;
    name: string | undefined;
    positionIndex: number;
    users: User[] | undefined;
    workbenchRoomTasks: WorkbenchRoomTask[] | undefined;
}

export class WorkbenchRoomModel implements IWorkbenchRoomModel {
    id: string;
    locationId: string;
    name: string | undefined;
    positionIndex: number;

    constructor(data?: IWorkbenchRoomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.positionIndex = _data["positionIndex"];
        }
    }

    static fromJS(data: any): WorkbenchRoomModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchRoomModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["positionIndex"] = this.positionIndex;
        return data;
    }

    clone(): WorkbenchRoomModel {
        const json = this.toJSON();
        let result = new WorkbenchRoomModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchRoomModel {
    id: string;
    locationId: string;
    name: string | undefined;
    positionIndex: number;
}

export class WorkbenchRoomTask implements IWorkbenchRoomTask {
    id: string;
    locationId: string;
    location: Location;
    workbenchRoomId: string;
    workbenchRoom: WorkbenchRoom;
    name: string | undefined;
    defaultUserId: string | undefined;
    defaultUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;

    constructor(data?: IWorkbenchRoomTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.workbenchRoomId = _data["workbenchRoomId"];
            this.workbenchRoom = _data["workbenchRoom"] ? WorkbenchRoom.fromJS(_data["workbenchRoom"]) : <any>undefined;
            this.name = _data["name"];
            this.defaultUserId = _data["defaultUserId"];
            this.defaultUser = _data["defaultUser"] ? User.fromJS(_data["defaultUser"]) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
            if (Array.isArray(_data["workbenchTasks"])) {
                this.workbenchTasks = [] as any;
                for (let item of _data["workbenchTasks"])
                    this.workbenchTasks.push(WorkbenchTask.fromJS(item));
            }
            if (Array.isArray(_data["workbenchTaskPrototypes"])) {
                this.workbenchTaskPrototypes = [] as any;
                for (let item of _data["workbenchTaskPrototypes"])
                    this.workbenchTaskPrototypes.push(WorkbenchTaskPrototype.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbenchRoomTask {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchRoomTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["workbenchRoomId"] = this.workbenchRoomId;
        data["workbenchRoom"] = this.workbenchRoom ? this.workbenchRoom.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["defaultUserId"] = this.defaultUserId;
        data["defaultUser"] = this.defaultUser ? this.defaultUser.toJSON() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        if (Array.isArray(this.workbenchTasks)) {
            data["workbenchTasks"] = [];
            for (let item of this.workbenchTasks)
                data["workbenchTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.workbenchTaskPrototypes)) {
            data["workbenchTaskPrototypes"] = [];
            for (let item of this.workbenchTaskPrototypes)
                data["workbenchTaskPrototypes"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkbenchRoomTask {
        const json = this.toJSON();
        let result = new WorkbenchRoomTask();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchRoomTask {
    id: string;
    locationId: string;
    location: Location;
    workbenchRoomId: string;
    workbenchRoom: WorkbenchRoom;
    name: string | undefined;
    defaultUserId: string | undefined;
    defaultUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    workbenchTasks: WorkbenchTask[] | undefined;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;
}

export class WorkbenchRoomTaskModel implements IWorkbenchRoomTaskModel {
    id: string;
    locationId: string;
    workbenchRoom: WorkbenchRoomModel;
    name: string | undefined;
    defaultUser: WorkbenchSettingsUserModel;
    orderStatusId: number | undefined;
    commission: number | undefined;

    constructor(data?: IWorkbenchRoomTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.workbenchRoom = _data["workbenchRoom"] ? WorkbenchRoomModel.fromJS(_data["workbenchRoom"]) : <any>undefined;
            this.name = _data["name"];
            this.defaultUser = _data["defaultUser"] ? WorkbenchSettingsUserModel.fromJS(_data["defaultUser"]) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
        }
    }

    static fromJS(data: any): WorkbenchRoomTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchRoomTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["workbenchRoom"] = this.workbenchRoom ? this.workbenchRoom.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["defaultUser"] = this.defaultUser ? this.defaultUser.toJSON() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        return data;
    }

    clone(): WorkbenchRoomTaskModel {
        const json = this.toJSON();
        let result = new WorkbenchRoomTaskModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchRoomTaskModel {
    id: string;
    locationId: string;
    workbenchRoom: WorkbenchRoomModel;
    name: string | undefined;
    defaultUser: WorkbenchSettingsUserModel;
    orderStatusId: number | undefined;
    commission: number | undefined;
}

export class WorkbenchSettingsUserModel implements IWorkbenchSettingsUserModel {
    id: string;
    email: string | undefined;
    fullName: string | undefined;
    emailConfirmed: boolean;
    roleName: string | undefined;
    rooms: WorkbenchRoomModel[] | undefined;

    constructor(data?: IWorkbenchSettingsUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms.push(WorkbenchRoomModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbenchSettingsUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchSettingsUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["emailConfirmed"] = this.emailConfirmed;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkbenchSettingsUserModel {
        const json = this.toJSON();
        let result = new WorkbenchSettingsUserModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchSettingsUserModel {
    id: string;
    email: string | undefined;
    fullName: string | undefined;
    emailConfirmed: boolean;
    roleName: string | undefined;
    rooms: WorkbenchRoomModel[] | undefined;
}

export class WorkbenchTask implements IWorkbenchTask {
    id: string;
    orderId: string;
    order: Order;
    locationId: string;
    location: Location;
    workbenchRoomTaskId: string;
    workbenchRoomTask: WorkbenchRoomTask;
    assignedUserId: string | undefined;
    assignedUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    startTime: Date;
    endTime: Date;
    isAsigned: boolean;
    isStarted: boolean;
    isFinished: boolean;
    priority: number;
    taskFragments: WorkbenchTaskFragment[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;

    constructor(data?: IWorkbenchTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.workbenchRoomTask = _data["workbenchRoomTask"] ? WorkbenchRoomTask.fromJS(_data["workbenchRoomTask"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUser = _data["assignedUser"] ? User.fromJS(_data["assignedUser"]) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.isAsigned = _data["isAsigned"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["taskFragments"])) {
                this.taskFragments = [] as any;
                for (let item of _data["taskFragments"])
                    this.taskFragments.push(WorkbenchTaskFragment.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdateById = _data["lastUpdateById"];
            this.createdById = _data["createdById"];
        }
    }

    static fromJS(data: any): WorkbenchTask {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["workbenchRoomTask"] = this.workbenchRoomTask ? this.workbenchRoomTask.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isAsigned"] = this.isAsigned;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["priority"] = this.priority;
        if (Array.isArray(this.taskFragments)) {
            data["taskFragments"] = [];
            for (let item of this.taskFragments)
                data["taskFragments"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdateById"] = this.lastUpdateById;
        data["createdById"] = this.createdById;
        return data;
    }

    clone(): WorkbenchTask {
        const json = this.toJSON();
        let result = new WorkbenchTask();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTask {
    id: string;
    orderId: string;
    order: Order;
    locationId: string;
    location: Location;
    workbenchRoomTaskId: string;
    workbenchRoomTask: WorkbenchRoomTask;
    assignedUserId: string | undefined;
    assignedUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    startTime: Date;
    endTime: Date;
    isAsigned: boolean;
    isStarted: boolean;
    isFinished: boolean;
    priority: number;
    taskFragments: WorkbenchTaskFragment[] | undefined;
    createdAt: Date;
    createdBy: string | undefined;
    lastUpdatedAt: Date;
    lastUpdatedBy: string | undefined;
    lastUpdateById: string | undefined;
    createdById: string | undefined;
}

export class WorkbenchTaskFragment implements IWorkbenchTaskFragment {
    id: string;
    userId: string;
    user: User;
    workbenchTaskId: string;
    workbenchTask: WorkbenchTask;
    startTime: Date;
    endTime: Date;
    isFinished: boolean;

    constructor(data?: IWorkbenchTaskFragment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.workbenchTaskId = _data["workbenchTaskId"];
            this.workbenchTask = _data["workbenchTask"] ? WorkbenchTask.fromJS(_data["workbenchTask"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): WorkbenchTaskFragment {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTaskFragment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["workbenchTaskId"] = this.workbenchTaskId;
        data["workbenchTask"] = this.workbenchTask ? this.workbenchTask.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): WorkbenchTaskFragment {
        const json = this.toJSON();
        let result = new WorkbenchTaskFragment();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTaskFragment {
    id: string;
    userId: string;
    user: User;
    workbenchTaskId: string;
    workbenchTask: WorkbenchTask;
    startTime: Date;
    endTime: Date;
    isFinished: boolean;
}

export class WorkbenchTaskFragmentModel implements IWorkbenchTaskFragmentModel {
    id: string;
    user: WorkbenchSettingsUserModel;
    startTime: Date;
    endTime: Date;
    isFinished: boolean;

    constructor(data?: IWorkbenchTaskFragmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? WorkbenchSettingsUserModel.fromJS(_data["user"]) : <any>undefined;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
        }
    }

    static fromJS(data: any): WorkbenchTaskFragmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTaskFragmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        return data;
    }

    clone(): WorkbenchTaskFragmentModel {
        const json = this.toJSON();
        let result = new WorkbenchTaskFragmentModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTaskFragmentModel {
    id: string;
    user: WorkbenchSettingsUserModel;
    startTime: Date;
    endTime: Date;
    isFinished: boolean;
}

export class WorkbenchTaskModel implements IWorkbenchTaskModel {
    id: string;
    locationId: string;
    order: WorkbenchOrderModel;
    workbenchRoomTask: WorkbenchRoomTaskModel;
    previousUser: WorkbenchSettingsUserModel;
    assignedUser: WorkbenchSettingsUserModel;
    commission: number | undefined;
    isAsigned: boolean;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date;
    endTime: Date;
    priority: number;
    taskFragments: WorkbenchTaskFragmentModel[] | undefined;

    constructor(data?: IWorkbenchTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.order = _data["order"] ? WorkbenchOrderModel.fromJS(_data["order"]) : <any>undefined;
            this.workbenchRoomTask = _data["workbenchRoomTask"] ? WorkbenchRoomTaskModel.fromJS(_data["workbenchRoomTask"]) : <any>undefined;
            this.previousUser = _data["previousUser"] ? WorkbenchSettingsUserModel.fromJS(_data["previousUser"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? WorkbenchSettingsUserModel.fromJS(_data["assignedUser"]) : <any>undefined;
            this.commission = _data["commission"];
            this.isAsigned = _data["isAsigned"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.priority = _data["priority"];
            if (Array.isArray(_data["taskFragments"])) {
                this.taskFragments = [] as any;
                for (let item of _data["taskFragments"])
                    this.taskFragments.push(WorkbenchTaskFragmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbenchTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["workbenchRoomTask"] = this.workbenchRoomTask ? this.workbenchRoomTask.toJSON() : <any>undefined;
        data["previousUser"] = this.previousUser ? this.previousUser.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["commission"] = this.commission;
        data["isAsigned"] = this.isAsigned;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["priority"] = this.priority;
        if (Array.isArray(this.taskFragments)) {
            data["taskFragments"] = [];
            for (let item of this.taskFragments)
                data["taskFragments"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkbenchTaskModel {
        const json = this.toJSON();
        let result = new WorkbenchTaskModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTaskModel {
    id: string;
    locationId: string;
    order: WorkbenchOrderModel;
    workbenchRoomTask: WorkbenchRoomTaskModel;
    previousUser: WorkbenchSettingsUserModel;
    assignedUser: WorkbenchSettingsUserModel;
    commission: number | undefined;
    isAsigned: boolean;
    isStarted: boolean;
    isFinished: boolean;
    startTime: Date;
    endTime: Date;
    priority: number;
    taskFragments: WorkbenchTaskFragmentModel[] | undefined;
}

export class WorkbenchTaskPrototype implements IWorkbenchTaskPrototype {
    id: string;
    workbenchRoomTaskId: string;
    workbenchRoomTask: WorkbenchRoomTask;
    workbenchWorkflowId: string;
    workbenchWorkflow: WorkbenchWorkflow;
    assignedUserId: string | undefined;
    assignedUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;
    priority: number;

    constructor(data?: IWorkbenchTaskPrototype) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workbenchRoomTaskId = _data["workbenchRoomTaskId"];
            this.workbenchRoomTask = _data["workbenchRoomTask"] ? WorkbenchRoomTask.fromJS(_data["workbenchRoomTask"]) : <any>undefined;
            this.workbenchWorkflowId = _data["workbenchWorkflowId"];
            this.workbenchWorkflow = _data["workbenchWorkflow"] ? WorkbenchWorkflow.fromJS(_data["workbenchWorkflow"]) : <any>undefined;
            this.assignedUserId = _data["assignedUserId"];
            this.assignedUser = _data["assignedUser"] ? User.fromJS(_data["assignedUser"]) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
            this.isDisabled = _data["isDisabled"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): WorkbenchTaskPrototype {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTaskPrototype();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workbenchRoomTaskId"] = this.workbenchRoomTaskId;
        data["workbenchRoomTask"] = this.workbenchRoomTask ? this.workbenchRoomTask.toJSON() : <any>undefined;
        data["workbenchWorkflowId"] = this.workbenchWorkflowId;
        data["workbenchWorkflow"] = this.workbenchWorkflow ? this.workbenchWorkflow.toJSON() : <any>undefined;
        data["assignedUserId"] = this.assignedUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        data["isDisabled"] = this.isDisabled;
        data["priority"] = this.priority;
        return data;
    }

    clone(): WorkbenchTaskPrototype {
        const json = this.toJSON();
        let result = new WorkbenchTaskPrototype();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTaskPrototype {
    id: string;
    workbenchRoomTaskId: string;
    workbenchRoomTask: WorkbenchRoomTask;
    workbenchWorkflowId: string;
    workbenchWorkflow: WorkbenchWorkflow;
    assignedUserId: string | undefined;
    assignedUser: User;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;
    priority: number;
}

export class WorkbenchTaskPrototypeModel implements IWorkbenchTaskPrototypeModel {
    id: string;
    workbenchRoomTask: WorkbenchRoomTaskModel;
    assignedUser: WorkbenchSettingsUserModel;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;
    priority: number;

    constructor(data?: IWorkbenchTaskPrototypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workbenchRoomTask = _data["workbenchRoomTask"] ? WorkbenchRoomTaskModel.fromJS(_data["workbenchRoomTask"]) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? WorkbenchSettingsUserModel.fromJS(_data["assignedUser"]) : <any>undefined;
            this.orderStatusId = _data["orderStatusId"];
            this.commission = _data["commission"];
            this.isDisabled = _data["isDisabled"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): WorkbenchTaskPrototypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchTaskPrototypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workbenchRoomTask"] = this.workbenchRoomTask ? this.workbenchRoomTask.toJSON() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["orderStatusId"] = this.orderStatusId;
        data["commission"] = this.commission;
        data["isDisabled"] = this.isDisabled;
        data["priority"] = this.priority;
        return data;
    }

    clone(): WorkbenchTaskPrototypeModel {
        const json = this.toJSON();
        let result = new WorkbenchTaskPrototypeModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchTaskPrototypeModel {
    id: string;
    workbenchRoomTask: WorkbenchRoomTaskModel;
    assignedUser: WorkbenchSettingsUserModel;
    orderStatusId: number | undefined;
    commission: number | undefined;
    isDisabled: boolean;
    priority: number;
}

export class WorkbenchWorkflow implements IWorkbenchWorkflow {
    id: string;
    name: string | undefined;
    locationId: string;
    location: Location;
    productCategoryId: number | undefined;
    productCategory: ProductCategory;
    isDisabled: boolean;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;
    rules: PredicateGroup;

    constructor(data?: IWorkbenchWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.productCategoryId = _data["productCategoryId"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            this.isDisabled = _data["isDisabled"];
            if (Array.isArray(_data["workbenchTaskPrototypes"])) {
                this.workbenchTaskPrototypes = [] as any;
                for (let item of _data["workbenchTaskPrototypes"])
                    this.workbenchTaskPrototypes.push(WorkbenchTaskPrototype.fromJS(item));
            }
            this.rules = _data["rules"] ? PredicateGroup.fromJS(_data["rules"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkbenchWorkflow {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchWorkflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["isDisabled"] = this.isDisabled;
        if (Array.isArray(this.workbenchTaskPrototypes)) {
            data["workbenchTaskPrototypes"] = [];
            for (let item of this.workbenchTaskPrototypes)
                data["workbenchTaskPrototypes"].push(item.toJSON());
        }
        data["rules"] = this.rules ? this.rules.toJSON() : <any>undefined;
        return data;
    }

    clone(): WorkbenchWorkflow {
        const json = this.toJSON();
        let result = new WorkbenchWorkflow();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchWorkflow {
    id: string;
    name: string | undefined;
    locationId: string;
    location: Location;
    productCategoryId: number | undefined;
    productCategory: ProductCategory;
    isDisabled: boolean;
    workbenchTaskPrototypes: WorkbenchTaskPrototype[] | undefined;
    rules: PredicateGroup;
}

export class WorkbenchWorkflowModel implements IWorkbenchWorkflowModel {
    id: string;
    locationId: string;
    name: string | undefined;
    productCategory: ProductCategoryModel;
    isDisabled: boolean;
    workbenchTaskPrototypes: WorkbenchTaskPrototypeModel[] | undefined;

    constructor(data?: IWorkbenchWorkflowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationId = _data["locationId"];
            this.name = _data["name"];
            this.productCategory = _data["productCategory"] ? ProductCategoryModel.fromJS(_data["productCategory"]) : <any>undefined;
            this.isDisabled = _data["isDisabled"];
            if (Array.isArray(_data["workbenchTaskPrototypes"])) {
                this.workbenchTaskPrototypes = [] as any;
                for (let item of _data["workbenchTaskPrototypes"])
                    this.workbenchTaskPrototypes.push(WorkbenchTaskPrototypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbenchWorkflowModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbenchWorkflowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["name"] = this.name;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["isDisabled"] = this.isDisabled;
        if (Array.isArray(this.workbenchTaskPrototypes)) {
            data["workbenchTaskPrototypes"] = [];
            for (let item of this.workbenchTaskPrototypes)
                data["workbenchTaskPrototypes"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkbenchWorkflowModel {
        const json = this.toJSON();
        let result = new WorkbenchWorkflowModel();
        result.init(json);
        return result;
    }
}

export interface IWorkbenchWorkflowModel {
    id: string;
    locationId: string;
    name: string | undefined;
    productCategory: ProductCategoryModel;
    isDisabled: boolean;
    workbenchTaskPrototypes: WorkbenchTaskPrototypeModel[] | undefined;
}

export class XeroInvoiceDto implements IXeroInvoiceDto {
    invoiceId: string;
    tenantId: string;
    locationId: string;

    constructor(data?: IXeroInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.tenantId = _data["tenantId"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): XeroInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new XeroInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["tenantId"] = this.tenantId;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): XeroInvoiceDto {
        const json = this.toJSON();
        let result = new XeroInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IXeroInvoiceDto {
    invoiceId: string;
    tenantId: string;
    locationId: string;
}

export class XeroRequestDto implements IXeroRequestDto {
    code: string | undefined;
    userName: string | undefined;
    userId: string | undefined;
    userTime: number;
    locationId: string;

    constructor(data?: IXeroRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.userTime = _data["userTime"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): XeroRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new XeroRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["userTime"] = this.userTime;
        data["locationId"] = this.locationId;
        return data;
    }

    clone(): XeroRequestDto {
        const json = this.toJSON();
        let result = new XeroRequestDto();
        result.init(json);
        return result;
    }
}

export interface IXeroRequestDto {
    code: string | undefined;
    userName: string | undefined;
    userId: string | undefined;
    userTime: number;
    locationId: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}